var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { print } from 'graphql';
import gql from 'graphql-tag';
export var AcceleratorAnalyticsEventTypes;
(function (AcceleratorAnalyticsEventTypes) {
  AcceleratorAnalyticsEventTypes["IMPRESSION"] = "IMPRESSION";
  AcceleratorAnalyticsEventTypes["INTERACTION"] = "INTERACTION";
  AcceleratorAnalyticsEventTypes["OUTCOME"] = "OUTCOME";
  AcceleratorAnalyticsEventTypes["PAGE_VIEW"] = "PAGE_VIEW";
})(AcceleratorAnalyticsEventTypes || (AcceleratorAnalyticsEventTypes = {}));
export var AcceleratorButtonTypes;
(function (AcceleratorButtonTypes) {
  AcceleratorButtonTypes["PRIMARY"] = "PRIMARY";
  AcceleratorButtonTypes["SECONDARY"] = "SECONDARY";
  AcceleratorButtonTypes["TERTIARY"] = "TERTIARY";
})(AcceleratorButtonTypes || (AcceleratorButtonTypes = {}));
/** Describes what kind of action being described. Copy for example describes the coupon code copy behavior. Authwindow shows the login/signup dialog. */
export var ActionDetailsType;
(function (ActionDetailsType) {
  /** Action to pop auth window */
  ActionDetailsType["AUTHWINDOW"] = "AUTHWINDOW";
  /** Action to close a dropdown option */
  ActionDetailsType["CLOSE"] = "CLOSE";
  /** Action to copy contents to clipboard */
  ActionDetailsType["COPY"] = "COPY";
  /** Action to open the date picker */
  ActionDetailsType["DATEPICKER"] = "DATEPICKER";
  /** Action to open an external link off */
  ActionDetailsType["EXTERNAL_LINK"] = "EXTERNAL_LINK";
  /** Action to display free lx message */
  ActionDetailsType["FREE_LX"] = "FREE_LX";
  /** Action to open a link off */
  ActionDetailsType["OPEN"] = "OPEN";
  /** Action to display term and conditions */
  ActionDetailsType["TERMS_AND_CONDITIONS"] = "TERMS_AND_CONDITIONS";
})(ActionDetailsType || (ActionDetailsType = {}));
export var ActionStationType;
(function (ActionStationType) {
  ActionStationType["REVIEW_ACTIVE_REQUEST"] = "REVIEW_ACTIVE_REQUEST";
  ActionStationType["REVIEW_CANCELLATION_REQUEST"] = "REVIEW_CANCELLATION_REQUEST";
  ActionStationType["VIEW_BOOKING_DETAILS"] = "VIEW_BOOKING_DETAILS";
})(ActionStationType || (ActionStationType = {}));
export var ActionType;
(function (ActionType) {
  ActionType["DOWNLOADDPREPORT"] = "DownloadDPReport";
  ActionType["MODAL"] = "Modal";
  ActionType["OPEN"] = "Open";
  ActionType["OPENPRICECHANGEALERT"] = "OpenPriceChangeAlert";
})(ActionType || (ActionType = {}));
/** Indicates the coupon's active state */
export var ActiveState;
(function (ActiveState) {
  ActiveState["ACTIVE"] = "ACTIVE";
  ActiveState["INACTIVE"] = "INACTIVE";
  ActiveState["UNKNOWN"] = "UNKNOWN";
  ActiveState["USED"] = "USED";
})(ActiveState || (ActiveState = {}));
export var ActivityAvailabilityPriceTextTheme;
(function (ActivityAvailabilityPriceTextTheme) {
  ActivityAvailabilityPriceTextTheme["POSITIVE"] = "POSITIVE";
})(ActivityAvailabilityPriceTextTheme || (ActivityAvailabilityPriceTextTheme = {}));
export var ActivityBadgeType;
(function (ActivityBadgeType) {
  ActivityBadgeType["CAMPAIGN_DEAL"] = "CAMPAIGN_DEAL";
  ActivityBadgeType["DEAL_ADD_ON"] = "DEAL_ADD_ON";
  ActivityBadgeType["DEAL_GENERIC"] = "DEAL_GENERIC";
  ActivityBadgeType["DEAL_MEMBER"] = "DEAL_MEMBER";
  ActivityBadgeType["GLOBAL_LOW_TIER"] = "GLOBAL_LOW_TIER";
})(ActivityBadgeType || (ActivityBadgeType = {}));
/** Activity banner type */
export var ActivityBannerType;
(function (ActivityBannerType) {
  ActivityBannerType["ALERT"] = "ALERT";
  ActivityBannerType["INFO"] = "INFO";
  ActivityBannerType["SHOP_WITH_POINTS"] = "SHOP_WITH_POINTS";
})(ActivityBannerType || (ActivityBannerType = {}));
export var ActivityCancellationType;
(function (ActivityCancellationType) {
  ActivityCancellationType["FREE_CANCELLATION"] = "FREE_CANCELLATION";
  ActivityCancellationType["NO_CANCELLATION"] = "NO_CANCELLATION";
})(ActivityCancellationType || (ActivityCancellationType = {}));
export var ActivityCategory;
(function (ActivityCategory) {
  ActivityCategory["ADULTS_ONLY_SHOWS"] = "ADULTS_ONLY_SHOWS";
  ActivityCategory["ADVENTURES"] = "ADVENTURES";
  ActivityCategory["ADVENTURE_OUTDOOR"] = "ADVENTURE_OUTDOOR";
  ActivityCategory["AIRBOAT_TOURS"] = "AIRBOAT_TOURS";
  ActivityCategory["AIRPLANE_RIDES"] = "AIRPLANE_RIDES";
  ActivityCategory["AIRPLANE_TOURS"] = "AIRPLANE_TOURS";
  ActivityCategory["AIRPORT_GROUND_TRANSPORTATION"] = "AIRPORT_GROUND_TRANSPORTATION";
  ActivityCategory["AIRPORT_LOUNGES"] = "AIRPORT_LOUNGES";
  ActivityCategory["AIRPORT_TO_AIRPORT_TRANSFERS"] = "AIRPORT_TO_AIRPORT_TRANSFERS";
  ActivityCategory["AIR_BALLOON_HELICOPTER_TOURS"] = "AIR_BALLOON_HELICOPTER_TOURS";
  ActivityCategory["AIR_HELICOPTER_BALLOON_TOURS"] = "AIR_HELICOPTER_BALLOON_TOURS";
  ActivityCategory["AMUSEMENT_THEME_PARKS"] = "AMUSEMENT_THEME_PARKS";
  ActivityCategory["ARCHITECTURE_TOURS"] = "ARCHITECTURE_TOURS";
  ActivityCategory["ART_CLASSES"] = "ART_CLASSES";
  ActivityCategory["ART_CULTURE_HISTORY_TOURS"] = "ART_CULTURE_HISTORY_TOURS";
  ActivityCategory["ART_MUSIC_LITERARYTOURS"] = "ART_MUSIC_LITERARYTOURS";
  ActivityCategory["ATTRACTIONS"] = "ATTRACTIONS";
  ActivityCategory["ATTRACTION_TICKETS"] = "ATTRACTION_TICKETS";
  ActivityCategory["BALLOON_RIDES"] = "BALLOON_RIDES";
  ActivityCategory["BALLOON_TOURS"] = "BALLOON_TOURS";
  ActivityCategory["BAR_PUB_TOURS"] = "BAR_PUB_TOURS";
  ActivityCategory["BEER_BREWERY_TOURS"] = "BEER_BREWERY_TOURS";
  ActivityCategory["BEYOND_THE_CITY"] = "BEYOND_THE_CITY";
  ActivityCategory["BIKE_MOUNTAIN_BIKE_TOURS"] = "BIKE_MOUNTAIN_BIKE_TOURS";
  ActivityCategory["BIKE_RENTALS"] = "BIKE_RENTALS";
  ActivityCategory["BOAT_RENTAL"] = "BOAT_RENTAL";
  ActivityCategory["BOAT_TOURS"] = "BOAT_TOURS";
  ActivityCategory["BOAT_TOURS_CRUISES"] = "BOAT_TOURS_CRUISES";
  ActivityCategory["BRUNCHC_RUISES"] = "BRUNCHC_RUISES";
  ActivityCategory["BUNGEE_JUMPING_SKYDIVING"] = "BUNGEE_JUMPING_SKYDIVING";
  ActivityCategory["BUS_MINIVAN_TOURS"] = "BUS_MINIVAN_TOURS";
  ActivityCategory["CABARET"] = "CABARET";
  ActivityCategory["CAMPAIGN_DEALS"] = "CAMPAIGN_DEALS";
  ActivityCategory["CASTLE_PALACE_TOURS"] = "CASTLE_PALACE_TOURS";
  ActivityCategory["CHAUFFER_SERVICES"] = "CHAUFFER_SERVICES";
  ActivityCategory["CHRISTMAS"] = "CHRISTMAS";
  ActivityCategory["CIRQUE"] = "CIRQUE";
  ActivityCategory["CIRQUE_DU_SOLEIL"] = "CIRQUE_DU_SOLEIL";
  ActivityCategory["CIRQUE_DU_SOLEILSHOWS"] = "CIRQUE_DU_SOLEILSHOWS";
  ActivityCategory["CITY_AND_ATTRACTION_TRANSFERS"] = "CITY_AND_ATTRACTION_TRANSFERS";
  ActivityCategory["CITY_ATTRACTION_TRANSFERS"] = "CITY_ATTRACTION_TRANSFERS";
  ActivityCategory["CITY_TOURS"] = "CITY_TOURS";
  ActivityCategory["CITY_TOURS_PACKAGES"] = "CITY_TOURS_PACKAGES";
  ActivityCategory["CLASSES_WORKSHOPS"] = "CLASSES_WORKSHOPS";
  ActivityCategory["CLUB_AND_PARTY_BUS_TOURS"] = "CLUB_AND_PARTY_BUS_TOURS";
  ActivityCategory["CLUB_PARTY_BUS_TOURS"] = "CLUB_PARTY_BUS_TOURS";
  ActivityCategory["COFFEE_TEA_TOURS"] = "COFFEE_TEA_TOURS";
  ActivityCategory["COMEDY_SHOWS"] = "COMEDY_SHOWS";
  ActivityCategory["CONCERTS_SPECIAL_EVENTS"] = "CONCERTS_SPECIAL_EVENTS";
  ActivityCategory["COOKING_CLASSES"] = "COOKING_CLASSES";
  ActivityCategory["CRUISES_BOAT_TOURS"] = "CRUISES_BOAT_TOURS";
  ActivityCategory["CRUISES_WATER_TOURS"] = "CRUISES_WATER_TOURS";
  ActivityCategory["CULTURAL_HERITAGE_EXPERIENCES"] = "CULTURAL_HERITAGE_EXPERIENCES";
  ActivityCategory["CUSTOM_PRIVATE_TOURS"] = "CUSTOM_PRIVATE_TOURS";
  ActivityCategory["DANCE_CLASSES"] = "DANCE_CLASSES";
  ActivityCategory["DAY_OF_THE_DEAD"] = "DAY_OF_THE_DEAD";
  ActivityCategory["DAY_SPAS"] = "DAY_SPAS";
  ActivityCategory["DAY_TRIPS"] = "DAY_TRIPS";
  ActivityCategory["DAY_TRIPS_EXCURSIONS"] = "DAY_TRIPS_EXCURSIONS";
  ActivityCategory["DINING_EXPERIENCES"] = "DINING_EXPERIENCES";
  ActivityCategory["DINNER_CRUISES"] = "DINNER_CRUISES";
  ActivityCategory["DINNER_THEATER"] = "DINNER_THEATER";
  ActivityCategory["DISNEY"] = "DISNEY";
  ActivityCategory["DISNEY_PARKS"] = "DISNEY_PARKS";
  ActivityCategory["DOLPHIN_WHALE_WATCHING"] = "DOLPHIN_WHALE_WATCHING";
  ActivityCategory["DOSE_OF_CULTURE"] = "DOSE_OF_CULTURE";
  ActivityCategory["DUCK_TOURS"] = "DUCK_TOURS";
  ActivityCategory["EASTER"] = "EASTER";
  ActivityCategory["FAMILY_FRIENDLY"] = "FAMILY_FRIENDLY";
  ActivityCategory["FASHION_SHOWS_TOURS"] = "FASHION_SHOWS_TOURS";
  ActivityCategory["FISHING_CHARTERS_TOURS"] = "FISHING_CHARTERS_TOURS";
  ActivityCategory["FISHING_TOURS_AND_CHARTERS"] = "FISHING_TOURS_AND_CHARTERS";
  ActivityCategory["FOOD_DRINK"] = "FOOD_DRINK";
  ActivityCategory["FOOD_DRINK_NIGHTLIFE"] = "FOOD_DRINK_NIGHTLIFE";
  ActivityCategory["FOOD_TOURS"] = "FOOD_TOURS";
  ActivityCategory["FUN_FOR_FOODIES"] = "FUN_FOR_FOODIES";
  ActivityCategory["FUN_ON_THE_WATER"] = "FUN_ON_THE_WATER";
  ActivityCategory["GALLERIES_MUSEUMS"] = "GALLERIES_MUSEUMS";
  ActivityCategory["GAMES_SHOWS_SPECIAL_EVENTS"] = "GAMES_SHOWS_SPECIAL_EVENTS";
  ActivityCategory["GETTING_AROUND"] = "GETTING_AROUND";
  ActivityCategory["GOLF_TEE_TIMES"] = "GOLF_TEE_TIMES";
  ActivityCategory["GOLF_TOURS_TEE_TIMES"] = "GOLF_TOURS_TEE_TIMES";
  ActivityCategory["HALLOWEEN"] = "HALLOWEEN";
  ActivityCategory["HAMMAMS_TURKISH_BATHS"] = "HAMMAMS_TURKISH_BATHS";
  ActivityCategory["HELICOPTER_RIDES"] = "HELICOPTER_RIDES";
  ActivityCategory["HELICOPTER_TOURS"] = "HELICOPTER_TOURS";
  ActivityCategory["HIGH_SPEED_DRIVING"] = "HIGH_SPEED_DRIVING";
  ActivityCategory["HIGH_SPEED_RIDES"] = "HIGH_SPEED_RIDES";
  ActivityCategory["HIKING_CAMPING"] = "HIKING_CAMPING";
  ActivityCategory["HISTORICAL_TOURS"] = "HISTORICAL_TOURS";
  ActivityCategory["HISTORY_CULTURE"] = "HISTORY_CULTURE";
  ActivityCategory["HOLIDAY_SEASONAL_TOURS"] = "HOLIDAY_SEASONAL_TOURS";
  ActivityCategory["HONEYMOON_PACKAGE"] = "HONEYMOON_PACKAGE";
  ActivityCategory["HONEYMOON_PACKAGES"] = "HONEYMOON_PACKAGES";
  ActivityCategory["HOP_ON_HOP_OFF"] = "HOP_ON_HOP_OFF";
  ActivityCategory["HOP_ON_HOP_OFF_TOURS"] = "HOP_ON_HOP_OFF_TOURS";
  ActivityCategory["HORSE_CARRIAGE_RIDES"] = "HORSE_CARRIAGE_RIDES";
  ActivityCategory["HOT_SPRINGS_THERMAL_SPAS"] = "HOT_SPRINGS_THERMAL_SPAS";
  ActivityCategory["INTERESTS"] = "INTERESTS";
  ActivityCategory["KAYAKING_CANOEING"] = "KAYAKING_CANOEING";
  ActivityCategory["LATEST_GREATEST"] = "LATEST_GREATEST";
  ActivityCategory["LIFT_TICKETS"] = "LIFT_TICKETS";
  ActivityCategory["LIKELY_TO_SELL_OUT"] = "LIKELY_TO_SELL_OUT";
  ActivityCategory["LITERARY_ART_MUSIC_TOURS"] = "LITERARY_ART_MUSIC_TOURS";
  ActivityCategory["LOCAL_EXPERT_PICKS"] = "LOCAL_EXPERT_PICKS";
  ActivityCategory["LUNCH_CRUISES"] = "LUNCH_CRUISES";
  ActivityCategory["MOTORCYCLE_SCOOTER_TOURS"] = "MOTORCYCLE_SCOOTER_TOURS";
  ActivityCategory["MOVIE_TV_TOURS"] = "MOVIE_TV_TOURS";
  ActivityCategory["MULTIDAY_CRUISES"] = "MULTIDAY_CRUISES";
  ActivityCategory["MULTI_DAY_EXTENDED_TOURS"] = "MULTI_DAY_EXTENDED_TOURS";
  ActivityCategory["MUSEUM_TICKETS"] = "MUSEUM_TICKETS";
  ActivityCategory["MUSEUM_TICKETS_PASSES"] = "MUSEUM_TICKETS_PASSES";
  ActivityCategory["MUST_SEE_SIGHTS"] = "MUST_SEE_SIGHTS";
  ActivityCategory["NA"] = "NA";
  ActivityCategory["NATIONAL_HOLIDAYS"] = "NATIONAL_HOLIDAYS";
  ActivityCategory["NEW"] = "NEW";
  ActivityCategory["NEWY_EARS"] = "NEWY_EARS";
  ActivityCategory["NIGHTLIFE"] = "NIGHTLIFE";
  ActivityCategory["NIGHTLIFE_PASSES"] = "NIGHTLIFE_PASSES";
  ActivityCategory["NIGHT_CRUISES"] = "NIGHT_CRUISES";
  ActivityCategory["NIGHT_TOURS"] = "NIGHT_TOURS";
  ActivityCategory["ONSENS"] = "ONSENS";
  ActivityCategory["OTHER_ANIMALS_ACTIVITIES"] = "OTHER_ANIMALS_ACTIVITIES";
  ActivityCategory["OTHER_ANIMAL_ACTIVITIES"] = "OTHER_ANIMAL_ACTIVITIES";
  ActivityCategory["OTHER_CLASSES"] = "OTHER_CLASSES";
  ActivityCategory["OTHER_OUTDOOR_ACTIVITIES"] = "OTHER_OUTDOOR_ACTIVITIES";
  ActivityCategory["OTHER_SEASONAL_EVENTS"] = "OTHER_SEASONAL_EVENTS";
  ActivityCategory["OTHER_TOURS"] = "OTHER_TOURS";
  ActivityCategory["OTHER_TRANSFERS"] = "OTHER_TRANSFERS";
  ActivityCategory["OTHER_TRANSPORTATION"] = "OTHER_TRANSPORTATION";
  ActivityCategory["OTHER_WATER_ACTIVITIES"] = "OTHER_WATER_ACTIVITIES";
  ActivityCategory["PHOTOGRAPHY_TOURS"] = "PHOTOGRAPHY_TOURS";
  ActivityCategory["PORT_TRANSFERS"] = "PORT_TRANSFERS";
  ActivityCategory["PRIVATE_CUSTOM_TOURS"] = "PRIVATE_CUSTOM_TOURS";
  ActivityCategory["PRIVATE_DAY_TRIPS"] = "PRIVATE_DAY_TRIPS";
  ActivityCategory["PRIVATE_TOURS"] = "PRIVATE_TOURS";
  ActivityCategory["PRIVATE_TRANSFERS"] = "PRIVATE_TRANSFERS";
  ActivityCategory["PURE_ROMANCE"] = "PURE_ROMANCE";
  ActivityCategory["RELIGIOUS_SPIRITUAL_TOURS"] = "RELIGIOUS_SPIRITUAL_TOURS";
  ActivityCategory["RIVER_HARBOUR_CRUISES"] = "RIVER_HARBOUR_CRUISES";
  ActivityCategory["ROMAN_STAYCATION"] = "ROMAN_STAYCATION";
  ActivityCategory["SAFARIS"] = "SAFARIS";
  ActivityCategory["SAILING_TRIPS"] = "SAILING_TRIPS";
  ActivityCategory["SCOOTER_RENTALS"] = "SCOOTER_RENTALS";
  ActivityCategory["SEGWAY_TOURS"] = "SEGWAY_TOURS";
  ActivityCategory["SHARED_TRANSFERS"] = "SHARED_TRANSFERS";
  ActivityCategory["SHARK_DIVING"] = "SHARK_DIVING";
  ActivityCategory["SHOPPING_FASHION"] = "SHOPPING_FASHION";
  ActivityCategory["SHOPPING_PASSES_OFFERS"] = "SHOPPING_PASSES_OFFERS";
  ActivityCategory["SHOPPING_TOURS"] = "SHOPPING_TOURS";
  ActivityCategory["SHORE_EXCURIONS"] = "SHORE_EXCURIONS";
  ActivityCategory["SHOWS_CONCERTS"] = "SHOWS_CONCERTS";
  ActivityCategory["SHOW_SPORT_TICKETS"] = "SHOW_SPORT_TICKETS";
  ActivityCategory["SIGHTSEEING_ATTRACTION_PASSES"] = "SIGHTSEEING_ATTRACTION_PASSES";
  ActivityCategory["SIGHTSEEING_CITY_PASSES"] = "SIGHTSEEING_CITY_PASSES";
  ActivityCategory["SIGHTSEEING_PASSES"] = "SIGHTSEEING_PASSES";
  ActivityCategory["SKIING_RENTALS"] = "SKIING_RENTALS";
  ActivityCategory["SKIP_THE_LINE_TOURS"] = "SKIP_THE_LINE_TOURS";
  ActivityCategory["SNORKELING_SCUBA_DIVING"] = "SNORKELING_SCUBA_DIVING";
  ActivityCategory["SNOWBOARDING_RENTALS"] = "SNOWBOARDING_RENTALS";
  ActivityCategory["SNOWMOBILE_TOURS"] = "SNOWMOBILE_TOURS";
  ActivityCategory["SNOWSHOEING"] = "SNOWSHOEING";
  ActivityCategory["SPA"] = "SPA";
  ActivityCategory["SPA_WELLNESS"] = "SPA_WELLNESS";
  ActivityCategory["SPEED_BOATS_JET_SKIS"] = "SPEED_BOATS_JET_SKIS";
  ActivityCategory["SPORTING_EVENTS_PACKAGES"] = "SPORTING_EVENTS_PACKAGES";
  ActivityCategory["SPORTS_PACKAGES"] = "SPORTS_PACKAGES";
  ActivityCategory["STAY_ACTIVE"] = "STAY_ACTIVE";
  ActivityCategory["SUBMARINE_TOURS"] = "SUBMARINE_TOURS";
  ActivityCategory["SUNSET_CRUISES"] = "SUNSET_CRUISES";
  ActivityCategory["SUPERNATURAL_TOURS"] = "SUPERNATURAL_TOURS";
  ActivityCategory["SUSTAINABLE_TOURS"] = "SUSTAINABLE_TOURS";
  ActivityCategory["SWIM_WITH_DOLPHINS"] = "SWIM_WITH_DOLPHINS";
  ActivityCategory["THEATER_SHOWS_MUSICALS"] = "THEATER_SHOWS_MUSICALS";
  ActivityCategory["THEME_PARKS"] = "THEME_PARKS";
  ActivityCategory["THEME_PARK_TICKETS_TOURS"] = "THEME_PARK_TICKETS_TOURS";
  ActivityCategory["THE_GREAT_OUTDOORS"] = "THE_GREAT_OUTDOORS";
  ActivityCategory["THRILL_SEEKER"] = "THRILL_SEEKER";
  ActivityCategory["TICKETS"] = "TICKETS";
  ActivityCategory["TOURS_ACTIVITIES"] = "TOURS_ACTIVITIES";
  ActivityCategory["TOURS_SIGHTSEEING"] = "TOURS_SIGHTSEEING";
  ActivityCategory["TRANSPORTATION_SERVICES"] = "TRANSPORTATION_SERVICES";
  ActivityCategory["TREAT_YOURSELF"] = "TREAT_YOURSELF";
  ActivityCategory["TUBING"] = "TUBING";
  ActivityCategory["UNIVERSAL_THEME_PARKS"] = "UNIVERSAL_THEME_PARKS";
  ActivityCategory["VALENTINES_DAY"] = "VALENTINES_DAY";
  ActivityCategory["WALKING_BIKE_TOURS"] = "WALKING_BIKE_TOURS";
  ActivityCategory["WALKING_TOURS"] = "WALKING_TOURS";
  ActivityCategory["WATERSKIING_WAKEBOARDING"] = "WATERSKIING_WAKEBOARDING";
  ActivityCategory["WATER_ACTIVITIES"] = "WATER_ACTIVITIES";
  ActivityCategory["WATER_PARKS"] = "WATER_PARKS";
  ActivityCategory["WEDDING_CEREMONIES"] = "WEDDING_CEREMONIES";
  ActivityCategory["WEDDING_HONEYMOON"] = "WEDDING_HONEYMOON";
  ActivityCategory["WEDDING_PACKAGES"] = "WEDDING_PACKAGES";
  ActivityCategory["WEDDING_SHONEYMOONS"] = "WEDDING_SHONEYMOONS";
  ActivityCategory["WHAT_TO_DO_WITH_GROUPS"] = "WHAT_TO_DO_WITH_GROUPS";
  ActivityCategory["WHAT_TO_DO_WITH_KIDS"] = "WHAT_TO_DO_WITH_KIDS";
  ActivityCategory["WHITE_WATER_RAFTING"] = "WHITE_WATER_RAFTING";
  ActivityCategory["WILDLIFE_NATURE"] = "WILDLIFE_NATURE";
  ActivityCategory["WINE_TASTING_WINERY_TOURS"] = "WINE_TASTING_WINERY_TOURS";
  ActivityCategory["WINTER_ACTIVITIES"] = "WINTER_ACTIVITIES";
  ActivityCategory["YOGA_CLASS"] = "YOGA_CLASS";
  ActivityCategory["YOGA_CLASSES"] = "YOGA_CLASSES";
  ActivityCategory["ZOO_TICKETS"] = "ZOO_TICKETS";
  ActivityCategory["ZOO_TICKETS_PASSES"] = "ZOO_TICKETS_PASSES";
})(ActivityCategory || (ActivityCategory = {}));
export var ActivityCategoryType;
(function (ActivityCategoryType) {
  ActivityCategoryType["ACTIVITIES"] = "ACTIVITIES";
  ActivityCategoryType["CATEGORIES"] = "CATEGORIES";
  ActivityCategoryType["DEALS_PROMOTIONS"] = "DEALS_PROMOTIONS";
  ActivityCategoryType["NA"] = "NA";
  ActivityCategoryType["RECOMMENDATIONS"] = "RECOMMENDATIONS";
  ActivityCategoryType["TOURS"] = "TOURS";
  ActivityCategoryType["TRANSPORTATION"] = "TRANSPORTATION";
})(ActivityCategoryType || (ActivityCategoryType = {}));
/** Details view options that are not filters */
export var ActivityDetailViewOptions;
(function (ActivityDetailViewOptions) {
  ActivityDetailViewOptions["NON_CONSOLIDATED_OFFERS"] = "NON_CONSOLIDATED_OFFERS";
  ActivityDetailViewOptions["SHOP_WITH_POINTS"] = "SHOP_WITH_POINTS";
  ActivityDetailViewOptions["THIRD_PARTY_REVIEWS"] = "THIRD_PARTY_REVIEWS";
})(ActivityDetailViewOptions || (ActivityDetailViewOptions = {}));
export var ActivityDiscountType;
(function (ActivityDiscountType) {
  ActivityDiscountType["AIR_ATTACH_MIP"] = "AIR_ATTACH_MIP";
  ActivityDiscountType["AIR_HOTEL_ATTACH_MIP"] = "AIR_HOTEL_ATTACH_MIP";
  ActivityDiscountType["CAMPAIGN_DEAL"] = "CAMPAIGN_DEAL";
  ActivityDiscountType["FREE_ACTIVITY"] = "FREE_ACTIVITY";
  ActivityDiscountType["GUEST"] = "GUEST";
  ActivityDiscountType["HOTEL_ATTACH_MIP"] = "HOTEL_ATTACH_MIP";
  ActivityDiscountType["MIP"] = "MIP";
  ActivityDiscountType["MOD"] = "MOD";
  ActivityDiscountType["STRIKE_OUT"] = "STRIKE_OUT";
})(ActivityDiscountType || (ActivityDiscountType = {}));
export var ActivityGroupType;
(function (ActivityGroupType) {
  ActivityGroupType["ACTIVITY_LIST"] = "ACTIVITY_LIST";
  ActivityGroupType["ACTIVITY_MESSAGE"] = "ACTIVITY_MESSAGE";
  ActivityGroupType["AVAILABLE_TODAY"] = "AVAILABLE_TODAY";
  ActivityGroupType["CATEGORY"] = "CATEGORY";
  ActivityGroupType["FILTERED_ACTIVITIES"] = "FILTERED_ACTIVITIES";
  ActivityGroupType["INTERESTS"] = "INTERESTS";
  ActivityGroupType["KEYWORD_SEARCH"] = "KEYWORD_SEARCH";
  ActivityGroupType["MORE_ACTIVITIES"] = "MORE_ACTIVITIES";
  ActivityGroupType["NEIGHBOURHOOD"] = "NEIGHBOURHOOD";
  ActivityGroupType["PINNED_ACTIVITY"] = "PINNED_ACTIVITY";
  ActivityGroupType["POI"] = "POI";
  ActivityGroupType["RECOMMENDATIONS"] = "RECOMMENDATIONS";
  ActivityGroupType["SLIM_CATEGORY"] = "SLIM_CATEGORY";
  ActivityGroupType["SUB_CATEGORIES"] = "SUB_CATEGORIES";
  ActivityGroupType["SUB_CATEGORY"] = "SUB_CATEGORY";
  ActivityGroupType["SWP_SORT_SECTION"] = "SWP_SORT_SECTION";
  ActivityGroupType["TOP_ACTIVITIES"] = "TOP_ACTIVITIES";
  ActivityGroupType["TRIPS_ACTIVITY_LIST"] = "TRIPS_ACTIVITY_LIST";
  ActivityGroupType["XSELL_RECOMMENDATIONS"] = "XSELL_RECOMMENDATIONS";
})(ActivityGroupType || (ActivityGroupType = {}));
export var ActivityGroupViewType;
(function (ActivityGroupViewType) {
  ActivityGroupViewType["ACTIVITY_LIST"] = "ACTIVITY_LIST";
  ActivityGroupViewType["ACTIVITY_SPANNED_TILE_LIST"] = "ACTIVITY_SPANNED_TILE_LIST";
  ActivityGroupViewType["ACTIVITY_TILES_CAROUSEL"] = "ACTIVITY_TILES_CAROUSEL";
  ActivityGroupViewType["CATEGORY_TILES_CAROUSEL"] = "CATEGORY_TILES_CAROUSEL";
  ActivityGroupViewType["KEYWORD_SEARCH"] = "KEYWORD_SEARCH";
  ActivityGroupViewType["MESSAGE"] = "MESSAGE";
  ActivityGroupViewType["SLIM_CATEGORY_TILES_CAROUSEL"] = "SLIM_CATEGORY_TILES_CAROUSEL";
  ActivityGroupViewType["TEXT"] = "TEXT";
})(ActivityGroupViewType || (ActivityGroupViewType = {}));
export var ActivityMapGroupType;
(function (ActivityMapGroupType) {
  ActivityMapGroupType["POI"] = "POI";
})(ActivityMapGroupType || (ActivityMapGroupType = {}));
/** Unique identifier for a message if one needs to identify the reason for the message creation */
export var ActivityMessageType;
(function (ActivityMessageType) {
  ActivityMessageType["ADDON"] = "ADDON";
  ActivityMessageType["EARN_2X_REWARD_POINTS"] = "EARN_2X_REWARD_POINTS";
  ActivityMessageType["GIFTING_LX_BANNER"] = "GIFTING_LX_BANNER";
  ActivityMessageType["LOGIN"] = "LOGIN";
  ActivityMessageType["SOURCED_CAMPAIGN"] = "SOURCED_CAMPAIGN";
  ActivityMessageType["SUMMER_CAMPAIGN_PRIMARY"] = "SUMMER_CAMPAIGN_PRIMARY";
  ActivityMessageType["SUMMER_CAMPAIGN_SECONDARY"] = "SUMMER_CAMPAIGN_SECONDARY";
})(ActivityMessageType || (ActivityMessageType = {}));
export var ActivityOfferUdsToken;
(function (ActivityOfferUdsToken) {
  ActivityOfferUdsToken["SELECTED"] = "SELECTED";
  ActivityOfferUdsToken["UNSELECTED"] = "UNSELECTED";
})(ActivityOfferUdsToken || (ActivityOfferUdsToken = {}));
/** Activity page Meta Tag types - NamedMetaTag, PropertyMetaTag and so on */
export var ActivityPageMetaTagType;
(function (ActivityPageMetaTagType) {
  ActivityPageMetaTagType["HTTP_EQUIV"] = "HTTP_EQUIV";
  ActivityPageMetaTagType["NAME"] = "NAME";
  ActivityPageMetaTagType["PROPERTY"] = "PROPERTY";
})(ActivityPageMetaTagType || (ActivityPageMetaTagType = {}));
/** Activity Page Type - infosite */
export var ActivityPageType;
(function (ActivityPageType) {
  ActivityPageType["ACTIVITY_INFO"] = "ACTIVITY_INFO";
})(ActivityPageType || (ActivityPageType = {}));
/** Activity Price types */
export var ActivityPriceType;
(function (ActivityPriceType) {
  ActivityPriceType["GROUP"] = "GROUP";
  ActivityPriceType["NORMAL"] = "NORMAL";
  ActivityPriceType["VOLUME_BASED"] = "VOLUME_BASED";
})(ActivityPriceType || (ActivityPriceType = {}));
export var ActivityRedemptionType;
(function (ActivityRedemptionType) {
  ActivityRedemptionType["PRINT"] = "PRINT";
  ActivityRedemptionType["VOUCHER_LESS"] = "VOUCHER_LESS";
})(ActivityRedemptionType || (ActivityRedemptionType = {}));
export var ActivityReviewSort;
(function (ActivityReviewSort) {
  ActivityReviewSort["HIGHEST_TO_LOWEST_RATED"] = "HIGHEST_TO_LOWEST_RATED";
  ActivityReviewSort["LOWEST_TO_HIGHEST_RATED"] = "LOWEST_TO_HIGHEST_RATED";
  ActivityReviewSort["NEWEST_TO_OLDEST"] = "NEWEST_TO_OLDEST";
})(ActivityReviewSort || (ActivityReviewSort = {}));
/** Search options that are not filters */
export var ActivitySearchOptions;
(function (ActivitySearchOptions) {
  /** @deprecated using ActivityGroupType now for filtering Activity Groups */
  ActivitySearchOptions["CATEGORY"] = "CATEGORY";
  ActivitySearchOptions["FILTER_NESTED_CATEGORIES"] = "FILTER_NESTED_CATEGORIES";
  ActivitySearchOptions["GAIA_RETURN_ADDITIONAL_DISTANCE_PARAMETER"] = "GAIA_RETURN_ADDITIONAL_DISTANCE_PARAMETER";
  ActivitySearchOptions["GIFTING_ACTIVITIES"] = "GIFTING_ACTIVITIES";
  /** @deprecated Guest Promotion is always true */
  ActivitySearchOptions["GUEST_PROMO"] = "GUEST_PROMO";
  ActivitySearchOptions["NON_CONSOLIDATED_OFFERS"] = "NON_CONSOLIDATED_OFFERS";
  ActivitySearchOptions["SHOP_WITH_POINTS"] = "SHOP_WITH_POINTS";
  ActivitySearchOptions["SHOW_GT_BANNER"] = "SHOW_GT_BANNER";
})(ActivitySearchOptions || (ActivitySearchOptions = {}));
/** Search view options that are not filters */
export var ActivitySearchViewOptions;
(function (ActivitySearchViewOptions) {
  ActivitySearchViewOptions["DISTANCE_FROM_HOTEL_TO_ACTIVITY"] = "DISTANCE_FROM_HOTEL_TO_ACTIVITY";
  ActivitySearchViewOptions["FILTER_NESTED_CATEGORIES"] = "FILTER_NESTED_CATEGORIES";
  ActivitySearchViewOptions["NEARBY_ACTIVITIES"] = "NEARBY_ACTIVITIES";
  ActivitySearchViewOptions["SHOP_WITH_POINTS"] = "SHOP_WITH_POINTS";
  ActivitySearchViewOptions["SHOW_GT_BANNER"] = "SHOW_GT_BANNER";
  ActivitySearchViewOptions["THIRD_PARTY_REVIEWS"] = "THIRD_PARTY_REVIEWS";
  ActivitySearchViewOptions["TRAVEL_DISTANCE_FROM_HOTEL"] = "TRAVEL_DISTANCE_FROM_HOTEL";
})(ActivitySearchViewOptions || (ActivitySearchViewOptions = {}));
/** Activity sort types */
export var ActivitySort;
(function (ActivitySort) {
  ActivitySort["CAMPAIGN_DEALS"] = "CAMPAIGN_DEALS";
  ActivitySort["DISCOUNT"] = "DISCOUNT";
  ActivitySort["DISTANCE_FROM_HOTEL"] = "DISTANCE_FROM_HOTEL";
  ActivitySort["PRICE_HIGH_TO_LOW"] = "PRICE_HIGH_TO_LOW";
  ActivitySort["PRICE_LOW_TO_HIGH"] = "PRICE_LOW_TO_HIGH";
  ActivitySort["RECOMMENDED"] = "RECOMMENDED";
})(ActivitySort || (ActivitySort = {}));
export var ActivityTextAlignment;
(function (ActivityTextAlignment) {
  ActivityTextAlignment["CENTRE"] = "CENTRE";
  ActivityTextAlignment["LEFT"] = "LEFT";
  ActivityTextAlignment["RIGHT"] = "RIGHT";
})(ActivityTextAlignment || (ActivityTextAlignment = {}));
export var ActivityTextSize;
(function (ActivityTextSize) {
  ActivityTextSize["LARGE"] = "LARGE";
  ActivityTextSize["MEDIUM"] = "MEDIUM";
  ActivityTextSize["SMALL"] = "SMALL";
})(ActivityTextSize || (ActivityTextSize = {}));
export var ActivityUdsToken;
(function (ActivityUdsToken) {
  ActivityUdsToken["MULTI_SELECT_LIST"] = "MULTI_SELECT_LIST";
  ActivityUdsToken["MULTI_SELECT_RANGE"] = "MULTI_SELECT_RANGE";
  ActivityUdsToken["SINGLE_SELECT"] = "SINGLE_SELECT";
  ActivityUdsToken["TEXT"] = "TEXT";
})(ActivityUdsToken || (ActivityUdsToken = {}));
/** Enum representing the flow of handling an ad copy */
export var AdCopyHandleFlow;
(function (AdCopyHandleFlow) {
  /** Represents the approval flow */
  AdCopyHandleFlow["APPROVED"] = "APPROVED";
  /** Represents the rejection flow */
  AdCopyHandleFlow["DENIED"] = "DENIED";
})(AdCopyHandleFlow || (AdCopyHandleFlow = {}));
export var AdType;
(function (AdType) {
  AdType["FLIGHT_SPONSORED_LISTING"] = "FLIGHT_SPONSORED_LISTING";
  AdType["LODGING_BRAND_RESULT_LISTING"] = "LODGING_BRAND_RESULT_LISTING";
  AdType["LODGING_SPONSORED_LISTING"] = "LODGING_SPONSORED_LISTING";
  AdType["UNKNOWN"] = "UNKNOWN";
})(AdType || (AdType = {}));
/** Represents values for add ons */
export var AddOnRequested;
(function (AddOnRequested) {
  AddOnRequested["CB1"] = "CB1";
  AddOnRequested["COB"] = "COB";
  AddOnRequested["SC"] = "SC";
})(AddOnRequested || (AddOnRequested = {}));
/** Represents the type of mutation to be performed on JCID with the additional Products */
export var AdditionalProductsOperationType;
(function (AdditionalProductsOperationType) {
  AdditionalProductsOperationType["ADD"] = "ADD";
  AdditionalProductsOperationType["REMOVE"] = "REMOVE";
})(AdditionalProductsOperationType || (AdditionalProductsOperationType = {}));
export var AdditionalShoppedAncillaries;
(function (AdditionalShoppedAncillaries) {
  AdditionalShoppedAncillaries["FIRST_CHECKED_BAG"] = "FIRST_CHECKED_BAG";
})(AdditionalShoppedAncillaries || (AdditionalShoppedAncillaries = {}));
export var AdditionalShopping;
(function (AdditionalShopping) {
  AdditionalShopping["FIRST_CHECKED_BAG"] = "FIRST_CHECKED_BAG";
})(AdditionalShopping || (AdditionalShopping = {}));
export var AdjustmentType;
(function (AdjustmentType) {
  AdjustmentType["NIGHTLY"] = "Nightly";
  AdjustmentType["PERSTAY"] = "PerStay";
})(AdjustmentType || (AdjustmentType = {}));
export var AdvertiserPortalPageInput;
(function (AdvertiserPortalPageInput) {
  AdvertiserPortalPageInput["ONBOARDING"] = "ONBOARDING";
  AdvertiserPortalPageInput["STANDALONE"] = "STANDALONE";
})(AdvertiserPortalPageInput || (AdvertiserPortalPageInput = {}));
export var AdvertiserPortalResponseStatus;
(function (AdvertiserPortalResponseStatus) {
  AdvertiserPortalResponseStatus["FAILURE"] = "FAILURE";
  AdvertiserPortalResponseStatus["SUCCESS"] = "SUCCESS";
})(AdvertiserPortalResponseStatus || (AdvertiserPortalResponseStatus = {}));
export var AdvertiserReportingContext;
(function (AdvertiserReportingContext) {
  AdvertiserReportingContext["FLIGHTS"] = "FLIGHTS";
  AdvertiserReportingContext["LODGING_SPONSORED_LISTINGS"] = "LODGING_SPONSORED_LISTINGS";
})(AdvertiserReportingContext || (AdvertiserReportingContext = {}));
export var AdvertiserReportingGroupBy;
(function (AdvertiserReportingGroupBy) {
  AdvertiserReportingGroupBy["AD"] = "AD";
  AdvertiserReportingGroupBy["AD_GROUP"] = "AD_GROUP";
  AdvertiserReportingGroupBy["CAMPAIGN"] = "CAMPAIGN";
  AdvertiserReportingGroupBy["COUNTRY_CODE"] = "COUNTRY_CODE";
  AdvertiserReportingGroupBy["PERIOD"] = "PERIOD";
})(AdvertiserReportingGroupBy || (AdvertiserReportingGroupBy = {}));
export var AdvertiserReportingLevel;
(function (AdvertiserReportingLevel) {
  AdvertiserReportingLevel["AD"] = "AD";
  AdvertiserReportingLevel["AD_GROUP"] = "AD_GROUP";
  AdvertiserReportingLevel["CAMPAIGN"] = "CAMPAIGN";
  AdvertiserReportingLevel["CAMPAIGN_AND_AD_GROUP"] = "CAMPAIGN_AND_AD_GROUP";
})(AdvertiserReportingLevel || (AdvertiserReportingLevel = {}));
export var AffiliatesChannelType;
(function (AffiliatesChannelType) {
  AffiliatesChannelType["ANDROID"] = "ANDROID";
  AffiliatesChannelType["IOS"] = "IOS";
  AffiliatesChannelType["WEB"] = "WEB";
})(AffiliatesChannelType || (AffiliatesChannelType = {}));
export var AffiliatesCheckFailureType;
(function (AffiliatesCheckFailureType) {
  AffiliatesCheckFailureType["PARTNER_NOT_LINKED"] = "PARTNER_NOT_LINKED";
  AffiliatesCheckFailureType["STATUS_NOT_APPROVED"] = "STATUS_NOT_APPROVED";
  AffiliatesCheckFailureType["TOOL_DISABLED"] = "TOOL_DISABLED";
})(AffiliatesCheckFailureType || (AffiliatesCheckFailureType = {}));
export var AffiliatesIconPlacement;
(function (AffiliatesIconPlacement) {
  AffiliatesIconPlacement["LEADING"] = "LEADING";
  AffiliatesIconPlacement["TRAILING"] = "TRAILING";
})(AffiliatesIconPlacement || (AffiliatesIconPlacement = {}));
export var AgencyBusinessModel;
(function (AgencyBusinessModel) {
  AgencyBusinessModel["EXPEDIA_COLLECT"] = "EXPEDIA_COLLECT";
  AgencyBusinessModel["HOTEL_COLLECT"] = "HOTEL_COLLECT";
})(AgencyBusinessModel || (AgencyBusinessModel = {}));
/** Parameters for header cells for the records to be sorted in ascending, descending or to be unsorted manner */
export var AgencyQuoteListSortType;
(function (AgencyQuoteListSortType) {
  AgencyQuoteListSortType["ASCENDING"] = "ASCENDING";
  AgencyQuoteListSortType["DESCENDING"] = "DESCENDING";
  AgencyQuoteListSortType["NOT_SORTED"] = "NOT_SORTED";
})(AgencyQuoteListSortType || (AgencyQuoteListSortType = {}));
/** The type of message line */
export var AgencyServiceChargeMessageLineType;
(function (AgencyServiceChargeMessageLineType) {
  AgencyServiceChargeMessageLineType["ERROR"] = "ERROR";
  AgencyServiceChargeMessageLineType["WARNING"] = "WARNING";
})(AgencyServiceChargeMessageLineType || (AgencyServiceChargeMessageLineType = {}));
export var AgentStateType;
(function (AgentStateType) {
  AgentStateType["NOTREADY"] = "NotReady";
  AgentStateType["OFFLINE"] = "Offline";
  AgentStateType["READY"] = "Ready";
})(AgentStateType || (AgentStateType = {}));
export var AgentToolsChannelType;
(function (AgentToolsChannelType) {
  AgentToolsChannelType["CHAT"] = "CHAT";
  AgentToolsChannelType["EMAIL"] = "EMAIL";
  AgentToolsChannelType["SMS"] = "SMS";
  AgentToolsChannelType["VOICE"] = "VOICE";
})(AgentToolsChannelType || (AgentToolsChannelType = {}));
export var AgentToolsLodgingActionType;
(function (AgentToolsLodgingActionType) {
  AgentToolsLodgingActionType["CANCEL"] = "Cancel";
  AgentToolsLodgingActionType["DATECHANGE"] = "DateChange";
  AgentToolsLodgingActionType["OCCUPANCYCHANGE"] = "OccupancyChange";
  AgentToolsLodgingActionType["ROOMTYPECHANGE"] = "RoomTypeChange";
})(AgentToolsLodgingActionType || (AgentToolsLodgingActionType = {}));
export var AgentToolsPaymentFlow;
(function (AgentToolsPaymentFlow) {
  AgentToolsPaymentFlow["PAYMENT_ASSIST"] = "PAYMENT_ASSIST";
  AgentToolsPaymentFlow["PAYMENT_VERIFICATION"] = "PAYMENT_VERIFICATION";
})(AgentToolsPaymentFlow || (AgentToolsPaymentFlow = {}));
export var AgentToolsSummaryCardComponentType;
(function (AgentToolsSummaryCardComponentType) {
  AgentToolsSummaryCardComponentType["FLIGHT_CANCEL"] = "FLIGHT_CANCEL";
  AgentToolsSummaryCardComponentType["LODGING_CANCEL"] = "LODGING_CANCEL";
  AgentToolsSummaryCardComponentType["LODGING_CHANGE"] = "LODGING_CHANGE";
})(AgentToolsSummaryCardComponentType || (AgentToolsSummaryCardComponentType = {}));
/** Airport location type chosen in flight search. */
export var AirportLocationType;
(function (AirportLocationType) {
  AirportLocationType["AIRPORT"] = "AIRPORT";
  AirportLocationType["METROCODE"] = "METROCODE";
  AirportLocationType["UNSPECIFIED"] = "UNSPECIFIED";
})(AirportLocationType || (AirportLocationType = {}));
export var Alignment;
(function (Alignment) {
  Alignment["CENTER"] = "CENTER";
  Alignment["LEFT"] = "LEFT";
  Alignment["RIGHT"] = "RIGHT";
})(Alignment || (Alignment = {}));
/** Specifies the behavior of ALTER, which is used to run Abacus experiments on localization messages. */
export var AlterMode;
(function (AlterMode) {
  /** Localization messages will be replaced with their namespace and loc key. */
  AlterMode["DEBUG"] = "DEBUG";
  /** None of the ALTER experiments will be used when resolving localization messages. */
  AlterMode["NONE"] = "NONE";
  /** Both released and draft ALTER experiments will be used when resolving localization messages. */
  AlterMode["PREVIEW"] = "PREVIEW";
  /** This is the default. Only released ALTER experiments will be used when resolving localization messages. */
  AlterMode["RELEASED"] = "RELEASED";
})(AlterMode || (AlterMode = {}));
/** List of all the managed link type. */
export var AlternativeLinkType;
(function (AlternativeLinkType) {
  AlternativeLinkType["ALTERNATIVE_ACCOMMODATION"] = "ALTERNATIVE_ACCOMMODATION";
  AlternativeLinkType["ALTERNATIVE_LOBS"] = "ALTERNATIVE_LOBS";
})(AlternativeLinkType || (AlternativeLinkType = {}));
export var AmenityCategory;
(function (AmenityCategory) {
  AmenityCategory["ACCESSIBLE_ROLL_IN_SHOWER"] = "ACCESSIBLE_ROLL_IN_SHOWER";
  AmenityCategory["AIR_CONDITIONING"] = "AIR_CONDITIONING";
  AmenityCategory["ALL_INCLUSIVE"] = "ALL_INCLUSIVE";
  AmenityCategory["ARCADE"] = "ARCADE";
  AmenityCategory["BABYSITTING"] = "BABYSITTING";
  AmenityCategory["BAR"] = "BAR";
  AmenityCategory["BARBECUE"] = "BARBECUE";
  AmenityCategory["BOWLING"] = "BOWLING";
  AmenityCategory["BREAKFAST_AVAILABLE"] = "BREAKFAST_AVAILABLE";
  AmenityCategory["BREAKFAST_INCLUDED"] = "BREAKFAST_INCLUDED";
  AmenityCategory["BREAKFAST_NOT_AVAILABLE"] = "BREAKFAST_NOT_AVAILABLE";
  AmenityCategory["BUSINESS_SERVICES"] = "BUSINESS_SERVICES";
  AmenityCategory["CHILDREN_CLUB"] = "CHILDREN_CLUB";
  AmenityCategory["DAILY_HOUSEKEEPING"] = "DAILY_HOUSEKEEPING";
  AmenityCategory["EXTRA_BED"] = "EXTRA_BED";
  AmenityCategory["FIRE_PLACE"] = "FIRE_PLACE";
  AmenityCategory["FITNESS_EQUIPMENT"] = "FITNESS_EQUIPMENT";
  AmenityCategory["FREE_AIRPORT_TRANSPORTATION"] = "FREE_AIRPORT_TRANSPORTATION";
  AmenityCategory["FREE_BREAKFAST"] = "FREE_BREAKFAST";
  AmenityCategory["FREE_CANCEL"] = "FREE_CANCEL";
  AmenityCategory["FREE_PARKING"] = "FREE_PARKING";
  AmenityCategory["FREE_WELCOME_DRINK"] = "FREE_WELCOME_DRINK";
  AmenityCategory["FREE_WIRED_INTERNET"] = "FREE_WIRED_INTERNET";
  AmenityCategory["FRONT_DESK_24_HOURS"] = "FRONT_DESK_24_HOURS";
  AmenityCategory["GROCERY"] = "GROCERY";
  AmenityCategory["HIGH_SPEED_INTERNET"] = "HIGH_SPEED_INTERNET";
  AmenityCategory["HOT_TUB"] = "HOT_TUB";
  AmenityCategory["INTERNET_NOT_AVAILABLE"] = "INTERNET_NOT_AVAILABLE";
  AmenityCategory["IN_ROOM_INTERNET"] = "IN_ROOM_INTERNET";
  AmenityCategory["KIDS_POOL"] = "KIDS_POOL";
  AmenityCategory["KITCHEN"] = "KITCHEN";
  AmenityCategory["LAUNDRY"] = "LAUNDRY";
  AmenityCategory["LIVING_AREA"] = "LIVING_AREA";
  AmenityCategory["MICROWAVE"] = "MICROWAVE";
  AmenityCategory["MINI_GOLF"] = "MINI_GOLF";
  AmenityCategory["NON_REFUNDABLE"] = "NON_REFUNDABLE";
  AmenityCategory["ON_PRIVATE_BEACH"] = "ON_PRIVATE_BEACH";
  AmenityCategory["ON_THE_BEACH"] = "ON_THE_BEACH";
  AmenityCategory["OUTDOOR_SPACE"] = "OUTDOOR_SPACE";
  AmenityCategory["PARKING"] = "PARKING";
  AmenityCategory["PARTIAL_REFUND"] = "PARTIAL_REFUND";
  AmenityCategory["PETS_ALLOWED"] = "PETS_ALLOWED";
  AmenityCategory["PLAYGROUND"] = "PLAYGROUND";
  AmenityCategory["POOL"] = "POOL";
  AmenityCategory["RESERVE_NOW_PAY_DEPOSIT"] = "RESERVE_NOW_PAY_DEPOSIT";
  AmenityCategory["RESERVE_NOW_PAY_LATER"] = "RESERVE_NOW_PAY_LATER";
  AmenityCategory["RESTAURANT_IN_HOTEL"] = "RESTAURANT_IN_HOTEL";
  AmenityCategory["ROOM_SERVICE"] = "ROOM_SERVICE";
  AmenityCategory["SMOKE_FREE"] = "SMOKE_FREE";
  AmenityCategory["SOUNDPROOF_ROOM"] = "SOUNDPROOF_ROOM";
  AmenityCategory["SPA_SERVICES_ON_SITE"] = "SPA_SERVICES_ON_SITE";
  AmenityCategory["SPECIAL_DEAL"] = "SPECIAL_DEAL";
  AmenityCategory["TENNIS_COURT"] = "TENNIS_COURT";
  AmenityCategory["TOYS"] = "TOYS";
  AmenityCategory["WASHER"] = "WASHER";
  AmenityCategory["WATERSLIDE"] = "WATERSLIDE";
  AmenityCategory["WIFI_SURCHARGE"] = "WIFI_SURCHARGE";
  AmenityCategory["WIRED_INTERNET_SURCHARGE"] = "WIRED_INTERNET_SURCHARGE";
})(AmenityCategory || (AmenityCategory = {}));
export var AmenityFilter;
(function (AmenityFilter) {
  AmenityFilter["CARRY_ON_BAG"] = "CARRY_ON_BAG";
  AmenityFilter["INVALID"] = "INVALID";
  AmenityFilter["NO_CANCEL_FEE"] = "NO_CANCEL_FEE";
  AmenityFilter["NO_CHANGE_FEE"] = "NO_CHANGE_FEE";
  AmenityFilter["SEAT_CHOICE"] = "SEAT_CHOICE";
})(AmenityFilter || (AmenityFilter = {}));
/** represents the bag template analytics keys */
export var AnalyticsKey;
(function (AnalyticsKey) {
  /** Represents the analytics key for number of bags per traveller */
  AnalyticsKey["NUMBER_OF_BAGS"] = "NUMBER_OF_BAGS";
  /** Represents the analytics key for piece or weight selling model criteria analytics per traveller */
  AnalyticsKey["PIECE_OR_WEIGHT_CONCEPT"] = "PIECE_OR_WEIGHT_CONCEPT";
  /** Represents the analytics key for quantity of bags per traveller (NONE/SOME/ALL) */
  AnalyticsKey["QUANTITY_OF_BAGS"] = "QUANTITY_OF_BAGS";
})(AnalyticsKey || (AnalyticsKey = {}));
/** Represents path plus page for where ancillaries will be shopped. */
export var AncillaryShoppingPath;
(function (AncillaryShoppingPath) {
  AncillaryShoppingPath["PACKAGE_INFOSITE"] = "PACKAGE_INFOSITE";
  AncillaryShoppingPath["PACKAGE_TRIPS"] = "PACKAGE_TRIPS";
  AncillaryShoppingPath["STANDALONE_INFOSITE"] = "STANDALONE_INFOSITE";
  AncillaryShoppingPath["STANDALONE_TRIPS"] = "STANDALONE_TRIPS";
})(AncillaryShoppingPath || (AncillaryShoppingPath = {}));
export var AnnualSummaryCardId;
(function (AnnualSummaryCardId) {
  AnnualSummaryCardId["END_TRANSITION"] = "END_TRANSITION";
  AnnualSummaryCardId["INTRO_TRENDS_1"] = "INTRO_TRENDS_1";
  AnnualSummaryCardId["INTRO_TRENDS_2"] = "INTRO_TRENDS_2";
  AnnualSummaryCardId["INTRO_TRENDS_3"] = "INTRO_TRENDS_3";
  AnnualSummaryCardId["INTRO_TRENDS_4"] = "INTRO_TRENDS_4";
  AnnualSummaryCardId["INTRO_TRENDS_5"] = "INTRO_TRENDS_5";
  AnnualSummaryCardId["LOOK_FORWARD_DEST1"] = "LOOK_FORWARD_DEST1";
  AnnualSummaryCardId["LOOK_FORWARD_DEST2"] = "LOOK_FORWARD_DEST2";
  AnnualSummaryCardId["LOOK_FORWARD_DEST3"] = "LOOK_FORWARD_DEST3";
  AnnualSummaryCardId["LOOK_FORWARD_LANDING"] = "LOOK_FORWARD_LANDING";
  AnnualSummaryCardId["LOOK_FORWARD_TRANSITION"] = "LOOK_FORWARD_TRANSITION";
  AnnualSummaryCardId["PLAYBACK_FLIGHTS"] = "PLAYBACK_FLIGHTS";
  AnnualSummaryCardId["PLAYBACK_MAPS"] = "PLAYBACK_MAPS";
  AnnualSummaryCardId["PLAYBACK_MONTH"] = "PLAYBACK_MONTH";
  AnnualSummaryCardId["PLAYBACK_PERCENTILE_FLIGHTS"] = "PLAYBACK_PERCENTILE_FLIGHTS";
  AnnualSummaryCardId["PLAYBACK_PERCENTILE_STAYS"] = "PLAYBACK_PERCENTILE_STAYS";
  AnnualSummaryCardId["PLAYBACK_SHARE"] = "PLAYBACK_SHARE";
  AnnualSummaryCardId["PLAYBACK_SINGLE_TRIP_COVER"] = "PLAYBACK_SINGLE_TRIP_COVER";
  AnnualSummaryCardId["PLAYBACK_SINGLE_TRIP_DESTINATION"] = "PLAYBACK_SINGLE_TRIP_DESTINATION";
  AnnualSummaryCardId["PLAYBACK_STAYS"] = "PLAYBACK_STAYS";
  AnnualSummaryCardId["PLAYBACK_TRANSITION"] = "PLAYBACK_TRANSITION";
  AnnualSummaryCardId["RECS_1"] = "RECS_1";
  AnnualSummaryCardId["RECS_2"] = "RECS_2";
  AnnualSummaryCardId["RECS_3"] = "RECS_3";
  AnnualSummaryCardId["RECS_TRANSITION"] = "RECS_TRANSITION";
})(AnnualSummaryCardId || (AnnualSummaryCardId = {}));
export var AnnualSummaryPageType;
(function (AnnualSummaryPageType) {
  AnnualSummaryPageType["HOME_PAGE"] = "HOME_PAGE";
  AnnualSummaryPageType["PROFILE_PAGE"] = "PROFILE_PAGE";
})(AnnualSummaryPageType || (AnnualSummaryPageType = {}));
export var AnnualSummaryPlayBackSummaryType;
(function (AnnualSummaryPlayBackSummaryType) {
  AnnualSummaryPlayBackSummaryType["MULTIPLE_TRIPS"] = "MULTIPLE_TRIPS";
  AnnualSummaryPlayBackSummaryType["ONE_TRIP"] = "ONE_TRIP";
})(AnnualSummaryPlayBackSummaryType || (AnnualSummaryPlayBackSummaryType = {}));
/** Represents a section type in the annual summary */
export var AnnualSummarySectionType;
(function (AnnualSummarySectionType) {
  AnnualSummarySectionType["END"] = "END";
  AnnualSummarySectionType["INTRO_TRENDS"] = "INTRO_TRENDS";
  AnnualSummarySectionType["LOOK_FORWARD"] = "LOOK_FORWARD";
  AnnualSummarySectionType["PLAYBACK"] = "PLAYBACK";
  AnnualSummarySectionType["RECS"] = "RECS";
})(AnnualSummarySectionType || (AnnualSummarySectionType = {}));
export var AppGrowthBorderShape;
(function (AppGrowthBorderShape) {
  AppGrowthBorderShape["ROUNDED"] = "ROUNDED";
  AppGrowthBorderShape["SQUARE"] = "SQUARE";
})(AppGrowthBorderShape || (AppGrowthBorderShape = {}));
export var AppGrowthBorderStyle;
(function (AppGrowthBorderStyle) {
  AppGrowthBorderStyle["BOLD"] = "BOLD";
  AppGrowthBorderStyle["DEFAULT"] = "DEFAULT";
  AppGrowthBorderStyle["NONE"] = "NONE";
})(AppGrowthBorderStyle || (AppGrowthBorderStyle = {}));
export var AppGrowthLineOfBusiness;
(function (AppGrowthLineOfBusiness) {
  AppGrowthLineOfBusiness["ACTIVITIES"] = "ACTIVITIES";
  AppGrowthLineOfBusiness["CAR"] = "CAR";
  AppGrowthLineOfBusiness["CRUISES"] = "CRUISES";
  AppGrowthLineOfBusiness["DEFAULT"] = "DEFAULT";
  AppGrowthLineOfBusiness["FLIGHT"] = "FLIGHT";
  AppGrowthLineOfBusiness["GROUNDTRANSFERS"] = "GROUNDTRANSFERS";
  AppGrowthLineOfBusiness["HOTEL"] = "HOTEL";
  AppGrowthLineOfBusiness["PACKAGES"] = "PACKAGES";
  AppGrowthLineOfBusiness["RAILS"] = "RAILS";
  AppGrowthLineOfBusiness["UNCLASSIFIED"] = "UNCLASSIFIED";
})(AppGrowthLineOfBusiness || (AppGrowthLineOfBusiness = {}));
export var AppGrowthToolbarIcon;
(function (AppGrowthToolbarIcon) {
  AppGrowthToolbarIcon["BACK"] = "BACK";
  AppGrowthToolbarIcon["CLOSE"] = "CLOSE";
})(AppGrowthToolbarIcon || (AppGrowthToolbarIcon = {}));
export var AppGrowthToolbarStyle;
(function (AppGrowthToolbarStyle) {
  AppGrowthToolbarStyle["TRANSPARENT_ACTION_OVERLAY"] = "TRANSPARENT_ACTION_OVERLAY";
})(AppGrowthToolbarStyle || (AppGrowthToolbarStyle = {}));
/** type of action being performed */
export var AppGrowthUiActionName;
(function (AppGrowthUiActionName) {
  /** accept - used for notification prompt */
  AppGrowthUiActionName["ACCEPT"] = "ACCEPT";
  /** should perform a deeplink action */
  AppGrowthUiActionName["DEEPLINK"] = "DEEPLINK";
  /** deny - used for notification prompt */
  AppGrowthUiActionName["DENY"] = "DENY";
  /** exit travel trivia to app home */
  AppGrowthUiActionName["EXIT_TO_APP_HOME"] = "EXIT_TO_APP_HOME";
  /** go to dashboard action */
  AppGrowthUiActionName["GOTO_DASHBOARD"] = "GOTO_DASHBOARD";
  /** login and signup */
  AppGrowthUiActionName["LOGIN_AND_SIGNUP"] = "LOGIN_AND_SIGNUP";
  /** no action to perform - used then object sometimes has an action and other times doesn't */
  AppGrowthUiActionName["NONE"] = "NONE";
  /** ok action */
  AppGrowthUiActionName["OK"] = "OK";
  /** share action */
  AppGrowthUiActionName["SHARE"] = "SHARE";
  /** signup for travel trivia campaign */
  AppGrowthUiActionName["SIGNUP"] = "SIGNUP";
  /** submit trivia answer */
  AppGrowthUiActionName["TRIVIA_ANSWER"] = "TRIVIA_ANSWER";
  /** finish the trivia */
  AppGrowthUiActionName["TRIVIA_END"] = "TRIVIA_END";
  /** go to trivia how to play */
  AppGrowthUiActionName["TRIVIA_HOW_TO"] = "TRIVIA_HOW_TO";
  /** move to next trivia question */
  AppGrowthUiActionName["TRIVIA_NEXT"] = "TRIVIA_NEXT";
  /** go to trivia start */
  AppGrowthUiActionName["TRIVIA_START"] = "TRIVIA_START";
})(AppGrowthUiActionName || (AppGrowthUiActionName = {}));
export var ApprovalStatusType;
(function (ApprovalStatusType) {
  ApprovalStatusType["APPROVED"] = "APPROVED";
  ApprovalStatusType["DENIED"] = "DENIED";
  ApprovalStatusType["PENDING"] = "PENDING";
  ApprovalStatusType["UNKNOWN"] = "UNKNOWN";
})(ApprovalStatusType || (ApprovalStatusType = {}));
export var ArticleSearchType;
(function (ArticleSearchType) {
  ArticleSearchType["CONTEXTUAL_FOLLOW_UP"] = "CONTEXTUAL_FOLLOW_UP";
  ArticleSearchType["GENERIC"] = "GENERIC";
  /** @deprecated LLM search is deprecated and replaced with Intelligent Search */
  ArticleSearchType["LLM"] = "LLM";
})(ArticleSearchType || (ArticleSearchType = {}));
/** Possible aspect ratios of EGDS images */
export var AspectRatio;
(function (AspectRatio) {
  /** Aspect ratio 4:1 */
  AspectRatio["FOUR_ONE"] = "FOUR_ONE";
  /** Aspect ratio 4:3 */
  AspectRatio["FOUR_THREE"] = "FOUR_THREE";
  /** Aspect ratio 1:1 */
  AspectRatio["ONE_ONE"] = "ONE_ONE";
  /** Aspect ratio 16:9 */
  AspectRatio["SIXTEEN_NINE"] = "SIXTEEN_NINE";
  /** Aspect ratio 3:4 */
  AspectRatio["THREE_FOUR"] = "THREE_FOUR";
  /** Aspect ratio 3:2 */
  AspectRatio["THREE_TWO"] = "THREE_TWO";
  /** Aspect ratio 21:9 */
  AspectRatio["TWENTY_ONE_NINE"] = "TWENTY_ONE_NINE";
})(AspectRatio || (AspectRatio = {}));
export var AtoChallengePlacement;
(function (AtoChallengePlacement) {
  AtoChallengePlacement["DIRECTFEEDBACKSUBMITFORMACTION"] = "DirectFeedbackSubmitFormAction";
})(AtoChallengePlacement || (AtoChallengePlacement = {}));
export var AuthStepIdentifier;
(function (AuthStepIdentifier) {
  AuthStepIdentifier["ACCOUNT_MERGE"] = "ACCOUNT_MERGE";
  AuthStepIdentifier["ADD_PHONE"] = "ADD_PHONE";
  AuthStepIdentifier["CREATE_PASSWORD"] = "CREATE_PASSWORD";
  AuthStepIdentifier["ONE_KEY"] = "ONE_KEY";
  AuthStepIdentifier["ORIGIN"] = "ORIGIN";
  AuthStepIdentifier["PROFILE_DETAILS"] = "PROFILE_DETAILS";
})(AuthStepIdentifier || (AuthStepIdentifier = {}));
export var AuthenticationFlowVariant;
(function (AuthenticationFlowVariant) {
  /** DEFAULT will be used when we want AuthenticationFlowVariant to be server driven */
  AuthenticationFlowVariant["DEFAULT"] = "DEFAULT";
  AuthenticationFlowVariant["EMAIL_OTP_DEFAULT"] = "EMAIL_OTP_DEFAULT";
  AuthenticationFlowVariant["EMAIL_OTP_WITH_PHONE_AUTH"] = "EMAIL_OTP_WITH_PHONE_AUTH";
  AuthenticationFlowVariant["PASSWORD_DEFAULT"] = "PASSWORD_DEFAULT";
  AuthenticationFlowVariant["PASSWORD_WITH_PHONE_AUTH"] = "PASSWORD_WITH_PHONE_AUTH";
  AuthenticationFlowVariant["SMS_OTP_DEFAULT"] = "SMS_OTP_DEFAULT";
})(AuthenticationFlowVariant || (AuthenticationFlowVariant = {}));
export var AuthenticationState;
(function (AuthenticationState) {
  AuthenticationState["ANONYMOUS"] = "ANONYMOUS";
  AuthenticationState["AUTHENTICATED"] = "AUTHENTICATED";
  AuthenticationState["IDENTIFIED"] = "IDENTIFIED";
})(AuthenticationState || (AuthenticationState = {}));
/** supported sizes of avatars */
export var AvatarSize;
(function (AvatarSize) {
  AvatarSize["LARGE"] = "LARGE";
  AvatarSize["MEDIUM"] = "MEDIUM";
  AvatarSize["SMALL"] = "SMALL";
  AvatarSize["XLARGE"] = "XLARGE";
})(AvatarSize || (AvatarSize = {}));
/** Background styles for the cards */
export var BackgroundType;
(function (BackgroundType) {
  BackgroundType["PRIMARY"] = "PRIMARY";
  BackgroundType["SECONDARY"] = "SECONDARY";
})(BackgroundType || (BackgroundType = {}));
export var BadgeIcon;
(function (BadgeIcon) {
  BadgeIcon["ACCESS_TIME"] = "ACCESS_TIME";
  BadgeIcon["ADD"] = "ADD";
  BadgeIcon["BUNDLED_SAVINGS_PLUS"] = "BUNDLED_SAVINGS_PLUS";
  BadgeIcon["EXP29639_ORB"] = "EXP29639_ORB";
  BadgeIcon["FAMILY_FRIENDLY"] = "FAMILY_FRIENDLY";
  BadgeIcon["INFO_OUTLINE"] = "INFO_OUTLINE";
  BadgeIcon["LOB_DEALS"] = "LOB_DEALS";
  BadgeIcon["LOCAL_OFFER"] = "LOCAL_OFFER";
  BadgeIcon["MOD"] = "MOD";
  BadgeIcon["SMARTPHONE"] = "SMARTPHONE";
})(BadgeIcon || (BadgeIcon = {}));
export var BadgeThemes;
(function (BadgeThemes) {
  BadgeThemes["DEFAULT"] = "DEFAULT";
  BadgeThemes["FEATURED"] = "FEATURED";
  BadgeThemes["INFO"] = "INFO";
  BadgeThemes["POSITIVE"] = "POSITIVE";
  BadgeThemes["WARNING"] = "WARNING";
})(BadgeThemes || (BadgeThemes = {}));
/** Represents the baggage type */
export var BaggageType;
(function (BaggageType) {
  /** Baggage type for carry bag */
  BaggageType["CARRY_BAG"] = "CARRY_BAG";
  /** Baggage type for checked bag */
  BaggageType["CHECKED_BAG"] = "CHECKED_BAG";
  /** Baggage type for Personal item */
  BaggageType["PERSONAL_ITEM"] = "PERSONAL_ITEM";
  /** Default value for baggage type */
  BaggageType["UNKNOWN"] = "UNKNOWN";
})(BaggageType || (BaggageType = {}));
/** Represents the quantity of bags to be sent in analytics none/some/all */
export var BagsSelectionType;
(function (BagsSelectionType) {
  BagsSelectionType["ALL"] = "ALL";
  BagsSelectionType["NONE"] = "NONE";
  BagsSelectionType["SOME"] = "SOME";
})(BagsSelectionType || (BagsSelectionType = {}));
export var BannerDisplayType;
(function (BannerDisplayType) {
  BannerDisplayType["ERROR"] = "ERROR";
  BannerDisplayType["INFO"] = "INFO";
  BannerDisplayType["NO_BANNER"] = "NO_BANNER";
  BannerDisplayType["WARN"] = "WARN";
})(BannerDisplayType || (BannerDisplayType = {}));
export var BannerLocation;
(function (BannerLocation) {
  BannerLocation["HOME"] = "HOME";
  BannerLocation["TRIP_CONFIRMATION"] = "TRIP_CONFIRMATION";
  BannerLocation["TRIP_LIST"] = "TRIP_LIST";
})(BannerLocation || (BannerLocation = {}));
export var BannerTag;
(function (BannerTag) {
  BannerTag["AD"] = "AD";
  BannerTag["AD_GROUP"] = "AD_GROUP";
  BannerTag["CAMPAIGN"] = "CAMPAIGN";
})(BannerTag || (BannerTag = {}));
export var BannerTheme;
(function (BannerTheme) {
  BannerTheme["BRAND_PROMO_PRIMARY"] = "BRAND_PROMO_PRIMARY";
  BannerTheme["PRIMARY"] = "PRIMARY";
  BannerTheme["SECONDARY"] = "SECONDARY";
})(BannerTheme || (BannerTheme = {}));
export var BannerThemes;
(function (BannerThemes) {
  BannerThemes["CRITICAL"] = "CRITICAL";
  BannerThemes["ERROR"] = "ERROR";
})(BannerThemes || (BannerThemes = {}));
export var BannerType;
(function (BannerType) {
  BannerType["ERROR"] = "ERROR";
  BannerType["INFO"] = "INFO";
})(BannerType || (BannerType = {}));
/** Represents the views that the accept path supports */
export var BookingServicingAcceptViews;
(function (BookingServicingAcceptViews) {
  BookingServicingAcceptViews["CONFIRMATION"] = "CONFIRMATION";
  BookingServicingAcceptViews["HEADS_UP"] = "HEADS_UP";
  BookingServicingAcceptViews["REVIEW"] = "REVIEW";
})(BookingServicingAcceptViews || (BookingServicingAcceptViews = {}));
export var BookingServicingButtonModifier;
(function (BookingServicingButtonModifier) {
  /** The button renders disabled while the action is being loaded from a parent component. */
  BookingServicingButtonModifier["ACTION_LAZY_LOADED"] = "ACTION_LAZY_LOADED";
})(BookingServicingButtonModifier || (BookingServicingButtonModifier = {}));
/** The path for cancellation that will be performed by the traveler */
export var BookingServicingCancelType;
(function (BookingServicingCancelType) {
  /** Represents the type for Involuntary/ASC Cancel */
  BookingServicingCancelType["INVOLUNTARY"] = "INVOLUNTARY";
  /** Represents the type for Voluntary Cancel */
  BookingServicingCancelType["VOLUNTARY"] = "VOLUNTARY";
})(BookingServicingCancelType || (BookingServicingCancelType = {}));
/** Represents the views that the cancellation path supports */
export var BookingServicingCancelViews;
(function (BookingServicingCancelViews) {
  BookingServicingCancelViews["CONFIRMATION"] = "CONFIRMATION";
  BookingServicingCancelViews["HEADS_UP"] = "HEADS_UP";
  BookingServicingCancelViews["REVIEW"] = "REVIEW";
})(BookingServicingCancelViews || (BookingServicingCancelViews = {}));
export var BookingServicingCardTheme;
(function (BookingServicingCardTheme) {
  /** Represents negative theme for the BookingServicingCard */
  BookingServicingCardTheme["NEGATIVE"] = "NEGATIVE";
})(BookingServicingCardTheme || (BookingServicingCardTheme = {}));
/** Represents the views the change lodging path supports */
export var BookingServicingChangeLodgingViews;
(function (BookingServicingChangeLodgingViews) {
  BookingServicingChangeLodgingViews["TRAVELER_DETAILS"] = "TRAVELER_DETAILS";
})(BookingServicingChangeLodgingViews || (BookingServicingChangeLodgingViews = {}));
/** Represents the views that the change path supports */
export var BookingServicingChangeViews;
(function (BookingServicingChangeViews) {
  BookingServicingChangeViews["CHANGE_FORM"] = "CHANGE_FORM";
})(BookingServicingChangeViews || (BookingServicingChangeViews = {}));
export var BookingServicingClient;
(function (BookingServicingClient) {
  /** Represents virtual agent domain */
  BookingServicingClient["VIRTUAL_AGENT"] = "VIRTUAL_AGENT";
  /** Represents VNEXT domain */
  BookingServicingClient["VNEXT"] = "VNEXT";
  /** Represents web domain */
  BookingServicingClient["WEB"] = "WEB";
})(BookingServicingClient || (BookingServicingClient = {}));
/** Represents the requirement to decide the view for the details query input */
export var BookingServicingDetailsStrategy;
(function (BookingServicingDetailsStrategy) {
  /** Represents the booking details view when we need the details collapsed in an expando */
  BookingServicingDetailsStrategy["BOOKING_COLLAPSED_DETAILS"] = "BOOKING_COLLAPSED_DETAILS";
  /** Represents the booking details view for the details query input */
  BookingServicingDetailsStrategy["BOOKING_DETAILS"] = "BOOKING_DETAILS";
  /** Represents the booking and price details view for the details query input */
  BookingServicingDetailsStrategy["BOOKING_PRICE_DETAILS"] = "BOOKING_PRICE_DETAILS";
})(BookingServicingDetailsStrategy || (BookingServicingDetailsStrategy = {}));
/** Represents the different types of dialog behaviors */
export var BookingServicingDialogActionType;
(function (BookingServicingDialogActionType) {
  BookingServicingDialogActionType["CLOSE"] = "CLOSE";
  BookingServicingDialogActionType["OPEN"] = "OPEN";
  BookingServicingDialogActionType["TOGGLE"] = "TOGGLE";
})(BookingServicingDialogActionType || (BookingServicingDialogActionType = {}));
/** Represents the type of validation to be performed */
export var BookingServicingDynamicConditionValidation;
(function (BookingServicingDynamicConditionValidation) {
  /** Represents if we need to validate a equal to validation */
  BookingServicingDynamicConditionValidation["EQUAL"] = "EQUAL";
})(BookingServicingDynamicConditionValidation || (BookingServicingDynamicConditionValidation = {}));
/** Represents the input state */
export var BookingServicingDynamicState;
(function (BookingServicingDynamicState) {
  /** The input is hidden */
  BookingServicingDynamicState["HIDDEN"] = "HIDDEN";
  /** The input is rendered */
  BookingServicingDynamicState["VISIBLE"] = "VISIBLE";
})(BookingServicingDynamicState || (BookingServicingDynamicState = {}));
export var BookingServicingExternalComponents;
(function (BookingServicingExternalComponents) {
  BookingServicingExternalComponents["ADDITIONAL_INFORMATION"] = "ADDITIONAL_INFORMATION";
  BookingServicingExternalComponents["CURRENT_FLIGHT_DETAILS"] = "CURRENT_FLIGHT_DETAILS";
  BookingServicingExternalComponents["FLIGHT_PRICE_SUMMARY"] = "FLIGHT_PRICE_SUMMARY";
  BookingServicingExternalComponents["NEW_FLIGHT_DETAILS"] = "NEW_FLIGHT_DETAILS";
  BookingServicingExternalComponents["TRAVELERS_PLAYBACK"] = "TRAVELERS_PLAYBACK";
})(BookingServicingExternalComponents || (BookingServicingExternalComponents = {}));
/** Represents the supported flows in booking servicing */
export var BookingServicingFlow;
(function (BookingServicingFlow) {
  BookingServicingFlow["INVOLUNTARY"] = "INVOLUNTARY";
  BookingServicingFlow["VOLUNTARY"] = "VOLUNTARY";
})(BookingServicingFlow || (BookingServicingFlow = {}));
/** Represents the direction of the input fields when rendering multiple fields */
export var BookingServicingFormInputFieldsDirection;
(function (BookingServicingFormInputFieldsDirection) {
  /** All fields align horizontally */
  BookingServicingFormInputFieldsDirection["HORIZONTAL"] = "HORIZONTAL";
  /** All fields align vertically */
  BookingServicingFormInputFieldsDirection["VERTICAL"] = "VERTICAL";
})(BookingServicingFormInputFieldsDirection || (BookingServicingFormInputFieldsDirection = {}));
/** Represents the supported intents in booking servicing */
export var BookingServicingIntent;
(function (BookingServicingIntent) {
  BookingServicingIntent["ACCEPT"] = "ACCEPT";
  BookingServicingIntent["CANCEL"] = "CANCEL";
  BookingServicingIntent["CHANGE"] = "CHANGE";
})(BookingServicingIntent || (BookingServicingIntent = {}));
/** Target of the Link when clicked */
export var BookingServicingLinkTarget;
(function (BookingServicingLinkTarget) {
  /** Link will be opened in an external view e.g. new tab or browser window */
  BookingServicingLinkTarget["EXTERNAL"] = "EXTERNAL";
  /** Link will be opened in the same view where the user is currently e.g. same tab or webview inside an app */
  BookingServicingLinkTarget["INTERNAL"] = "INTERNAL";
})(BookingServicingLinkTarget || (BookingServicingLinkTarget = {}));
export var BookingServicingNavigateDirection;
(function (BookingServicingNavigateDirection) {
  BookingServicingNavigateDirection["BACK"] = "BACK";
  BookingServicingNavigateDirection["FORWARD"] = "FORWARD";
  BookingServicingNavigateDirection["RELOAD"] = "RELOAD";
})(BookingServicingNavigateDirection || (BookingServicingNavigateDirection = {}));
/** Represents the supported paths in booking servicing */
export var BookingServicingPath;
(function (BookingServicingPath) {
  /** @deprecated Use BookingServicingIntent.ACCEPT instead */
  BookingServicingPath["ACCEPT"] = "ACCEPT";
  /** @deprecated Use BookingServicingIntent.CANCEL instead */
  BookingServicingPath["CANCEL"] = "CANCEL";
  /** @deprecated Use BookingServicingIntent.CHANGE instead */
  BookingServicingPath["CHANGE"] = "CHANGE";
})(BookingServicingPath || (BookingServicingPath = {}));
export var BookingServicingRyanAirRefundApplicationFormIds;
(function (BookingServicingRyanAirRefundApplicationFormIds) {
  BookingServicingRyanAirRefundApplicationFormIds["CREATE_REQUEST"] = "CREATE_REQUEST";
  BookingServicingRyanAirRefundApplicationFormIds["SEACH_REQUEST"] = "SEACH_REQUEST";
})(BookingServicingRyanAirRefundApplicationFormIds || (BookingServicingRyanAirRefundApplicationFormIds = {}));
export var BookingServicingRyanAirRefundReason;
(function (BookingServicingRyanAirRefundReason) {
  BookingServicingRyanAirRefundReason["ANCILLARY"] = "ANCILLARY";
  BookingServicingRyanAirRefundReason["BEREAVEMENT"] = "BEREAVEMENT";
  BookingServicingRyanAirRefundReason["DISRUPTION"] = "DISRUPTION";
  BookingServicingRyanAirRefundReason["GOVTAX"] = "GOVTAX";
})(BookingServicingRyanAirRefundReason || (BookingServicingRyanAirRefundReason = {}));
/** Booking servicing toolbar navigation type */
export var BookingServicingToolbarNavigationType;
(function (BookingServicingToolbarNavigationType) {
  /** Represents the toolbar with a back button */
  BookingServicingToolbarNavigationType["BACK"] = "BACK";
  /** Represents the toolbar with a back button that triggers a dialog */
  BookingServicingToolbarNavigationType["BACK_DIALOG"] = "BACK_DIALOG";
  /** Represents the toolbar with a close button */
  BookingServicingToolbarNavigationType["CLOSE"] = "CLOSE";
  /** Represents the toolbar with a expand less button */
  BookingServicingToolbarNavigationType["EXPAND_LESS"] = "EXPAND_LESS";
  /** Represents the toolbar with a expand up button */
  BookingServicingToolbarNavigationType["EXPAND_UP"] = "EXPAND_UP";
})(BookingServicingToolbarNavigationType || (BookingServicingToolbarNavigationType = {}));
/** Booking servicing toolbar type */
export var BookingServicingToolbarType;
(function (BookingServicingToolbarType) {
  /** Represents the standard type */
  BookingServicingToolbarType["STANDARD"] = "STANDARD";
  /** Represents the transparent type */
  BookingServicingToolbarType["TRANSPARENT"] = "TRANSPARENT";
})(BookingServicingToolbarType || (BookingServicingToolbarType = {}));
export var BookingServicingTravelerType;
(function (BookingServicingTravelerType) {
  BookingServicingTravelerType["ADULT"] = "ADULT";
  BookingServicingTravelerType["CHILD"] = "CHILD";
  BookingServicingTravelerType["INFANT"] = "INFANT";
})(BookingServicingTravelerType || (BookingServicingTravelerType = {}));
/** The type of input validation that will be performed on the traveler input */
export var BookingServicingTravelerValidationType;
(function (BookingServicingTravelerValidationType) {
  /** Represents the type of validation when a child is traveling alone without an adult */
  BookingServicingTravelerValidationType["CHILD_TRAVELING_ALONE"] = "CHILD_TRAVELING_ALONE";
})(BookingServicingTravelerValidationType || (BookingServicingTravelerValidationType = {}));
export var BooleanEnum;
(function (BooleanEnum) {
  BooleanEnum["FALSE"] = "FALSE";
  BooleanEnum["TRUE"] = "TRUE";
})(BooleanEnum || (BooleanEnum = {}));
export var BulkEditResponseType;
(function (BulkEditResponseType) {
  BulkEditResponseType["ERROR"] = "ERROR";
  BulkEditResponseType["SUCCESS"] = "SUCCESS";
})(BulkEditResponseType || (BulkEditResponseType = {}));
export var BulletStyle;
(function (BulletStyle) {
  BulletStyle["DEFAULT"] = "DEFAULT";
  BulletStyle["ICON_ALTERNATE"] = "ICON_ALTERNATE";
  BulletStyle["ICON_STANDARD"] = "ICON_STANDARD";
  BulletStyle["NO_BULLET"] = "NO_BULLET";
  BulletStyle["UNRECOGNIZED"] = "UNRECOGNIZED";
})(BulletStyle || (BulletStyle = {}));
/** Indicate the business model type of a given offer */
export var BusinessModelType;
(function (BusinessModelType) {
  BusinessModelType["EXPEDIA_COLLECT"] = "EXPEDIA_COLLECT";
  BusinessModelType["HOTEL_COLLECT"] = "HOTEL_COLLECT";
})(BusinessModelType || (BusinessModelType = {}));
export var ButtonSourceType;
(function (ButtonSourceType) {
  ButtonSourceType["SCRIPT"] = "SCRIPT";
  ButtonSourceType["URL"] = "URL";
})(ButtonSourceType || (ButtonSourceType = {}));
/** Supported EGDSButton types */
export var ButtonType;
(function (ButtonType) {
  ButtonType["PRIMARY"] = "PRIMARY";
  ButtonType["SECONDARY"] = "SECONDARY";
  ButtonType["TERTIARY"] = "TERTIARY";
})(ButtonType || (ButtonType = {}));
export var CampaignOfferBadgeType;
(function (CampaignOfferBadgeType) {
  CampaignOfferBadgeType["DEFAULT"] = "DEFAULT";
  CampaignOfferBadgeType["DISCOUNT"] = "DISCOUNT";
})(CampaignOfferBadgeType || (CampaignOfferBadgeType = {}));
export var CampaignProductType;
(function (CampaignProductType) {
  CampaignProductType["ACTIVITY"] = "ACTIVITY";
  CampaignProductType["FLIGHT"] = "FLIGHT";
  CampaignProductType["HOTEL"] = "HOTEL";
  CampaignProductType["PACKAGE"] = "PACKAGE";
})(CampaignProductType || (CampaignProductType = {}));
export var CampaignSearchFilters;
(function (CampaignSearchFilters) {
  CampaignSearchFilters["CAMPAIGN_ID"] = "CAMPAIGN_ID";
  CampaignSearchFilters["CAMPAIGN_NAME"] = "CAMPAIGN_NAME";
  CampaignSearchFilters["PARTNER_ACCOUNT_ID"] = "PARTNER_ACCOUNT_ID";
  CampaignSearchFilters["PROPERTY_ID"] = "PROPERTY_ID";
})(CampaignSearchFilters || (CampaignSearchFilters = {}));
export var CarAccessorySelectionState;
(function (CarAccessorySelectionState) {
  CarAccessorySelectionState["NOT_SELECTED"] = "NOT_SELECTED";
  CarAccessorySelectionState["SELECTED"] = "SELECTED";
})(CarAccessorySelectionState || (CarAccessorySelectionState = {}));
export var CarActionType;
(function (CarActionType) {
  /** Apply loyalty points to offer */
  CarActionType["APPLY_LOYALTY_POINTS"] = "APPLY_LOYALTY_POINTS";
  /** Click map marker */
  CarActionType["CAR_MAP_MARKER"] = "CAR_MAP_MARKER";
  /** Change Search */
  CarActionType["CHANGE_SEARCH"] = "CHANGE_SEARCH";
  /** Dismisses a dialog */
  CarActionType["DISMISS"] = "DISMISS";
  /** Click to filter car sales */
  CarActionType["FILTER_SALE_OFFER"] = "FILTER_SALE_OFFER";
  /** Submit content to server */
  CarActionType["FORM_SUBMISSION"] = "FORM_SUBMISSION";
  /** Go back to search page to see all cars */
  CarActionType["GO_BACK_TO_SEARCH"] = "GO_BACK_TO_SEARCH";
  /** Open cancellation policy link */
  CarActionType["GO_TO_CANCELLATION_POLICY"] = "GO_TO_CANCELLATION_POLICY";
  /** Continues to the standalone details page */
  CarActionType["GO_TO_CHECKOUT"] = "GO_TO_CHECKOUT";
  /** Open dialog to see cleaning and safety practices */
  CarActionType["GO_TO_CLEANLINESS_DIALOG"] = "GO_TO_CLEANLINESS_DIALOG";
  /** Open Delta Campaign page */
  CarActionType["GO_TO_DELTA_CAMPAIGN_LINK"] = "GO_TO_DELTA_CAMPAIGN_LINK";
  /** Continues to the standalone details page */
  CarActionType["GO_TO_DETAILS"] = "GO_TO_DETAILS";
  /** Continues to the packages path */
  CarActionType["GO_TO_PACKAGES"] = "GO_TO_PACKAGES";
  /** Open recommended sort FAQ page */
  CarActionType["GO_TO_RECOMMENDED_SORT_FAQ"] = "GO_TO_RECOMMENDED_SORT_FAQ";
  /** Continues to the user sign in page */
  CarActionType["GO_TO_SIGNIN"] = "GO_TO_SIGNIN";
  /** Continues to the user sign up page */
  CarActionType["GO_TO_SIGNUP"] = "GO_TO_SIGNUP";
  /** Click to sign in and unlock car sales */
  CarActionType["GO_TO_SIGN_IN_AND_UNLOCK_CAR_SALES"] = "GO_TO_SIGN_IN_AND_UNLOCK_CAR_SALES";
  /** Open Walmart plus member trial page */
  CarActionType["GO_TO_WPLUS_MEMBER_TRIAL_LINK"] = "GO_TO_WPLUS_MEMBER_TRIAL_LINK";
  /** Load more results to search page */
  CarActionType["LOAD_MORE"] = "LOAD_MORE";
  /** Change Search */
  CarActionType["OFF_AIRPORT_CHANGE_SEARCH"] = "OFF_AIRPORT_CHANGE_SEARCH";
  /** Opens a dialog */
  CarActionType["OPEN_DIALOG"] = "OPEN_DIALOG";
  /** Open merchant rules in iframe */
  CarActionType["OPEN_DOC"] = "OPEN_DOC";
  /** Open ground transfers page */
  CarActionType["OPEN_GROUND_TRANSFERS"] = "OPEN_GROUND_TRANSFERS";
  /** Opens the inline time wizard */
  CarActionType["OPEN_INLINE_TIME_WIZARD"] = "OPEN_INLINE_TIME_WIZARD";
  /** Opens the inline search wizard */
  CarActionType["OPEN_INLINE_WIZARD"] = "OPEN_INLINE_WIZARD";
  /** Opens a new tab */
  CarActionType["OPEN_NEW_TAB"] = "OPEN_NEW_TAB";
  /** Opens on current tab */
  CarActionType["OPEN_ON_CURRENT_TAB"] = "OPEN_ON_CURRENT_TAB";
  /** Open Partner Messaging Link */
  CarActionType["OPEN_PARTNER_MESSAGING_LINK"] = "OPEN_PARTNER_MESSAGING_LINK";
  /** Open vendor rules from domain rules */
  CarActionType["OPEN_RULE"] = "OPEN_RULE";
  /** Used to open Telephone Link */
  CarActionType["OPEN_TEL"] = "OPEN_TEL";
  /** Refreshes the current page */
  CarActionType["REFRESH"] = "REFRESH";
  /** Remove loyalty points to offer */
  CarActionType["REMOVE_LOYALTY_POINTS"] = "REMOVE_LOYALTY_POINTS";
  /** Click see cars on map marker item card */
  CarActionType["SEE_CARS_AT_MAP_MARKER"] = "SEE_CARS_AT_MAP_MARKER";
  /** Open share feedback form */
  CarActionType["SHARE_FEEDBACK"] = "SHARE_FEEDBACK";
  /** Show offers with AARP Exclusive benefits */
  CarActionType["SHOW_AARP_EXCLUSIVE_OFFERS"] = "SHOW_AARP_EXCLUSIVE_OFFERS";
  /** Show offers with free cancellations */
  CarActionType["SHOW_FREE_CANCELLATION_OFFERS"] = "SHOW_FREE_CANCELLATION_OFFERS";
  /** Click to unlock car sales */
  CarActionType["UNLOCK_CAR_SALES"] = "UNLOCK_CAR_SALES";
})(CarActionType || (CarActionType = {}));
export var CarDetailsMapMarkerType;
(function (CarDetailsMapMarkerType) {
  CarDetailsMapMarkerType["CARMARKER"] = "CarMarker";
  CarDetailsMapMarkerType["PLACEMARKER"] = "PlaceMarker";
})(CarDetailsMapMarkerType || (CarDetailsMapMarkerType = {}));
export var CarFormatStyle;
(function (CarFormatStyle) {
  CarFormatStyle["IFRAME"] = "IFRAME";
  CarFormatStyle["LIST"] = "LIST";
})(CarFormatStyle || (CarFormatStyle = {}));
export var CarMapMarkerType;
(function (CarMapMarkerType) {
  CarMapMarkerType["CARMARKER"] = "CarMarker";
  CarMapMarkerType["PLACEMARKER"] = "PlaceMarker";
})(CarMapMarkerType || (CarMapMarkerType = {}));
export var CarOfferOptionAction;
(function (CarOfferOptionAction) {
  CarOfferOptionAction["SELECT"] = "SELECT";
  CarOfferOptionAction["UNSELECT"] = "UNSELECT";
})(CarOfferOptionAction || (CarOfferOptionAction = {}));
export var CarRouteType;
(function (CarRouteType) {
  CarRouteType["ONEWAY"] = "ONEWAY";
  CarRouteType["ROUNDTRIP"] = "ROUNDTRIP";
})(CarRouteType || (CarRouteType = {}));
/** Represents name and code for each car brand. */
export var CarSearchFormPreferredBrand;
(function (CarSearchFormPreferredBrand) {
  CarSearchFormPreferredBrand["AC"] = "AC";
  CarSearchFormPreferredBrand["AD"] = "AD";
  CarSearchFormPreferredBrand["AL"] = "AL";
  CarSearchFormPreferredBrand["EP"] = "EP";
  CarSearchFormPreferredBrand["ET"] = "ET";
  CarSearchFormPreferredBrand["EY"] = "EY";
  CarSearchFormPreferredBrand["FX"] = "FX";
  CarSearchFormPreferredBrand["GI"] = "GI";
  CarSearchFormPreferredBrand["MW"] = "MW";
  CarSearchFormPreferredBrand["NU"] = "NU";
  CarSearchFormPreferredBrand["RO"] = "RO";
  CarSearchFormPreferredBrand["SC"] = "SC";
  CarSearchFormPreferredBrand["SV"] = "SV";
  CarSearchFormPreferredBrand["SX"] = "SX";
  CarSearchFormPreferredBrand["ZA"] = "ZA";
  CarSearchFormPreferredBrand["ZD"] = "ZD";
  CarSearchFormPreferredBrand["ZE"] = "ZE";
  CarSearchFormPreferredBrand["ZI"] = "ZI";
  CarSearchFormPreferredBrand["ZL"] = "ZL";
  CarSearchFormPreferredBrand["ZR"] = "ZR";
  CarSearchFormPreferredBrand["ZT"] = "ZT";
})(CarSearchFormPreferredBrand || (CarSearchFormPreferredBrand = {}));
export var CardActions;
(function (CardActions) {
  CardActions["DISMISS"] = "DISMISS";
})(CardActions || (CardActions = {}));
export var CardSize;
(function (CardSize) {
  CardSize["LARGE"] = "LARGE";
  CardSize["MEDIUM"] = "MEDIUM";
  CardSize["SMALL"] = "SMALL";
})(CardSize || (CardSize = {}));
export var CardStatus;
(function (CardStatus) {
  CardStatus["NOT_UPGRADED"] = "NOT_UPGRADED";
  CardStatus["REFUNDABLE"] = "REFUNDABLE";
  CardStatus["UPDATED"] = "UPDATED";
  CardStatus["UPGRADED"] = "UPGRADED";
})(CardStatus || (CardStatus = {}));
export var CardTheme;
(function (CardTheme) {
  CardTheme["GLOBAL_LOYALTY_EXTRAHIGH"] = "GLOBAL_LOYALTY_EXTRAHIGH";
  CardTheme["GLOBAL_LOYALTY_HIGH"] = "GLOBAL_LOYALTY_HIGH";
  CardTheme["GLOBAL_LOYALTY_LOW"] = "GLOBAL_LOYALTY_LOW";
  CardTheme["GLOBAL_LOYALTY_MIDDLE"] = "GLOBAL_LOYALTY_MIDDLE";
  CardTheme["GLOBAL_LOYALTY_STANDARD"] = "GLOBAL_LOYALTY_STANDARD";
  CardTheme["PRIMARY"] = "PRIMARY";
  CardTheme["SECONDARY"] = "SECONDARY";
})(CardTheme || (CardTheme = {}));
export var CarouselScrimType;
(function (CarouselScrimType) {
  /** Scrim should contain UitkPaginationDot and be inset */
  CarouselScrimType["INSET_PAGINATION_DOT"] = "INSET_PAGINATION_DOT";
  /** Scrim should contain UitkPaginationDot and be offset */
  CarouselScrimType["OFFSET_PAGINATION_DOT"] = "OFFSET_PAGINATION_DOT";
})(CarouselScrimType || (CarouselScrimType = {}));
/** Enum class to represent the type of carry on bag */
export var CarryOnBagType;
(function (CarryOnBagType) {
  CarryOnBagType["CARRY_ON_BAG"] = "CARRY_ON_BAG";
})(CarryOnBagType || (CarryOnBagType = {}));
export var CarsDialogType;
(function (CarsDialogType) {
  CarsDialogType["LIMITED_RESULTS"] = "LIMITED_RESULTS";
  CarsDialogType["LIMITED_RESULTS_WITHOUT_TURO"] = "LIMITED_RESULTS_WITHOUT_TURO";
  CarsDialogType["LIMITED_RESULTS_WITH_TURO"] = "LIMITED_RESULTS_WITH_TURO";
})(CarsDialogType || (CarsDialogType = {}));
export var CarsMessagingCardLinkPosition;
(function (CarsMessagingCardLinkPosition) {
  CarsMessagingCardLinkPosition["BOTTOM"] = "BOTTOM";
  CarsMessagingCardLinkPosition["RIGHT"] = "RIGHT";
})(CarsMessagingCardLinkPosition || (CarsMessagingCardLinkPosition = {}));
export var CarsRichTextStyle;
(function (CarsRichTextStyle) {
  CarsRichTextStyle["BOLD"] = "BOLD";
  CarsRichTextStyle["BULLET"] = "BULLET";
  CarsRichTextStyle["ITALICIZE"] = "ITALICIZE";
})(CarsRichTextStyle || (CarsRichTextStyle = {}));
export var CartTtl;
(function (CartTtl) {
  CartTtl["FIVE_MINUTES"] = "FIVE_MINUTES";
  CartTtl["SEVEN_DAYS"] = "SEVEN_DAYS";
  CartTtl["TWELVE_HOURS"] = "TWELVE_HOURS";
})(CartTtl || (CartTtl = {}));
export var CellHighlightType;
(function (CellHighlightType) {
  CellHighlightType["ALTERNATE_HIGHLIGHT"] = "ALTERNATE_HIGHLIGHT";
  CellHighlightType["HIGHLIGHT"] = "HIGHLIGHT";
})(CellHighlightType || (CellHighlightType = {}));
export var ChannelType;
(function (ChannelType) {
  ChannelType["VIRTUAL_AGENT"] = "VIRTUAL_AGENT";
})(ChannelType || (ChannelType = {}));
/** Indicates the type of intent. */
export var ChatBotIntentType;
(function (ChatBotIntentType) {
  ChatBotIntentType["CANCEL"] = "CANCEL";
  ChatBotIntentType["CHANGE"] = "CHANGE";
  ChatBotIntentType["VIEW_BOOKING"] = "VIEW_BOOKING";
})(ChatBotIntentType || (ChatBotIntentType = {}));
/** Indicates the type of product. */
export var ChatBotProductType;
(function (ChatBotProductType) {
  ChatBotProductType["FLIGHT"] = "FLIGHT";
})(ChatBotProductType || (ChatBotProductType = {}));
/** Indicates the waiver redemption state. */
export var ChatBotWaiverRedemptionState;
(function (ChatBotWaiverRedemptionState) {
  ChatBotWaiverRedemptionState["CREDIT_REDEMPTION"] = "CREDIT_REDEMPTION";
})(ChatBotWaiverRedemptionState || (ChatBotWaiverRedemptionState = {}));
/** Hold status of chat input for particular message on the basis of flags received form message */
export var ChatInputStatus;
(function (ChatInputStatus) {
  ChatInputStatus["DISABLE"] = "DISABLE";
  ChatInputStatus["ENABLE"] = "ENABLE";
})(ChatInputStatus || (ChatInputStatus = {}));
/** Supported capabilities of chatbot VAC. */
export var ChatbotCapabilities;
(function (ChatbotCapabilities) {
  ChatbotCapabilities["CLICKSTREAM"] = "CLICKSTREAM";
  ChatbotCapabilities["GLASSBOX"] = "GLASSBOX";
})(ChatbotCapabilities || (ChatbotCapabilities = {}));
/** Supported versions of chatbot. */
export var ChatbotVersionId;
(function (ChatbotVersionId) {
  ChatbotVersionId["V1"] = "V1";
  ChatbotVersionId["V2"] = "V2";
})(ChatbotVersionId || (ChatbotVersionId = {}));
export var CheckinValidityWithReason;
(function (CheckinValidityWithReason) {
  /** the associated date is not valid for checkin due to an unknown reason */
  CheckinValidityWithReason["INVALID"] = "INVALID";
  /** the associated date is not valid for checkin due to being in the past */
  CheckinValidityWithReason["INVALID_DUE_TO_BEING_IN_PAST"] = "INVALID_DUE_TO_BEING_IN_PAST";
  /** the associated date is not valid for checkin because checkin was prohibited on that specific date */
  CheckinValidityWithReason["INVALID_DUE_TO_CHANGEOVER_EXCLUSION"] = "INVALID_DUE_TO_CHANGEOVER_EXCLUSION";
  /** the associated date is not valid for checkin because it is too far in the future */
  CheckinValidityWithReason["INVALID_DUE_TO_MAX_FUTURE_BOOKING"] = "INVALID_DUE_TO_MAX_FUTURE_BOOKING";
  /** the associated date is not valid for checkin because checking in on this date would not meet the owner's minimum prior notification requirements */
  CheckinValidityWithReason["INVALID_DUE_TO_MIN_PRIOR_NOTIFICATION"] = "INVALID_DUE_TO_MIN_PRIOR_NOTIFICATION";
  /** the associated date is not valid for checkin because checking in on this date does not satisfy the minimum stay duration */
  CheckinValidityWithReason["INVALID_DUE_TO_MIN_STAY_NOT_ACHIEVABLE"] = "INVALID_DUE_TO_MIN_STAY_NOT_ACHIEVABLE";
  /** the associated date is not valid for checkin because it falls on a day of the week that checkin is prohibited */
  CheckinValidityWithReason["INVALID_DUE_TO_NON_CHANGEOVER_DAY_OF_WEEK"] = "INVALID_DUE_TO_NON_CHANGEOVER_DAY_OF_WEEK";
  /** the associated date is not valid for checkin because it is not available (ie. the date is already reserved) */
  CheckinValidityWithReason["INVALID_DUE_TO_NOT_AVAILABLE"] = "INVALID_DUE_TO_NOT_AVAILABLE";
  /** the associated date is not valid for checkin because there is not an associated checkout date that would allow the stay to satisfy stay constraints */
  CheckinValidityWithReason["INVALID_DUE_TO_NO_VALID_CHECKOUT_WITHIN_CONSTRAINTS"] = "INVALID_DUE_TO_NO_VALID_CHECKOUT_WITHIN_CONSTRAINTS";
  /** the associated date is valid for checkin */
  CheckinValidityWithReason["VALID"] = "VALID";
})(CheckinValidityWithReason || (CheckinValidityWithReason = {}));
/** Supported Features on prepareCheckout */
export var CheckoutOptionType;
(function (CheckoutOptionType) {
  CheckoutOptionType["CROSS_SELL"] = "CROSS_SELL";
  CheckoutOptionType["DESTINATION_ID"] = "DESTINATION_ID";
  CheckoutOptionType["FENCING_ATTRIBUTES"] = "FENCING_ATTRIBUTES";
  /** @deprecated Use PropertyNaturalKeyInput.businessModelType instead */
  CheckoutOptionType["HOTEL_BUSINESS_MODEL"] = "HOTEL_BUSINESS_MODEL";
  CheckoutOptionType["HOTEL_MARKETING_CHANNEL"] = "HOTEL_MARKETING_CHANNEL";
  CheckoutOptionType["INSTANT_BOOK"] = "INSTANT_BOOK";
  CheckoutOptionType["LEGACY_CHECKOUT_URL"] = "LEGACY_CHECKOUT_URL";
  CheckoutOptionType["LOYALTY_REWARDS_ID"] = "LOYALTY_REWARDS_ID";
  CheckoutOptionType["META_DEEPLINK"] = "META_DEEPLINK";
  CheckoutOptionType["NATIVE"] = "NATIVE";
  CheckoutOptionType["PRICE_TOKEN"] = "PRICE_TOKEN";
  CheckoutOptionType["PROPERTY_UPSELL_AMOUNT"] = "PROPERTY_UPSELL_AMOUNT";
  CheckoutOptionType["RATE_UPGRADE_ELIGIBLE"] = "RATE_UPGRADE_ELIGIBLE";
  CheckoutOptionType["RATE_UPSELL"] = "RATE_UPSELL";
  CheckoutOptionType["RATE_UPSELL_AMOUNT"] = "RATE_UPSELL_AMOUNT";
  CheckoutOptionType["REFERRER_ID"] = "REFERRER_ID";
  CheckoutOptionType["REFUNDABLE_DAMAGE_DEPOSIT_REQUIRED"] = "REFUNDABLE_DAMAGE_DEPOSIT_REQUIRED";
  CheckoutOptionType["ROOM_UPGRADE_ELIGIBLE"] = "ROOM_UPGRADE_ELIGIBLE";
  CheckoutOptionType["ROOM_UPSELL"] = "ROOM_UPSELL";
  CheckoutOptionType["SEARCH_ID"] = "SEARCH_ID";
  CheckoutOptionType["SHOPPING_DEAL_BADGE_PERCENTAGE"] = "SHOPPING_DEAL_BADGE_PERCENTAGE";
  CheckoutOptionType["SHOP_WITH_POINTS"] = "SHOP_WITH_POINTS";
  CheckoutOptionType["TAAP_PACKAGE_RATES"] = "TAAP_PACKAGE_RATES";
})(CheckoutOptionType || (CheckoutOptionType = {}));
export var CheckoutValidityWithReason;
(function (CheckoutValidityWithReason) {
  /** the associated date's is not valid for checkout for an unknown reason */
  CheckoutValidityWithReason["INVALID"] = "INVALID";
  /** the associated date is not valid for checkout because checkout was prohibited on that specific date */
  CheckoutValidityWithReason["INVALID_DUE_TO_CHANGEOVER_EXCLUSION"] = "INVALID_DUE_TO_CHANGEOVER_EXCLUSION";
  /** the associated date is not valid for checkout because it falls on a day of the week that checkout is prohibited */
  CheckoutValidityWithReason["INVALID_DUE_TO_NON_CHANGEOVER_DAY_OF_WEEK"] = "INVALID_DUE_TO_NON_CHANGEOVER_DAY_OF_WEEK";
  /** the associated date is valid for checkout */
  CheckoutValidityWithReason["VALID"] = "VALID";
})(CheckoutValidityWithReason || (CheckoutValidityWithReason = {}));
export var ChronoUnit;
(function (ChronoUnit) {
  ChronoUnit["CENTURIES"] = "CENTURIES";
  ChronoUnit["DAYS"] = "DAYS";
  ChronoUnit["DECADES"] = "DECADES";
  ChronoUnit["ERAS"] = "ERAS";
  ChronoUnit["FOREVER"] = "FOREVER";
  ChronoUnit["HALFDAYS"] = "HALFDAYS";
  ChronoUnit["HOURS"] = "HOURS";
  ChronoUnit["MICROS"] = "MICROS";
  ChronoUnit["MILLENNIA"] = "MILLENNIA";
  ChronoUnit["MILLIS"] = "MILLIS";
  ChronoUnit["MINUTES"] = "MINUTES";
  ChronoUnit["MONTHS"] = "MONTHS";
  ChronoUnit["NANOS"] = "NANOS";
  ChronoUnit["SECONDS"] = "SECONDS";
  ChronoUnit["WEEKS"] = "WEEKS";
  ChronoUnit["YEARS"] = "YEARS";
})(ChronoUnit || (ChronoUnit = {}));
export var CleaningAndSafetyPractice;
(function (CleaningAndSafetyPractice) {
  CleaningAndSafetyPractice["ENHANCED_CLEANING"] = "ENHANCED_CLEANING";
})(CleaningAndSafetyPractice || (CleaningAndSafetyPractice = {}));
export var ClientSideIllustrationAsset;
(function (ClientSideIllustrationAsset) {
  ClientSideIllustrationAsset["FLIGHTHOTELINCLUDEDSET"] = "FlightHotelIncludedSet";
})(ClientSideIllustrationAsset || (ClientSideIllustrationAsset = {}));
/** The closed bounding type of the date period. (Boundaries are always included) */
export var ClosedPeriodBounding;
(function (ClosedPeriodBounding) {
  ClosedPeriodBounding["LOWER"] = "LOWER";
  ClosedPeriodBounding["UPPER"] = "UPPER";
})(ClosedPeriodBounding || (ClosedPeriodBounding = {}));
export var CoachingTipsView;
(function (CoachingTipsView) {
  CoachingTipsView["IN_CONTEXT_COACHING_CAROUSEL"] = "IN_CONTEXT_COACHING_CAROUSEL";
  CoachingTipsView["OPPY_HUB"] = "OPPY_HUB";
  CoachingTipsView["STANDALONE_MINIMAL"] = "STANDALONE_MINIMAL";
  CoachingTipsView["STANDALONE_SUGGESTED"] = "STANDALONE_SUGGESTED";
})(CoachingTipsView || (CoachingTipsView = {}));
/** CollectionItemClickthrough is an optional parameter that specifies the URL linked to each card in the carousel, determining where the user is directed upon clicking a card. */
export var CollectionItemClickthrough;
(function (CollectionItemClickthrough) {
  CollectionItemClickthrough["PDP"] = "PDP";
  CollectionItemClickthrough["PINNED_SRP"] = "PINNED_SRP";
})(CollectionItemClickthrough || (CollectionItemClickthrough = {}));
/** The type of the collection */
export var CollectionType;
(function (CollectionType) {
  CollectionType["FLIGHT"] = "FLIGHT";
  CollectionType["GEOGRAPHY"] = "GEOGRAPHY";
  CollectionType["LODGING"] = "LODGING";
  CollectionType["PACKAGE"] = "PACKAGE";
})(CollectionType || (CollectionType = {}));
export var CommissionTier;
(function (CommissionTier) {
  CommissionTier["BASIC"] = "BASIC";
  CommissionTier["BASIC_PLUS"] = "BASIC_PLUS";
  CommissionTier["PREMIUM"] = "PREMIUM";
  CommissionTier["PREMIUM_PLUS"] = "PREMIUM_PLUS";
})(CommissionTier || (CommissionTier = {}));
/** Represents the state of a conversation thread */
export var CommunicationCenterConversationState;
(function (CommunicationCenterConversationState) {
  /** Represents read state */
  CommunicationCenterConversationState["READ"] = "READ";
  /** Represents invalid state */
  CommunicationCenterConversationState["UNKNOWN"] = "UNKNOWN";
  /** Represents unread state - initial state of conversation thread */
  CommunicationCenterConversationState["UNREAD"] = "UNREAD";
})(CommunicationCenterConversationState || (CommunicationCenterConversationState = {}));
export var CommunicationCenterConversationType;
(function (CommunicationCenterConversationType) {
  CommunicationCenterConversationType["SUPPLIER"] = "SUPPLIER";
  CommunicationCenterConversationType["TRIP_COLLABORATION"] = "TRIP_COLLABORATION";
})(CommunicationCenterConversationType || (CommunicationCenterConversationType = {}));
/** Represents left or right alignment of a specific messages in the conversation View */
export var CommunicationCenterMessageAlignment;
(function (CommunicationCenterMessageAlignment) {
  /** Represents a card that is not aligned to either left or right */
  CommunicationCenterMessageAlignment["FULL"] = "FULL";
  /** Represents left Alignment */
  CommunicationCenterMessageAlignment["LEFT"] = "LEFT";
  /** Represents Right Alignment */
  CommunicationCenterMessageAlignment["RIGHT"] = "RIGHT";
})(CommunicationCenterMessageAlignment || (CommunicationCenterMessageAlignment = {}));
/** Represents the state of message preview */
export var CommunicationCenterMessagePreviewState;
(function (CommunicationCenterMessagePreviewState) {
  /** Represents read state */
  CommunicationCenterMessagePreviewState["READ"] = "READ";
  /** Represents unread state */
  CommunicationCenterMessagePreviewState["UNREAD"] = "UNREAD";
})(CommunicationCenterMessagePreviewState || (CommunicationCenterMessagePreviewState = {}));
/** The display type of the Customer notification message */
export var CommunicationCenterNotificationMessageDisplayType;
(function (CommunicationCenterNotificationMessageDisplayType) {
  /** Display the message for the form */
  CommunicationCenterNotificationMessageDisplayType["FORM"] = "FORM";
  /** Dislay message on the page level, eg: fly-in message on the page */
  CommunicationCenterNotificationMessageDisplayType["PAGE"] = "PAGE";
})(CommunicationCenterNotificationMessageDisplayType || (CommunicationCenterNotificationMessageDisplayType = {}));
/** The level type of the Customer notification message */
export var CommunicationCenterNotificationMessageLevel;
(function (CommunicationCenterNotificationMessageLevel) {
  /** Type of error for the message */
  CommunicationCenterNotificationMessageLevel["ERROR"] = "ERROR";
  /** Type of info for the message */
  CommunicationCenterNotificationMessageLevel["INFO"] = "INFO";
  /** Type of success for the message */
  CommunicationCenterNotificationMessageLevel["SUCCESS"] = "SUCCESS";
  /** Type of warning for the message */
  CommunicationCenterNotificationMessageLevel["WARNING"] = "WARNING";
})(CommunicationCenterNotificationMessageLevel || (CommunicationCenterNotificationMessageLevel = {}));
/** Represents the state of notification or message */
export var CommunicationCenterNotificationState;
(function (CommunicationCenterNotificationState) {
  /** Represents read state */
  CommunicationCenterNotificationState["READ"] = "READ";
  /** Represents seen state - equivalents as unread */
  CommunicationCenterNotificationState["SEEN"] = "SEEN";
  /** Represents invalid state */
  CommunicationCenterNotificationState["UNKNOWN"] = "UNKNOWN";
  /** Represents unseen state - initial state of notification */
  CommunicationCenterNotificationState["UNSEEN"] = "UNSEEN";
})(CommunicationCenterNotificationState || (CommunicationCenterNotificationState = {}));
/** Represents the type of the notification */
export var CommunicationCenterNotificationType;
(function (CommunicationCenterNotificationType) {
  /** Represents coupon notification */
  CommunicationCenterNotificationType["COUPON_CAMPAIGN"] = "COUPON_CAMPAIGN";
  /** Represents default type of notification */
  CommunicationCenterNotificationType["DEFAULT"] = "DEFAULT";
})(CommunicationCenterNotificationType || (CommunicationCenterNotificationType = {}));
/** Represents the type of user actions of the notification. */
export var CommunicationCenterNotificationUserActionType;
(function (CommunicationCenterNotificationUserActionType) {
  /** Represents the action of deleting a notification */
  CommunicationCenterNotificationUserActionType["DELETE"] = "DELETE";
  /** Represents the action of marking a notification as read */
  CommunicationCenterNotificationUserActionType["MARK_AS_READ"] = "MARK_AS_READ";
  /** Represents the action of marking a notification as unread */
  CommunicationCenterNotificationUserActionType["MARK_AS_UNREAD"] = "MARK_AS_UNREAD";
  /** Represents the action of turning off price alerts */
  CommunicationCenterNotificationUserActionType["PRICE_TRACKING_UNSUBSCRIBE"] = "PRICE_TRACKING_UNSUBSCRIBE";
})(CommunicationCenterNotificationUserActionType || (CommunicationCenterNotificationUserActionType = {}));
/** Represents the status of query/mutation response */
export var CommunicationCenterOperationStatus;
(function (CommunicationCenterOperationStatus) {
  /** Represents the status of failure response for generic or unknown reasons */
  CommunicationCenterOperationStatus["GENERIC_FAILURE"] = "GENERIC_FAILURE";
  /** Represents the status of failure response for invalid input */
  CommunicationCenterOperationStatus["INVALID_INPUT"] = "INVALID_INPUT";
  /** Represents the status of failure response for service errors */
  CommunicationCenterOperationStatus["SERVICE_ERROR"] = "SERVICE_ERROR";
  /** Represents the status of successful response */
  CommunicationCenterOperationStatus["SUCCESS"] = "SUCCESS";
})(CommunicationCenterOperationStatus || (CommunicationCenterOperationStatus = {}));
export var CommunicationChannel;
(function (CommunicationChannel) {
  CommunicationChannel["EMAIL"] = "EMAIL";
  CommunicationChannel["PUSH"] = "PUSH";
  CommunicationChannel["SMS"] = "SMS";
})(CommunicationChannel || (CommunicationChannel = {}));
/** BRANDS/PROGRAMS that can be subscribed to */
export var CommunicationPreferencesCategory;
(function (CommunicationPreferencesCategory) {
  CommunicationPreferencesCategory["EXPEDIA"] = "EXPEDIA";
  CommunicationPreferencesCategory["HOTELS"] = "HOTELS";
  CommunicationPreferencesCategory["ONE_KEY"] = "ONE_KEY";
  CommunicationPreferencesCategory["VRBO"] = "VRBO";
})(CommunicationPreferencesCategory || (CommunicationPreferencesCategory = {}));
export var CommunicationPreferencesOptionsType;
(function (CommunicationPreferencesOptionsType) {
  CommunicationPreferencesOptionsType["ACCOUNT_SUPPORT"] = "ACCOUNT_SUPPORT";
  CommunicationPreferencesOptionsType["COMMUNICATION_PREFERENCES_EXPEDIA"] = "COMMUNICATION_PREFERENCES_EXPEDIA";
  CommunicationPreferencesOptionsType["COMMUNICATION_PREFERENCES_HOTELS"] = "COMMUNICATION_PREFERENCES_HOTELS";
  CommunicationPreferencesOptionsType["COMMUNICATION_PREFERENCES_VRBO"] = "COMMUNICATION_PREFERENCES_VRBO";
  CommunicationPreferencesOptionsType["COMMUNICATION_PREFERENCES_WOTIF"] = "COMMUNICATION_PREFERENCES_WOTIF";
  CommunicationPreferencesOptionsType["CONFIRMATION_AND_CRITICAL_UPDATES"] = "CONFIRMATION_AND_CRITICAL_UPDATES";
  CommunicationPreferencesOptionsType["DEFAULT"] = "DEFAULT";
  CommunicationPreferencesOptionsType["MANAGE_EMAIL_PREFERENCE"] = "MANAGE_EMAIL_PREFERENCE";
  CommunicationPreferencesOptionsType["OFFERS_AND_INSPIRATION"] = "OFFERS_AND_INSPIRATION";
  CommunicationPreferencesOptionsType["ONE_KEY"] = "ONE_KEY";
  CommunicationPreferencesOptionsType["ONE_KEY_MONTHLY_STATEMENTS"] = "ONE_KEY_MONTHLY_STATEMENTS";
  CommunicationPreferencesOptionsType["PARTNERS_OFFERS_WITH_US"] = "PARTNERS_OFFERS_WITH_US";
  CommunicationPreferencesOptionsType["PERSONALIZED_TRIP_RECOMMENDATIONS"] = "PERSONALIZED_TRIP_RECOMMENDATIONS";
  CommunicationPreferencesOptionsType["PRIVACY_STATEMENT"] = "PRIVACY_STATEMENT";
  CommunicationPreferencesOptionsType["REVIEWS"] = "REVIEWS";
  CommunicationPreferencesOptionsType["SURVEYS"] = "SURVEYS";
  CommunicationPreferencesOptionsType["THE_TRAVEL_EDIT"] = "THE_TRAVEL_EDIT";
  CommunicationPreferencesOptionsType["TRIP_BOARD_ACTIVITY"] = "TRIP_BOARD_ACTIVITY";
  CommunicationPreferencesOptionsType["TRIP_PLANNING_ASSISTANCE"] = "TRIP_PLANNING_ASSISTANCE";
  CommunicationPreferencesOptionsType["UNSUB_ALL"] = "UNSUB_ALL";
  CommunicationPreferencesOptionsType["UNSUB_OTHER_EMAILS"] = "UNSUB_OTHER_EMAILS";
})(CommunicationPreferencesOptionsType || (CommunicationPreferencesOptionsType = {}));
/** A rough measure of the percentage of properties that are sold out in the destination region as calculated by the Urgency Service. */
export var CompressionLevel;
(function (CompressionLevel) {
  CompressionLevel["CAP"] = "CAP";
  CompressionLevel["HIGH"] = "HIGH";
  CompressionLevel["LOW"] = "LOW";
  CompressionLevel["MEDIUM"] = "MEDIUM";
  CompressionLevel["NA"] = "NA";
})(CompressionLevel || (CompressionLevel = {}));
export var ConfigTag;
(function (ConfigTag) {
  ConfigTag["H1"] = "H1";
  ConfigTag["H2"] = "H2";
  ConfigTag["H3"] = "H3";
  ConfigTag["H4"] = "H4";
  ConfigTag["H5"] = "H5";
  ConfigTag["H6"] = "H6";
})(ConfigTag || (ConfigTag = {}));
export var ConnectivityPartnerPortalApiAdoptionPhaseBadgeStatus;
(function (ConnectivityPartnerPortalApiAdoptionPhaseBadgeStatus) {
  ConnectivityPartnerPortalApiAdoptionPhaseBadgeStatus["COMPLETED"] = "COMPLETED";
  ConnectivityPartnerPortalApiAdoptionPhaseBadgeStatus["FUTURE"] = "FUTURE";
  ConnectivityPartnerPortalApiAdoptionPhaseBadgeStatus["IN_PROGRESS"] = "IN_PROGRESS";
})(ConnectivityPartnerPortalApiAdoptionPhaseBadgeStatus || (ConnectivityPartnerPortalApiAdoptionPhaseBadgeStatus = {}));
export var ConnectivityPartnerPortalBrand;
(function (ConnectivityPartnerPortalBrand) {
  ConnectivityPartnerPortalBrand["EXPEDIA"] = "EXPEDIA";
  ConnectivityPartnerPortalBrand["VRBO"] = "VRBO";
})(ConnectivityPartnerPortalBrand || (ConnectivityPartnerPortalBrand = {}));
export var ConnectivityPartnerPortalButtonVariant;
(function (ConnectivityPartnerPortalButtonVariant) {
  ConnectivityPartnerPortalButtonVariant["DEFAULT"] = "DEFAULT";
  ConnectivityPartnerPortalButtonVariant["PRIMARY"] = "PRIMARY";
  ConnectivityPartnerPortalButtonVariant["SECONDARY"] = "SECONDARY";
})(ConnectivityPartnerPortalButtonVariant || (ConnectivityPartnerPortalButtonVariant = {}));
export var ConnectivityPartnerPortalNavigationItemSeparatorType;
(function (ConnectivityPartnerPortalNavigationItemSeparatorType) {
  ConnectivityPartnerPortalNavigationItemSeparatorType["HORIZONTAL_BAR"] = "HORIZONTAL_BAR";
})(ConnectivityPartnerPortalNavigationItemSeparatorType || (ConnectivityPartnerPortalNavigationItemSeparatorType = {}));
export var ConnectivityPartnerPortalNavigationItemTextBadgeVariant;
(function (ConnectivityPartnerPortalNavigationItemTextBadgeVariant) {
  ConnectivityPartnerPortalNavigationItemTextBadgeVariant["EXPEDIA"] = "EXPEDIA";
  ConnectivityPartnerPortalNavigationItemTextBadgeVariant["VRBO"] = "VRBO";
})(ConnectivityPartnerPortalNavigationItemTextBadgeVariant || (ConnectivityPartnerPortalNavigationItemTextBadgeVariant = {}));
export var ConnectivityPartnerPortalSwitchButtonSide;
(function (ConnectivityPartnerPortalSwitchButtonSide) {
  ConnectivityPartnerPortalSwitchButtonSide["LEFT"] = "LEFT";
  ConnectivityPartnerPortalSwitchButtonSide["RIGHT"] = "RIGHT";
})(ConnectivityPartnerPortalSwitchButtonSide || (ConnectivityPartnerPortalSwitchButtonSide = {}));
export var ConnectivitySettingsButtonType;
(function (ConnectivitySettingsButtonType) {
  ConnectivitySettingsButtonType["BACK"] = "BACK";
  ConnectivitySettingsButtonType["CANCEL"] = "CANCEL";
  ConnectivitySettingsButtonType["CHANGE"] = "CHANGE";
  ConnectivitySettingsButtonType["CONFIRM"] = "CONFIRM";
  ConnectivitySettingsButtonType["CONNECT"] = "CONNECT";
  ConnectivitySettingsButtonType["DISCONNECT"] = "DISCONNECT";
  ConnectivitySettingsButtonType["NEXT"] = "NEXT";
})(ConnectivitySettingsButtonType || (ConnectivitySettingsButtonType = {}));
export var ConnectivitySettingsTabName;
(function (ConnectivitySettingsTabName) {
  ConnectivitySettingsTabName["BY_PROVIDER"] = "BY_PROVIDER";
  ConnectivitySettingsTabName["BY_SERVICE"] = "BY_SERVICE";
})(ConnectivitySettingsTabName || (ConnectivitySettingsTabName = {}));
export var ContactUsOptionType;
(function (ContactUsOptionType) {
  ContactUsOptionType["CALL_BACK_WITH_AGENT"] = "CALL_BACK_WITH_AGENT";
  ContactUsOptionType["CALL_TO_AGENT"] = "CALL_TO_AGENT";
  ContactUsOptionType["CHAT_BACK_WITH_AGENT"] = "CHAT_BACK_WITH_AGENT";
  ContactUsOptionType["CHAT_WITH_AGENT"] = "CHAT_WITH_AGENT";
  ContactUsOptionType["SEND_EMAIL_AGENT"] = "SEND_EMAIL_AGENT";
})(ContactUsOptionType || (ContactUsOptionType = {}));
/** UI Theme to be applied to a `UISectionContainer` or a `TripsSectionContainer`. */
export var ContainerTheme;
(function (ContainerTheme) {
  ContainerTheme["DEFAULT"] = "DEFAULT";
  ContainerTheme["IMPORTANT"] = "IMPORTANT";
})(ContainerTheme || (ContainerTheme = {}));
export var ContentSource;
(function (ContentSource) {
  ContentSource["DESTINATION_API"] = "DESTINATION_API";
  ContentSource["EM"] = "EM";
})(ContentSource || (ContentSource = {}));
export var ConversationMode;
(function (ConversationMode) {
  ConversationMode["CREATE_CONVERSATION"] = "CREATE_CONVERSATION";
  ConversationMode["JOIN_CONVERSATION"] = "JOIN_CONVERSATION";
  ConversationMode["RESUME_CONVERSATION"] = "RESUME_CONVERSATION";
})(ConversationMode || (ConversationMode = {}));
export var ConversationParticipantType;
(function (ConversationParticipantType) {
  ConversationParticipantType["HUMANAGENT"] = "HumanAgent";
  ConversationParticipantType["HUMANAGENTVA"] = "HumanAgentVA";
  ConversationParticipantType["SUPPLIER"] = "Supplier";
  ConversationParticipantType["SUPPLIERVA"] = "SupplierVA";
  ConversationParticipantType["TRAVELER"] = "Traveler";
  ConversationParticipantType["TRAVELERVA"] = "TravelerVA";
})(ConversationParticipantType || (ConversationParticipantType = {}));
export var ConversationType;
(function (ConversationType) {
  ConversationType["AI_CONCIERGE"] = "AI_CONCIERGE";
  ConversationType["CHATGPT"] = "CHATGPT";
  ConversationType["GOOGLE_ITINERARY"] = "GOOGLE_ITINERARY";
  ConversationType["MAIN"] = "MAIN";
  ConversationType["PROPERTY_COMPARE"] = "PROPERTY_COMPARE";
  ConversationType["ROMIE_V1"] = "ROMIE_V1";
  ConversationType["ROMIE_V1_VARIANT"] = "ROMIE_V1_VARIANT";
  ConversationType["SUPPLIER"] = "SUPPLIER";
  ConversationType["TRIP_COLLABORATION"] = "TRIP_COLLABORATION";
})(ConversationType || (ConversationType = {}));
/** Coupon campaign status */
export var CouponCampaignStatus;
(function (CouponCampaignStatus) {
  CouponCampaignStatus["ACTIVE"] = "ACTIVE";
  CouponCampaignStatus["EXPIRED"] = "EXPIRED";
  CouponCampaignStatus["INACTIVE"] = "INACTIVE";
  CouponCampaignStatus["NOT_STARTED"] = "NOT_STARTED";
})(CouponCampaignStatus || (CouponCampaignStatus = {}));
export var CouponIdentifierType;
(function (CouponIdentifierType) {
  CouponIdentifierType["CODE"] = "CODE";
  CouponIdentifierType["INSTANCE_ID"] = "INSTANCE_ID";
})(CouponIdentifierType || (CouponIdentifierType = {}));
export var CreditCardAccountPlacementSourcePage;
(function (CreditCardAccountPlacementSourcePage) {
  CreditCardAccountPlacementSourcePage["GLOBAL_NAV"] = "GLOBAL_NAV";
  CreditCardAccountPlacementSourcePage["REWARDS"] = "REWARDS";
  CreditCardAccountPlacementSourcePage["UNIVERSAL_PROFILE"] = "UNIVERSAL_PROFILE";
})(CreditCardAccountPlacementSourcePage || (CreditCardAccountPlacementSourcePage = {}));
export var CreditCardAccountPlacementVariant;
(function (CreditCardAccountPlacementVariant) {
  /** The variant with medium heading, subheading, and bottom label */
  CreditCardAccountPlacementVariant["MEDIUM"] = "MEDIUM";
  /** The variant with small heading and subheading */
  CreditCardAccountPlacementVariant["SMALL"] = "SMALL";
})(CreditCardAccountPlacementVariant || (CreditCardAccountPlacementVariant = {}));
/** This enum follows the [bash comparison operators](https://tldp.org/LDP/abs/html/comparison-ops.html) convention */
export var CreditCardApplicationFormOperation;
(function (CreditCardApplicationFormOperation) {
  CreditCardApplicationFormOperation["EQ"] = "EQ";
  CreditCardApplicationFormOperation["GE"] = "GE";
  CreditCardApplicationFormOperation["GT"] = "GT";
  CreditCardApplicationFormOperation["LE"] = "LE";
  CreditCardApplicationFormOperation["LT"] = "LT";
  CreditCardApplicationFormOperation["NE"] = "NE";
  CreditCardApplicationFormOperation["NREX"] = "NREX";
  CreditCardApplicationFormOperation["REX"] = "REX";
})(CreditCardApplicationFormOperation || (CreditCardApplicationFormOperation = {}));
export var CreditCardApplicationHeadingSize;
(function (CreditCardApplicationHeadingSize) {
  CreditCardApplicationHeadingSize["LARGE"] = "LARGE";
  CreditCardApplicationHeadingSize["SMALL"] = "SMALL";
})(CreditCardApplicationHeadingSize || (CreditCardApplicationHeadingSize = {}));
export var CreditCardApplicationSsaConsent;
(function (CreditCardApplicationSsaConsent) {
  /** Missing/Suppressed */
  CreditCardApplicationSsaConsent["M"] = "M";
  /** Customer NOT agreed */
  CreditCardApplicationSsaConsent["N"] = "N";
  /** Not applicable/ITIN entered */
  CreditCardApplicationSsaConsent["X"] = "X";
  /** Customer agreed */
  CreditCardApplicationSsaConsent["Y"] = "Y";
})(CreditCardApplicationSsaConsent || (CreditCardApplicationSsaConsent = {}));
/** See https://github.expedia.biz/eg-business-domains/travel-api-common/blob/main/travel-api-taxonomy/src/main/resources/taxonomy/taxonomycheckoutsignaltype-concept-mapping.csv */
export var CreditCardCheckoutSignalType;
(function (CreditCardCheckoutSignalType) {
  CreditCardCheckoutSignalType["OFFER_CHANGED"] = "OFFER_CHANGED";
  CreditCardCheckoutSignalType["PRICE_ADJUSTED"] = "PRICE_ADJUSTED";
  CreditCardCheckoutSignalType["PRICE_CHANGED"] = "PRICE_CHANGED";
  CreditCardCheckoutSignalType["USER_TIER_UPGRADED"] = "USER_TIER_UPGRADED";
})(CreditCardCheckoutSignalType || (CreditCardCheckoutSignalType = {}));
export var CreditCardContentFormat;
(function (CreditCardContentFormat) {
  CreditCardContentFormat["HTML"] = "HTML";
  CreditCardContentFormat["PDF"] = "PDF";
})(CreditCardContentFormat || (CreditCardContentFormat = {}));
export var CreditCardContentSource;
(function (CreditCardContentSource) {
  CreditCardContentSource["TERMS_AND_CONDITIONS"] = "TERMS_AND_CONDITIONS";
})(CreditCardContentSource || (CreditCardContentSource = {}));
export var CreditCardDialogType;
(function (CreditCardDialogType) {
  CreditCardDialogType["EARLY_EXIT"] = "EARLY_EXIT";
})(CreditCardDialogType || (CreditCardDialogType = {}));
export var CreditCardEncodingType;
(function (CreditCardEncodingType) {
  CreditCardEncodingType["BASE64"] = "Base64";
})(CreditCardEncodingType || (CreditCardEncodingType = {}));
export var CreditCardFraudOtpError;
(function (CreditCardFraudOtpError) {
  CreditCardFraudOtpError["EXPIRED_CODE"] = "EXPIRED_CODE";
  CreditCardFraudOtpError["INVALID_CODE"] = "INVALID_CODE";
})(CreditCardFraudOtpError || (CreditCardFraudOtpError = {}));
export var CreditCardFraudOtpScreenType;
(function (CreditCardFraudOtpScreenType) {
  CreditCardFraudOtpScreenType["GENERATE_CODE"] = "GENERATE_CODE";
  CreditCardFraudOtpScreenType["VERIFY_CODE"] = "VERIFY_CODE";
})(CreditCardFraudOtpScreenType || (CreditCardFraudOtpScreenType = {}));
export var CreditCardRecaptureReason;
(function (CreditCardRecaptureReason) {
  CreditCardRecaptureReason["CONTACT_ISSUING_BANK"] = "CONTACT_ISSUING_BANK";
  CreditCardRecaptureReason["GUEST_NAME_CARD_NAME_MISMATCH"] = "GUEST_NAME_CARD_NAME_MISMATCH";
  CreditCardRecaptureReason["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
  CreditCardRecaptureReason["INVALID_ACCOUNT"] = "INVALID_ACCOUNT";
  CreditCardRecaptureReason["INVALID_CREDIT_CARD_NUMBER"] = "INVALID_CREDIT_CARD_NUMBER";
  CreditCardRecaptureReason["INVALID_EXPIRATION_DATE"] = "INVALID_EXPIRATION_DATE";
  CreditCardRecaptureReason["INVALID_SECURITY_CODE"] = "INVALID_SECURITY_CODE";
  CreditCardRecaptureReason["NETWORK_ERROR"] = "NETWORK_ERROR";
  CreditCardRecaptureReason["OTHER"] = "OTHER";
})(CreditCardRecaptureReason || (CreditCardRecaptureReason = {}));
/** Represents the value to map to the related mutation */
export var CreditCardRemoteValidationType;
(function (CreditCardRemoteValidationType) {
  CreditCardRemoteValidationType["SSN_ITIN"] = "SSN_ITIN";
})(CreditCardRemoteValidationType || (CreditCardRemoteValidationType = {}));
export var CreditCardScreen;
(function (CreditCardScreen) {
  CreditCardScreen["APPLICATION_FORM"] = "APPLICATION_FORM";
  CreditCardScreen["ERROR"] = "ERROR";
  CreditCardScreen["FRAUD_OTP_GENERATE"] = "FRAUD_OTP_GENERATE";
  CreditCardScreen["FRAUD_OTP_VERIFY"] = "FRAUD_OTP_VERIFY";
  CreditCardScreen["OFFER"] = "OFFER";
  /** the travellers will be redirected to the screen where they started from (Pillar/Checkout) */
  CreditCardScreen["ORIGIN"] = "ORIGIN";
  CreditCardScreen["PREFILL_CONFIRM_YOUR_IDENTITY"] = "PREFILL_CONFIRM_YOUR_IDENTITY";
  CreditCardScreen["TERMS_AND_CONDITIONS"] = "TERMS_AND_CONDITIONS";
  CreditCardScreen["THANK_YOU_APPROVED"] = "THANK_YOU_APPROVED";
  CreditCardScreen["THANK_YOU_PENDING"] = "THANK_YOU_PENDING";
})(CreditCardScreen || (CreditCardScreen = {}));
/** Page where application for Credit Card was started */
export var CreditCardSourcePage;
(function (CreditCardSourcePage) {
  /** Application/Pillar Page */
  CreditCardSourcePage["APPLICATION"] = "APPLICATION";
  /** Checkout */
  CreditCardSourcePage["CHECKOUT"] = "CHECKOUT";
})(CreditCardSourcePage || (CreditCardSourcePage = {}));
export var CreditCardThankYouScreenType;
(function (CreditCardThankYouScreenType) {
  CreditCardThankYouScreenType["APPROVED"] = "APPROVED";
  CreditCardThankYouScreenType["PENDING"] = "PENDING";
})(CreditCardThankYouScreenType || (CreditCardThankYouScreenType = {}));
export var CreditCardType;
(function (CreditCardType) {
  CreditCardType["FEE"] = "FEE";
  CreditCardType["NO_FEE"] = "NO_FEE";
})(CreditCardType || (CreditCardType = {}));
/** Enum class to represent the type of credit eligible filter */
export var CreditEligibleFilterType;
(function (CreditEligibleFilterType) {
  CreditEligibleFilterType["CREDIT_ELIGIBLE"] = "CREDIT_ELIGIBLE";
})(CreditEligibleFilterType || (CreditEligibleFilterType = {}));
export var CrossSellProductType;
(function (CrossSellProductType) {
  CrossSellProductType["ACTIVITY"] = "ACTIVITY";
  CrossSellProductType["CAR"] = "CAR";
  CrossSellProductType["FLIGHT"] = "FLIGHT";
  CrossSellProductType["GROUND_TRANSFER"] = "GROUND_TRANSFER";
  CrossSellProductType["HOTEL"] = "HOTEL";
})(CrossSellProductType || (CrossSellProductType = {}));
export var CruiseBadgeTheme;
(function (CruiseBadgeTheme) {
  CruiseBadgeTheme["DEAL_GENERIC"] = "DEAL_GENERIC";
  CruiseBadgeTheme["DEAL_MEMBER"] = "DEAL_MEMBER";
  CruiseBadgeTheme["GLOBAL_LOYALTY_EXTRAHIGH_TIER"] = "GLOBAL_LOYALTY_EXTRAHIGH_TIER";
  CruiseBadgeTheme["GLOBAL_LOYALTY_HIGH_TIER"] = "GLOBAL_LOYALTY_HIGH_TIER";
  CruiseBadgeTheme["GLOBAL_LOYALTY_LOW_TIER"] = "GLOBAL_LOYALTY_LOW_TIER";
  CruiseBadgeTheme["GLOBAL_LOYALTY_MID_TIER"] = "GLOBAL_LOYALTY_MID_TIER";
  CruiseBadgeTheme["VIP"] = "VIP";
})(CruiseBadgeTheme || (CruiseBadgeTheme = {}));
export var CruiseFeature;
(function (CruiseFeature) {
  CruiseFeature["CRUISE_WLT"] = "CRUISE_WLT";
  CruiseFeature["LIVE_SHOPPING_USING_MSC_ADAPTER"] = "LIVE_SHOPPING_USING_MSC_ADAPTER";
  CruiseFeature["MEMBER_DEALS"] = "MEMBER_DEALS";
  CruiseFeature["MEMBER_DEALS_FOR_NON_MEMBERS"] = "MEMBER_DEALS_FOR_NON_MEMBERS";
})(CruiseFeature || (CruiseFeature = {}));
export var CruiseFilterType;
(function (CruiseFilterType) {
  /** cabin experience - eg. Suite  */
  CruiseFilterType["CABIN"] = "CABIN";
  /** departure port */
  CruiseFilterType["DEPARTURE"] = "DEPARTURE";
  /** use for filtering by the destination */
  CruiseFilterType["DESTINATION"] = "DESTINATION";
  /** length of cruise nights 1-2, 3-5, 6-9 , 10-14, 15+ */
  CruiseFilterType["LENGTH"] = "LENGTH";
  /** use for filtering by the cruise line name */
  CruiseFilterType["NAME"] = "NAME";
  /** default not set value */
  CruiseFilterType["NOT_SET"] = "NOT_SET";
  /** ship type */
  CruiseFilterType["SHIP"] = "SHIP";
  /** use for ocean cruise */
  CruiseFilterType["THEME_OCEAN"] = "THEME_OCEAN";
  /** use for river cruise */
  CruiseFilterType["THEME_RIVER"] = "THEME_RIVER";
})(CruiseFilterType || (CruiseFilterType = {}));
/** Gender of the customer */
export var CustomerGender;
(function (CustomerGender) {
  CustomerGender["FEMALE"] = "FEMALE";
  CustomerGender["MALE"] = "MALE";
  CustomerGender["UNKNOWN"] = "UNKNOWN";
})(CustomerGender || (CustomerGender = {}));
/** The button type of the Customer notification submit button */
export var CustomerNotificationFormButtonType;
(function (CustomerNotificationFormButtonType) {
  /** Type of floating action button */
  CustomerNotificationFormButtonType["FLOATING_ACTION_BUTTON"] = "FLOATING_ACTION_BUTTON";
  /** Type of primary button */
  CustomerNotificationFormButtonType["PRIMARY_BUTTON"] = "PRIMARY_BUTTON";
  /** Type of secondary button */
  CustomerNotificationFormButtonType["SECONDARY_BUTTON"] = "SECONDARY_BUTTON";
  /** Type of tertiary button */
  CustomerNotificationFormButtonType["TERTIARY_BUTTON"] = "TERTIARY_BUTTON";
})(CustomerNotificationFormButtonType || (CustomerNotificationFormButtonType = {}));
/** Represents the target of the link */
export var CustomerNotificationLinkTarget;
(function (CustomerNotificationLinkTarget) {
  CustomerNotificationLinkTarget["NEW_TAB"] = "NEW_TAB";
  CustomerNotificationLinkTarget["SAME_TAB"] = "SAME_TAB";
})(CustomerNotificationLinkTarget || (CustomerNotificationLinkTarget = {}));
/** Represents the link type */
export var CustomerNotificationLinkType;
(function (CustomerNotificationLinkType) {
  CustomerNotificationLinkType["ANCHOR"] = "ANCHOR";
  CustomerNotificationLinkType["APP_DOWNLOAD_LINK"] = "APP_DOWNLOAD_LINK";
  CustomerNotificationLinkType["BUTTON"] = "BUTTON";
  CustomerNotificationLinkType["FLOATING_ACTION_BUTTON"] = "FLOATING_ACTION_BUTTON";
  CustomerNotificationLinkType["PRIMARY_BUTTON"] = "PRIMARY_BUTTON";
  CustomerNotificationLinkType["SECONDARY_BUTTON"] = "SECONDARY_BUTTON";
  CustomerNotificationLinkType["TERTIARY_BUTTON"] = "TERTIARY_BUTTON";
})(CustomerNotificationLinkType || (CustomerNotificationLinkType = {}));
/** The display type of the Customer notification message */
export var CustomerNotificationMessageDisplayType;
(function (CustomerNotificationMessageDisplayType) {
  /** Display the message for the form */
  CustomerNotificationMessageDisplayType["FORM"] = "FORM";
  /** Dislay message on the page level, eg: fly-in message on the page */
  CustomerNotificationMessageDisplayType["PAGE"] = "PAGE";
})(CustomerNotificationMessageDisplayType || (CustomerNotificationMessageDisplayType = {}));
/** The level type of the Customer notification message */
export var CustomerNotificationMessageLevel;
(function (CustomerNotificationMessageLevel) {
  /** Type of error for the message */
  CustomerNotificationMessageLevel["ERROR"] = "ERROR";
  /** Type of success for the message */
  CustomerNotificationMessageLevel["SUCCESS"] = "SUCCESS";
  /** Type of warning for the message */
  CustomerNotificationMessageLevel["WARNING"] = "WARNING";
})(CustomerNotificationMessageLevel || (CustomerNotificationMessageLevel = {}));
export var CustomerNotificationMessageType;
(function (CustomerNotificationMessageType) {
  /** INVALID_INPUT message */
  CustomerNotificationMessageType["INVALID_INPUT"] = "INVALID_INPUT";
  /** SERVICE_ERROR message */
  CustomerNotificationMessageType["SERVICE_ERROR"] = "SERVICE_ERROR";
  /** SUCCESS message */
  CustomerNotificationMessageType["SUCCESS"] = "SUCCESS";
})(CustomerNotificationMessageType || (CustomerNotificationMessageType = {}));
/** The style to apply to phrase links */
export var CustomerNotificationPhraseLinkStyle;
(function (CustomerNotificationPhraseLinkStyle) {
  CustomerNotificationPhraseLinkStyle["FLOATING_ACTION_BUTTON"] = "FLOATING_ACTION_BUTTON";
  CustomerNotificationPhraseLinkStyle["PRIMARY_BUTTON"] = "PRIMARY_BUTTON";
  CustomerNotificationPhraseLinkStyle["SECONDARY_BUTTON"] = "SECONDARY_BUTTON";
  CustomerNotificationPhraseLinkStyle["TERTIARY_BUTTON"] = "TERTIARY_BUTTON";
})(CustomerNotificationPhraseLinkStyle || (CustomerNotificationPhraseLinkStyle = {}));
/** The text style to apply to strings */
export var CustomerNotificationPhrasePartStyle;
(function (CustomerNotificationPhrasePartStyle) {
  /** Italic styling */
  CustomerNotificationPhrasePartStyle["EMPHASIS"] = "EMPHASIS";
  /** Bold styling */
  CustomerNotificationPhrasePartStyle["IMPORTANT"] = "IMPORTANT";
  /** Represents no style or regular text */
  CustomerNotificationPhrasePartStyle["STANDARD"] = "STANDARD";
})(CustomerNotificationPhrasePartStyle || (CustomerNotificationPhrasePartStyle = {}));
export var CustomerNotificationType;
(function (CustomerNotificationType) {
  CustomerNotificationType["APP_DOWNLOAD"] = "APP_DOWNLOAD";
  CustomerNotificationType["APP_HERO"] = "APP_HERO";
  CustomerNotificationType["CITI_COBRAND"] = "CITI_COBRAND";
  CustomerNotificationType["CITI_COBRAND_VERTICAL"] = "CITI_COBRAND_VERTICAL";
  CustomerNotificationType["CLEANLINESS"] = "CLEANLINESS";
  CustomerNotificationType["GDPR"] = "GDPR";
  CustomerNotificationType["GENERIC"] = "GENERIC";
  CustomerNotificationType["HEADER"] = "HEADER";
  CustomerNotificationType["INBOX"] = "INBOX";
  CustomerNotificationType["MAD_MARQUEE"] = "MAD_MARQUEE";
  CustomerNotificationType["NONE"] = "NONE";
  CustomerNotificationType["OSANO"] = "OSANO";
  CustomerNotificationType["TAKEOVER"] = "TAKEOVER";
  CustomerNotificationType["TRAVEL_ADVISORY"] = "TRAVEL_ADVISORY";
})(CustomerNotificationType || (CustomerNotificationType = {}));
export var DamageLiability;
(function (DamageLiability) {
  DamageLiability["COF"] = "COF";
  DamageLiability["RDD"] = "RDD";
})(DamageLiability || (DamageLiability = {}));
export var DashboardType;
(function (DashboardType) {
  DashboardType["DEFERRED_PAYMENT"] = "DEFERRED_PAYMENT";
  DashboardType["PERFORMANCE"] = "PERFORMANCE";
})(DashboardType || (DashboardType = {}));
/**
 * Used to identify the downstream data source.
 * ENTITY: A stateful data service driven by the owning domain
 * CART: Cart Service
 * OFFER: Offer Service
 * ORDER: Ordering Service
 * CHECKOUT: Core Checkout Identifying Service
 */
export var DataSourceType;
(function (DataSourceType) {
  DataSourceType["CART"] = "CART";
  DataSourceType["CHECKOUT"] = "CHECKOUT";
  DataSourceType["ENTITY"] = "ENTITY";
  DataSourceType["OFFER"] = "OFFER";
  DataSourceType["ORDER"] = "ORDER";
})(DataSourceType || (DataSourceType = {}));
/** Represents the internally supported actions/events in the DataTable. */
export var DataTableActionType;
(function (DataTableActionType) {
  DataTableActionType["REFRESH"] = "REFRESH";
  DataTableActionType["RESET"] = "RESET";
  DataTableActionType["SNAPSHOT"] = "SNAPSHOT";
})(DataTableActionType || (DataTableActionType = {}));
/** Used for aligning elements within a DataTable. Only for use with DataTable. */
export var DataTableAlignItems;
(function (DataTableAlignItems) {
  DataTableAlignItems["CENTER"] = "CENTER";
  DataTableAlignItems["END"] = "END";
  DataTableAlignItems["START"] = "START";
  DataTableAlignItems["STRETCH"] = "STRETCH";
})(DataTableAlignItems || (DataTableAlignItems = {}));
/** Used to specify element flow direction within a DataTable. Only for use with DataTable. */
export var DataTableElementsFlowDirection;
(function (DataTableElementsFlowDirection) {
  DataTableElementsFlowDirection["COLUMN"] = "COLUMN";
  DataTableElementsFlowDirection["COLUMN_REVERSE"] = "COLUMN_REVERSE";
  DataTableElementsFlowDirection["ROW"] = "ROW";
  DataTableElementsFlowDirection["ROW_REVERSE"] = "ROW_REVERSE";
})(DataTableElementsFlowDirection || (DataTableElementsFlowDirection = {}));
/** Used to justify elements within a DataTable. Only for use with DataTable. */
export var DataTableElementsJustifyContent;
(function (DataTableElementsJustifyContent) {
  DataTableElementsJustifyContent["CENTER"] = "CENTER";
  DataTableElementsJustifyContent["END"] = "END";
  DataTableElementsJustifyContent["SPACE_AROUND"] = "SPACE_AROUND";
  DataTableElementsJustifyContent["SPACE_BETWEEN"] = "SPACE_BETWEEN";
  DataTableElementsJustifyContent["START"] = "START";
})(DataTableElementsJustifyContent || (DataTableElementsJustifyContent = {}));
/** Used to specify spacing of elements within a DataTable. Only for use with DataTable. */
export var DataTableElementsSpace;
(function (DataTableElementsSpace) {
  DataTableElementsSpace["FOUR"] = "FOUR";
  DataTableElementsSpace["HALF"] = "HALF";
  DataTableElementsSpace["ONE"] = "ONE";
  DataTableElementsSpace["SIX"] = "SIX";
  DataTableElementsSpace["THREE"] = "THREE";
  DataTableElementsSpace["TWELVE"] = "TWELVE";
  DataTableElementsSpace["TWO"] = "TWO";
})(DataTableElementsSpace || (DataTableElementsSpace = {}));
/** Used to specify how elements should wrap within a DataTable. Only for use with DataTable. */
export var DataTableElementsWrap;
(function (DataTableElementsWrap) {
  DataTableElementsWrap["NO_WRAP"] = "NO_WRAP";
  DataTableElementsWrap["WRAP"] = "WRAP";
  DataTableElementsWrap["WRAP_REVERSE"] = "WRAP_REVERSE";
})(DataTableElementsWrap || (DataTableElementsWrap = {}));
/** Represents the supported order directions for sorting data in the table */
export var DataTableSortOrder;
(function (DataTableSortOrder) {
  DataTableSortOrder["ASC"] = "ASC";
  DataTableSortOrder["DESC"] = "DESC";
})(DataTableSortOrder || (DataTableSortOrder = {}));
/** The unit of date period */
export var DatePeriodUnit;
(function (DatePeriodUnit) {
  DatePeriodUnit["DAY"] = "DAY";
  DatePeriodUnit["MONTH"] = "MONTH";
  DatePeriodUnit["WEEK"] = "WEEK";
  DatePeriodUnit["WEEKEND"] = "WEEKEND";
})(DatePeriodUnit || (DatePeriodUnit = {}));
export var DealType;
(function (DealType) {
  DealType["AARP"] = "AARP";
  DealType["POINTS_PROMOTION"] = "POINTS_PROMOTION";
})(DealType || (DealType = {}));
/** Enum for error type to deduce the error scenario */
export var DealsErrorType;
(function (DealsErrorType) {
  DealsErrorType["NO_DEALS_FOUND"] = "NO_DEALS_FOUND";
  DealsErrorType["SYSTEM_ERROR"] = "SYSTEM_ERROR";
})(DealsErrorType || (DealsErrorType = {}));
export var DeeplinkType;
(function (DeeplinkType) {
  DeeplinkType["HSR"] = "HSR";
  DeeplinkType["PDP"] = "PDP";
})(DeeplinkType || (DeeplinkType = {}));
/** Destination Neighborhoods Configuration Identifier */
export var DestinationNeighborhoodsConfigurationIdentifier;
(function (DestinationNeighborhoodsConfigurationIdentifier) {
  /** Default configuration identifier */
  DestinationNeighborhoodsConfigurationIdentifier["DEFAULT"] = "DEFAULT";
  /** Top neighborhoods configuration identifier */
  DestinationNeighborhoodsConfigurationIdentifier["TOP_NEIGHBORHOODS"] = "TOP_NEIGHBORHOODS";
  /** Top neighborhoods configuration identifier v2 */
  DestinationNeighborhoodsConfigurationIdentifier["TOP_NEIGHBORHOODS_V2"] = "TOP_NEIGHBORHOODS_V2";
})(DestinationNeighborhoodsConfigurationIdentifier || (DestinationNeighborhoodsConfigurationIdentifier = {}));
export var DestinationRecommendationPlaceType;
(function (DestinationRecommendationPlaceType) {
  DestinationRecommendationPlaceType["CITY"] = "CITY";
  DestinationRecommendationPlaceType["NEIGHBORHOOD"] = "NEIGHBORHOOD";
  DestinationRecommendationPlaceType["POI"] = "POI";
})(DestinationRecommendationPlaceType || (DestinationRecommendationPlaceType = {}));
/** Strategy to select the relationship of the output destinations and the origin */
export var DestinationRecommendationStrategy;
(function (DestinationRecommendationStrategy) {
  DestinationRecommendationStrategy["NEARBY"] = "NEARBY";
  DestinationRecommendationStrategy["SIMILAR"] = "SIMILAR";
  DestinationRecommendationStrategy["TOP"] = "TOP";
})(DestinationRecommendationStrategy || (DestinationRecommendationStrategy = {}));
/** Input for travelGuideRecommendation query */
export var DestinationTravelGuidePolicy;
(function (DestinationTravelGuidePolicy) {
  DestinationTravelGuidePolicy["PERSONALIZED"] = "PERSONALIZED";
  DestinationTravelGuidePolicy["PLACE_ID"] = "PLACE_ID";
  DestinationTravelGuidePolicy["USER_LOCATION"] = "USER_LOCATION";
})(DestinationTravelGuidePolicy || (DestinationTravelGuidePolicy = {}));
/** Valid device types */
export var DeviceType;
(function (DeviceType) {
  DeviceType["APP_PHONE"] = "APP_PHONE";
  DeviceType["APP_TABLET"] = "APP_TABLET";
  DeviceType["CHAT_APP"] = "CHAT_APP";
  DeviceType["DESKTOP"] = "DESKTOP";
  DeviceType["MOBILE_PHONE"] = "MOBILE_PHONE";
  DeviceType["MOBILE_TABLET"] = "MOBILE_TABLET";
  DeviceType["VOICE_APP"] = "VOICE_APP";
})(DeviceType || (DeviceType = {}));
export var DialogButtonActionType;
(function (DialogButtonActionType) {
  DialogButtonActionType["CLOSE_DIALOG"] = "CLOSE_DIALOG";
  DialogButtonActionType["CREATE_TRACKING_MUTATION"] = "CREATE_TRACKING_MUTATION";
  DialogButtonActionType["DISABLE_TRACKING_MUTATION"] = "DISABLE_TRACKING_MUTATION";
  DialogButtonActionType["EMAIL_OPT_OUT"] = "EMAIL_OPT_OUT";
  DialogButtonActionType["UPDATE_TRACKING_MUTATION"] = "UPDATE_TRACKING_MUTATION";
})(DialogButtonActionType || (DialogButtonActionType = {}));
export var DialogElementType;
(function (DialogElementType) {
  DialogElementType["CLEAR_RATES"] = "CLEAR_RATES";
  DialogElementType["DELETE_QUOTES"] = "DELETE_QUOTES";
})(DialogElementType || (DialogElementType = {}));
/** Represents the different ways a dialog sections can be aligned */
export var DialogSectionAlignment;
(function (DialogSectionAlignment) {
  DialogSectionAlignment["CENTER"] = "CENTER";
  DialogSectionAlignment["LEADING"] = "LEADING";
})(DialogSectionAlignment || (DialogSectionAlignment = {}));
export var DirectFeedbackMultiSelectStyle;
(function (DirectFeedbackMultiSelectStyle) {
  DirectFeedbackMultiSelectStyle["DEFAULT"] = "DEFAULT";
  DirectFeedbackMultiSelectStyle["PILL"] = "PILL";
})(DirectFeedbackMultiSelectStyle || (DirectFeedbackMultiSelectStyle = {}));
export var DirectFeedbackPageCommandOrientation;
(function (DirectFeedbackPageCommandOrientation) {
  DirectFeedbackPageCommandOrientation["HORIZONTAL"] = "HORIZONTAL";
  DirectFeedbackPageCommandOrientation["VERTICAL"] = "VERTICAL";
})(DirectFeedbackPageCommandOrientation || (DirectFeedbackPageCommandOrientation = {}));
export var DirectFeedbackPageDisplayConditionType;
(function (DirectFeedbackPageDisplayConditionType) {
  DirectFeedbackPageDisplayConditionType["BOOL"] = "BOOL";
  DirectFeedbackPageDisplayConditionType["NONE"] = "NONE";
  DirectFeedbackPageDisplayConditionType["PATTERN"] = "PATTERN";
  DirectFeedbackPageDisplayConditionType["TEXT"] = "TEXT";
})(DirectFeedbackPageDisplayConditionType || (DirectFeedbackPageDisplayConditionType = {}));
/** Represents the type of dialog containing a direct feedback prompt */
export var DirectFeedbackSheetType;
(function (DirectFeedbackSheetType) {
  DirectFeedbackSheetType["BOTTOM_SHEET"] = "BOTTOM_SHEET";
  DirectFeedbackSheetType["CENTERED_SHEET"] = "CENTERED_SHEET";
  DirectFeedbackSheetType["FULL_SHEET"] = "FULL_SHEET";
})(DirectFeedbackSheetType || (DirectFeedbackSheetType = {}));
export var DiscoveryCardContentSize;
(function (DiscoveryCardContentSize) {
  DiscoveryCardContentSize["ABBREVIATED"] = "ABBREVIATED";
  DiscoveryCardContentSize["FOUNDATION"] = "FOUNDATION";
  DiscoveryCardContentSize["FOUNDATION_DETAILS_LIST"] = "FOUNDATION_DETAILS_LIST";
  DiscoveryCardContentSize["LANDING"] = "LANDING";
  DiscoveryCardContentSize["LONG_FORM"] = "LONG_FORM";
  DiscoveryCardContentSize["LONG_FORM_FEATURED"] = "LONG_FORM_FEATURED";
  DiscoveryCardContentSize["SHORT_FORM"] = "SHORT_FORM";
  DiscoveryCardContentSize["SMART_LANDING"] = "SMART_LANDING";
  DiscoveryCardContentSize["UBER_ABBREVIATED"] = "UBER_ABBREVIATED";
  DiscoveryCardContentSize["UBER_ABBREVIATED_PRICE"] = "UBER_ABBREVIATED_PRICE";
  DiscoveryCardContentSize["UBER_ABBREVIATED_RATING"] = "UBER_ABBREVIATED_RATING";
})(DiscoveryCardContentSize || (DiscoveryCardContentSize = {}));
export var DiscoveryContainerType;
(function (DiscoveryContainerType) {
  DiscoveryContainerType["CAROUSEL"] = "CAROUSEL";
  DiscoveryContainerType["EXPANDO"] = "EXPANDO";
  DiscoveryContainerType["GRID"] = "GRID";
  DiscoveryContainerType["LIST"] = "LIST";
})(DiscoveryContainerType || (DiscoveryContainerType = {}));
/** List of all the managed offering types. */
export var DiscoveryOfferingType;
(function (DiscoveryOfferingType) {
  DiscoveryOfferingType["DESTINATION"] = "DESTINATION";
  DiscoveryOfferingType["PRODUCT"] = "PRODUCT";
})(DiscoveryOfferingType || (DiscoveryOfferingType = {}));
/** Strategy used to resolve pricing information. */
export var DiscoveryPriceStrategy;
(function (DiscoveryPriceStrategy) {
  /**
   * Get the best price in the next 30 days seen in the website per pos, input dates are ignored.
   * Products returned can be not available.
   */
  DiscoveryPriceStrategy["DATELESS"] = "DATELESS";
  /** Call for live price, check availability of returned products. */
  DiscoveryPriceStrategy["LIVE"] = "LIVE";
  /** Do not hydrate price. */
  DiscoveryPriceStrategy["NONE"] = "NONE";
})(DiscoveryPriceStrategy || (DiscoveryPriceStrategy = {}));
/** Used to select which parameters should be used to run the inference. */
export var DiscoveryRecommendationInputContext;
(function (DiscoveryRecommendationInputContext) {
  /** Uses the 'destination' section from the context object. */
  DiscoveryRecommendationInputContext["DESTINATION"] = "DESTINATION";
  /** Uses the image presented to the user to generate similar images recommendations content strategy */
  DiscoveryRecommendationInputContext["DISPLAYED_IMAGE"] = "DISPLAYED_IMAGE";
  /** Uses the 'orderId' section from the context object. */
  DiscoveryRecommendationInputContext["ORDER"] = "ORDER";
  /** Uses the 'product' section from the context object. */
  DiscoveryRecommendationInputContext["PRODUCT"] = "PRODUCT";
  /** Personalize the recommendations using the latest products a user saw. */
  DiscoveryRecommendationInputContext["RECENTLY_VIEWED_PRODUCT"] = "RECENTLY_VIEWED_PRODUCT";
  /** Personalize the recommendations using the recent searches of the user. */
  DiscoveryRecommendationInputContext["RECENT_SEARCHES"] = "RECENT_SEARCHES";
  /** Base the recommendations on the user location. */
  DiscoveryRecommendationInputContext["USER_LOCATION"] = "USER_LOCATION";
})(DiscoveryRecommendationInputContext || (DiscoveryRecommendationInputContext = {}));
/** List of all the managed recommendations strategies. */
export var DiscoveryRecommendationStrategy;
(function (DiscoveryRecommendationStrategy) {
  DiscoveryRecommendationStrategy["ALTERNATIVE"] = "ALTERNATIVE";
  DiscoveryRecommendationStrategy["EG_PLACES"] = "EG_PLACES";
  DiscoveryRecommendationStrategy["EG_SEARCH_NEAR_PLACE"] = "EG_SEARCH_NEAR_PLACE";
  DiscoveryRecommendationStrategy["EG_SEARCH_RECOMMENDED_SELECTION"] = "EG_SEARCH_RECOMMENDED_SELECTION";
  /** @deprecated replaced by EG_SEARCH_RECOMMENDED_SELECTION and EG_SEARCH_SELECTION_SORT_GUEST_RATING */
  DiscoveryRecommendationStrategy["EG_SEARCH_SELECTION"] = "EG_SEARCH_SELECTION";
  DiscoveryRecommendationStrategy["EG_SEARCH_SELECTION_SORT_GUEST_RATING"] = "EG_SEARCH_SELECTION_SORT_GUEST_RATING";
  DiscoveryRecommendationStrategy["LOOKUP_AND_ASSEMBLE"] = "LOOKUP_AND_ASSEMBLE";
  DiscoveryRecommendationStrategy["NEARBY"] = "NEARBY";
  DiscoveryRecommendationStrategy["POPULAR"] = "POPULAR";
  DiscoveryRecommendationStrategy["SEM_RESULT"] = "SEM_RESULT";
  DiscoveryRecommendationStrategy["SIMILAR"] = "SIMILAR";
  DiscoveryRecommendationStrategy["SPONSORED"] = "SPONSORED";
  DiscoveryRecommendationStrategy["THEMED_POPULAR"] = "THEMED_POPULAR";
  DiscoveryRecommendationStrategy["THEMED_REFINEMENT"] = "THEMED_REFINEMENT";
  DiscoveryRecommendationStrategy["TOP_CITIES"] = "TOP_CITIES";
  DiscoveryRecommendationStrategy["TRENDING"] = "TRENDING";
})(DiscoveryRecommendationStrategy || (DiscoveryRecommendationStrategy = {}));
/** Enum of the units of measure and their abbreviations */
export var DistanceUnit;
(function (DistanceUnit) {
  DistanceUnit["KILOMETER"] = "KILOMETER";
  DistanceUnit["MILE"] = "MILE";
})(DistanceUnit || (DistanceUnit = {}));
export var DividerPlacement;
(function (DividerPlacement) {
  DividerPlacement["BOTTOM"] = "BOTTOM";
  DividerPlacement["TOP"] = "TOP";
})(DividerPlacement || (DividerPlacement = {}));
export var DividerStyle;
(function (DividerStyle) {
  DividerStyle["NARROW"] = "NARROW";
  DividerStyle["WIDE"] = "WIDE";
})(DividerStyle || (DividerStyle = {}));
export var DuiButtonSize;
(function (DuiButtonSize) {
  DuiButtonSize["LARGE"] = "LARGE";
  DuiButtonSize["MEDIUM"] = "MEDIUM";
  DuiButtonSize["SMALL"] = "SMALL";
})(DuiButtonSize || (DuiButtonSize = {}));
export var DuiDividerOrientation;
(function (DuiDividerOrientation) {
  DuiDividerOrientation["HORIZONTAL"] = "HORIZONTAL";
})(DuiDividerOrientation || (DuiDividerOrientation = {}));
export var DuiLayoutAdvancedAlignment;
(function (DuiLayoutAdvancedAlignment) {
  DuiLayoutAdvancedAlignment["CENTER"] = "CENTER";
  DuiLayoutAdvancedAlignment["END"] = "END";
  DuiLayoutAdvancedAlignment["SPACE_AROUND"] = "SPACE_AROUND";
  DuiLayoutAdvancedAlignment["SPACE_BETWEEN"] = "SPACE_BETWEEN";
  DuiLayoutAdvancedAlignment["SPACE_EVENLY"] = "SPACE_EVENLY";
  DuiLayoutAdvancedAlignment["START"] = "START";
})(DuiLayoutAdvancedAlignment || (DuiLayoutAdvancedAlignment = {}));
export var DuiLayoutBasicAlignment;
(function (DuiLayoutBasicAlignment) {
  DuiLayoutBasicAlignment["CENTER"] = "CENTER";
  DuiLayoutBasicAlignment["END"] = "END";
  DuiLayoutBasicAlignment["START"] = "START";
})(DuiLayoutBasicAlignment || (DuiLayoutBasicAlignment = {}));
export var DuiLayoutCoords;
(function (DuiLayoutCoords) {
  DuiLayoutCoords["BOTTOM_CENTER"] = "BOTTOM_CENTER";
  DuiLayoutCoords["BOTTOM_END"] = "BOTTOM_END";
  DuiLayoutCoords["BOTTOM_FULL"] = "BOTTOM_FULL";
  DuiLayoutCoords["BOTTOM_START"] = "BOTTOM_START";
  DuiLayoutCoords["CENTER"] = "CENTER";
  DuiLayoutCoords["CENTER_END"] = "CENTER_END";
  DuiLayoutCoords["CENTER_FULL"] = "CENTER_FULL";
  DuiLayoutCoords["CENTER_START"] = "CENTER_START";
  DuiLayoutCoords["TOP_CENTER"] = "TOP_CENTER";
  DuiLayoutCoords["TOP_END"] = "TOP_END";
  DuiLayoutCoords["TOP_FULL"] = "TOP_FULL";
  DuiLayoutCoords["TOP_START"] = "TOP_START";
})(DuiLayoutCoords || (DuiLayoutCoords = {}));
export var DuiLayoutZType;
(function (DuiLayoutZType) {
  DuiLayoutZType["ABSOLUTE"] = "ABSOLUTE";
  DuiLayoutZType["RELATIVE"] = "RELATIVE";
})(DuiLayoutZType || (DuiLayoutZType = {}));
export var DuiScrimBackgroundType;
(function (DuiScrimBackgroundType) {
  DuiScrimBackgroundType["SOLID"] = "SOLID";
  DuiScrimBackgroundType["VERTICAL_GRADIENT"] = "VERTICAL_GRADIENT";
})(DuiScrimBackgroundType || (DuiScrimBackgroundType = {}));
export var DuiSize;
(function (DuiSize) {
  DuiSize["FOUR"] = "FOUR";
  DuiSize["HALF"] = "HALF";
  DuiSize["ONE"] = "ONE";
  DuiSize["SIX"] = "SIX";
  DuiSize["SIXTEEN"] = "SIXTEEN";
  DuiSize["THREE"] = "THREE";
  DuiSize["TWELVE"] = "TWELVE";
  DuiSize["TWO"] = "TWO";
})(DuiSize || (DuiSize = {}));
export var DuiTextAlign;
(function (DuiTextAlign) {
  DuiTextAlign["CENTER"] = "CENTER";
  DuiTextAlign["END"] = "END";
  DuiTextAlign["START"] = "START";
})(DuiTextAlign || (DuiTextAlign = {}));
export var DuiTextOverflow;
(function (DuiTextOverflow) {
  DuiTextOverflow["CLIP"] = "CLIP";
  DuiTextOverflow["ELLIPSIS"] = "ELLIPSIS";
})(DuiTextOverflow || (DuiTextOverflow = {}));
export var DuiThemeProvider;
(function (DuiThemeProvider) {
  DuiThemeProvider["DARK"] = "DARK";
  DuiThemeProvider["DEFAULT"] = "DEFAULT";
  DuiThemeProvider["LIGHT"] = "LIGHT";
})(DuiThemeProvider || (DuiThemeProvider = {}));
export var DuiViewport;
(function (DuiViewport) {
  DuiViewport["EXTRA_LARGE"] = "EXTRA_LARGE";
  DuiViewport["LARGE"] = "LARGE";
  DuiViewport["MEDIUM"] = "MEDIUM";
  DuiViewport["SMALL"] = "SMALL";
})(DuiViewport || (DuiViewport = {}));
/** Different types of duration span input validations. */
export var DurationSpanValidationType;
(function (DurationSpanValidationType) {
  /** Used to validate that a maximum input value is greater than a minimum input value. */
  DurationSpanValidationType["MAXIMUM_GREATER_THAN_MINIMUM"] = "MAXIMUM_GREATER_THAN_MINIMUM";
  /** Used to validate that the user input is less than or equal to some specified value. Example: Maximum 10 nights. */
  DurationSpanValidationType["MAXIMUM_VALUE"] = "MAXIMUM_VALUE";
  /** Used to validate that a minimum input value is less than a maximum input value. */
  DurationSpanValidationType["MINIMUM_LESS_THAN_MAXIMUM"] = "MINIMUM_LESS_THAN_MAXIMUM";
  /** Used to validate that the user input is greater than or equal to some specified value. Example: Minimum 2 nights. */
  DurationSpanValidationType["MINIMUM_VALUE"] = "MINIMUM_VALUE";
  /** Used to validate that the user input has a value. */
  DurationSpanValidationType["REQUIRED_VALUE"] = "REQUIRED_VALUE";
})(DurationSpanValidationType || (DurationSpanValidationType = {}));
/** Represents where within the card's cover image we want an overlay positioned, abstraction over absolute positioning, i.e. BOTTOM_LEFT is bottom: 0, left: 0 */
export var DynamicCardOverlayPosition;
(function (DynamicCardOverlayPosition) {
  DynamicCardOverlayPosition["BOTTOM_LEFT"] = "BOTTOM_LEFT";
  DynamicCardOverlayPosition["TOP_RIGHT"] = "TOP_RIGHT";
})(DynamicCardOverlayPosition || (DynamicCardOverlayPosition = {}));
/** Styles established in EGDS design docs. https://www.figma.com/file/bbPtPOgPN4sttR3BzDaTZc/Buttons */
export var EgdsButtonStyle;
(function (EgdsButtonStyle) {
  EgdsButtonStyle["PRIMARY"] = "PRIMARY";
  EgdsButtonStyle["SECONDARY"] = "SECONDARY";
  EgdsButtonStyle["TERTIARY"] = "TERTIARY";
})(EgdsButtonStyle || (EgdsButtonStyle = {}));
/** Represents the background theme for the card */
export var EgdsCardBackgroundTheme;
(function (EgdsCardBackgroundTheme) {
  EgdsCardBackgroundTheme["GLOBAL_LOYALTY_EXTRAHIGH"] = "GLOBAL_LOYALTY_EXTRAHIGH";
  EgdsCardBackgroundTheme["GLOBAL_LOYALTY_HIGH"] = "GLOBAL_LOYALTY_HIGH";
  EgdsCardBackgroundTheme["GLOBAL_LOYALTY_LOW"] = "GLOBAL_LOYALTY_LOW";
  EgdsCardBackgroundTheme["GLOBAL_LOYALTY_MIDDLE"] = "GLOBAL_LOYALTY_MIDDLE";
  EgdsCardBackgroundTheme["GLOBAL_LOYALTY_STANDARD"] = "GLOBAL_LOYALTY_STANDARD";
  EgdsCardBackgroundTheme["HIGHLIGHT"] = "HIGHLIGHT";
  EgdsCardBackgroundTheme["PRIMARY"] = "PRIMARY";
  EgdsCardBackgroundTheme["SECONDARY"] = "SECONDARY";
})(EgdsCardBackgroundTheme || (EgdsCardBackgroundTheme = {}));
/**
 * Represents the variations of a card. Can be used with EGDSCard union members.
 * https://www.figma.com/file/M3udFrUojCRwrcoAiPnQ3Yaw/Card?node-id=11143%3A833&t=blroVUeSfs4Eqnoj-0
 */
export var EgdsCardThemes;
(function (EgdsCardThemes) {
  EgdsCardThemes["BORDERED"] = "BORDERED";
  EgdsCardThemes["PADDED"] = "PADDED";
})(EgdsCardThemes || (EgdsCardThemes = {}));
/** Defines how checkbox state should be displayed on client. */
export var EgdsCheckBoxState;
(function (EgdsCheckBoxState) {
  EgdsCheckBoxState["CHECKED"] = "CHECKED";
  EgdsCheckBoxState["INDETERMINATE"] = "INDETERMINATE";
  EgdsCheckBoxState["UNCHECKED"] = "UNCHECKED";
})(EgdsCheckBoxState || (EgdsCheckBoxState = {}));
/** Represents the label theme for the date range result. */
export var EgdsDateRangeResultTheme;
(function (EgdsDateRangeResultTheme) {
  EgdsDateRangeResultTheme["LINK"] = "LINK";
  EgdsDateRangeResultTheme["POSITIVE"] = "POSITIVE";
})(EgdsDateRangeResultTheme || (EgdsDateRangeResultTheme = {}));
/** Represents short day name. */
export var EgdsDayName;
(function (EgdsDayName) {
  EgdsDayName["FRI"] = "FRI";
  EgdsDayName["MON"] = "MON";
  EgdsDayName["SAT"] = "SAT";
  EgdsDayName["SUN"] = "SUN";
  EgdsDayName["THU"] = "THU";
  EgdsDayName["TUE"] = "TUE";
  EgdsDayName["WED"] = "WED";
})(EgdsDayName || (EgdsDayName = {}));
/** Represents the type of decorative in the text element. e.g. superscript */
export var EgdsDecorativeText;
(function (EgdsDecorativeText) {
  /** Renders with a background color to highlight the text */
  EgdsDecorativeText["HIGHLIGHT"] = "HIGHLIGHT";
  /** Renders with a line through the text */
  EgdsDecorativeText["LINE_THROUGH"] = "LINE_THROUGH";
  /** Renders as a subscript at the bottom of the text line */
  EgdsDecorativeText["SUBSCRIPT"] = "SUBSCRIPT";
  /** Renders as a superscript at the top of the text line */
  EgdsDecorativeText["SUPERSCRIPT"] = "SUPERSCRIPT";
  /** Renders with a line under the text */
  EgdsDecorativeText["UNDERLINE"] = "UNDERLINE";
})(EgdsDecorativeText || (EgdsDecorativeText = {}));
/**
 * DO NOT USE. Mobile doesn't support these html style. Client should handle heading tags.
 *
 * https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography
 */
export var EgdsHeadingStyle;
(function (EgdsHeadingStyle) {
  EgdsHeadingStyle["H1"] = "H1";
  EgdsHeadingStyle["H2"] = "H2";
  EgdsHeadingStyle["H3"] = "H3";
  EgdsHeadingStyle["H4"] = "H4";
  EgdsHeadingStyle["H5"] = "H5";
  EgdsHeadingStyle["H6"] = "H6";
  EgdsHeadingStyle["H7"] = "H7";
  EgdsHeadingStyle["H8"] = "H8";
})(EgdsHeadingStyle || (EgdsHeadingStyle = {}));
/** Represents where the icon should be places in a EGDS Standard Link */
export var EgdsIconPosition;
(function (EgdsIconPosition) {
  EgdsIconPosition["LEADING"] = "LEADING";
  EgdsIconPosition["TRAILING"] = "TRAILING";
})(EgdsIconPosition || (EgdsIconPosition = {}));
/** Option for selecting an infant seat on a plane. */
export var EgdsInfantSeat;
(function (EgdsInfantSeat) {
  EgdsInfantSeat["IN_SEAT"] = "IN_SEAT";
  EgdsInfantSeat["ON_LAP"] = "ON_LAP";
})(EgdsInfantSeat || (EgdsInfantSeat = {}));
/** Represents the size of the text in a EGDS Standard Link */
export var EgdsLinkSize;
(function (EgdsLinkSize) {
  EgdsLinkSize["LARGE"] = "LARGE";
  EgdsLinkSize["MEDIUM"] = "MEDIUM";
  EgdsLinkSize["SMALL"] = "SMALL";
})(EgdsLinkSize || (EgdsLinkSize = {}));
/**
 * ON_DEVICE means the custom places are saved locally on the device.
 * EXTERNAL means the custom places are saved externally on the backend.
 */
export var EgdsMapCustomPlacePersistanceType;
(function (EgdsMapCustomPlacePersistanceType) {
  EgdsMapCustomPlacePersistanceType["EXTERNAL"] = "EXTERNAL";
  EgdsMapCustomPlacePersistanceType["ON_DEVICE"] = "ON_DEVICE";
})(EgdsMapCustomPlacePersistanceType || (EgdsMapCustomPlacePersistanceType = {}));
/** The type of feature */
export var EgdsMapFeatureType;
(function (EgdsMapFeatureType) {
  /** Any place like restaurant, point of interest, airport */
  EgdsMapFeatureType["PLACE"] = "PLACE";
  /** Any product sold by EG like hotel, vacation_rental, car, cruise, activity, flight */
  EgdsMapFeatureType["PRODUCT"] = "PRODUCT";
  /** @deprecated Use product */
  EgdsMapFeatureType["PROPERTY"] = "PROPERTY";
})(EgdsMapFeatureType || (EgdsMapFeatureType = {}));
/** The initial viewport to use for the map when markers have been pushed and just before they are rendered */
export var EgdsMapInitialViewport;
(function (EgdsMapInitialViewport) {
  /** To use bounds value as initial viewport */
  EgdsMapInitialViewport["BOUNDS"] = "BOUNDS";
  /** To compute a bound from a set of options with a specified center */
  EgdsMapInitialViewport["CENTERED_COMPUTED_BOUNDS"] = "CENTERED_COMPUTED_BOUNDS";
  /** To use zoom and center values as initial viewport */
  EgdsMapInitialViewport["CENTER_AND_ZOOM"] = "CENTER_AND_ZOOM";
  /** To compute a bound from a set of options */
  EgdsMapInitialViewport["COMPUTED_BOUNDS"] = "COMPUTED_BOUNDS";
  /** Will center the map to show all markers pushed to the map */
  EgdsMapInitialViewport["FIT_MARKERS"] = "FIT_MARKERS";
})(EgdsMapInitialViewport || (EgdsMapInitialViewport = {}));
/** Marker pin style based on the applied filter and inventory - AVAILABLE, FILTERED, SOLD_OUT or UNKNOWN */
export var EgdsMapMarkerStatus;
(function (EgdsMapMarkerStatus) {
  /** Use for products. Indicates that the product is available. */
  EgdsMapMarkerStatus["AVAILABLE"] = "AVAILABLE";
  /** Use for products. Indicates that the product is available but filtered. */
  EgdsMapMarkerStatus["FILTERED"] = "FILTERED";
  /** Use for products. Indicates that the product is sold out. */
  EgdsMapMarkerStatus["SOLD_OUT"] = "SOLD_OUT";
  /** Use for products and places. Indicates that the status is unknown. */
  EgdsMapMarkerStatus["UNKNOWN"] = "UNKNOWN";
})(EgdsMapMarkerStatus || (EgdsMapMarkerStatus = {}));
/** 'zoomAndCenter' (requires zoom + center) or 'fitBounds' (map will include all rendered markers) */
export var EgdsMapPositionMode;
(function (EgdsMapPositionMode) {
  EgdsMapPositionMode["FIT_BOUNDS"] = "FIT_BOUNDS";
  EgdsMapPositionMode["ZOOM_AND_CENTER"] = "ZOOM_AND_CENTER";
})(EgdsMapPositionMode || (EgdsMapPositionMode = {}));
/** type of maps that can be used */
export var EgdsMapProvider;
(function (EgdsMapProvider) {
  EgdsMapProvider["GOOGLE"] = "GOOGLE";
  EgdsMapProvider["MAPBOX"] = "MAPBOX";
  EgdsMapProvider["MAPKIT"] = "MAPKIT";
})(EgdsMapProvider || (EgdsMapProvider = {}));
export var EgdsMark;
(function (EgdsMark) {
  EgdsMark["AARP"] = "AARP";
  EgdsMark["AARP_MEMBER_BENEFITS"] = "AARP_MEMBER_BENEFITS";
  EgdsMark["ADDON"] = "ADDON";
  EgdsMark["AIR_NEW_ZEALAND"] = "AIR_NEW_ZEALAND";
  EgdsMark["APPLE"] = "APPLE";
  EgdsMark["APPLE_MAPS"] = "APPLE_MAPS";
  EgdsMark["APP_CTX"] = "APP_CTX";
  EgdsMark["APP_EBOOK"] = "APP_EBOOK";
  EgdsMark["APP_EXP"] = "APP_EXP";
  EgdsMark["APP_HOTWIRE"] = "APP_HOTWIRE";
  EgdsMark["APP_ORB"] = "APP_ORB";
  EgdsMark["APP_TVLY"] = "APP_TVLY";
  EgdsMark["APP_WOTIF"] = "APP_WOTIF";
  EgdsMark["BONUS_EBOOK"] = "BONUS_EBOOK";
  EgdsMark["COMMISSION_TIER_FOUR"] = "COMMISSION_TIER_FOUR";
  EgdsMark["COMMISSION_TIER_ONE"] = "COMMISSION_TIER_ONE";
  EgdsMark["COMMISSION_TIER_THREE"] = "COMMISSION_TIER_THREE";
  EgdsMark["COMMISSION_TIER_TWO"] = "COMMISSION_TIER_TWO";
  EgdsMark["FACEBOOK"] = "FACEBOOK";
  EgdsMark["FLAGS__AR"] = "FLAGS__AR";
  EgdsMark["FLAGS__AS"] = "FLAGS__AS";
  EgdsMark["FLAGS__AT"] = "FLAGS__AT";
  EgdsMark["FLAGS__AU"] = "FLAGS__AU";
  EgdsMark["FLAGS__BE"] = "FLAGS__BE";
  EgdsMark["FLAGS__BO"] = "FLAGS__BO";
  EgdsMark["FLAGS__BR"] = "FLAGS__BR";
  EgdsMark["FLAGS__BZ"] = "FLAGS__BZ";
  EgdsMark["FLAGS__CA"] = "FLAGS__CA";
  EgdsMark["FLAGS__CH"] = "FLAGS__CH";
  EgdsMark["FLAGS__CL"] = "FLAGS__CL";
  EgdsMark["FLAGS__CN"] = "FLAGS__CN";
  EgdsMark["FLAGS__CO"] = "FLAGS__CO";
  EgdsMark["FLAGS__CR"] = "FLAGS__CR";
  EgdsMark["FLAGS__CZ"] = "FLAGS__CZ";
  EgdsMark["FLAGS__DE"] = "FLAGS__DE";
  EgdsMark["FLAGS__DK"] = "FLAGS__DK";
  EgdsMark["FLAGS__EC"] = "FLAGS__EC";
  EgdsMark["FLAGS__EE"] = "FLAGS__EE";
  EgdsMark["FLAGS__EG"] = "FLAGS__EG";
  EgdsMark["FLAGS__ES"] = "FLAGS__ES";
  EgdsMark["FLAGS__EU"] = "FLAGS__EU";
  EgdsMark["FLAGS__FI"] = "FLAGS__FI";
  EgdsMark["FLAGS__FR"] = "FLAGS__FR";
  EgdsMark["FLAGS__GR"] = "FLAGS__GR";
  EgdsMark["FLAGS__GT"] = "FLAGS__GT";
  EgdsMark["FLAGS__GY"] = "FLAGS__GY";
  EgdsMark["FLAGS__HK"] = "FLAGS__HK";
  EgdsMark["FLAGS__HN"] = "FLAGS__HN";
  EgdsMark["FLAGS__HR"] = "FLAGS__HR";
  EgdsMark["FLAGS__HU"] = "FLAGS__HU";
  EgdsMark["FLAGS__ID"] = "FLAGS__ID";
  EgdsMark["FLAGS__IE"] = "FLAGS__IE";
  EgdsMark["FLAGS__IL"] = "FLAGS__IL";
  EgdsMark["FLAGS__IN"] = "FLAGS__IN";
  EgdsMark["FLAGS__IS"] = "FLAGS__IS";
  EgdsMark["FLAGS__IT"] = "FLAGS__IT";
  EgdsMark["FLAGS__JP"] = "FLAGS__JP";
  EgdsMark["FLAGS__KR"] = "FLAGS__KR";
  EgdsMark["FLAGS__L1"] = "FLAGS__L1";
  EgdsMark["FLAGS__LT"] = "FLAGS__LT";
  EgdsMark["FLAGS__LV"] = "FLAGS__LV";
  EgdsMark["FLAGS__MX"] = "FLAGS__MX";
  EgdsMark["FLAGS__MY"] = "FLAGS__MY";
  EgdsMark["FLAGS__NI"] = "FLAGS__NI";
  EgdsMark["FLAGS__NL"] = "FLAGS__NL";
  EgdsMark["FLAGS__NO"] = "FLAGS__NO";
  EgdsMark["FLAGS__NZ"] = "FLAGS__NZ";
  EgdsMark["FLAGS__PA"] = "FLAGS__PA";
  EgdsMark["FLAGS__PE"] = "FLAGS__PE";
  EgdsMark["FLAGS__PH"] = "FLAGS__PH";
  EgdsMark["FLAGS__PL"] = "FLAGS__PL";
  EgdsMark["FLAGS__PT"] = "FLAGS__PT";
  EgdsMark["FLAGS__PY"] = "FLAGS__PY";
  EgdsMark["FLAGS__RU"] = "FLAGS__RU";
  EgdsMark["FLAGS__SA"] = "FLAGS__SA";
  EgdsMark["FLAGS__SE"] = "FLAGS__SE";
  EgdsMark["FLAGS__SG"] = "FLAGS__SG";
  EgdsMark["FLAGS__SK"] = "FLAGS__SK";
  EgdsMark["FLAGS__SR"] = "FLAGS__SR";
  EgdsMark["FLAGS__SV"] = "FLAGS__SV";
  EgdsMark["FLAGS__TH"] = "FLAGS__TH";
  EgdsMark["FLAGS__TR"] = "FLAGS__TR";
  EgdsMark["FLAGS__TW"] = "FLAGS__TW";
  EgdsMark["FLAGS__UA"] = "FLAGS__UA";
  EgdsMark["FLAGS__UAE"] = "FLAGS__UAE";
  EgdsMark["FLAGS__UK"] = "FLAGS__UK";
  EgdsMark["FLAGS__US"] = "FLAGS__US";
  EgdsMark["FLAGS__UY"] = "FLAGS__UY";
  EgdsMark["FLAGS__VE"] = "FLAGS__VE";
  EgdsMark["FLAGS__VN"] = "FLAGS__VN";
  EgdsMark["FLAGS__WW"] = "FLAGS__WW";
  EgdsMark["FLAGS__ZA"] = "FLAGS__ZA";
  EgdsMark["GOOGLE"] = "GOOGLE";
  EgdsMark["GOOGLE_LOGO"] = "GOOGLE_LOGO";
  EgdsMark["GOOGLE_MAP"] = "GOOGLE_MAP";
  EgdsMark["GOOGLE_TRANSLATED"] = "GOOGLE_TRANSLATED";
  EgdsMark["HAWAIIAN"] = "HAWAIIAN";
  EgdsMark["HOTWIRE_HOTRATE_CIRCLE"] = "HOTWIRE_HOTRATE_CIRCLE";
  EgdsMark["LINE"] = "LINE";
  EgdsMark["LOYALTY_HOTELS__HIGH_TIER"] = "LOYALTY_HOTELS__HIGH_TIER";
  EgdsMark["LOYALTY_HOTELS__LOW_TIER"] = "LOYALTY_HOTELS__LOW_TIER";
  EgdsMark["LOYALTY_HOTELS__MIDDLE_TIER"] = "LOYALTY_HOTELS__MIDDLE_TIER";
  EgdsMark["LOYALTY_HOTELS__REWARDS"] = "LOYALTY_HOTELS__REWARDS";
  EgdsMark["LOYALTY_HOTELS__STAMP_EMPTY"] = "LOYALTY_HOTELS__STAMP_EMPTY";
  EgdsMark["LOYALTY_HOTELS__STAMP_PENDING"] = "LOYALTY_HOTELS__STAMP_PENDING";
  EgdsMark["LOYALTY_HOTELS__STAMP_SEARCHED"] = "LOYALTY_HOTELS__STAMP_SEARCHED";
  EgdsMark["LOYALTY_TVLY"] = "LOYALTY_TVLY";
  EgdsMark["MAPBOX"] = "MAPBOX";
  EgdsMark["MIP_PRIMARY"] = "MIP_PRIMARY";
  EgdsMark["MIP_REVERSE"] = "MIP_REVERSE";
  EgdsMark["MIP_SECONDARY"] = "MIP_SECONDARY";
  EgdsMark["MOD_CTX"] = "MOD_CTX";
  EgdsMark["MOD_EBOOK"] = "MOD_EBOOK";
  EgdsMark["MOD_EXP"] = "MOD_EXP";
  EgdsMark["MOD_HOTELS"] = "MOD_HOTELS";
  EgdsMark["MOD_ORB"] = "MOD_ORB";
  EgdsMark["MOD_TVLY"] = "MOD_TVLY";
  EgdsMark["MOD_WOTIF"] = "MOD_WOTIF";
  EgdsMark["NAVER"] = "NAVER";
  EgdsMark["ONEKEY__ABRITEL"] = "ONEKEY__ABRITEL";
  EgdsMark["ONEKEY__BLUE"] = "ONEKEY__BLUE";
  EgdsMark["ONEKEY__BOOKABACH"] = "ONEKEY__BOOKABACH";
  EgdsMark["ONEKEY__CASH"] = "ONEKEY__CASH";
  EgdsMark["ONEKEY__EXPEDIA"] = "ONEKEY__EXPEDIA";
  EgdsMark["ONEKEY__FEWODIREKT"] = "ONEKEY__FEWODIREKT";
  EgdsMark["ONEKEY__GOLD"] = "ONEKEY__GOLD";
  EgdsMark["ONEKEY__HOTELS__CHINESE"] = "ONEKEY__HOTELS__CHINESE";
  EgdsMark["ONEKEY__HOTELS__ENGLISH"] = "ONEKEY__HOTELS__ENGLISH";
  EgdsMark["ONEKEY__HOTELS__PORTUGUESE"] = "ONEKEY__HOTELS__PORTUGUESE";
  EgdsMark["ONEKEY__HOTELS__SPANISH"] = "ONEKEY__HOTELS__SPANISH";
  EgdsMark["ONEKEY__KNOCKEDOUT__ALWAYS_LIGHT"] = "ONEKEY__KNOCKEDOUT__ALWAYS_LIGHT";
  EgdsMark["ONEKEY__PLATINUM"] = "ONEKEY__PLATINUM";
  EgdsMark["ONEKEY__SILVER"] = "ONEKEY__SILVER";
  EgdsMark["ONEKEY__STANDARD"] = "ONEKEY__STANDARD";
  EgdsMark["ONEKEY__STANDARD__ALWAYS_LIGHT"] = "ONEKEY__STANDARD__ALWAYS_LIGHT";
  EgdsMark["ONEKEY__STAYZ"] = "ONEKEY__STAYZ";
  EgdsMark["ONEKEY__VRBO"] = "ONEKEY__VRBO";
  EgdsMark["ONEKEY__WORDMARK"] = "ONEKEY__WORDMARK";
  EgdsMark["ONEKEY__WORDMARK__ALWAYS_LIGHT"] = "ONEKEY__WORDMARK__ALWAYS_LIGHT";
  EgdsMark["PAYMENT__7_ELEVEN"] = "PAYMENT__7_ELEVEN";
  EgdsMark["PAYMENT__AFFIRM"] = "PAYMENT__AFFIRM";
  EgdsMark["PAYMENT__AIRPLUS"] = "PAYMENT__AIRPLUS";
  EgdsMark["PAYMENT__ALIPAY"] = "PAYMENT__ALIPAY";
  EgdsMark["PAYMENT__AMEX"] = "PAYMENT__AMEX";
  EgdsMark["PAYMENT__APPLEPAY"] = "PAYMENT__APPLEPAY";
  EgdsMark["PAYMENT__CHASE"] = "PAYMENT__CHASE";
  EgdsMark["PAYMENT__CLICKTOPAY"] = "PAYMENT__CLICKTOPAY";
  EgdsMark["PAYMENT__DINERS_CLUB_INTERNATIONAL"] = "PAYMENT__DINERS_CLUB_INTERNATIONAL";
  EgdsMark["PAYMENT__DISCOVER"] = "PAYMENT__DISCOVER";
  EgdsMark["PAYMENT__GOOGLE_PAY"] = "PAYMENT__GOOGLE_PAY";
  EgdsMark["PAYMENT__IDEAL"] = "PAYMENT__IDEAL";
  EgdsMark["PAYMENT__JAPAN_CREDIT_BUREAU"] = "PAYMENT__JAPAN_CREDIT_BUREAU";
  EgdsMark["PAYMENT__KLARNA"] = "PAYMENT__KLARNA";
  EgdsMark["PAYMENT__MAESTRO"] = "PAYMENT__MAESTRO";
  EgdsMark["PAYMENT__MASTERCARD"] = "PAYMENT__MASTERCARD";
  EgdsMark["PAYMENT__MASTERPASS"] = "PAYMENT__MASTERPASS";
  EgdsMark["PAYMENT__PAYPAL"] = "PAYMENT__PAYPAL";
  EgdsMark["PAYMENT__SAMSUNG_CARD"] = "PAYMENT__SAMSUNG_CARD";
  EgdsMark["PAYMENT__UATP"] = "PAYMENT__UATP";
  EgdsMark["PAYMENT__UNION_PAY"] = "PAYMENT__UNION_PAY";
  EgdsMark["PAYMENT__VISA"] = "PAYMENT__VISA";
  EgdsMark["PLUS_CIRCLE"] = "PLUS_CIRCLE";
  EgdsMark["PLUS_CIRCLE_CTX"] = "PLUS_CIRCLE_CTX";
  EgdsMark["PLUS_CIRCLE_EBOOK"] = "PLUS_CIRCLE_EBOOK";
  EgdsMark["PLUS_CIRCLE_ORB"] = "PLUS_CIRCLE_ORB";
  EgdsMark["PLUS_CIRCLE_TVLY"] = "PLUS_CIRCLE_TVLY";
  EgdsMark["PLUS_CIRCLE_WOTIF"] = "PLUS_CIRCLE_WOTIF";
  EgdsMark["PREMIUM_TVLY"] = "PREMIUM_TVLY";
  EgdsMark["REWARDS_ORB"] = "REWARDS_ORB";
  EgdsMark["TRIPADVISOR"] = "TRIPADVISOR";
  EgdsMark["TRIVAGO"] = "TRIVAGO";
  EgdsMark["VAP_HOTELS__HIGH_TIER"] = "VAP_HOTELS__HIGH_TIER";
  EgdsMark["VAP_HOTELS__LOW_TIER"] = "VAP_HOTELS__LOW_TIER";
  EgdsMark["VAP_HOTELS__MIDDLE_TIER"] = "VAP_HOTELS__MIDDLE_TIER";
  EgdsMark["VIP_BEX"] = "VIP_BEX";
  EgdsMark["VIP_CIRCLE_BEX"] = "VIP_CIRCLE_BEX";
  EgdsMark["VIP_CIRCLE_EBOOKERS"] = "VIP_CIRCLE_EBOOKERS";
  EgdsMark["VIP_CIRCLE_HOTELS"] = "VIP_CIRCLE_HOTELS";
  EgdsMark["VIP_CIRCLE_ORBITZ"] = "VIP_CIRCLE_ORBITZ";
  EgdsMark["VIP_EBOOKERS"] = "VIP_EBOOKERS";
  EgdsMark["VIP_ORBITZ"] = "VIP_ORBITZ";
  EgdsMark["VIRGIN_AU"] = "VIRGIN_AU";
  EgdsMark["VRBO"] = "VRBO";
})(EgdsMark || (EgdsMark = {}));
/**
 * This should only be used in unique design cases where the UX changes frequently and specific product requirements must be met.
 * Most teams should just use String over EGDSParagraph or EGDSText.
 *
 * https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography
 */
export var EgdsParagraphStyle;
(function (EgdsParagraphStyle) {
  EgdsParagraphStyle["P1"] = "P1";
  EgdsParagraphStyle["P2"] = "P2";
  EgdsParagraphStyle["P3"] = "P3";
})(EgdsParagraphStyle || (EgdsParagraphStyle = {}));
/** The type of path for directions */
export var EgdsPathType;
(function (EgdsPathType) {
  EgdsPathType["CYCLING"] = "CYCLING";
  EgdsPathType["DRIVING"] = "DRIVING";
  EgdsPathType["FLYING"] = "FLYING";
  EgdsPathType["TRANSIT"] = "TRANSIT";
  EgdsPathType["WALKING"] = "WALKING";
})(EgdsPathType || (EgdsPathType = {}));
/** Possible camera movement for the photosphere image */
export var EgdsPhotosphereCameraMovement;
(function (EgdsPhotosphereCameraMovement) {
  EgdsPhotosphereCameraMovement["AUTO_PAN"] = "AUTO_PAN";
  EgdsPhotosphereCameraMovement["DISABLED"] = "DISABLED";
  EgdsPhotosphereCameraMovement["FULL_MOVE"] = "FULL_MOVE";
})(EgdsPhotosphereCameraMovement || (EgdsPhotosphereCameraMovement = {}));
/** Different field types of location field */
export var EgdsSearchFormLocationFieldRegionType;
(function (EgdsSearchFormLocationFieldRegionType) {
  EgdsSearchFormLocationFieldRegionType["ADDRESS"] = "ADDRESS";
  EgdsSearchFormLocationFieldRegionType["AIRPORT"] = "AIRPORT";
  EgdsSearchFormLocationFieldRegionType["CITY"] = "CITY";
  EgdsSearchFormLocationFieldRegionType["CONTINENT"] = "CONTINENT";
  EgdsSearchFormLocationFieldRegionType["COUNTRY"] = "COUNTRY";
  EgdsSearchFormLocationFieldRegionType["MULTI_CITY_VICINITY"] = "MULTI_CITY_VICINITY";
  EgdsSearchFormLocationFieldRegionType["NEIGHBORHOOD"] = "NEIGHBORHOOD";
  EgdsSearchFormLocationFieldRegionType["POINT_OF_INTEREST"] = "POINT_OF_INTEREST";
  EgdsSearchFormLocationFieldRegionType["UNKNOWN"] = "UNKNOWN";
})(EgdsSearchFormLocationFieldRegionType || (EgdsSearchFormLocationFieldRegionType = {}));
/** Type of EGDSSheet */
export var EgdsSheetType;
(function (EgdsSheetType) {
  EgdsSheetType["BOTTOM"] = "BOTTOM";
  EgdsSheetType["CENTERED"] = "CENTERED";
  EgdsSheetType["FULLSCREEN"] = "FULLSCREEN";
  EgdsSheetType["POPOVER"] = "POPOVER";
  EgdsSheetType["SIDE"] = "SIDE";
})(EgdsSheetType || (EgdsSheetType = {}));
/** ONLY USE IN EGDSSheetTypePerViewSize, represents the size of the travelers application / window */
export var EgdsSheetTypeViewSize;
(function (EgdsSheetTypeViewSize) {
  EgdsSheetTypeViewSize["LARGE"] = "LARGE";
  EgdsSheetTypeViewSize["MEDIUM"] = "MEDIUM";
  EgdsSheetTypeViewSize["SMALL"] = "SMALL";
})(EgdsSheetTypeViewSize || (EgdsSheetTypeViewSize = {}));
export var EgdsTextListItemStyle;
(function (EgdsTextListItemStyle) {
  EgdsTextListItemStyle["DEFAULT"] = "DEFAULT";
  EgdsTextListItemStyle["EMPHASIS"] = "EMPHASIS";
  EgdsTextListItemStyle["LOYALTY"] = "LOYALTY";
  EgdsTextListItemStyle["NEGATIVE"] = "NEGATIVE";
  EgdsTextListItemStyle["POSITIVE"] = "POSITIVE";
})(EgdsTextListItemStyle || (EgdsTextListItemStyle = {}));
/** https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography */
export var EgdsTextListSize;
(function (EgdsTextListSize) {
  EgdsTextListSize["LIST_1"] = "LIST_1";
  EgdsTextListSize["LIST_2"] = "LIST_2";
  EgdsTextListSize["LIST_3"] = "LIST_3";
})(EgdsTextListSize || (EgdsTextListSize = {}));
/**
 * This represents UI variations of EGDS List
 *        figma: https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography?node-id=11931%3A11857
 */
export var EgdsTextListType;
(function (EgdsTextListType) {
  EgdsTextListType["BULLET"] = "BULLET";
  EgdsTextListType["ICON"] = "ICON";
  EgdsTextListType["NO_BULLET"] = "NO_BULLET";
  EgdsTextListType["NUMBER"] = "NUMBER";
})(EgdsTextListType || (EgdsTextListType = {}));
/**
 * Represents the possible UI theme colors.
 *
 * https://uitk.expedia.biz/en_US/components/cards#global_loyalty_card_patterns
 * https://www.figma.com/file/x9PecZwsESUjIsB1s4D676/Visual-Identity-Refinement?type=design&node-id=6873-216790&mode=design&t=zsn1QbwSKBHJ7OD5-0
 */
export var EgdsThemeProviderColor;
(function (EgdsThemeProviderColor) {
  EgdsThemeProviderColor["BRIGHT_1"] = "BRIGHT_1";
  EgdsThemeProviderColor["DARK_1"] = "DARK_1";
  EgdsThemeProviderColor["GLOBAL_LOYALTY_EXTRA_HIGH"] = "GLOBAL_LOYALTY_EXTRA_HIGH";
  EgdsThemeProviderColor["GLOBAL_LOYALTY_EXTRA_HIGH_BRIGHT"] = "GLOBAL_LOYALTY_EXTRA_HIGH_BRIGHT";
  EgdsThemeProviderColor["GLOBAL_LOYALTY_HIGH"] = "GLOBAL_LOYALTY_HIGH";
  EgdsThemeProviderColor["GLOBAL_LOYALTY_HIGH_BRIGHT"] = "GLOBAL_LOYALTY_HIGH_BRIGHT";
  EgdsThemeProviderColor["GLOBAL_LOYALTY_LOW"] = "GLOBAL_LOYALTY_LOW";
  EgdsThemeProviderColor["GLOBAL_LOYALTY_LOW_BRIGHT"] = "GLOBAL_LOYALTY_LOW_BRIGHT";
  EgdsThemeProviderColor["GLOBAL_LOYALTY_MID"] = "GLOBAL_LOYALTY_MID";
  EgdsThemeProviderColor["GLOBAL_LOYALTY_MID_BRIGHT"] = "GLOBAL_LOYALTY_MID_BRIGHT";
  EgdsThemeProviderColor["GLOBAL_LOYALTY_STANDARD"] = "GLOBAL_LOYALTY_STANDARD";
  EgdsThemeProviderColor["LIGHT_1"] = "LIGHT_1";
  EgdsThemeProviderColor["MARKETING_1"] = "MARKETING_1";
  EgdsThemeProviderColor["MARKETING_2"] = "MARKETING_2";
  EgdsThemeProviderColor["NONE"] = "NONE";
  EgdsThemeProviderColor["STANDARD"] = "STANDARD";
})(EgdsThemeProviderColor || (EgdsThemeProviderColor = {}));
/**
 * Toolbars are built with two variants.
 * STANDARD: They have a solid background built in. This is the default variant type..
 * TRANSPARENT: They do not have a solid background.
 */
export var EgdsToolbarStyle;
(function (EgdsToolbarStyle) {
  EgdsToolbarStyle["STANDARD"] = "STANDARD";
  EgdsToolbarStyle["TRANSPARENT"] = "TRANSPARENT";
})(EgdsToolbarStyle || (EgdsToolbarStyle = {}));
/** Travelers types used on travelers selector */
export var EgdsTravelerType;
(function (EgdsTravelerType) {
  EgdsTravelerType["ADULT"] = "ADULT";
  EgdsTravelerType["CHILD"] = "CHILD";
  EgdsTravelerType["INFANT"] = "INFANT";
  EgdsTravelerType["SENIOR"] = "SENIOR";
  EgdsTravelerType["YOUTH"] = "YOUTH";
})(EgdsTravelerType || (EgdsTravelerType = {}));
/** Represents different type of travelers validation. */
export var EgdsTravelersValidationType;
(function (EgdsTravelersValidationType) {
  /** Used to validate child age required. */
  EgdsTravelersValidationType["CHILD_AGE_REQUIRED"] = "CHILD_AGE_REQUIRED";
  /** Used to validate maximum number of allowed infants in seat. */
  EgdsTravelersValidationType["MANY_INFANT_IN_SEAT"] = "MANY_INFANT_IN_SEAT";
  /** Used to validate maximum number of allowed infants on lap. */
  EgdsTravelersValidationType["MANY_INFANT_ON_LAP"] = "MANY_INFANT_ON_LAP";
  /** Used to validate maximum allowed travelers for search. */
  EgdsTravelersValidationType["MAX_TRAVELERS"] = "MAX_TRAVELERS";
})(EgdsTravelersValidationType || (EgdsTravelersValidationType = {}));
/** Defines how typeahead results should be displayed on client. */
export var EgdsTypeaheadRenderType;
(function (EgdsTypeaheadRenderType) {
  EgdsTypeaheadRenderType["ADAPTIVE"] = "ADAPTIVE";
  EgdsTypeaheadRenderType["DIALOG"] = "DIALOG";
  EgdsTypeaheadRenderType["MENU"] = "MENU";
})(EgdsTypeaheadRenderType || (EgdsTypeaheadRenderType = {}));
/**
 * Used to specify event type for an interaction.
 * See https://github.expedia.biz/Brand-Expedia/uis-prime-schemas/blob/master/schemas/micro/platform/referrer.json#L26
 */
export var EgReferrerEventType;
(function (EgReferrerEventType) {
  /** Used to track a click on a UI component. */
  EgReferrerEventType["CLICK"] = "CLICK";
  /** Used to track an impression of a UI component. */
  EgReferrerEventType["IMPRESSION"] = "IMPRESSION";
})(EgReferrerEventType || (EgReferrerEventType = {}));
/** Predefined image sizes */
export var EmImageSize;
(function (EmImageSize) {
  EmImageSize["L"] = "L";
  EmImageSize["M"] = "M";
  EmImageSize["S"] = "S";
  EmImageSize["XL"] = "XL";
  EmImageSize["XS"] = "XS";
})(EmImageSize || (EmImageSize = {}));
export var EmptyStateType;
(function (EmptyStateType) {
  EmptyStateType["ENABLE_PUSH"] = "ENABLE_PUSH";
  EmptyStateType["EXPLORE_TRIPS"] = "EXPLORE_TRIPS";
  EmptyStateType["SIGN_IN"] = "SIGN_IN";
})(EmptyStateType || (EmptyStateType = {}));
export var EventType;
(function (EventType) {
  EventType["CANCELLEDTRIPSITEMDETAILVIEWED"] = "CancelledTripsItemDetailViewed";
  EventType["DELETETRIPALERTPRESENTED"] = "DeleteTripAlertPresented";
  EventType["DELETETRIPDIALOGPRESENTED"] = "DeleteTripDialogPresented";
  EventType["DELETETRIPERRORTOASTPRESENTED"] = "DeleteTripErrorToastPresented";
  EventType["DELETETRIPFAILED"] = "DeleteTripFailed";
  EventType["DELETETRIPSUCCEEDED"] = "DeleteTripSucceeded";
  EventType["DELETETRIPSUCCESSTOASTPRESENTED"] = "DeleteTripSuccessToastPresented";
  EventType["HEROMODULECAMPAIGN"] = "HeroModuleCampaign";
  EventType["HEROMODULECOLDSTART"] = "HeroModuleColdStart";
  EventType["ITINACTIVECAR"] = "ItinActiveCar";
  EventType["ITINACTIVECRUISE"] = "ItinActiveCruise";
  EventType["ITINACTIVEFLIGHT"] = "ItinActiveFlight";
  EventType["ITINACTIVEGT"] = "ItinActiveGT";
  EventType["ITINACTIVEHOTEL"] = "ItinActiveHotel";
  EventType["ITINACTIVELX"] = "ItinActiveLX";
  EventType["ITINACTIVEPACKAGEFH"] = "ItinActivePackageFH";
  EventType["ITINACTIVERAIL"] = "ItinActiveRail";
  EventType["ITINCANCELLATION"] = "ItinCancellation";
  EventType["MOVEITEMDRAWERPRESENTED"] = "MoveItemDrawerPresented";
  EventType["MOVEITEMERRORTOASTPRESENTED"] = "MoveItemErrorToastPresented";
  EventType["MOVEITEMSUBMITTED"] = "MoveItemSubmitted";
  EventType["MOVEITEMSUCCESSTOASTPRESENTED"] = "MoveItemSuccessToastPresented";
  EventType["MOVEITEMSUCEEDED"] = "MoveItemSuceeded";
  EventType["MOVELINKEDITEMSDIALOGPRESENTED"] = "MoveLinkedItemsDialogPresented";
  EventType["REMOVEITEMDIALOGPRESENTED"] = "RemoveItemDialogPresented";
  EventType["TRIPITEMMENUPRESENTED"] = "TripItemMenuPresented";
  EventType["TRIPSIGNINDIALOGPRESENTED"] = "TripSignInDialogPresented";
  EventType["TRIPSCANCELLEDITEMDETAILVIEWED"] = "TripsCancelledItemDetailViewed";
  EventType["TRIPSCOLLABINVITECONFIRMATIONVIEWED"] = "TripsCollabInviteConfirmationViewed";
  EventType["TRIPSCOLLABINVITEFAILUREVIEWED"] = "TripsCollabInviteFailureViewed";
  EventType["TRIPSCOLLABINVITESUCCEEDED"] = "TripsCollabInviteSucceeded";
  EventType["TRIPSCOLLABJOINGROUPFAILED"] = "TripsCollabJoinGroupFailed";
  EventType["TRIPSCOLLABJOINGROUPSUCCEEDED"] = "TripsCollabJoinGroupSucceeded";
  EventType["TRIPSCOLLABJOINTRIPCONFIRMATIONVIEWED"] = "TripsCollabJoinTripConfirmationViewed";
  EventType["TRIPSCOLLABJOINTRIPERRORTOASTPRESENTED"] = "TripsCollabJoinTripErrorToastPresented";
  EventType["TRIPSCOLLABLANDINGSCREENREDIRECTTOTRIPOVERVIEW"] = "TripsCollabLandingScreenRedirectToTripOverView";
  EventType["TRIPSCOLLABLANDINGSCREENVIEWED"] = "TripsCollabLandingScreenViewed";
  EventType["TRIPSCOLLABMANAGEGROUPVIEWED"] = "TripsCollabManageGroupViewed";
  EventType["TRIPSCOLLABVIEWPRESENTEDACTIVITIES"] = "TripsCollabViewPresentedActivities";
  EventType["TRIPSCOLLABVIEWPRESENTEDCARS"] = "TripsCollabViewPresentedCars";
  EventType["TRIPSCOLLABVIEWPRESENTEDCRUISE"] = "TripsCollabViewPresentedCruise";
  EventType["TRIPSCOLLABVIEWPRESENTEDFLIGHT"] = "TripsCollabViewPresentedFlight";
  EventType["TRIPSCOLLABVIEWPRESENTEDHOTEL"] = "TripsCollabViewPresentedHotel";
  EventType["TRIPSCOLLABVIEWPRESENTEDVACATIONRENTAL"] = "TripsCollabViewPresentedVacationRental";
  EventType["TRIPSEDITITEMSUCCEEDED"] = "TripsEditItemSucceeded";
  EventType["TRIPSEDITTRIPERRORTOASTPRESENTED"] = "TripsEditTripErrorToastPresented";
  EventType["TRIPSEDITTRIPPRESENTED"] = "TripsEditTripPresented";
  EventType["TRIPSEDITTRIPSUBMITTED"] = "TripsEditTripSubmitted";
  EventType["TRIPSEDITTRIPSUCCESSTOASTPRESENTED"] = "TripsEditTripSuccessToastPresented";
  EventType["TRIPSFLIGHTSCHEDULECHANGEBANNERDISPLAYED"] = "TripsFlightScheduleChangeBannerDisplayed";
  EventType["TRIPSHEROMODULECURRENTTRIP"] = "TripsHeroModuleCurrentTrip";
  EventType["TRIPSHEROMODULEPOSSIBLEACTIVITYTRIP"] = "TripsHeroModulePossibleActivityTrip";
  EventType["TRIPSHEROMODULEPOSSIBLEAIRTRIP"] = "TripsHeroModulePossibleAirTrip";
  EventType["TRIPSHEROMODULEPOSSIBLECARTRIP"] = "TripsHeroModulePossibleCarTrip";
  EventType["TRIPSHEROMODULEPOSSIBLEHOTELTRIP"] = "TripsHeroModulePossibleHotelTrip";
  EventType["TRIPSHEROMODULEPOSSIBLEPACKAGEHFTRIP"] = "TripsHeroModulePossiblePackageHFTrip";
  EventType["TRIPSHEROMODULEPOSSIBLETRIP"] = "TripsHeroModulePossibleTrip";
  EventType["TRIPSHEROMODULEPOTENTIALTRIP"] = "TripsHeroModulePotentialTrip";
  EventType["TRIPSHEROMODULEUPCOMINGTRIP"] = "TripsHeroModuleUpcomingTrip";
  EventType["TRIPSITEMDETAILVIEWED"] = "TripsItemDetailViewed";
  EventType["TRIPSLISTVIEWED"] = "TripsListViewed";
  EventType["TRIPSMODULEDESTINATIONGUIDE"] = "TripsModuleDestinationGuide";
  EventType["TRIPSMODULERECOMMENDEDACTIVITY"] = "TripsModuleRecommendedActivity";
  EventType["TRIPSMODULERECOMMENDEDCAR"] = "TripsModuleRecommendedCar";
  EventType["TRIPSMODULERECOMMENDEDHOTEL"] = "TripsModuleRecommendedHotel";
  EventType["TRIPSOVERVIEWVIEWED"] = "TripsOverviewViewed";
  EventType["TRIPSTRAVELPLANNERITINNUMBERPRESENT"] = "TripsTravelPlannerItinNumberPresent";
  EventType["UNKNOWN"] = "Unknown";
})(EventType || (EventType = {}));
export var EventsRecommendationIdType;
(function (EventsRecommendationIdType) {
  EventsRecommendationIdType["TRIP_ID"] = "TRIP_ID";
  EventsRecommendationIdType["TRIP_ITEM_ID"] = "TRIP_ITEM_ID";
})(EventsRecommendationIdType || (EventsRecommendationIdType = {}));
export var ExpLineOfBusiness;
(function (ExpLineOfBusiness) {
  ExpLineOfBusiness["ACTIVITIES"] = "ACTIVITIES";
  ExpLineOfBusiness["CAR"] = "CAR";
  ExpLineOfBusiness["CRUISES"] = "CRUISES";
  ExpLineOfBusiness["FLIGHT"] = "FLIGHT";
  ExpLineOfBusiness["GROUNDTRANSFERS"] = "GROUNDTRANSFERS";
  ExpLineOfBusiness["HOTEL"] = "HOTEL";
  ExpLineOfBusiness["PACKAGES"] = "PACKAGES";
  ExpLineOfBusiness["RAILS"] = "RAILS";
  ExpLineOfBusiness["UNCLASSIFIED"] = "UNCLASSIFIED";
})(ExpLineOfBusiness || (ExpLineOfBusiness = {}));
/** Specifies the position of the trigger icon  */
export var ExpandoTriggerPosition;
(function (ExpandoTriggerPosition) {
  ExpandoTriggerPosition["LEADING"] = "LEADING";
  ExpandoTriggerPosition["TRAILING"] = "TRAILING";
})(ExpandoTriggerPosition || (ExpandoTriggerPosition = {}));
export var ExperimentalActionType;
(function (ExperimentalActionType) {
  ExperimentalActionType["JUMPLINK"] = "JUMPLINK";
  ExperimentalActionType["MODAL"] = "MODAL";
  ExperimentalActionType["REDIRECT"] = "REDIRECT";
})(ExperimentalActionType || (ExperimentalActionType = {}));
export var ExperimentalAspectRatio;
(function (ExperimentalAspectRatio) {
  ExperimentalAspectRatio["FIT"] = "FIT";
  ExperimentalAspectRatio["FOUR_ONE"] = "FOUR_ONE";
  ExperimentalAspectRatio["FOUR_THREE"] = "FOUR_THREE";
  ExperimentalAspectRatio["NONE"] = "NONE";
  ExperimentalAspectRatio["ONE_ONE"] = "ONE_ONE";
  ExperimentalAspectRatio["SIXTEEN_NINE"] = "SIXTEEN_NINE";
  ExperimentalAspectRatio["THREE_FOUR"] = "THREE_FOUR";
  ExperimentalAspectRatio["THREE_TWO"] = "THREE_TWO";
  ExperimentalAspectRatio["TWENTY_ONE_NINE"] = "TWENTY_ONE_NINE";
})(ExperimentalAspectRatio || (ExperimentalAspectRatio = {}));
export var ExperimentalContainerSize;
(function (ExperimentalContainerSize) {
  ExperimentalContainerSize["EIGHTY_EIGHT"] = "EIGHTY_EIGHT";
  ExperimentalContainerSize["FIVE_HUNDRED"] = "FIVE_HUNDRED";
  ExperimentalContainerSize["FORTY_EIGHT"] = "FORTY_EIGHT";
  /** @deprecated Use HUNDRED instead */
  ExperimentalContainerSize["FOUR_HUNDRED"] = "FOUR_HUNDRED";
  ExperimentalContainerSize["HUNDRED"] = "HUNDRED";
  ExperimentalContainerSize["NINETY_SIX"] = "NINETY_SIX";
  ExperimentalContainerSize["ONE_HUNDRED_EIGHTY"] = "ONE_HUNDRED_EIGHTY";
  /** @deprecated Use THIRTY_EIGHT instead */
  ExperimentalContainerSize["ONE_HUNDRED_FIFTY_TWO"] = "ONE_HUNDRED_FIFTY_TWO";
  ExperimentalContainerSize["ONE_HUNDRED_THIRTY"] = "ONE_HUNDRED_THIRTY";
  ExperimentalContainerSize["ONE_HUNDRED_TWELVE"] = "ONE_HUNDRED_TWELVE";
  /** @deprecated Use THIRTY instead */
  ExperimentalContainerSize["ONE_HUNDRED_TWENTY"] = "ONE_HUNDRED_TWENTY";
  ExperimentalContainerSize["SEVENTY"] = "SEVENTY";
  ExperimentalContainerSize["SIXTY"] = "SIXTY";
  ExperimentalContainerSize["SIXTY_FOUR"] = "SIXTY_FOUR";
  ExperimentalContainerSize["THIRTY"] = "THIRTY";
  ExperimentalContainerSize["THIRTY_EIGHT"] = "THIRTY_EIGHT";
  ExperimentalContainerSize["THIRTY_SIX"] = "THIRTY_SIX";
  ExperimentalContainerSize["THREE_HUNDRED_TWELVE"] = "THREE_HUNDRED_TWELVE";
  ExperimentalContainerSize["TWELVE"] = "TWELVE";
  ExperimentalContainerSize["TWENTY_FOUR"] = "TWENTY_FOUR";
  /** @deprecated Use SIXTY_FOUR instead */
  ExperimentalContainerSize["TWO_HUNDRED_FIFTY_SIX"] = "TWO_HUNDRED_FIFTY_SIX";
  ExperimentalContainerSize["TWO_HUNDRED_FOUR"] = "TWO_HUNDRED_FOUR";
})(ExperimentalContainerSize || (ExperimentalContainerSize = {}));
export var ExperimentalElements;
(function (ExperimentalElements) {
  /** EGDSStandardMessagingCard. Figma: https://www.figma.com/file/SRnOSnyVYE5dYh7wEQNIfC/Messaging-card-patterns?node-id=1551%3A1450 */
  ExperimentalElements["CARD"] = "Card";
  /** Image / Carousel */
  ExperimentalElements["CAROUSEL"] = "Carousel";
  /**
   * Clickable container for any element
   * @deprecated Deprecated: Use 'Container', replace with Container
   */
  ExperimentalElements["CLICKABLE"] = "Clickable";
  /** Experimental: Class to hold the props for a container, spacing, flex, impression, analytics */
  ExperimentalElements["CONTAINER"] = "Container";
  /** Expand / collapse sections. Peek and list type */
  ExperimentalElements["EXPANDO"] = "Expando";
  /** Grid system */
  ExperimentalElements["GRID"] = "Grid";
  /** Title, subtitle and paragraphs */
  ExperimentalElements["INFOSECTION"] = "InfoSection";
  /**
   * Intersection
   * @deprecated Deprecated: Use 'Container.impression', replace with Container.impression
   */
  ExperimentalElements["INTERSECTIONTRACKER"] = "IntersectionTracker";
  /** Media - Images / Video */
  ExperimentalElements["MEDIA"] = "Media";
  /** Modal - Bottom, Full, Popover, Centered, Side-sheet */
  ExperimentalElements["MODAL"] = "Modal";
  /** Rating */
  ExperimentalElements["RATING"] = "Rating";
  /** Conditional container for script tags to apply to its children NOT to be consumed on client side */
  ExperimentalElements["SCRIPT"] = "Script";
  /** Spacing */
  ExperimentalElements["SPACING"] = "Spacing";
  /** Tabs */
  ExperimentalElements["TABS"] = "Tabs";
  /** A list with icons and support for context menu. https://shared-ui.expedia.biz/components/web/retail/product/internal/product-text-info-section */
  ExperimentalElements["TEXTICONTOOLTIP"] = "TextIconTooltip";
})(ExperimentalElements || (ExperimentalElements = {}));
export var ExperimentalFlexAlign;
(function (ExperimentalFlexAlign) {
  ExperimentalFlexAlign["BASELINE"] = "BASELINE";
  ExperimentalFlexAlign["CENTER"] = "CENTER";
  ExperimentalFlexAlign["END"] = "END";
  ExperimentalFlexAlign["START"] = "START";
  ExperimentalFlexAlign["STRETCH"] = "STRETCH";
})(ExperimentalFlexAlign || (ExperimentalFlexAlign = {}));
export var ExperimentalFlexDirection;
(function (ExperimentalFlexDirection) {
  ExperimentalFlexDirection["COLUMN"] = "COLUMN";
  ExperimentalFlexDirection["ROW"] = "ROW";
})(ExperimentalFlexDirection || (ExperimentalFlexDirection = {}));
export var ExperimentalFlexJustify;
(function (ExperimentalFlexJustify) {
  ExperimentalFlexJustify["CENTER"] = "CENTER";
  ExperimentalFlexJustify["END"] = "END";
  ExperimentalFlexJustify["START"] = "START";
})(ExperimentalFlexJustify || (ExperimentalFlexJustify = {}));
export var ExperimentalHeadingType;
(function (ExperimentalHeadingType) {
  ExperimentalHeadingType["H1"] = "h1";
  ExperimentalHeadingType["H2"] = "h2";
  ExperimentalHeadingType["H3"] = "h3";
  ExperimentalHeadingType["H4"] = "h4";
  ExperimentalHeadingType["H5"] = "h5";
  ExperimentalHeadingType["H6"] = "h6";
})(ExperimentalHeadingType || (ExperimentalHeadingType = {}));
export var ExperimentalImageFit;
(function (ExperimentalImageFit) {
  ExperimentalImageFit["CONTAIN"] = "CONTAIN";
  ExperimentalImageFit["COVER"] = "COVER";
})(ExperimentalImageFit || (ExperimentalImageFit = {}));
export var ExperimentalImageLazyload;
(function (ExperimentalImageLazyload) {
  ExperimentalImageLazyload["EAGER"] = "EAGER";
  ExperimentalImageLazyload["LAZY"] = "LAZY";
  ExperimentalImageLazyload["OFF"] = "OFF";
})(ExperimentalImageLazyload || (ExperimentalImageLazyload = {}));
export var ExperimentalImageRounded;
(function (ExperimentalImageRounded) {
  ExperimentalImageRounded["ALL"] = "ALL";
  ExperimentalImageRounded["END_END"] = "END_END";
  ExperimentalImageRounded["END_START"] = "END_START";
  ExperimentalImageRounded["FALSE"] = "FALSE";
  ExperimentalImageRounded["MAX"] = "MAX";
  ExperimentalImageRounded["START_END"] = "START_END";
  ExperimentalImageRounded["START_START"] = "START_START";
  ExperimentalImageRounded["TRUE"] = "TRUE";
})(ExperimentalImageRounded || (ExperimentalImageRounded = {}));
export var ExperimentalModalPosition;
(function (ExperimentalModalPosition) {
  ExperimentalModalPosition["LEADING"] = "LEADING";
  ExperimentalModalPosition["TRAILING"] = "TRAILING";
})(ExperimentalModalPosition || (ExperimentalModalPosition = {}));
export var ExperimentalModalType;
(function (ExperimentalModalType) {
  ExperimentalModalType["BOTTOM"] = "BOTTOM";
  ExperimentalModalType["CENTERED"] = "CENTERED";
  ExperimentalModalType["FULL"] = "FULL";
  ExperimentalModalType["POPOVER"] = "POPOVER";
  ExperimentalModalType["SIDE"] = "SIDE";
})(ExperimentalModalType || (ExperimentalModalType = {}));
/** Handle text that would overflow out of the current line and element */
export var ExperimentalOverflow;
(function (ExperimentalOverflow) {
  ExperimentalOverflow["TRUNCATE"] = "TRUNCATE";
  ExperimentalOverflow["TRUNCATE_FOUR_LINES"] = "TRUNCATE_FOUR_LINES";
  ExperimentalOverflow["TRUNCATE_THREE_LINES"] = "TRUNCATE_THREE_LINES";
  ExperimentalOverflow["TRUNCATE_TWO_LINES"] = "TRUNCATE_TWO_LINES";
  ExperimentalOverflow["WRAP"] = "WRAP";
})(ExperimentalOverflow || (ExperimentalOverflow = {}));
export var ExperimentalSliderStyle;
(function (ExperimentalSliderStyle) {
  ExperimentalSliderStyle["SINGLEWITHTICKS"] = "singleWithTicks";
  ExperimentalSliderStyle["SINGLEWITHOUTTICKS"] = "singleWithoutTicks";
})(ExperimentalSliderStyle || (ExperimentalSliderStyle = {}));
export var ExperimentalSpace;
(function (ExperimentalSpace) {
  ExperimentalSpace["FOUR"] = "four";
  ExperimentalSpace["HALF"] = "half";
  ExperimentalSpace["ONE"] = "one";
  ExperimentalSpace["SIX"] = "six";
  ExperimentalSpace["THREE"] = "three";
  ExperimentalSpace["TWELVE"] = "twelve";
  ExperimentalSpace["TWO"] = "two";
})(ExperimentalSpace || (ExperimentalSpace = {}));
export var FallBackType;
(function (FallBackType) {
  FallBackType["ERROR"] = "ERROR";
})(FallBackType || (FallBackType = {}));
export var FallbackOperation;
(function (FallbackOperation) {
  FallbackOperation["APPLY_COUPON"] = "APPLY_COUPON";
  FallbackOperation["REMOVE_COUPON"] = "REMOVE_COUPON";
})(FallbackOperation || (FallbackOperation = {}));
export var FareNameAvailable;
(function (FareNameAvailable) {
  FareNameAvailable["AVAILABLE"] = "AVAILABLE";
  FareNameAvailable["NOT_AVAILABLE"] = "NOT_AVAILABLE";
})(FareNameAvailable || (FareNameAvailable = {}));
/** Represents the state of the fare */
export var FareState;
(function (FareState) {
  /** Fare is selected on meta search, but it has unselected visual state */
  FareState["META_UNSELECTED"] = "META_UNSELECTED";
  /** Fare is selected */
  FareState["SELECTED"] = "SELECTED";
  /** Fare is selected with PMP */
  FareState["SELECTED_PMP_SELECTED"] = "SELECTED_PMP_SELECTED";
  /** Fare is unselected */
  FareState["UNSELECTED"] = "UNSELECTED";
  /** Fare is unselected with PMP */
  FareState["UNSELECTED_PMP_SELECTED"] = "UNSELECTED_PMP_SELECTED";
})(FareState || (FareState = {}));
export var FastTrackActionType;
(function (FastTrackActionType) {
  FastTrackActionType["JUMPLINK"] = "JUMPLINK";
  FastTrackActionType["MODAL"] = "MODAL";
  FastTrackActionType["REDIRECT"] = "REDIRECT";
})(FastTrackActionType || (FastTrackActionType = {}));
export var FastTrackConfigTag;
(function (FastTrackConfigTag) {
  FastTrackConfigTag["H1"] = "H1";
  FastTrackConfigTag["H2"] = "H2";
  FastTrackConfigTag["H3"] = "H3";
  FastTrackConfigTag["H4"] = "H4";
  FastTrackConfigTag["H5"] = "H5";
  FastTrackConfigTag["H6"] = "H6";
})(FastTrackConfigTag || (FastTrackConfigTag = {}));
export var FastTrackContainerSize;
(function (FastTrackContainerSize) {
  FastTrackContainerSize["EIGHTY_EIGHT"] = "EIGHTY_EIGHT";
  FastTrackContainerSize["FIVE_HUNDRED"] = "FIVE_HUNDRED";
  FastTrackContainerSize["FORTY_EIGHT"] = "FORTY_EIGHT";
  FastTrackContainerSize["NINETY_SIX"] = "NINETY_SIX";
  FastTrackContainerSize["ONE_HUNDRED_EIGHTY"] = "ONE_HUNDRED_EIGHTY";
  FastTrackContainerSize["ONE_HUNDRED_THIRTY"] = "ONE_HUNDRED_THIRTY";
  FastTrackContainerSize["ONE_HUNDRED_TWELVE"] = "ONE_HUNDRED_TWELVE";
  FastTrackContainerSize["SEVENTY"] = "SEVENTY";
  FastTrackContainerSize["SIXTY"] = "SIXTY";
  FastTrackContainerSize["THIRTY_SIX"] = "THIRTY_SIX";
  FastTrackContainerSize["THREE_HUNDRED_TWELVE"] = "THREE_HUNDRED_TWELVE";
  FastTrackContainerSize["TWELVE"] = "TWELVE";
  FastTrackContainerSize["TWENTY_FOUR"] = "TWENTY_FOUR";
  FastTrackContainerSize["TWO_HUNDRED_FOUR"] = "TWO_HUNDRED_FOUR";
})(FastTrackContainerSize || (FastTrackContainerSize = {}));
export var FastTrackElements;
(function (FastTrackElements) {
  /** EGDSStandardMessagingCard. Figma: https://www.figma.com/file/SRnOSnyVYE5dYh7wEQNIfC/Messaging-card-patterns?node-id=1551%3A1450 */
  FastTrackElements["CARD"] = "Card";
  /** Image / Carousel */
  FastTrackElements["CAROUSEL"] = "Carousel";
  /** Clickable container for any element */
  FastTrackElements["CLICKABLE"] = "Clickable";
  /** Expand / collapse sections. Peek and list type */
  FastTrackElements["EXPANDO"] = "Expando";
  /** Grid system */
  FastTrackElements["GRID"] = "Grid";
  /** Title, subtitle and paragraphs */
  FastTrackElements["INFOSECTION"] = "InfoSection";
  /** Intersection */
  FastTrackElements["INTERSECTIONTRACKER"] = "IntersectionTracker";
  /** Media - Images / Video */
  FastTrackElements["MEDIA"] = "Media";
  /** Modal - Bottom, Full, Popover, Centered, Side-sheet */
  FastTrackElements["MODAL"] = "Modal";
  /** Rating */
  FastTrackElements["RATING"] = "Rating";
  /** Spacing */
  FastTrackElements["SPACING"] = "Spacing";
  /** Tabs */
  FastTrackElements["TABS"] = "Tabs";
  /** A list with icons and support for context menu. https://shared-ui.expedia.biz/components/web/retail/product/internal/product-text-info-section */
  FastTrackElements["TEXTICONTOOLTIP"] = "TextIconTooltip";
})(FastTrackElements || (FastTrackElements = {}));
export var FastTrackFlexAlign;
(function (FastTrackFlexAlign) {
  FastTrackFlexAlign["BASELINE"] = "BASELINE";
  FastTrackFlexAlign["CENTER"] = "CENTER";
  FastTrackFlexAlign["END"] = "END";
  FastTrackFlexAlign["START"] = "START";
  FastTrackFlexAlign["STRETCH"] = "STRETCH";
})(FastTrackFlexAlign || (FastTrackFlexAlign = {}));
export var FastTrackFlexDirection;
(function (FastTrackFlexDirection) {
  FastTrackFlexDirection["COLUMN"] = "COLUMN";
  FastTrackFlexDirection["ROW"] = "ROW";
})(FastTrackFlexDirection || (FastTrackFlexDirection = {}));
export var FastTrackFlexJustify;
(function (FastTrackFlexJustify) {
  FastTrackFlexJustify["CENTER"] = "CENTER";
  FastTrackFlexJustify["END"] = "END";
  FastTrackFlexJustify["START"] = "START";
})(FastTrackFlexJustify || (FastTrackFlexJustify = {}));
export var FastTrackHelperConfigMap;
(function (FastTrackHelperConfigMap) {
  FastTrackHelperConfigMap["AND"] = "And";
  FastTrackHelperConfigMap["CAPITALIZEFIRST"] = "CapitalizeFirst";
  FastTrackHelperConfigMap["DEVICETYPEEVALUATOR"] = "DeviceTypeEvaluator";
  FastTrackHelperConfigMap["EQUALS"] = "Equals";
  FastTrackHelperConfigMap["EVALUATEEXPERIMENT"] = "EvaluateExperiment";
  FastTrackHelperConfigMap["EVALUATEEXPERIMENTANDLOG"] = "EvaluateExperimentAndLog";
  FastTrackHelperConfigMap["EXPERIMENTEVALUATOR"] = "ExperimentEvaluator";
  FastTrackHelperConfigMap["FORMATDOUBLENUMBER"] = "FormatDoubleNumber";
  FastTrackHelperConfigMap["FORMATINTEGERNUMBER"] = "FormatIntegerNumber";
  FastTrackHelperConfigMap["GETSYSTEMTIMEINMS"] = "GetSystemTimeInMs";
  FastTrackHelperConfigMap["GETUSABLEURN"] = "GetUsableURN";
  FastTrackHelperConfigMap["GREATER"] = "Greater";
  FastTrackHelperConfigMap["GREATERANDEQUALS"] = "GreaterAndEquals";
  FastTrackHelperConfigMap["HTTPLINK"] = "HTTPLink";
  FastTrackHelperConfigMap["IMPRESSIONANALYTICSPAYLOAD"] = "ImpressionAnalyticsPayload";
  FastTrackHelperConfigMap["ISNOTNULLOREMPTY"] = "IsNotNullOrEmpty";
  FastTrackHelperConfigMap["ISQUALIFIEDVRBOPROPERTY"] = "IsQualifiedVrboProperty";
  FastTrackHelperConfigMap["JOIN"] = "Join";
  FastTrackHelperConfigMap["LIMIT"] = "Limit";
  FastTrackHelperConfigMap["LOCALIZE"] = "Localize";
  FastTrackHelperConfigMap["NOT"] = "Not";
  FastTrackHelperConfigMap["OR"] = "Or";
  FastTrackHelperConfigMap["SUBSTRING"] = "Substring";
})(FastTrackHelperConfigMap || (FastTrackHelperConfigMap = {}));
export var FastTrackImageFit;
(function (FastTrackImageFit) {
  FastTrackImageFit["CONTAIN"] = "CONTAIN";
  FastTrackImageFit["COVER"] = "COVER";
})(FastTrackImageFit || (FastTrackImageFit = {}));
export var FastTrackImageLazyload;
(function (FastTrackImageLazyload) {
  FastTrackImageLazyload["EAGER"] = "EAGER";
  FastTrackImageLazyload["LAZY"] = "LAZY";
  FastTrackImageLazyload["OFF"] = "OFF";
})(FastTrackImageLazyload || (FastTrackImageLazyload = {}));
export var FastTrackImageRounded;
(function (FastTrackImageRounded) {
  FastTrackImageRounded["ALL"] = "ALL";
  FastTrackImageRounded["END_END"] = "END_END";
  FastTrackImageRounded["END_START"] = "END_START";
  FastTrackImageRounded["FALSE"] = "FALSE";
  FastTrackImageRounded["MAX"] = "MAX";
  FastTrackImageRounded["START_END"] = "START_END";
  FastTrackImageRounded["START_START"] = "START_START";
  FastTrackImageRounded["TRUE"] = "TRUE";
})(FastTrackImageRounded || (FastTrackImageRounded = {}));
export var FastTrackModalNavType;
(function (FastTrackModalNavType) {
  FastTrackModalNavType["BACK"] = "BACK";
  FastTrackModalNavType["CLOSE"] = "CLOSE";
  FastTrackModalNavType["EXPAND_DOWN"] = "EXPAND_DOWN";
  FastTrackModalNavType["EXPAND_UP"] = "EXPAND_UP";
})(FastTrackModalNavType || (FastTrackModalNavType = {}));
export var FastTrackModalPosition;
(function (FastTrackModalPosition) {
  FastTrackModalPosition["LEADING"] = "LEADING";
  FastTrackModalPosition["TRAILING"] = "TRAILING";
})(FastTrackModalPosition || (FastTrackModalPosition = {}));
export var FastTrackModalSideSheetLayout;
(function (FastTrackModalSideSheetLayout) {
  FastTrackModalSideSheetLayout["EIGHT"] = "EIGHT";
  FastTrackModalSideSheetLayout["FOUR"] = "FOUR";
  FastTrackModalSideSheetLayout["ONE"] = "ONE";
  FastTrackModalSideSheetLayout["SIX"] = "SIX";
  FastTrackModalSideSheetLayout["THREE"] = "THREE";
  FastTrackModalSideSheetLayout["TWELVE"] = "TWELVE";
  FastTrackModalSideSheetLayout["TWO"] = "TWO";
})(FastTrackModalSideSheetLayout || (FastTrackModalSideSheetLayout = {}));
export var FastTrackModalType;
(function (FastTrackModalType) {
  FastTrackModalType["BOTTOM"] = "BOTTOM";
  FastTrackModalType["CENTERED"] = "CENTERED";
  FastTrackModalType["FULL"] = "FULL";
  FastTrackModalType["POPOVER"] = "POPOVER";
  FastTrackModalType["SIDE"] = "SIDE";
})(FastTrackModalType || (FastTrackModalType = {}));
/** Handle text that would overflow out of the current line and element */
export var FastTrackOverflow;
(function (FastTrackOverflow) {
  FastTrackOverflow["TRUNCATE"] = "TRUNCATE";
  FastTrackOverflow["TRUNCATE_FOUR_LINES"] = "TRUNCATE_FOUR_LINES";
  FastTrackOverflow["TRUNCATE_THREE_LINES"] = "TRUNCATE_THREE_LINES";
  FastTrackOverflow["TRUNCATE_TWO_LINES"] = "TRUNCATE_TWO_LINES";
  FastTrackOverflow["WRAP"] = "WRAP";
})(FastTrackOverflow || (FastTrackOverflow = {}));
export var FastTrackProductEntityAssetSelection;
(function (FastTrackProductEntityAssetSelection) {
  FastTrackProductEntityAssetSelection["ACCESSIBILITY_CONTENT"] = "ACCESSIBILITY_CONTENT";
  FastTrackProductEntityAssetSelection["AMENITY"] = "AMENITY";
  FastTrackProductEntityAssetSelection["EXPERIENCE_SCORE"] = "EXPERIENCE_SCORE";
  FastTrackProductEntityAssetSelection["EXPERIENCE_SCORE_WITH_TOP_RATED_ATTRIBUTES"] = "EXPERIENCE_SCORE_WITH_TOP_RATED_ATTRIBUTES";
  FastTrackProductEntityAssetSelection["FAMILY_HIGHLIGHTS"] = "FAMILY_HIGHLIGHTS";
  FastTrackProductEntityAssetSelection["HEADLINE"] = "HEADLINE";
  FastTrackProductEntityAssetSelection["IMAGE"] = "IMAGE";
  FastTrackProductEntityAssetSelection["LOCATION_DESCRIPTION"] = "LOCATION_DESCRIPTION";
  FastTrackProductEntityAssetSelection["LUXURY_STAYS"] = "LUXURY_STAYS";
  FastTrackProductEntityAssetSelection["PLACE"] = "PLACE";
  FastTrackProductEntityAssetSelection["POLICY"] = "POLICY";
  FastTrackProductEntityAssetSelection["PRODUCT_ATTRIBUTE"] = "PRODUCT_ATTRIBUTE";
  FastTrackProductEntityAssetSelection["PRODUCT_HIGHLIGHTS"] = "PRODUCT_HIGHLIGHTS";
  FastTrackProductEntityAssetSelection["PRODUCT_UNIQUENESS_HIGHLIGHTS"] = "PRODUCT_UNIQUENESS_HIGHLIGHTS";
  FastTrackProductEntityAssetSelection["PROPERTY_AMENITY_GROUPS"] = "PROPERTY_AMENITY_GROUPS";
  FastTrackProductEntityAssetSelection["RELEVANT_AMENITY_DETAILS"] = "RELEVANT_AMENITY_DETAILS";
  FastTrackProductEntityAssetSelection["REVIEW_DETAILS"] = "REVIEW_DETAILS";
  FastTrackProductEntityAssetSelection["REVIEW_IMAGES"] = "REVIEW_IMAGES";
  FastTrackProductEntityAssetSelection["REVIEW_SUMMARY"] = "REVIEW_SUMMARY";
  FastTrackProductEntityAssetSelection["REVIEW_SUMMARY_HIGHLIGHTS"] = "REVIEW_SUMMARY_HIGHLIGHTS";
  FastTrackProductEntityAssetSelection["SUPPLY_SCORE"] = "SUPPLY_SCORE";
  FastTrackProductEntityAssetSelection["TOP_RATED_DETAILS"] = "TOP_RATED_DETAILS";
  FastTrackProductEntityAssetSelection["VIRTUAL_TOUR"] = "VIRTUAL_TOUR";
})(FastTrackProductEntityAssetSelection || (FastTrackProductEntityAssetSelection = {}));
export var FastTrackProductEntityRefinementSelection;
(function (FastTrackProductEntityRefinementSelection) {
  FastTrackProductEntityRefinementSelection["EMBARGO"] = "EMBARGO";
})(FastTrackProductEntityRefinementSelection || (FastTrackProductEntityRefinementSelection = {}));
export var FastTrackSpace;
(function (FastTrackSpace) {
  FastTrackSpace["FOUR"] = "four";
  FastTrackSpace["HALF"] = "half";
  FastTrackSpace["ONE"] = "one";
  FastTrackSpace["SIX"] = "six";
  FastTrackSpace["THREE"] = "three";
  FastTrackSpace["TWELVE"] = "twelve";
  FastTrackSpace["TWO"] = "two";
})(FastTrackSpace || (FastTrackSpace = {}));
export var FastTrackSpacingOptions;
(function (FastTrackSpacingOptions) {
  FastTrackSpacingOptions["FOUR"] = "FOUR";
  FastTrackSpacingOptions["HALF"] = "HALF";
  FastTrackSpacingOptions["ONE"] = "ONE";
  FastTrackSpacingOptions["SIX"] = "SIX";
  FastTrackSpacingOptions["SIXTEEN"] = "SIXTEEN";
  FastTrackSpacingOptions["THREE"] = "THREE";
  FastTrackSpacingOptions["TWELVE"] = "TWELVE";
  FastTrackSpacingOptions["TWO"] = "TWO";
  FastTrackSpacingOptions["UNSET"] = "UNSET";
})(FastTrackSpacingOptions || (FastTrackSpacingOptions = {}));
export var FastTrackTabType;
(function (FastTrackTabType) {
  FastTrackTabType["EQUAL_WIDTH"] = "EQUAL_WIDTH";
  FastTrackTabType["NATURAL"] = "NATURAL";
})(FastTrackTabType || (FastTrackTabType = {}));
export var FeeType;
(function (FeeType) {
  FeeType["CARD_ON_FILE_DAMAGE_LIABILITY"] = "CARD_ON_FILE_DAMAGE_LIABILITY";
  FeeType["DEFAULT"] = "DEFAULT";
  FeeType["DEFAULT_SUPPLIER_COLLECTED"] = "DEFAULT_SUPPLIER_COLLECTED";
  FeeType["GROUPED_MANDATORY_FEES"] = "GROUPED_MANDATORY_FEES";
  FeeType["L26_TAX_BREAKOUT"] = "L26_TAX_BREAKOUT";
  FeeType["NORMAL"] = "NORMAL";
  FeeType["OTHER"] = "OTHER";
  FeeType["PER_PERSON_PER_NIGHT"] = "PER_PERSON_PER_NIGHT";
  FeeType["PROPERTY"] = "PROPERTY";
  FeeType["REFUNDABLE_DAMAGE_DEPOSIT"] = "REFUNDABLE_DAMAGE_DEPOSIT";
  FeeType["RESORT"] = "RESORT";
})(FeeType || (FeeType = {}));
/** The filter placement for the map view */
export var FilterPlacement;
(function (FilterPlacement) {
  /** Display the filters on the bottom, over the map */
  FilterPlacement["OVERLAY_BOTTOM"] = "OVERLAY_BOTTOM";
  /** Display the filters on the top, over the map */
  FilterPlacement["OVERLAY_TOP"] = "OVERLAY_TOP";
  /** Display the filters in the toolbar */
  FilterPlacement["TOOLBAR"] = "TOOLBAR";
})(FilterPlacement || (FilterPlacement = {}));
/** Enum class to represent the type of flexible change policies */
export var FilterPolicyType;
(function (FilterPolicyType) {
  FilterPolicyType["NO_CHANGE_FEE"] = "NO_CHANGE_FEE";
})(FilterPolicyType || (FilterPolicyType = {}));
/** Enum class to represent the type of travel and baggage */
export var FilterTravelAndBaggageType;
(function (FilterTravelAndBaggageType) {
  FilterTravelAndBaggageType["CARRY_ON_BAG"] = "CARRY_ON_BAG";
  FilterTravelAndBaggageType["FIRST_CHECKED_BAG"] = "FIRST_CHECKED_BAG";
  FilterTravelAndBaggageType["NO_CANCEL_FEE"] = "NO_CANCEL_FEE";
  FilterTravelAndBaggageType["NO_CHANGE_FEE"] = "NO_CHANGE_FEE";
  FilterTravelAndBaggageType["SEAT_CHOICE"] = "SEAT_CHOICE";
})(FilterTravelAndBaggageType || (FilterTravelAndBaggageType = {}));
export var FlavorType;
(function (FlavorType) {
  FlavorType["DEMO"] = "DEMO";
  FlavorType["INT"] = "INT";
  FlavorType["LAB"] = "LAB";
  FlavorType["PROD"] = "PROD";
  FlavorType["SANDBOX"] = "SANDBOX";
})(FlavorType || (FlavorType = {}));
/** Controls the alignment along the cross axis. */
export var FlexAlignItems;
(function (FlexAlignItems) {
  FlexAlignItems["CENTER"] = "CENTER";
  FlexAlignItems["END"] = "END";
  FlexAlignItems["START"] = "START";
  FlexAlignItems["STRETCH"] = "STRETCH";
})(FlexAlignItems || (FlexAlignItems = {}));
/** The direction children items are placed inside the flex container, it determines the direction of the main axis (and the cross axis, perpendicular to the main axis). */
export var FlexDirection;
(function (FlexDirection) {
  FlexDirection["ROW"] = "ROW";
})(FlexDirection || (FlexDirection = {}));
/** Controls the alignment along the main axis. */
export var FlexJustifyContent;
(function (FlexJustifyContent) {
  FlexJustifyContent["CENTER"] = "CENTER";
  FlexJustifyContent["END"] = "END";
  FlexJustifyContent["SPACE_AROUND"] = "SPACE_AROUND";
  FlexJustifyContent["SPACE_BETWEEN"] = "SPACE_BETWEEN";
  FlexJustifyContent["START"] = "START";
})(FlexJustifyContent || (FlexJustifyContent = {}));
/** Controls whether the flex container is single-line or multi-line, and the direction of the cross axis. */
export var FlexWrap;
(function (FlexWrap) {
  FlexWrap["NOWRAP"] = "NOWRAP";
})(FlexWrap || (FlexWrap = {}));
/** The trip duration type for the flex search */
export var FlexibleSearchTripDurationType;
(function (FlexibleSearchTripDurationType) {
  FlexibleSearchTripDurationType["MONTH"] = "MONTH";
  FlexibleSearchTripDurationType["WEEK"] = "WEEK";
  FlexibleSearchTripDurationType["WEEKEND"] = "WEEKEND";
})(FlexibleSearchTripDurationType || (FlexibleSearchTripDurationType = {}));
export var FlightCabinClassInfo;
(function (FlightCabinClassInfo) {
  FlightCabinClassInfo["ANY"] = "ANY";
  FlightCabinClassInfo["BUSINESS"] = "BUSINESS";
  FlightCabinClassInfo["COACH"] = "COACH";
  FlightCabinClassInfo["FIRST"] = "FIRST";
  FlightCabinClassInfo["PREMIUM_ECONOMY"] = "PREMIUM_ECONOMY";
})(FlightCabinClassInfo || (FlightCabinClassInfo = {}));
/** Represents cross sell product types that will be displayed */
export var FlightCrossSellProductType;
(function (FlightCrossSellProductType) {
  FlightCrossSellProductType["CAR"] = "CAR";
  FlightCrossSellProductType["HOTEL"] = "HOTEL";
})(FlightCrossSellProductType || (FlightCrossSellProductType = {}));
/** Represents the enum for flight journey status */
export var FlightJourneyStatus;
(function (FlightJourneyStatus) {
  /** Represents that the segment status as failure */
  FlightJourneyStatus["FAILURE"] = "FAILURE";
  /** Represents that the segment status as success */
  FlightJourneyStatus["SUCCESS"] = "SUCCESS";
})(FlightJourneyStatus || (FlightJourneyStatus = {}));
/** Represents the different sub-pages of Flight Search where the OneKeyLoyaltyBanner can be shown */
export var FlightPage;
(function (FlightPage) {
  FlightPage["MULTIDEST_LEG_0"] = "MULTIDEST_LEG_0";
  FlightPage["MULTIDEST_LEG_1"] = "MULTIDEST_LEG_1";
  FlightPage["MULTIDEST_LEG_2"] = "MULTIDEST_LEG_2";
  FlightPage["MULTIDEST_LEG_3"] = "MULTIDEST_LEG_3";
  FlightPage["MULTIDEST_LEG_4"] = "MULTIDEST_LEG_4";
  FlightPage["ONE_WAY"] = "ONE_WAY";
  FlightPage["ROUNDTRIP_IN"] = "ROUNDTRIP_IN";
  FlightPage["ROUNDTRIP_OUT"] = "ROUNDTRIP_OUT";
})(FlightPage || (FlightPage = {}));
/** Represent Type for the values of FlightSelectableAncillaryOption */
export var FlightSelectableAncillaryOptionValuesType;
(function (FlightSelectableAncillaryOptionValuesType) {
  /** Represents NONE value */
  FlightSelectableAncillaryOptionValuesType["NONE"] = "NONE";
  /** Represents a Valid value | eg: upto 15 kg */
  FlightSelectableAncillaryOptionValuesType["VALID"] = "VALID";
})(FlightSelectableAncillaryOptionValuesType || (FlightSelectableAncillaryOptionValuesType = {}));
/** Represents the theme for the duration timeline */
export var FlightShoppingCardDurationTimelineTheme;
(function (FlightShoppingCardDurationTimelineTheme) {
  /** Default timeline theme (brand accent color) */
  FlightShoppingCardDurationTimelineTheme["DEFAULT"] = "DEFAULT";
  /** Represents a color indicating a muted state (gray) */
  FlightShoppingCardDurationTimelineTheme["MUTE"] = "MUTE";
  /** Represents a color indicating a success state (green) */
  FlightShoppingCardDurationTimelineTheme["SUCCESS"] = "SUCCESS";
})(FlightShoppingCardDurationTimelineTheme || (FlightShoppingCardDurationTimelineTheme = {}));
/** Describes the type of actionable button. Types reference UDS tokens for buttons. */
export var FlightsActionDisplayType;
(function (FlightsActionDisplayType) {
  /** Checkbox. Example: To add Price Match Promise */
  FlightsActionDisplayType["CHECKBOX"] = "CHECKBOX";
  /** Primary action. Example: 'Add Hotel Now' button, 'Retry' button */
  FlightsActionDisplayType["PRIMARY"] = "PRIMARY";
  /** Radio Button. Example: To choose seats for a particular traveler */
  FlightsActionDisplayType["RADIO_BUTTON"] = "RADIO_BUTTON";
  /** Secondary action. */
  FlightsActionDisplayType["SECONDARY"] = "SECONDARY";
  /** Switch toggle action. Example: price alerts subscription toggle */
  FlightsActionDisplayType["SWITCH"] = "SWITCH";
  /** Tertiary action. Example: 'No Thanks' */
  FlightsActionDisplayType["TERTIARY"] = "TERTIARY";
  /** Toggle action. Example: seat button in seat map */
  FlightsActionDisplayType["TOGGLE"] = "TOGGLE";
})(FlightsActionDisplayType || (FlightsActionDisplayType = {}));
/** Represents the position of the action in the placard */
export var FlightsActionPosition;
(function (FlightsActionPosition) {
  /** Represents the action to be placed at the BOTTOM of the placard */
  FlightsActionPosition["BOTTOM"] = "BOTTOM";
  /** Represents the action to be placed at the RIGHT of the placard */
  FlightsActionPosition["RIGHT"] = "RIGHT";
})(FlightsActionPosition || (FlightsActionPosition = {}));
/** Available action types an actionable element */
export var FlightsActionType;
(function (FlightsActionType) {
  /** Add Price Match Promise to the seleted fare */
  FlightsActionType["ADD_PRICE_MATCH_PROMISE"] = "ADD_PRICE_MATCH_PROMISE";
  /** User has selected seat(s) for all passengers in that leg */
  FlightsActionType["ALL_SEATS_SELECTED_FOR_A_LEG"] = "ALL_SEATS_SELECTED_FOR_A_LEG";
  /** Selects the chosen fare and reloads dynamic elements */
  FlightsActionType["APPLY_FARE"] = "APPLY_FARE";
  /** Highlights the fare chosen by the user */
  FlightsActionType["CHOOSE_FARE"] = "CHOOSE_FARE";
  /** Dialog Box used when customer clicks the 'Next Flight' Button before selecting seats for Current Flight */
  FlightsActionType["CLICKING_NEXT_FLIGHT_BEFORE_FINISHING_CURRENT_FLIGHT_SEAT_SELECTION_DIALOG"] = "CLICKING_NEXT_FLIGHT_BEFORE_FINISHING_CURRENT_FLIGHT_SEAT_SELECTION_DIALOG";
  /** Dialog Box used when customer clicks the 'Continue Booking' Button before selecting all the seats */
  FlightsActionType["CONTINUE_BOOKING_WITHOUT_SELECTING_SEATS_DIALOG"] = "CONTINUE_BOOKING_WITHOUT_SELECTING_SEATS_DIALOG";
  /** Go to coupon credit page */
  FlightsActionType["COUPON_CREDIT"] = "COUPON_CREDIT";
  /** Dismisses a dialog */
  FlightsActionType["DISMISS"] = "DISMISS";
  /** Activates the suggested filter */
  FlightsActionType["ENABLE_SUGGESTED_FILTER"] = "ENABLE_SUGGESTED_FILTER";
  /** Fetch more search listings */
  FlightsActionType["FETCH_SEARCH_LISTINGS"] = "FETCH_SEARCH_LISTINGS";
  /** Redirect used when customer clicks signin/signup page/module option from 'you might have credits module listing' */
  FlightsActionType["GO_TO_AUTH"] = "GO_TO_AUTH";
  /** Go to Checkout page */
  FlightsActionType["GO_TO_CHECKOUT"] = "GO_TO_CHECKOUT";
  /** Go to the confirmation page of post booking ancillary selection */
  FlightsActionType["GO_TO_CONFIRMATION"] = "GO_TO_CONFIRMATION";
  /** Continues to the standalone details page */
  FlightsActionType["GO_TO_DETAILS"] = "GO_TO_DETAILS";
  /** Go to the merch hub of post booking ancillary selections */
  FlightsActionType["GO_TO_MERCH_HUB"] = "GO_TO_MERCH_HUB";
  /** Continues to the next set of journey results */
  FlightsActionType["GO_TO_NEXT_JOURNEY"] = "GO_TO_NEXT_JOURNEY";
  /** Continues to the packages path */
  FlightsActionType["GO_TO_PACKAGES"] = "GO_TO_PACKAGES";
  /** Redirects to flights search page */
  FlightsActionType["GO_TO_SEARCH"] = "GO_TO_SEARCH";
  /** Redirects back to storefront */
  FlightsActionType["GO_TO_STOREFRONT"] = "GO_TO_STOREFRONT";
  /** Go to the trips overview page */
  FlightsActionType["GO_TO_TRIPS"] = "GO_TO_TRIPS";
  /** Opens a dialog for to display cross sell information */
  FlightsActionType["LOAD_CROSS_SELL_DIALOG"] = "LOAD_CROSS_SELL_DIALOG";
  /** open amenities tray and upsell options for standard offer flight listings */
  FlightsActionType["LOAD_STANDARD_OFFER_FARE_RULE_MODULE"] = "LOAD_STANDARD_OFFER_FARE_RULE_MODULE";
  /** Opens a dialog to display tax breakdown information */
  FlightsActionType["LOAD_TAX_BREAKDOWN_DIALOG"] = "LOAD_TAX_BREAKDOWN_DIALOG";
  /** Opens signin pop up on clicking on checkout button on FIS */
  FlightsActionType["MEMBER_SIGNIN"] = "MEMBER_SIGNIN";
  /** User has not selected seat(s) for any passengers in that leg */
  FlightsActionType["NO_SEATS_SELECTED_FOR_A_LEG"] = "NO_SEATS_SELECTED_FOR_A_LEG";
  /** Opens bags selection alert dialog on clicking on checkout button on FIS */
  FlightsActionType["OPEN_BAGS_SELECTION_ALERT_DIALOG_ON_CHECKOUT"] = "OPEN_BAGS_SELECTION_ALERT_DIALOG_ON_CHECKOUT";
  /** Opens sidesheet for bags selection */
  FlightsActionType["OPEN_BAGS_SELECTION_SHEET"] = "OPEN_BAGS_SELECTION_SHEET";
  /** Opens a dialog to to go to Airlines Site for Booking */
  FlightsActionType["OPEN_BOOK_DIRECTLY_WITH_AIRLINES_DIALOG"] = "OPEN_BOOK_DIRECTLY_WITH_AIRLINES_DIALOG";
  /** Dialog Box used when customer clicks the 'Select credit' or 'Change Credit' option from 'you might have credits module listing' */
  FlightsActionType["OPEN_CREDIT_DIALOG"] = "OPEN_CREDIT_DIALOG";
  /** Open Fare Seat information when clicked on required seat button */
  FlightsActionType["OPEN_FARE_SEAT_MAP_SEAT_SHEET"] = "OPEN_FARE_SEAT_MAP_SEAT_SHEET";
  /** Open Fare Seat view to preview the seat map */
  FlightsActionType["OPEN_FARE_SEAT_MAP_VIEW"] = "OPEN_FARE_SEAT_MAP_VIEW";
  /** Open Fare Seat view to select the seat */
  FlightsActionType["OPEN_FARE_SEAT_SELECT_VIEW"] = "OPEN_FARE_SEAT_SELECT_VIEW";
  /** Open Flight leg drop down in seat map view */
  FlightsActionType["OPEN_FLIGHT_LEG_DROP_DOWN_IN_SEAT_MAP_DIALOG"] = "OPEN_FLIGHT_LEG_DROP_DOWN_IN_SEAT_MAP_DIALOG";
  /** Open Legend info sheet in bottom in case of mobile */
  FlightsActionType["OPEN_LEGEND_INFO_SHEET_MOBILE"] = "OPEN_LEGEND_INFO_SHEET_MOBILE";
  /** Open price summary */
  FlightsActionType["OPEN_PRICE_SUMMARY"] = "OPEN_PRICE_SUMMARY";
  /** Opens seat selection alert dialog on clicking on checkout button on FIS */
  FlightsActionType["OPEN_SEAT_SELECTION_ALERT_DIALOG_ON_CHECKOUT"] = "OPEN_SEAT_SELECTION_ALERT_DIALOG_ON_CHECKOUT";
  /** Redirects to Airlines Site for Booking */
  FlightsActionType["REDIRECT_TO_AIRLINES_FOR_BOOKING"] = "REDIRECT_TO_AIRLINES_FOR_BOOKING";
  /** Refreshes the current page */
  FlightsActionType["REFRESH"] = "REFRESH";
  /** Actionable item to add a journey */
  FlightsActionType["SEARCH_FORM_ADD_JOURNEY"] = "SEARCH_FORM_ADD_JOURNEY";
  /** Closes the expanded Search Form */
  FlightsActionType["SEARCH_FORM_CLOSE_BUTTON"] = "SEARCH_FORM_CLOSE_BUTTON";
  /** Actionable item to remove a journey */
  FlightsActionType["SEARCH_FORM_REMOVE_JOURNEY"] = "SEARCH_FORM_REMOVE_JOURNEY";
  /** Dialog Box used when customer clicks the 'Close' Button before selecting all the seats */
  FlightsActionType["SEAT_MAP_CLOSE_WITHOUT_SELECTING_SEATS_DIALOG"] = "SEAT_MAP_CLOSE_WITHOUT_SELECTING_SEATS_DIALOG";
  /** Continues to flight details page after selecting seats for all flights */
  FlightsActionType["SEAT_MAP_CONTINUE_BOOKING"] = "SEAT_MAP_CONTINUE_BOOKING";
  /** Closes the current flight seat selection page and continues for next flight */
  FlightsActionType["SEAT_MAP_GO_TO_NEXT_FLIGHT"] = "SEAT_MAP_GO_TO_NEXT_FLIGHT";
  /** Go to next flight section for selecting seats */
  FlightsActionType["SEAT_MAP_NEXT_FLIGHT"] = "SEAT_MAP_NEXT_FLIGHT";
  /** Saves user's seat preferences and redirects to FIS */
  FlightsActionType["SEAT_MAP_SAVE_AND_EXIT"] = "SEAT_MAP_SAVE_AND_EXIT";
  /** Stays at Page displaying Seat Map when selected by user */
  FlightsActionType["SEAT_MAP_STAY_HERE"] = "SEAT_MAP_STAY_HERE";
  /** Continues to stay on the current flight seat selection page */
  FlightsActionType["SEAT_MAP_STAY_ON_THIS_PAGE"] = "SEAT_MAP_STAY_ON_THIS_PAGE";
  /** Allows User to Continue Booking from the Seat Selection Dialog Box */
  FlightsActionType["SEAT_SELECT_DIALOG_CONTINUE_BOOKING"] = "SEAT_SELECT_DIALOG_CONTINUE_BOOKING";
  /** Displays seat map preview corresponding to each traveler */
  FlightsActionType["SEAT_SELECT_PREVIEW_FOR_TRAVELER"] = "SEAT_SELECT_PREVIEW_FOR_TRAVELER";
  /** Select Flight leg in seat map drop down menu */
  FlightsActionType["SELECT_FLIGHT_LEG_IN_SEAT_MAP_DIALOG"] = "SELECT_FLIGHT_LEG_IN_SEAT_MAP_DIALOG";
  /** Select the seat */
  FlightsActionType["SELECT_SEAT"] = "SELECT_SEAT";
  /** Open Opinion Lab Share Feedback dialogue */
  FlightsActionType["SHARE_FEEDBACK"] = "SHARE_FEEDBACK";
  /** Open a modal showing details of the free Price Match Promise product */
  FlightsActionType["SHOW_FREE_PRICE_MATCH_PROMISE_DETAILS"] = "SHOW_FREE_PRICE_MATCH_PROMISE_DETAILS";
  /** Open a modal showing details of the Price Match Promise product */
  FlightsActionType["SHOW_PRICE_MATCH_PROMISE_DETAILS"] = "SHOW_PRICE_MATCH_PROMISE_DETAILS";
  /** User has selected seat(s) for at least 1 passenger but not all passengers in that leg */
  FlightsActionType["SOME_SEATS_SELECTED_FOR_A_LEG"] = "SOME_SEATS_SELECTED_FOR_A_LEG";
  /** Subscribe to emails */
  FlightsActionType["SUBSCRIBE_TO_EMAILS"] = "SUBSCRIBE_TO_EMAILS";
  /** Subscribe/Unsubscribes from price alerts */
  FlightsActionType["TOGGLE_PRICE_ALERTS"] = "TOGGLE_PRICE_ALERTS";
  /** Unselect the selected seat */
  FlightsActionType["UNSELECT_SEAT"] = "UNSELECT_SEAT";
  /** Opens FIS sidesheet and highlights next fare to upgrade */
  FlightsActionType["UPGRADE_TO_NEXT_FARE"] = "UPGRADE_TO_NEXT_FARE";
})(FlightsActionType || (FlightsActionType = {}));
/** Possible advanced filter types */
export var FlightsAdvancedFilterType;
(function (FlightsAdvancedFilterType) {
  FlightsAdvancedFilterType["NONSTOP"] = "NONSTOP";
  FlightsAdvancedFilterType["REFUNDABLE"] = "REFUNDABLE";
})(FlightsAdvancedFilterType || (FlightsAdvancedFilterType = {}));
/** Enum class to represent the ancillary display action */
export var FlightsAncillaryDisplayAction;
(function (FlightsAncillaryDisplayAction) {
  FlightsAncillaryDisplayAction["NONE"] = "NONE";
  FlightsAncillaryDisplayAction["PREFETCH"] = "PREFETCH";
})(FlightsAncillaryDisplayAction || (FlightsAncillaryDisplayAction = {}));
/** Accessibility message types to be announced post selection */
export var FlightsAncillarySelectionAccessibilityMsgType;
(function (FlightsAncillarySelectionAccessibilityMsgType) {
  /** Ancillary Selection Failed */
  FlightsAncillarySelectionAccessibilityMsgType["SELECTION_FAILED"] = "SELECTION_FAILED";
  /** Ancillary Selection Success */
  FlightsAncillarySelectionAccessibilityMsgType["SELECTION_SUCCESS"] = "SELECTION_SUCCESS";
})(FlightsAncillarySelectionAccessibilityMsgType || (FlightsAncillarySelectionAccessibilityMsgType = {}));
/** Error types which can occur during ancillary selection */
export var FlightsAncillarySelectionErrorType;
(function (FlightsAncillarySelectionErrorType) {
  /** Baggage Details loaded call failed */
  FlightsAncillarySelectionErrorType["BAGGAGE_DETAILS_LOADED_FAILED"] = "BAGGAGE_DETAILS_LOADED_FAILED";
  /** Ancillary details loading failed */
  FlightsAncillarySelectionErrorType["DETAILS_LOADING_FAILED"] = "DETAILS_LOADING_FAILED";
  /** Ancillary Pre-Selection Unavailable */
  FlightsAncillarySelectionErrorType["PRE_SELECTION_FAILED"] = "PRE_SELECTION_FAILED";
  /** Ancillary Selection Failed */
  FlightsAncillarySelectionErrorType["SELECTION_FAILED"] = "SELECTION_FAILED";
  /** Ancillary Selection Unavailable */
  FlightsAncillarySelectionErrorType["SELECTION_UNAVAILABLE"] = "SELECTION_UNAVAILABLE";
})(FlightsAncillarySelectionErrorType || (FlightsAncillarySelectionErrorType = {}));
/** Type of ancillaries supported */
export var FlightsAncillaryType;
(function (FlightsAncillaryType) {
  FlightsAncillaryType["BAGS"] = "BAGS";
  FlightsAncillaryType["BAGS_V2"] = "BAGS_V2";
  FlightsAncillaryType["NONE"] = "NONE";
  FlightsAncillaryType["SEATS"] = "SEATS";
})(FlightsAncillaryType || (FlightsAncillaryType = {}));
/** Represents the theme values for a Badge */
export var FlightsBadgeTheme;
(function (FlightsBadgeTheme) {
  FlightsBadgeTheme["BRAND"] = "BRAND";
  FlightsBadgeTheme["DEAL_BUNDLED"] = "DEAL_BUNDLED";
  FlightsBadgeTheme["DEAL_GENERIC"] = "DEAL_GENERIC";
  FlightsBadgeTheme["DEAL_MEMBER"] = "DEAL_MEMBER";
  FlightsBadgeTheme["FAMILY_FRIENDLY"] = "FAMILY_FRIENDLY";
  FlightsBadgeTheme["NOTIFICATION"] = "NOTIFICATION";
  FlightsBadgeTheme["SAVED"] = "SAVED";
  FlightsBadgeTheme["SPONSORED"] = "SPONSORED";
  FlightsBadgeTheme["SUPPLIER_PROMO"] = "SUPPLIER_PROMO";
  FlightsBadgeTheme["VIEWED"] = "VIEWED";
  FlightsBadgeTheme["VIP"] = "VIP";
})(FlightsBadgeTheme || (FlightsBadgeTheme = {}));
/** Represents the button width in the UI */
export var FlightsButtonWidth;
(function (FlightsButtonWidth) {
  /** Button will take the width it needs */
  FlightsButtonWidth["DEFAULT"] = "DEFAULT";
  /** Button will take the full width of the content */
  FlightsButtonWidth["FULL_WIDTH"] = "FULL_WIDTH";
})(FlightsButtonWidth || (FlightsButtonWidth = {}));
/** Cabin class chosen in flight */
export var FlightsCabinClass;
(function (FlightsCabinClass) {
  FlightsCabinClass["ANY"] = "ANY";
  FlightsCabinClass["BUSINESS"] = "BUSINESS";
  FlightsCabinClass["COACH"] = "COACH";
  FlightsCabinClass["FIRST"] = "FIRST";
  FlightsCabinClass["PREMIUM_ECONOMY"] = "PREMIUM_ECONOMY";
})(FlightsCabinClass || (FlightsCabinClass = {}));
export var FlightsCardBackgroundTheme;
(function (FlightsCardBackgroundTheme) {
  FlightsCardBackgroundTheme["HIGHLIGHT"] = "HIGHLIGHT";
  FlightsCardBackgroundTheme["PRIMARY"] = "PRIMARY";
  FlightsCardBackgroundTheme["SECONDARY"] = "SECONDARY";
})(FlightsCardBackgroundTheme || (FlightsCardBackgroundTheme = {}));
/** Represents the type of categories */
export var FlightsCategorizedListSectionType;
(function (FlightsCategorizedListSectionType) {
  FlightsCategorizedListSectionType["BAG"] = "BAG";
  FlightsCategorizedListSectionType["BAG_STEPPER_EXPERIENCE"] = "BAG_STEPPER_EXPERIENCE";
  FlightsCategorizedListSectionType["SEAT"] = "SEAT";
})(FlightsCategorizedListSectionType || (FlightsCategorizedListSectionType = {}));
/** Enum class to represent cross sort types */
export var FlightsCrossSortType;
(function (FlightsCrossSortType) {
  FlightsCrossSortType["CABIN_CLASS"] = "CABIN_CLASS";
  FlightsCrossSortType["CANCELLATION"] = "CANCELLATION";
  FlightsCrossSortType["CARRY_ON_BAG"] = "CARRY_ON_BAG";
  FlightsCrossSortType["CHANGE_ALLOWED"] = "CHANGE_ALLOWED";
  FlightsCrossSortType["CHECKED_BAG"] = "CHECKED_BAG";
  FlightsCrossSortType["DURATION"] = "DURATION";
  FlightsCrossSortType["NUM_OF_STOPS"] = "NUM_OF_STOPS";
  FlightsCrossSortType["PRICE"] = "PRICE";
  FlightsCrossSortType["SEAT_CHOICE"] = "SEAT_CHOICE";
})(FlightsCrossSortType || (FlightsCrossSortType = {}));
/** Represents flights dialog actions */
export var FlightsDialogAction;
(function (FlightsDialogAction) {
  FlightsDialogAction["CLOSE"] = "CLOSE";
  FlightsDialogAction["OPEN"] = "OPEN";
  FlightsDialogAction["TOGGLE"] = "TOGGLE";
})(FlightsDialogAction || (FlightsDialogAction = {}));
/** Represents the type of animation the dialog will use when displayed */
export var FlightsDialogAnimation;
(function (FlightsDialogAnimation) {
  FlightsDialogAnimation["FADE"] = "FADE";
  FlightsDialogAnimation["NONE"] = "NONE";
})(FlightsDialogAnimation || (FlightsDialogAnimation = {}));
/** Represents IDs for flights dialogs */
export var FlightsDialogId;
(function (FlightsDialogId) {
  /** Represents the Airlines credit dialog */
  FlightsDialogId["AIRLINE_CREDITS"] = "AIRLINE_CREDITS";
  /** Represents the Close button dialog for the baggage details when complete selections have been made */
  FlightsDialogId["BAGGAGE_CLOSE_COMPLETE_DIALOG"] = "BAGGAGE_CLOSE_COMPLETE_DIALOG";
  /**
   * Represents the Close button dialog for the baggage details
   * @deprecated Use baggage close complete/incomplete dialogs
   */
  FlightsDialogId["BAGGAGE_CLOSE_DIALOG"] = "BAGGAGE_CLOSE_DIALOG";
  /** Represents the Close button dialog for the baggage details when incomplete selections have been made */
  FlightsDialogId["BAGGAGE_CLOSE_INCOMPLETE_DIALOG"] = "BAGGAGE_CLOSE_INCOMPLETE_DIALOG";
  /** Represents the Continue booking dialog for the baggage details */
  FlightsDialogId["BAGGAGE_CONTINUE_BOOKING"] = "BAGGAGE_CONTINUE_BOOKING";
  /** Represents the dialog ID for Baggage details */
  FlightsDialogId["BAGGAGE_DETAILS_DIALOG"] = "BAGGAGE_DETAILS_DIALOG";
  /** Represents the bags popup dialog on checkout button */
  FlightsDialogId["BAGS_POPUP_ON_CHECKOUT"] = "BAGS_POPUP_ON_CHECKOUT";
  /** Represents the check credits dialog for users coming from MCC and VA */
  FlightsDialogId["CHECK_CREDITS_DIALOG"] = "CHECK_CREDITS_DIALOG";
  /** Represents the dialog ID for disclaimer dialog related to cko reassurance banner */
  FlightsDialogId["CKO_REASSURANCE_DISCLAIMER_DIALOG"] = "CKO_REASSURANCE_DISCLAIMER_DIALOG";
  /** Represents the avion more info dialog */
  FlightsDialogId["FLIGHTS_AVION_MORE_INFO_DIALOG"] = "FLIGHTS_AVION_MORE_INFO_DIALOG";
  /** Represents the bag dimension bottom sheet */
  FlightsDialogId["FLIGHTS_BAG_DIMENSION_BOTTOM_SHEET"] = "FLIGHTS_BAG_DIMENSION_BOTTOM_SHEET";
  /** Represents the first journey bag dimension bottom sheet */
  FlightsDialogId["FLIGHTS_BAG_DIMENSION_BOTTOM_SHEET_FIRST"] = "FLIGHTS_BAG_DIMENSION_BOTTOM_SHEET_FIRST";
  /** Represents the second journey bag dimension bottom sheet */
  FlightsDialogId["FLIGHTS_BAG_DIMENSION_BOTTOM_SHEET_SECOND"] = "FLIGHTS_BAG_DIMENSION_BOTTOM_SHEET_SECOND";
  /** Represents the Flights Details and Fares dialog */
  FlightsDialogId["FLIGHTS_DETAILS_AND_FARES"] = "FLIGHTS_DETAILS_AND_FARES";
  /** Represents the Flights Details dialog */
  FlightsDialogId["FLIGHTS_DETAILS_DIALOG"] = "FLIGHTS_DETAILS_DIALOG";
  /** Represents the flights exit seats dialog */
  FlightsDialogId["FLIGHTS_EXIT_SEAT_DIALOG"] = "FLIGHTS_EXIT_SEAT_DIALOG";
  /** The Forced choice modal that appears in large breakpoints when going to FIS */
  FlightsDialogId["FORCED_CHOICE_MODAL"] = "FORCED_CHOICE_MODAL";
  /** Represents the ID for the expired flight deals dialog */
  FlightsDialogId["FSR_EXPIRED_DEALS_DIALOG"] = "FSR_EXPIRED_DEALS_DIALOG";
  /** Represents the ID for the more info on how flight deals work sheet on FSR page */
  FlightsDialogId["FSR_HOW_DEALS_WORK_SHEET"] = "FSR_HOW_DEALS_WORK_SHEET";
  /** Represents the ID for the disclaimer dialog related to the strikethrough price in the FSR out page */
  FlightsDialogId["FSR_OUT_DISCLAIMER_DIALOG"] = "FSR_OUT_DISCLAIMER_DIALOG";
  /** Represents the How Airlines Work dialog inside Select Credits */
  FlightsDialogId["HOW_CREDITS_WORK"] = "HOW_CREDITS_WORK";
  /** Represents the Leave This Page dialog inside Select Credits */
  FlightsDialogId["LEAVE_TO_COUPONS"] = "LEAVE_TO_COUPONS";
  /** Represents the sign in Dialog */
  FlightsDialogId["MEMBER_SIGN_IN_DIALOG"] = "MEMBER_SIGN_IN_DIALOG";
  /** Represents the dialog ID while merchandising selections are being booked */
  FlightsDialogId["MERCHANDISING_SELECTIONS_BOOKING_LOADING"] = "MERCHANDISING_SELECTIONS_BOOKING_LOADING";
  /** Represents the dialog ID for merchandising selections expiry dialog */
  FlightsDialogId["MERCHANDISING_SELECTIONS_EXPIRY"] = "MERCHANDISING_SELECTIONS_EXPIRY";
  /** Represents the ID for the Mobile Application Download Sheet */
  FlightsDialogId["MOBILE_APP_DOWNLOAD_SHEET"] = "MOBILE_APP_DOWNLOAD_SHEET";
  /** Represents the ID for the dialog box when for OCU we downgrade a fare and the dialog is shown for losing amenities */
  FlightsDialogId["ONE_CLICK_FARE_DOWNGRADE_DIALOG"] = "ONE_CLICK_FARE_DOWNGRADE_DIALOG";
  /** Represents the ID for the sheet which shows the fare split ticket banner */
  FlightsDialogId["ONE_CLICK_FARE_SPLIT_TICKET_BANNER_SHEET"] = "ONE_CLICK_FARE_SPLIT_TICKET_BANNER_SHEET";
  /** Represents the bags opening dialog eg:- sidesheet for desktop , fullscreendialog for mobile */
  FlightsDialogId["PAID_BAGS_DIALOG"] = "PAID_BAGS_DIALOG";
  /** Represents the Info dialog for Price Match Promise Selected Card */
  FlightsDialogId["PMP_INFO_DIALOG"] = "PMP_INFO_DIALOG";
  /** Represents the Price Match Promise One Key Web dialog */
  FlightsDialogId["PMP_ONE_KEY_WEB_DIALOG"] = "PMP_ONE_KEY_WEB_DIALOG";
  /** Represents the Remove dialog for Price Match Promise Selected Card */
  FlightsDialogId["PMP_REMOVE_DIALOG"] = "PMP_REMOVE_DIALOG";
  /** Represents the seats popup dialog on checkout button */
  FlightsDialogId["SEATS_POPUP_ON_CHECKOUT"] = "SEATS_POPUP_ON_CHECKOUT";
  /** Represents the dialog ID for seat cell details dialog */
  FlightsDialogId["SEAT_CELL_DETAILS_DIALOG"] = "SEAT_CELL_DETAILS_DIALOG";
  /** Represents the Close button dialog for the seat details */
  FlightsDialogId["SEAT_CLOSE_COMPLETE_DIALOG"] = "SEAT_CLOSE_COMPLETE_DIALOG";
  /** Represents the Continue booking dialog for the baggage details */
  FlightsDialogId["SEAT_CONTINUE_BOOKING"] = "SEAT_CONTINUE_BOOKING";
  /** Represents the dialog ID for seat legends dialog */
  FlightsDialogId["SEAT_LEGEND_DIALOG"] = "SEAT_LEGEND_DIALOG";
  /** Represents the seats opening dialog eg:- sidesheet for desktop , fullscreendialog for mobile */
  FlightsDialogId["SEAT_SELECTION_DIALOG"] = "SEAT_SELECTION_DIALOG";
  /** Represents the skip to bags seats incomplete selection dialog */
  FlightsDialogId["SKIP_TO_BAGS_SEATS_INCOMPLETE_SELECTION_DIALOG"] = "SKIP_TO_BAGS_SEATS_INCOMPLETE_SELECTION_DIALOG";
  /** Represents the skip to bags seats no selection dialog */
  FlightsDialogId["SKIP_TO_BAGS_SEATS_NO_SELECTION_DIALOG"] = "SKIP_TO_BAGS_SEATS_NO_SELECTION_DIALOG";
  /** Represents the skip to checkout bags dialog */
  FlightsDialogId["SKIP_TO_CKO_BAGS_DIALOG"] = "SKIP_TO_CKO_BAGS_DIALOG";
  /** Represents the skip to checkout seats and bags dialog */
  FlightsDialogId["SKIP_TO_CKO_SEATS_AND_BAGS_DIALOG"] = "SKIP_TO_CKO_SEATS_AND_BAGS_DIALOG";
  /** Represents the skip to checkout seats dialog */
  FlightsDialogId["SKIP_TO_CKO_SEATS_DIALOG"] = "SKIP_TO_CKO_SEATS_DIALOG";
  /** Represents the dialog on traveler mismatch for credits offer */
  FlightsDialogId["TRAVELER_MISMATCH_DIALOG"] = "TRAVELER_MISMATCH_DIALOG";
})(FlightsDialogId || (FlightsDialogId = {}));
/** Represents a pre action in flights dialog trigger */
export var FlightsDialogPreAction;
(function (FlightsDialogPreAction) {
  FlightsDialogPreAction["CLOSE_ALL_DIALOGS"] = "CLOSE_ALL_DIALOGS";
})(FlightsDialogPreAction || (FlightsDialogPreAction = {}));
/** Represents flights component */
export var FlightsDisplayComponent;
(function (FlightsDisplayComponent) {
  FlightsDisplayComponent["SMART_NFF_ALTERNATE_SUGGESTION"] = "SMART_NFF_ALTERNATE_SUGGESTION";
})(FlightsDisplayComponent || (FlightsDisplayComponent = {}));
/** Css class names for datepicker cell content. */
export var FlightsFareCalendarPriceTheme;
(function (FlightsFareCalendarPriceTheme) {
  FlightsFareCalendarPriceTheme["NEGATIVE"] = "NEGATIVE";
  FlightsFareCalendarPriceTheme["POSITIVE"] = "POSITIVE";
  FlightsFareCalendarPriceTheme["UNDEFINED"] = "UNDEFINED";
})(FlightsFareCalendarPriceTheme || (FlightsFareCalendarPriceTheme = {}));
/** Represents the fares scroll direction */
export var FlightsFaresScrollDirection;
(function (FlightsFaresScrollDirection) {
  FlightsFaresScrollDirection["HORIZONTAL"] = "HORIZONTAL";
  FlightsFaresScrollDirection["VERTICAL"] = "VERTICAL";
})(FlightsFaresScrollDirection || (FlightsFaresScrollDirection = {}));
/** Represent the fares needs to be present in listing results */
export var FlightsFaresSeparationType;
(function (FlightsFaresSeparationType) {
  FlightsFaresSeparationType["BASE_AND_UPSELL"] = "BASE_AND_UPSELL";
  FlightsFaresSeparationType["NONSTOP_BASE_AND_UPSELL"] = "NONSTOP_BASE_AND_UPSELL";
  FlightsFaresSeparationType["NONSTOP_ONLY_BASE"] = "NONSTOP_ONLY_BASE";
  FlightsFaresSeparationType["NONSTOP_ONLY_UPSELL"] = "NONSTOP_ONLY_UPSELL";
  FlightsFaresSeparationType["ONLY_BASE"] = "ONLY_BASE";
  FlightsFaresSeparationType["ONLY_UPSELL"] = "ONLY_UPSELL";
})(FlightsFaresSeparationType || (FlightsFaresSeparationType = {}));
/** Enum class to represent the available filter types */
export var FlightsFilterType;
(function (FlightsFilterType) {
  FlightsFilterType["ADDITIONAL_AMENITY"] = "ADDITIONAL_AMENITY";
  FlightsFilterType["ARRIVAL_AIRPORT"] = "ARRIVAL_AIRPORT";
  FlightsFilterType["ARRIVAL_TIME"] = "ARRIVAL_TIME";
  FlightsFilterType["ARRIVAL_TIME_SLIDER"] = "ARRIVAL_TIME_SLIDER";
  FlightsFilterType["CARRY_ON_BAG"] = "CARRY_ON_BAG";
  FlightsFilterType["CHECKED_BAG"] = "CHECKED_BAG";
  FlightsFilterType["CREDIT_ELIGIBLE"] = "CREDIT_ELIGIBLE";
  FlightsFilterType["DEPARTURE_AIRPORT"] = "DEPARTURE_AIRPORT";
  FlightsFilterType["DEPARTURE_TIME"] = "DEPARTURE_TIME";
  FlightsFilterType["DEPARTURE_TIME_SLIDER"] = "DEPARTURE_TIME_SLIDER";
  FlightsFilterType["DURATION"] = "DURATION";
  FlightsFilterType["FLEXIBLE_CHANGE_POLICIES"] = "FLEXIBLE_CHANGE_POLICIES";
  FlightsFilterType["LAYOVER_AIRPORT"] = "LAYOVER_AIRPORT";
  FlightsFilterType["LAYOVER_TIME_SLIDER"] = "LAYOVER_TIME_SLIDER";
  FlightsFilterType["NO_CANCEL_FEE"] = "NO_CANCEL_FEE";
  FlightsFilterType["NO_CHANGE_FEE"] = "NO_CHANGE_FEE";
  FlightsFilterType["NUM_OF_STOPS"] = "NUM_OF_STOPS";
  FlightsFilterType["PREFERRED_AIRLINE"] = "PREFERRED_AIRLINE";
  FlightsFilterType["PREFERRED_CABIN"] = "PREFERRED_CABIN";
  FlightsFilterType["PRICE"] = "PRICE";
  FlightsFilterType["SEAT_CHOICE"] = "SEAT_CHOICE";
  FlightsFilterType["TRAVEL_AND_BAGGAGE"] = "TRAVEL_AND_BAGGAGE";
  FlightsFilterType["TRAVEL_TIME_SLIDER"] = "TRAVEL_TIME_SLIDER";
})(FlightsFilterType || (FlightsFilterType = {}));
/** Represents the flexible grid type */
export var FlightsFlexibleGridType;
(function (FlightsFlexibleGridType) {
  /** Flex Search type shown for OW */
  FlightsFlexibleGridType["FLEX_SEARCH"] = "FLEX_SEARCH";
  /** Flex Search Grid type shown for RT Outbound */
  FlightsFlexibleGridType["FLEX_SEARCH_GRID"] = "FLEX_SEARCH_GRID";
  /** No Flex Search variant shown */
  FlightsFlexibleGridType["FLEX_SEARCH_NOT_APPLICABLE"] = "FLEX_SEARCH_NOT_APPLICABLE";
})(FlightsFlexibleGridType || (FlightsFlexibleGridType = {}));
/** Represent flexible search header cell theme */
export var FlightsFlexibleSearchHeaderCellTheme;
(function (FlightsFlexibleSearchHeaderCellTheme) {
  /** Theme to represent an outbound or inbound departureDate header */
  FlightsFlexibleSearchHeaderCellTheme["DEFAULT"] = "DEFAULT";
  /** Theme to represent an outbound or inbound departureDate that was searched on */
  FlightsFlexibleSearchHeaderCellTheme["SEARCHED_DATE_HEADER"] = "SEARCHED_DATE_HEADER";
})(FlightsFlexibleSearchHeaderCellTheme || (FlightsFlexibleSearchHeaderCellTheme = {}));
/** Represent flexible search legend cell theme */
export var FlightsFlexibleSearchLegendCellTheme;
(function (FlightsFlexibleSearchLegendCellTheme) {
  FlightsFlexibleSearchLegendCellTheme["DEFAULT"] = "DEFAULT";
})(FlightsFlexibleSearchLegendCellTheme || (FlightsFlexibleSearchLegendCellTheme = {}));
/** Represent flexible search result cell theme */
export var FlightsFlexibleSearchResultCellTheme;
(function (FlightsFlexibleSearchResultCellTheme) {
  /** Default theme */
  FlightsFlexibleSearchResultCellTheme["DEFAULT_PRICE"] = "DEFAULT_PRICE";
  /** Theme to represent highest priced cells in the matrix */
  FlightsFlexibleSearchResultCellTheme["HIGHEST_PRICE"] = "HIGHEST_PRICE";
  /** Theme to represent the lowest price displayed in the matrix */
  FlightsFlexibleSearchResultCellTheme["LOWEST_PRICE"] = "LOWEST_PRICE";
  /** Theme to represent when no price is available, 'Search' */
  FlightsFlexibleSearchResultCellTheme["NO_PRICE"] = "NO_PRICE";
  /** Theme to represent the price corresponding to the flight on the input departureDate */
  FlightsFlexibleSearchResultCellTheme["SEARCHED_DATE"] = "SEARCHED_DATE";
  /** Theme to represent a cell that corresponds to the input departureDate and is also lowest price displayed in the matrix */
  FlightsFlexibleSearchResultCellTheme["SEARCHED_DATE_LOWEST_PRICE"] = "SEARCHED_DATE_LOWEST_PRICE";
  /** Theme to represent a cell that corresponds to the input departureDate and is also the price is not available */
  FlightsFlexibleSearchResultCellTheme["SEARCHED_DATE_NO_PRICE"] = "SEARCHED_DATE_NO_PRICE";
  /** Theme to represent a cell that corresponds to the input departureDate and flights dont fly on the given departureDate */
  FlightsFlexibleSearchResultCellTheme["SEARCHED_DATE_UNAVAILABLE_FLIGHTS"] = "SEARCHED_DATE_UNAVAILABLE_FLIGHTS";
  /** Theme to represent the price is unavailable because flights don't fly for the given departureDate and route, 'No Flights' */
  FlightsFlexibleSearchResultCellTheme["UNAVAILABLE_FLIGHTS"] = "UNAVAILABLE_FLIGHTS";
})(FlightsFlexibleSearchResultCellTheme || (FlightsFlexibleSearchResultCellTheme = {}));
/** Enum class to represent the available heading sizes */
export var FlightsHeadingSize;
(function (FlightsHeadingSize) {
  FlightsHeadingSize["EIGHT"] = "EIGHT";
  FlightsHeadingSize["FIVE"] = "FIVE";
  FlightsHeadingSize["FOUR"] = "FOUR";
  FlightsHeadingSize["ONE"] = "ONE";
  FlightsHeadingSize["SEVEN"] = "SEVEN";
  FlightsHeadingSize["SIX"] = "SIX";
  FlightsHeadingSize["THREE"] = "THREE";
})(FlightsHeadingSize || (FlightsHeadingSize = {}));
/** Represents the position of the icon */
export var FlightsIconPosition;
(function (FlightsIconPosition) {
  /** Icon will be rendered at the beginning of the content */
  FlightsIconPosition["LEADING"] = "LEADING";
  /** Icon will be rendered at the end of the content */
  FlightsIconPosition["TRAILING"] = "TRAILING";
})(FlightsIconPosition || (FlightsIconPosition = {}));
/** This contains list of active experience that needs to be shown eg: StepperSeats, OCU etc */
export var FlightsInfositeExperience;
(function (FlightsInfositeExperience) {
  FlightsInfositeExperience["STEPPER_BAGS"] = "STEPPER_BAGS";
  FlightsInfositeExperience["STEPPER_SEATS"] = "STEPPER_SEATS";
})(FlightsInfositeExperience || (FlightsInfositeExperience = {}));
/** Target of the Link when clicked */
export var FlightsLinkTarget;
(function (FlightsLinkTarget) {
  /** Link will be opened in an external view e.g. new tab or browser window */
  FlightsLinkTarget["EXTERNAL"] = "EXTERNAL";
  /** Link will be opened in the same view where the user is currently e.g. same tab or webview inside an app */
  FlightsLinkTarget["INTERNAL"] = "INTERNAL";
})(FlightsLinkTarget || (FlightsLinkTarget = {}));
/** Represents page load type of FSR */
export var FlightsListingsViewType;
(function (FlightsListingsViewType) {
  FlightsListingsViewType["MIXED"] = "MIXED";
  FlightsListingsViewType["SINGLE"] = "SINGLE";
})(FlightsListingsViewType || (FlightsListingsViewType = {}));
/** Metrics names */
export var FlightsMetricName;
(function (FlightsMetricName) {
  FlightsMetricName["DETAILS_JOURNEY_SUMMARY_SUPPLY_RESPONSE_TIME"] = "DETAILS_JOURNEY_SUMMARY_SUPPLY_RESPONSE_TIME";
  FlightsMetricName["DETAILS_PRICE_SUMMARY_SUPPLY_RESPONSE_TIME"] = "DETAILS_PRICE_SUMMARY_SUPPLY_RESPONSE_TIME";
  FlightsMetricName["LISTINGS_SUPPLY_RESPONSE_TIME"] = "LISTINGS_SUPPLY_RESPONSE_TIME";
})(FlightsMetricName || (FlightsMetricName = {}));
export var FlightsOneClickFareUpgradeCardType;
(function (FlightsOneClickFareUpgradeCardType) {
  FlightsOneClickFareUpgradeCardType["OCU"] = "OCU";
  FlightsOneClickFareUpgradeCardType["REFUNDABILITY"] = "REFUNDABILITY";
})(FlightsOneClickFareUpgradeCardType || (FlightsOneClickFareUpgradeCardType = {}));
/** The text style to apply to strings */
export var FlightsPhrasePartStyle;
(function (FlightsPhrasePartStyle) {
  /** Italic styling */
  FlightsPhrasePartStyle["EMPHASIS"] = "EMPHASIS";
  /** Bold styling */
  FlightsPhrasePartStyle["IMPORTANT"] = "IMPORTANT";
  /** Represents no style or regular text */
  FlightsPhrasePartStyle["STANDARD"] = "STANDARD";
})(FlightsPhrasePartStyle || (FlightsPhrasePartStyle = {}));
/** Represents an object to be used to differentiate the type of Placards(Ex : Placards to be shown immediately vs those which are shown during server error */
export var FlightsPlacardDisplayType;
(function (FlightsPlacardDisplayType) {
  /** Represents the placard type to be shown immediately */
  FlightsPlacardDisplayType["IMMEDIATE"] = "IMMEDIATE";
  /** Represents the placard type to be shown during server error of sort and filter action */
  FlightsPlacardDisplayType["SORT_FILTERS_SERVER_ERROR"] = "SORT_FILTERS_SERVER_ERROR";
})(FlightsPlacardDisplayType || (FlightsPlacardDisplayType = {}));
/** Represents different background themes for placard */
export var FlightsPlacardTheme;
(function (FlightsPlacardTheme) {
  FlightsPlacardTheme["HIGHLIGHT"] = "HIGHLIGHT";
  FlightsPlacardTheme["LOYALTY"] = "LOYALTY";
  FlightsPlacardTheme["PRIMARY"] = "PRIMARY";
  FlightsPlacardTheme["SECONDARY"] = "SECONDARY";
  FlightsPlacardTheme["STANDARD"] = "STANDARD";
})(FlightsPlacardTheme || (FlightsPlacardTheme = {}));
/** Represents a type of placards the client can request for */
export var FlightsPlacardType;
(function (FlightsPlacardType) {
  /** Represents the placard of type free cancellation */
  FlightsPlacardType["FREE_CANCELLATION"] = "FREE_CANCELLATION";
  /** Represents the placard of type hotel attach */
  FlightsPlacardType["HOTEL_ATTACH"] = "HOTEL_ATTACH";
  /** Represents the placard of type loyalty reward */
  FlightsPlacardType["LOYALTY_REWARD"] = "LOYALTY_REWARD";
  /** Represents the placard of type no change fees */
  FlightsPlacardType["NO_CHANGE_FEES"] = "NO_CHANGE_FEES";
  /** Represents the placard of type passport */
  FlightsPlacardType["PASSPORT"] = "PASSPORT";
  /** Represents the placard of type price change */
  FlightsPlacardType["PRICE_CHANGE"] = "PRICE_CHANGE";
  /** Represents the placard of type split ticket */
  FlightsPlacardType["SPLIT_TICKET"] = "SPLIT_TICKET";
})(FlightsPlacardType || (FlightsPlacardType = {}));
/** Represents the display of progress bar when the results are loading */
export var FlightsProgressBarDisplay;
(function (FlightsProgressBarDisplay) {
  FlightsProgressBarDisplay["DISABLED"] = "DISABLED";
  FlightsProgressBarDisplay["ENABLED"] = "ENABLED";
})(FlightsProgressBarDisplay || (FlightsProgressBarDisplay = {}));
/** Represents the state the client wants to query */
export var FlightsQueryState;
(function (FlightsQueryState) {
  FlightsQueryState["LOADED"] = "LOADED";
  FlightsQueryState["LOADING"] = "LOADING";
})(FlightsQueryState || (FlightsQueryState = {}));
/** Enum class to represent the id associated with the rewards option */
export var FlightsRewardsOptionId;
(function (FlightsRewardsOptionId) {
  FlightsRewardsOptionId["ALTAIR"] = "ALTAIR";
  FlightsRewardsOptionId["AVION"] = "AVION";
  FlightsRewardsOptionId["NONAVION"] = "NONAVION";
})(FlightsRewardsOptionId || (FlightsRewardsOptionId = {}));
/** Represents the mismatched criterion between the current search and servicing need */
export var FlightsSearchCriteriaMismatch;
(function (FlightsSearchCriteriaMismatch) {
  FlightsSearchCriteriaMismatch["TRAVELER"] = "TRAVELER";
})(FlightsSearchCriteriaMismatch || (FlightsSearchCriteriaMismatch = {}));
/** Represents enum to distinguish between flights search queries */
export var FlightsSearchExperienceType;
(function (FlightsSearchExperienceType) {
  FlightsSearchExperienceType["CODESHARE"] = "CODESHARE";
  FlightsSearchExperienceType["FLIGHT_DETAILS"] = "FLIGHT_DETAILS";
  FlightsSearchExperienceType["OFFER_LISTING"] = "OFFER_LISTING";
})(FlightsSearchExperienceType || (FlightsSearchExperienceType = {}));
export var FlightsSearchFormErrorType;
(function (FlightsSearchFormErrorType) {
  /** Age of child is missing */
  FlightsSearchFormErrorType["CHILD_AGE_MISSING"] = "CHILD_AGE_MISSING";
  /** Date before previous date - Multi-dest */
  FlightsSearchFormErrorType["DATE_BEFORE_PREVIOUS_DATE"] = "DATE_BEFORE_PREVIOUS_DATE";
  /** Date must be between a range */
  FlightsSearchFormErrorType["DATE_NOT_IN_VALID_RANGE"] = "DATE_NOT_IN_VALID_RANGE";
  /** Dates must be greater than or equal to default date/checkin date. */
  FlightsSearchFormErrorType["DATE_NOT_IN_VALID_RANGE_TO_DEFAULT_DATE"] = "DATE_NOT_IN_VALID_RANGE_TO_DEFAULT_DATE";
  /** Age of infant is missing */
  FlightsSearchFormErrorType["INFANT_AGE_MISSING"] = "INFANT_AGE_MISSING";
  /** Date must be in the correct format */
  FlightsSearchFormErrorType["INVALID_DATE_FORMAT"] = "INVALID_DATE_FORMAT";
  /** Total traveler count must be equal or lower than max */
  FlightsSearchFormErrorType["INVALID_TRAVELER_COUNT"] = "INVALID_TRAVELER_COUNT";
  /** At least 1 traveler required in a booking */
  FlightsSearchFormErrorType["LESS_THAN_MINIMUM_ADULT"] = "LESS_THAN_MINIMUM_ADULT";
  /** Location must not be blank */
  FlightsSearchFormErrorType["LOCATION_EMPTY"] = "LOCATION_EMPTY";
  /** Origin and destination location must not be the same */
  FlightsSearchFormErrorType["LOCATION_SAME"] = "LOCATION_SAME";
  /** Dates must be no more than 26 days apart */
  FlightsSearchFormErrorType["MAX_STAY_DURATION_ERROR"] = "MAX_STAY_DURATION_ERROR";
  /** Origin and Destination city cannot be same */
  FlightsSearchFormErrorType["SAME_CITY"] = "SAME_CITY";
  /** Special characters are not allowed */
  FlightsSearchFormErrorType["SPECIAL_CHARACTER_NOT_ALLOWED"] = "SPECIAL_CHARACTER_NOT_ALLOWED";
  /** Enter at least 3 characters of the airport name */
  FlightsSearchFormErrorType["TOO_SHORT_AIRPORT_STRING"] = "TOO_SHORT_AIRPORT_STRING";
  /** Number of infant in lap must be equal or lower than number of adults */
  FlightsSearchFormErrorType["UNATTENDED_INFANT_IN_LAP"] = "UNATTENDED_INFANT_IN_LAP";
  /** There can't be more than 2 infants per traveler (age 12+) in a booking */
  FlightsSearchFormErrorType["UNATTENDED_INFANT_IN_SEAT"] = "UNATTENDED_INFANT_IN_SEAT";
})(FlightsSearchFormErrorType || (FlightsSearchFormErrorType = {}));
/** Represents a type content */
export var FlightsSearchListingHeaderContentType;
(function (FlightsSearchListingHeaderContentType) {
  FlightsSearchListingHeaderContentType["ONE_KEY"] = "ONE_KEY";
})(FlightsSearchListingHeaderContentType || (FlightsSearchListingHeaderContentType = {}));
/** Represents the enum to handle different styles for the card */
export var FlightsSeatCardStyles;
(function (FlightsSeatCardStyles) {
  /** Represents that the card should have border */
  FlightsSeatCardStyles["BORDER"] = "BORDER";
  /** Represents that the card should not have a border */
  FlightsSeatCardStyles["WITHOUT_BORDER"] = "WITHOUT_BORDER";
})(FlightsSeatCardStyles || (FlightsSeatCardStyles = {}));
export var FlightsSeatCellState;
(function (FlightsSeatCellState) {
  /** Represents the default theme for seat cell */
  FlightsSeatCellState["DEFAULT"] = "DEFAULT";
  /** Represents the theme for selected seat cell */
  FlightsSeatCellState["HIGHLIGHTED"] = "HIGHLIGHTED";
})(FlightsSeatCellState || (FlightsSeatCellState = {}));
export var FlightsSeatCellTheme;
(function (FlightsSeatCellTheme) {
  /** Represents the highlighted theme for selected seat cell */
  FlightsSeatCellTheme["HIGHLIGHTED"] = "HIGHLIGHTED";
  /** Represents the standard theme for seat cell */
  FlightsSeatCellTheme["STANDARD"] = "STANDARD";
})(FlightsSeatCellTheme || (FlightsSeatCellTheme = {}));
/** Error types which can occur during seat selection */
export var FlightsSeatSelectionErrorType;
(function (FlightsSeatSelectionErrorType) {
  /** Seat Selection Failed */
  FlightsSeatSelectionErrorType["SELECTION_FAILED"] = "SELECTION_FAILED";
  /** Seat Selection Unavailable */
  FlightsSeatSelectionErrorType["SELECTION_UNAVAILABLE"] = "SELECTION_UNAVAILABLE";
})(FlightsSeatSelectionErrorType || (FlightsSeatSelectionErrorType = {}));
/** Represents the enum for handling whether new seats experience should be enabled or not */
export var FlightsSeatsExperienceType;
(function (FlightsSeatsExperienceType) {
  /** Represents frontend to show old seats experience */
  FlightsSeatsExperienceType["CURRENT_SEATS_EXPERIENCE"] = "CURRENT_SEATS_EXPERIENCE";
  /** Represents frontend to show new seats experience */
  FlightsSeatsExperienceType["NEW_SEATS_EXPERIENCE"] = "NEW_SEATS_EXPERIENCE";
  /** Represents frontend to show rich content experience */
  FlightsSeatsExperienceType["SEATS_RICH_CONTENT_EXPERIENCE"] = "SEATS_RICH_CONTENT_EXPERIENCE";
})(FlightsSeatsExperienceType || (FlightsSeatsExperienceType = {}));
/** Represents the button width in the UI */
export var FlightsSmartShoppingButtonWidth;
(function (FlightsSmartShoppingButtonWidth) {
  /** Button will take the width it needs */
  FlightsSmartShoppingButtonWidth["DEFAULT"] = "DEFAULT";
  /** Button will take the full width of the content */
  FlightsSmartShoppingButtonWidth["FULL_WIDTH"] = "FULL_WIDTH";
})(FlightsSmartShoppingButtonWidth || (FlightsSmartShoppingButtonWidth = {}));
/** Represents flights dialog actions */
export var FlightsSmartShoppingDialogAction;
(function (FlightsSmartShoppingDialogAction) {
  FlightsSmartShoppingDialogAction["CLOSE"] = "CLOSE";
  FlightsSmartShoppingDialogAction["OPEN"] = "OPEN";
  FlightsSmartShoppingDialogAction["TOGGLE"] = "TOGGLE";
})(FlightsSmartShoppingDialogAction || (FlightsSmartShoppingDialogAction = {}));
/** Represents IDs for flights dialogs */
export var FlightsSmartShoppingDialogId;
(function (FlightsSmartShoppingDialogId) {
  /** Represents the Airlines credit dialog */
  FlightsSmartShoppingDialogId["AIRLINE_CREDITS"] = "AIRLINE_CREDITS";
  /** Represents the Close button dialog for the baggage details when complete selections have been made */
  FlightsSmartShoppingDialogId["BAGGAGE_CLOSE_COMPLETE_DIALOG"] = "BAGGAGE_CLOSE_COMPLETE_DIALOG";
  /** Represents the Close button dialog for the baggage details when incomplete selections have been made */
  FlightsSmartShoppingDialogId["BAGGAGE_CLOSE_INCOMPLETE_DIALOG"] = "BAGGAGE_CLOSE_INCOMPLETE_DIALOG";
  /** Represents the Continue booking dialog for the baggage details */
  FlightsSmartShoppingDialogId["BAGGAGE_CONTINUE_BOOKING"] = "BAGGAGE_CONTINUE_BOOKING";
  /** Represents the dialog ID for Baggage details */
  FlightsSmartShoppingDialogId["BAGGAGE_DETAILS_DIALOG"] = "BAGGAGE_DETAILS_DIALOG";
  /** Represents the bags popup dialog on checkout button */
  FlightsSmartShoppingDialogId["BAGS_POPUP_ON_CHECKOUT"] = "BAGS_POPUP_ON_CHECKOUT";
  /** Represents the check credits dialog for users coming from MCC and VA */
  FlightsSmartShoppingDialogId["CHECK_CREDITS_DIALOG"] = "CHECK_CREDITS_DIALOG";
  /** Represents the Flights Details and Fares dialog */
  FlightsSmartShoppingDialogId["FLIGHTS_DETAILS_AND_FARES"] = "FLIGHTS_DETAILS_AND_FARES";
  /** The Forced choice modal that appears in large breakpoints when going to FIS */
  FlightsSmartShoppingDialogId["FORCED_CHOICE_MODAL"] = "FORCED_CHOICE_MODAL";
  /** Represents the How Airlines Work dialog inside Select Credits */
  FlightsSmartShoppingDialogId["HOW_CREDITS_WORK"] = "HOW_CREDITS_WORK";
  /** Represents the Leave This Page dialog inside Select Credits */
  FlightsSmartShoppingDialogId["LEAVE_TO_COUPONS"] = "LEAVE_TO_COUPONS";
  /** Represents the bags opening dialog eg:- sidesheet for desktop , fullscreendialog for mobile */
  FlightsSmartShoppingDialogId["PAID_BAGS_DIALOG"] = "PAID_BAGS_DIALOG";
  /** Represents the Info dialog for Price Match Promise Selected Card */
  FlightsSmartShoppingDialogId["PMP_INFO_DIALOG"] = "PMP_INFO_DIALOG";
  /** Represents the Remove dialog for Price Match Promise Selected Card */
  FlightsSmartShoppingDialogId["PMP_REMOVE_DIALOG"] = "PMP_REMOVE_DIALOG";
  /** Represents the seats popup dialog on checkout button */
  FlightsSmartShoppingDialogId["SEATS_POPUP_ON_CHECKOUT"] = "SEATS_POPUP_ON_CHECKOUT";
  /** Represents the Close button dialog for the seat details */
  FlightsSmartShoppingDialogId["SEAT_CLOSE_COMPLETE_DIALOG"] = "SEAT_CLOSE_COMPLETE_DIALOG";
  /** Represents the Continue booking dialog for the baggage details */
  FlightsSmartShoppingDialogId["SEAT_CONTINUE_BOOKING"] = "SEAT_CONTINUE_BOOKING";
  /** Represents the seats opening dialog eg:- sidesheet for desktop , fullscreendialog for mobile */
  FlightsSmartShoppingDialogId["SEAT_SELECTION_DIALOG"] = "SEAT_SELECTION_DIALOG";
  /** Represents the dialog on traveler mismatch for credits offer */
  FlightsSmartShoppingDialogId["TRAVELER_MISMATCH_DIALOG"] = "TRAVELER_MISMATCH_DIALOG";
})(FlightsSmartShoppingDialogId || (FlightsSmartShoppingDialogId = {}));
/** Represents the position of the icon */
export var FlightsSmartShoppingIconPosition;
(function (FlightsSmartShoppingIconPosition) {
  /** Icon will be rendered at the beginning of the content */
  FlightsSmartShoppingIconPosition["LEADING"] = "LEADING";
  /** Icon will be rendered at the end of the content */
  FlightsSmartShoppingIconPosition["TRAILING"] = "TRAILING";
})(FlightsSmartShoppingIconPosition || (FlightsSmartShoppingIconPosition = {}));
/** Target of the Link when clicked */
export var FlightsSmartShoppingLinkTarget;
(function (FlightsSmartShoppingLinkTarget) {
  /** Link will be opened in an external view e.g. new tab or browser window */
  FlightsSmartShoppingLinkTarget["EXTERNAL"] = "EXTERNAL";
  /** Link will be opened in the same view where the user is currently e.g. same tab or webview inside an app */
  FlightsSmartShoppingLinkTarget["INTERNAL"] = "INTERNAL";
})(FlightsSmartShoppingLinkTarget || (FlightsSmartShoppingLinkTarget = {}));
/** Enum which lists the sort orders */
export var FlightsSortOrder;
(function (FlightsSortOrder) {
  FlightsSortOrder["DECREASING"] = "DECREASING";
  FlightsSortOrder["INCREASING"] = "INCREASING";
})(FlightsSortOrder || (FlightsSortOrder = {}));
/** Enum class which lists all the supported sorting criteria */
export var FlightsSortType;
(function (FlightsSortType) {
  FlightsSortType["ARRIVAL"] = "ARRIVAL";
  FlightsSortType["BEST_BETS"] = "BEST_BETS";
  FlightsSortType["BEST_SORT"] = "BEST_SORT";
  FlightsSortType["CROSS_SORT"] = "CROSS_SORT";
  FlightsSortType["DEPARTURE"] = "DEPARTURE";
  FlightsSortType["DURATION"] = "DURATION";
  FlightsSortType["NONSTOP"] = "NONSTOP";
  FlightsSortType["PRICE"] = "PRICE";
  FlightsSortType["RECOMMENDED"] = "RECOMMENDED";
})(FlightsSortType || (FlightsSortType = {}));
/** Represent the step label interface */
export var FlightsStep;
(function (FlightsStep) {
  FlightsStep["BAGS"] = "BAGS";
  FlightsStep["CHECKOUT"] = "CHECKOUT";
  FlightsStep["FLIGHT_DETAILS"] = "FLIGHT_DETAILS";
  FlightsStep["SEATS"] = "SEATS";
})(FlightsStep || (FlightsStep = {}));
/** Represents loading state of Price Summary for an offer */
export var FlightsStepperErrorMessagesKey;
(function (FlightsStepperErrorMessagesKey) {
  FlightsStepperErrorMessagesKey["PREFETCH_BAGS"] = "PREFETCH_BAGS";
  FlightsStepperErrorMessagesKey["PREFETCH_SEATS"] = "PREFETCH_SEATS";
  FlightsStepperErrorMessagesKey["SUPPLY_SIDE_BAGS"] = "SUPPLY_SIDE_BAGS";
  FlightsStepperErrorMessagesKey["SUPPLY_SIDE_SEATS"] = "SUPPLY_SIDE_SEATS";
})(FlightsStepperErrorMessagesKey || (FlightsStepperErrorMessagesKey = {}));
/** Enum class to represent the operation associated with num of stops */
export var FlightsStopFilterOperation;
(function (FlightsStopFilterOperation) {
  FlightsStopFilterOperation["EQUAL"] = "EQUAL";
  FlightsStopFilterOperation["GREATER_THAN_EQUAL"] = "GREATER_THAN_EQUAL";
  FlightsStopFilterOperation["LESS_THAN_EQUAL"] = "LESS_THAN_EQUAL";
})(FlightsStopFilterOperation || (FlightsStopFilterOperation = {}));
/** Represents enums for selection state of the tab */
export var FlightsTabSelectionState;
(function (FlightsTabSelectionState) {
  FlightsTabSelectionState["CURRENT"] = "CURRENT";
  FlightsTabSelectionState["SELECTED"] = "SELECTED";
  FlightsTabSelectionState["UNSELECTED"] = "UNSELECTED";
})(FlightsTabSelectionState || (FlightsTabSelectionState = {}));
/** This represents a decorator that can be applied to a section */
export var FlightsTextSectionDecorator;
(function (FlightsTextSectionDecorator) {
  /** This represents a separator that renders after the text section */
  FlightsTextSectionDecorator["BOTTOMSEPARATOR"] = "BOTTOMSEPARATOR";
  /** This represents a separator that renders above the text section */
  FlightsTextSectionDecorator["TOPSEPARATOR"] = "TOPSEPARATOR";
})(FlightsTextSectionDecorator || (FlightsTextSectionDecorator = {}));
/** Enum representing the various time slots in a day  */
export var FlightsTimeOfDay;
(function (FlightsTimeOfDay) {
  FlightsTimeOfDay["AFTERNOON"] = "AFTERNOON";
  FlightsTimeOfDay["EARLY_MORNING"] = "EARLY_MORNING";
  FlightsTimeOfDay["EVENING"] = "EVENING";
  FlightsTimeOfDay["MORNING"] = "MORNING";
})(FlightsTimeOfDay || (FlightsTimeOfDay = {}));
export var FlightsTimePeriodOfDay;
(function (FlightsTimePeriodOfDay) {
  FlightsTimePeriodOfDay["AFTERNOON"] = "AFTERNOON";
  FlightsTimePeriodOfDay["EARLY_MORNING"] = "EARLY_MORNING";
  FlightsTimePeriodOfDay["EVENING"] = "EVENING";
  FlightsTimePeriodOfDay["MORNING"] = "MORNING";
})(FlightsTimePeriodOfDay || (FlightsTimePeriodOfDay = {}));
/** Represent all the possible traveler types */
export var FlightsTravelerType;
(function (FlightsTravelerType) {
  FlightsTravelerType["ADULT"] = "ADULT";
  FlightsTravelerType["CHILD"] = "CHILD";
  FlightsTravelerType["INFANT_IN_LAP"] = "INFANT_IN_LAP";
  FlightsTravelerType["INFANT_IN_SEAT"] = "INFANT_IN_SEAT";
})(FlightsTravelerType || (FlightsTravelerType = {}));
/** Trip type chosen in flight search */
export var FlightsTripType;
(function (FlightsTripType) {
  FlightsTripType["MULTI_DESTINATION"] = "MULTI_DESTINATION";
  FlightsTripType["ONE_WAY"] = "ONE_WAY";
  FlightsTripType["ROUND_TRIP"] = "ROUND_TRIP";
})(FlightsTripType || (FlightsTripType = {}));
export var Flow;
(function (Flow) {
  Flow["AUTOMATED_MANUAL"] = "AUTOMATED_MANUAL";
  Flow["MANUAL"] = "MANUAL";
})(Flow || (Flow = {}));
export var FlowEntrypointIdentifier;
(function (FlowEntrypointIdentifier) {
  FlowEntrypointIdentifier["PROFILE"] = "PROFILE";
  FlowEntrypointIdentifier["SETTINGS"] = "SETTINGS";
})(FlowEntrypointIdentifier || (FlowEntrypointIdentifier = {}));
export var FlowType;
(function (FlowType) {
  FlowType["AUTOMATED"] = "AUTOMATED";
  FlowType["AUTOMATED_MANUAL"] = "AUTOMATED_MANUAL";
  FlowType["MANUAL"] = "MANUAL";
})(FlowType || (FlowType = {}));
export var FooterButtonType;
(function (FooterButtonType) {
  FooterButtonType["PRIMARY"] = "PRIMARY";
  FooterButtonType["SECONDARY"] = "SECONDARY";
  FooterButtonType["TERTIARY"] = "TERTIARY";
})(FooterButtonType || (FooterButtonType = {}));
export var FooterSeparatorType;
(function (FooterSeparatorType) {
  FooterSeparatorType["HORIZONTAL_RULE"] = "HORIZONTAL_RULE";
})(FooterSeparatorType || (FooterSeparatorType = {}));
export var FormInput;
(function (FormInput) {
  FormInput["AD_GROUP"] = "AD_GROUP";
  FormInput["CAMPAIGN"] = "CAMPAIGN";
})(FormInput || (FormInput = {}));
/** Represents all the common information in the journey review block on FIS  */
export var FreeCancellationApplicability;
(function (FreeCancellationApplicability) {
  FreeCancellationApplicability["ALL_JOURNEYS"] = "ALL_JOURNEYS";
  FreeCancellationApplicability["CURRENT_JOUNRNEY"] = "CURRENT_JOUNRNEY";
  FreeCancellationApplicability["NOT_APPLICABLE"] = "NOT_APPLICABLE";
})(FreeCancellationApplicability || (FreeCancellationApplicability = {}));
export var FunnelLocation;
(function (FunnelLocation) {
  FunnelLocation["CHECKOUT"] = "CHECKOUT";
  FunnelLocation["CHECKOUT_ERROR"] = "CHECKOUT_ERROR";
  FunnelLocation["CONFIRMATION"] = "CONFIRMATION";
  FunnelLocation["DETAILS"] = "DETAILS";
  FunnelLocation["ENTRY"] = "ENTRY";
  FunnelLocation["FEATURES"] = "FEATURES";
  FunnelLocation["PAYMENT_ERROR"] = "PAYMENT_ERROR";
  FunnelLocation["POST_BOOKING"] = "POST_BOOKING";
  FunnelLocation["SEARCH_RESULTS"] = "SEARCH_RESULTS";
  FunnelLocation["SYSTEM"] = "SYSTEM";
  FunnelLocation["USER"] = "USER";
})(FunnelLocation || (FunnelLocation = {}));
/** Possible direction types for ground transfers */
export var GeoType;
(function (GeoType) {
  GeoType["AIRPORT"] = "AIRPORT";
  GeoType["DESTINATION"] = "DESTINATION";
  GeoType["PROPERTY"] = "PROPERTY";
})(GeoType || (GeoType = {}));
export var GetUapCampaignIdErrorType;
(function (GetUapCampaignIdErrorType) {
  GetUapCampaignIdErrorType["EMPTY_ADBOOK_ID"] = "EMPTY_ADBOOK_ID";
  GetUapCampaignIdErrorType["NOT_FOUND"] = "NOT_FOUND";
  GetUapCampaignIdErrorType["UNKNOWN"] = "UNKNOWN";
})(GetUapCampaignIdErrorType || (GetUapCampaignIdErrorType = {}));
/** Line of business that is querying the global navigation elements. */
export var GlobalNavigationLineOfBusiness;
(function (GlobalNavigationLineOfBusiness) {
  GlobalNavigationLineOfBusiness["ACTIVITY"] = "ACTIVITY";
  GlobalNavigationLineOfBusiness["CAR"] = "CAR";
  GlobalNavigationLineOfBusiness["CRUISE"] = "CRUISE";
  GlobalNavigationLineOfBusiness["FLIGHT"] = "FLIGHT";
  GlobalNavigationLineOfBusiness["HOTEL"] = "HOTEL";
  GlobalNavigationLineOfBusiness["PACKAGE"] = "PACKAGE";
  GlobalNavigationLineOfBusiness["UNKNOWN"] = "UNKNOWN";
})(GlobalNavigationLineOfBusiness || (GlobalNavigationLineOfBusiness = {}));
/** Possible direction types for ground transfers */
export var GroundTransfersDirection;
(function (GroundTransfersDirection) {
  GroundTransfersDirection["FROM_AIRPORT"] = "FROM_AIRPORT";
  GroundTransfersDirection["ROUNDTRIP"] = "ROUNDTRIP";
  GroundTransfersDirection["TO_AIRPORT"] = "TO_AIRPORT";
})(GroundTransfersDirection || (GroundTransfersDirection = {}));
/** Possible traveler details types */
export var GroundTransfersTravelerDetailsType;
(function (GroundTransfersTravelerDetailsType) {
  GroundTransfersTravelerDetailsType["ADULT"] = "ADULT";
  GroundTransfersTravelerDetailsType["CHILD"] = "CHILD";
  GroundTransfersTravelerDetailsType["INFANT"] = "INFANT";
})(GroundTransfersTravelerDetailsType || (GroundTransfersTravelerDetailsType = {}));
export var GuestImageScrimType;
(function (GuestImageScrimType) {
  GuestImageScrimType["FADE_BOTTOM"] = "FADE_BOTTOM";
  GuestImageScrimType["OVERLAY"] = "OVERLAY";
})(GuestImageScrimType || (GuestImageScrimType = {}));
/** Header section alignment of elements to either the start or end of the section container. */
export var HeaderAlignment;
(function (HeaderAlignment) {
  HeaderAlignment["END"] = "END";
  HeaderAlignment["START"] = "START";
})(HeaderAlignment || (HeaderAlignment = {}));
/** Determines the type of button to display.  Primary or tertiary. */
export var HeaderButtonType;
(function (HeaderButtonType) {
  HeaderButtonType["PRIMARY"] = "PRIMARY";
  HeaderButtonType["SECONDARY"] = "SECONDARY";
  HeaderButtonType["TERTIARY"] = "TERTIARY";
})(HeaderButtonType || (HeaderButtonType = {}));
/** Used to position the header menu dropdown as well as icons in links and buttons.  Options are LEFT or RIGHT. */
export var HeaderItemPosition;
(function (HeaderItemPosition) {
  HeaderItemPosition["LEFT"] = "LEFT";
  HeaderItemPosition["RIGHT"] = "RIGHT";
})(HeaderItemPosition || (HeaderItemPosition = {}));
/** Header layout. */
export var HeaderLayout;
(function (HeaderLayout) {
  HeaderLayout["DEFAULT"] = "DEFAULT";
  HeaderLayout["MINIMAL"] = "MINIMAL";
  HeaderLayout["SIMPLIFIED"] = "SIMPLIFIED";
})(HeaderLayout || (HeaderLayout = {}));
/** Inserts a separator in header menus. */
export var HeaderSeparatorType;
(function (HeaderSeparatorType) {
  HeaderSeparatorType["HORIZONTAL_RULE"] = "HORIZONTAL_RULE";
})(HeaderSeparatorType || (HeaderSeparatorType = {}));
/** Heading text size. Small or large. */
export var HeaderTextSize;
(function (HeaderTextSize) {
  HeaderTextSize["LARGE"] = "LARGE";
  HeaderTextSize["SMALL"] = "SMALL";
})(HeaderTextSize || (HeaderTextSize = {}));
/** Type of text.  Heading or subheading. */
export var HeaderTextType;
(function (HeaderTextType) {
  HeaderTextType["HEADING"] = "HEADING";
  HeaderTextType["SUBHEADING"] = "SUBHEADING";
})(HeaderTextType || (HeaderTextType = {}));
/** Different viewport sizes to display the header. */
export var HeaderViewSize;
(function (HeaderViewSize) {
  HeaderViewSize["EXTRA_LARGE"] = "EXTRA_LARGE";
  HeaderViewSize["LARGE"] = "LARGE";
  HeaderViewSize["MEDIUM"] = "MEDIUM";
  HeaderViewSize["SMALL"] = "SMALL";
})(HeaderViewSize || (HeaderViewSize = {}));
/** Type of outline for Heart Icon */
export var HeartOutlineType;
(function (HeartOutlineType) {
  HeartOutlineType["NORMAL_OUTLINED"] = "NORMAL_OUTLINED";
  HeartOutlineType["RED_OUTLINED"] = "RED_OUTLINED";
})(HeartOutlineType || (HeartOutlineType = {}));
export var HelpAndFeedbackHelpCenterOptionsType;
(function (HelpAndFeedbackHelpCenterOptionsType) {
  HelpAndFeedbackHelpCenterOptionsType["OWNER"] = "OWNER";
  HelpAndFeedbackHelpCenterOptionsType["PROPERTY_MANAGER"] = "PROPERTY_MANAGER";
  HelpAndFeedbackHelpCenterOptionsType["TRAVELER"] = "TRAVELER";
  HelpAndFeedbackHelpCenterOptionsType["TRUST_AND_SAFETY"] = "TRUST_AND_SAFETY";
})(HelpAndFeedbackHelpCenterOptionsType || (HelpAndFeedbackHelpCenterOptionsType = {}));
export var HelpAndFeedbackOptionsType;
(function (HelpAndFeedbackOptionsType) {
  HelpAndFeedbackOptionsType["BRAND_CALL"] = "BRAND_CALL";
  HelpAndFeedbackOptionsType["CHAT_NOW"] = "CHAT_NOW";
  HelpAndFeedbackOptionsType["CREDIT_CARD"] = "CREDIT_CARD";
  HelpAndFeedbackOptionsType["RATE_OUR_APP"] = "RATE_OUR_APP";
  HelpAndFeedbackOptionsType["SHARE_YOUR_FEEDBACK"] = "SHARE_YOUR_FEEDBACK";
  HelpAndFeedbackOptionsType["VISIT_HELP_CENTER"] = "VISIT_HELP_CENTER";
})(HelpAndFeedbackOptionsType || (HelpAndFeedbackOptionsType = {}));
export var HelperConfigMap;
(function (HelperConfigMap) {
  HelperConfigMap["AND"] = "And";
  HelperConfigMap["CAPITALIZEFIRST"] = "CapitalizeFirst";
  HelperConfigMap["DEVICETYPEEVALUATOR"] = "DeviceTypeEvaluator";
  HelperConfigMap["EQUALS"] = "Equals";
  HelperConfigMap["EVALUATEEXPERIMENT"] = "EvaluateExperiment";
  HelperConfigMap["EVALUATEEXPERIMENTANDLOG"] = "EvaluateExperimentAndLog";
  HelperConfigMap["FORMATDOUBLENUMBER"] = "FormatDoubleNumber";
  HelperConfigMap["FORMATINTEGERNUMBER"] = "FormatIntegerNumber";
  HelperConfigMap["GETSYSTEMTIMEINMS"] = "GetSystemTimeInMs";
  HelperConfigMap["GETUSABLEURN"] = "GetUsableURN";
  HelperConfigMap["GREATER"] = "Greater";
  HelperConfigMap["GREATERANDEQUALS"] = "GreaterAndEquals";
  HelperConfigMap["HTTPLINK"] = "HTTPLink";
  HelperConfigMap["IMPRESSIONANALYTICSPAYLOAD"] = "ImpressionAnalyticsPayload";
  HelperConfigMap["ISNOTNULLOREMPTY"] = "IsNotNullOrEmpty";
  HelperConfigMap["ISQUALIFIEDVRBOPROPERTY"] = "IsQualifiedVrboProperty";
  HelperConfigMap["JOIN"] = "Join";
  HelperConfigMap["LIMIT"] = "Limit";
  HelperConfigMap["LOCALIZE"] = "Localize";
  HelperConfigMap["NOT"] = "Not";
  HelperConfigMap["NOTEQUAL"] = "NotEqual";
  HelperConfigMap["OR"] = "Or";
  HelperConfigMap["SUBSTRING"] = "Substring";
})(HelperConfigMap || (HelperConfigMap = {}));
export var HistoryType;
(function (HistoryType) {
  HistoryType["ACTIVITY_DETAIL"] = "ACTIVITY_DETAIL";
  HistoryType["ACTIVITY_SEARCH"] = "ACTIVITY_SEARCH";
  HistoryType["CAR_DETAIL"] = "CAR_DETAIL";
  HistoryType["CAR_SEARCH"] = "CAR_SEARCH";
  HistoryType["CRUISE_SEARCH"] = "CRUISE_SEARCH";
  HistoryType["FLIGHT_DETAIL"] = "FLIGHT_DETAIL";
  HistoryType["FLIGHT_SEARCH"] = "FLIGHT_SEARCH";
  HistoryType["PACKAGE_SEARCH"] = "PACKAGE_SEARCH";
  HistoryType["PROPERTY_DETAIL"] = "PROPERTY_DETAIL";
  HistoryType["PROPERTY_SEARCH"] = "PROPERTY_SEARCH";
})(HistoryType || (HistoryType = {}));
export var HttpStatus;
(function (HttpStatus) {
  HttpStatus["ACCEPTED"] = "ACCEPTED";
  HttpStatus["ALREADY_REPORTED"] = "ALREADY_REPORTED";
  HttpStatus["BAD_GATEWAY"] = "BAD_GATEWAY";
  HttpStatus["BAD_REQUEST"] = "BAD_REQUEST";
  HttpStatus["BANDWIDTH_LIMIT_EXCEEDED"] = "BANDWIDTH_LIMIT_EXCEEDED";
  HttpStatus["CHECKPOINT"] = "CHECKPOINT";
  HttpStatus["CONFLICT"] = "CONFLICT";
  HttpStatus["CONTINUE"] = "CONTINUE";
  HttpStatus["CREATED"] = "CREATED";
  HttpStatus["DESTINATION_LOCKED"] = "DESTINATION_LOCKED";
  HttpStatus["EXPECTATION_FAILED"] = "EXPECTATION_FAILED";
  HttpStatus["FAILED_DEPENDENCY"] = "FAILED_DEPENDENCY";
  HttpStatus["FORBIDDEN"] = "FORBIDDEN";
  HttpStatus["FOUND"] = "FOUND";
  HttpStatus["GATEWAY_TIMEOUT"] = "GATEWAY_TIMEOUT";
  HttpStatus["GONE"] = "GONE";
  HttpStatus["HTTP_VERSION_NOT_SUPPORTED"] = "HTTP_VERSION_NOT_SUPPORTED";
  HttpStatus["IM_USED"] = "IM_USED";
  HttpStatus["INSUFFICIENT_SPACE_ON_RESOURCE"] = "INSUFFICIENT_SPACE_ON_RESOURCE";
  HttpStatus["INSUFFICIENT_STORAGE"] = "INSUFFICIENT_STORAGE";
  HttpStatus["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
  HttpStatus["I_AM_A_TEAPOT"] = "I_AM_A_TEAPOT";
  HttpStatus["LENGTH_REQUIRED"] = "LENGTH_REQUIRED";
  HttpStatus["LOCKED"] = "LOCKED";
  HttpStatus["LOOP_DETECTED"] = "LOOP_DETECTED";
  HttpStatus["METHOD_FAILURE"] = "METHOD_FAILURE";
  HttpStatus["METHOD_NOT_ALLOWED"] = "METHOD_NOT_ALLOWED";
  HttpStatus["MOVED_PERMANENTLY"] = "MOVED_PERMANENTLY";
  HttpStatus["MOVED_TEMPORARILY"] = "MOVED_TEMPORARILY";
  HttpStatus["MULTIPLE_CHOICES"] = "MULTIPLE_CHOICES";
  HttpStatus["MULTI_STATUS"] = "MULTI_STATUS";
  HttpStatus["NETWORK_AUTHENTICATION_REQUIRED"] = "NETWORK_AUTHENTICATION_REQUIRED";
  HttpStatus["NON_AUTHORITATIVE_INFORMATION"] = "NON_AUTHORITATIVE_INFORMATION";
  HttpStatus["NOT_ACCEPTABLE"] = "NOT_ACCEPTABLE";
  HttpStatus["NOT_EXTENDED"] = "NOT_EXTENDED";
  HttpStatus["NOT_FOUND"] = "NOT_FOUND";
  HttpStatus["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
  HttpStatus["NOT_MODIFIED"] = "NOT_MODIFIED";
  HttpStatus["NO_CONTENT"] = "NO_CONTENT";
  HttpStatus["OK"] = "OK";
  HttpStatus["PARTIAL_CONTENT"] = "PARTIAL_CONTENT";
  HttpStatus["PAYLOAD_TOO_LARGE"] = "PAYLOAD_TOO_LARGE";
  HttpStatus["PAYMENT_REQUIRED"] = "PAYMENT_REQUIRED";
  HttpStatus["PERMANENT_REDIRECT"] = "PERMANENT_REDIRECT";
  HttpStatus["PRECONDITION_FAILED"] = "PRECONDITION_FAILED";
  HttpStatus["PRECONDITION_REQUIRED"] = "PRECONDITION_REQUIRED";
  HttpStatus["PROCESSING"] = "PROCESSING";
  HttpStatus["PROXY_AUTHENTICATION_REQUIRED"] = "PROXY_AUTHENTICATION_REQUIRED";
  HttpStatus["REQUESTED_RANGE_NOT_SATISFIABLE"] = "REQUESTED_RANGE_NOT_SATISFIABLE";
  HttpStatus["REQUEST_ENTITY_TOO_LARGE"] = "REQUEST_ENTITY_TOO_LARGE";
  HttpStatus["REQUEST_HEADER_FIELDS_TOO_LARGE"] = "REQUEST_HEADER_FIELDS_TOO_LARGE";
  HttpStatus["REQUEST_TIMEOUT"] = "REQUEST_TIMEOUT";
  HttpStatus["REQUEST_URI_TOO_LONG"] = "REQUEST_URI_TOO_LONG";
  HttpStatus["RESET_CONTENT"] = "RESET_CONTENT";
  HttpStatus["SEE_OTHER"] = "SEE_OTHER";
  HttpStatus["SERVICE_UNAVAILABLE"] = "SERVICE_UNAVAILABLE";
  HttpStatus["SWITCHING_PROTOCOLS"] = "SWITCHING_PROTOCOLS";
  HttpStatus["TEMPORARY_REDIRECT"] = "TEMPORARY_REDIRECT";
  HttpStatus["TOO_EARLY"] = "TOO_EARLY";
  HttpStatus["TOO_MANY_REQUESTS"] = "TOO_MANY_REQUESTS";
  HttpStatus["UNAUTHORIZED"] = "UNAUTHORIZED";
  HttpStatus["UNAVAILABLE_FOR_LEGAL_REASONS"] = "UNAVAILABLE_FOR_LEGAL_REASONS";
  HttpStatus["UNPROCESSABLE_ENTITY"] = "UNPROCESSABLE_ENTITY";
  HttpStatus["UNSUPPORTED_MEDIA_TYPE"] = "UNSUPPORTED_MEDIA_TYPE";
  HttpStatus["UPGRADE_REQUIRED"] = "UPGRADE_REQUIRED";
  HttpStatus["URI_TOO_LONG"] = "URI_TOO_LONG";
  HttpStatus["USE_PROXY"] = "USE_PROXY";
  HttpStatus["VARIANT_ALSO_NEGOTIATES"] = "VARIANT_ALSO_NEGOTIATES";
})(HttpStatus || (HttpStatus = {}));
export var IsViewType;
(function (IsViewType) {
  /** The view to display when the traveller confirms booking */
  IsViewType["BOOKING_CONFIRM"] = "BOOKING_CONFIRM";
  /** The view to display when the traveller skips booking selection */
  IsViewType["BOOKING_SKIP"] = "BOOKING_SKIP";
  /** The view that displays the search results */
  IsViewType["SEARCH"] = "SEARCH";
})(IsViewType || (IsViewType = {}));
/** supported sizes of icons */
export var IconSize;
(function (IconSize) {
  IconSize["EXTRA_SMALL"] = "EXTRA_SMALL";
  IconSize["LARGE"] = "LARGE";
  IconSize["MEDIUM"] = "MEDIUM";
  /** @deprecated LARGE icon size changed from 48px to 32px. Use LARGE instead of MEDIUM_LARGE */
  IconSize["MEDIUM_LARGE"] = "MEDIUM_LARGE";
  IconSize["SMALL"] = "SMALL";
  IconSize["XLARGE"] = "XLARGE";
})(IconSize || (IconSize = {}));
/** Supported themes of spotlights. See the prop definitions here: https://www.figma.com/file/Cq6XtgvVIEriWmWmVIMPzNOE/Icons?node-id=6402%3A115 */
export var IconSpotLight;
(function (IconSpotLight) {
  IconSpotLight["INFO"] = "INFO";
  IconSpotLight["POSITIVE"] = "POSITIVE";
  IconSpotLight["STANDARD"] = "STANDARD";
  IconSpotLight["WARNING"] = "WARNING";
})(IconSpotLight || (IconSpotLight = {}));
/** Supported themes of icons. See the prop definitions here: http://uitk-react.tools.expedia.com/expedia/en_US/components/icons */
export var IconTheme;
(function (IconTheme) {
  IconTheme["DEFAULT"] = "default";
  IconTheme["EMPHASIS"] = "emphasis";
  IconTheme["INVERSE"] = "inverse";
  IconTheme["NEGATIVE"] = "negative";
  IconTheme["POSITIVE"] = "positive";
})(IconTheme || (IconTheme = {}));
/** To define  type of status icon  */
export var IconType;
(function (IconType) {
  IconType["DONE"] = "DONE";
  IconType["ERROR"] = "ERROR";
})(IconType || (IconType = {}));
/** Enum to specify the type for InputId */
export var IdentifierType;
(function (IdentifierType) {
  IdentifierType["ACTIVITY_ID"] = "ACTIVITY_ID";
  /** @deprecated Use CHECKOUT_SESSION_ID instead */
  IdentifierType["CART_ID"] = "CART_ID";
  IdentifierType["CAR_OFFER_TOKEN"] = "CAR_OFFER_TOKEN";
  IdentifierType["CHECKOUT_SESSION_ID"] = "CHECKOUT_SESSION_ID";
  /** @deprecated This has been deprecated */
  IdentifierType["ENTITY_ID"] = "ENTITY_ID";
  IdentifierType["LEGACY_ORDER_ID"] = "LEGACY_ORDER_ID";
  /** @deprecated Use CHECKOUT_SESSION_ID instead */
  IdentifierType["OFFER_ID"] = "OFFER_ID";
  IdentifierType["ORDER_ID"] = "ORDER_ID";
  IdentifierType["PROPERTY_ID"] = "PROPERTY_ID";
  IdentifierType["SAILING_TOKEN"] = "SAILING_TOKEN";
})(IdentifierType || (IdentifierType = {}));
export var IdentityAccountCreationState;
(function (IdentityAccountCreationState) {
  IdentityAccountCreationState["INVALID"] = "INVALID";
  IdentityAccountCreationState["NOT_UPGRADED"] = "NOT_UPGRADED";
  IdentityAccountCreationState["UPGRADED"] = "UPGRADED";
})(IdentityAccountCreationState || (IdentityAccountCreationState = {}));
export var IdentityAccountCreationType;
(function (IdentityAccountCreationType) {
  IdentityAccountCreationType["INVALID"] = "INVALID";
  IdentityAccountCreationType["REGISTERED"] = "REGISTERED";
  IdentityAccountCreationType["UNREGISTERED"] = "UNREGISTERED";
})(IdentityAccountCreationType || (IdentityAccountCreationType = {}));
export var IdentityAccountTakeOverDeviceType;
(function (IdentityAccountTakeOverDeviceType) {
  IdentityAccountTakeOverDeviceType["TRUST_WIDGET"] = "TRUST_WIDGET";
})(IdentityAccountTakeOverDeviceType || (IdentityAccountTakeOverDeviceType = {}));
export var IdentityAccountTakeOverType;
(function (IdentityAccountTakeOverType) {
  IdentityAccountTakeOverType["CAPTCHA_ARKOSE_MOBILE_APP"] = "CAPTCHA_ARKOSE_MOBILE_APP";
  IdentityAccountTakeOverType["CAPTCHA_SAFETYNET_ANDROID"] = "CAPTCHA_SAFETYNET_ANDROID";
  IdentityAccountTakeOverType["CAPTCHA_WEB"] = "CAPTCHA_WEB";
  IdentityAccountTakeOverType["CSRF"] = "CSRF";
  IdentityAccountTakeOverType["DEVICE_CHECK"] = "DEVICE_CHECK";
  IdentityAccountTakeOverType["TRUST_WIDGET"] = "TRUST_WIDGET";
})(IdentityAccountTakeOverType || (IdentityAccountTakeOverType = {}));
export var IdentityAnalyticsPayloadType;
(function (IdentityAnalyticsPayloadType) {
  IdentityAnalyticsPayloadType["EG_CLICK_STREAM"] = "EG_CLICK_STREAM";
  IdentityAnalyticsPayloadType["UIS_PRIME"] = "UIS_PRIME";
})(IdentityAnalyticsPayloadType || (IdentityAnalyticsPayloadType = {}));
export var IdentityAuthenticationScenario;
(function (IdentityAuthenticationScenario) {
  IdentityAuthenticationScenario["CHECKOUT_SIGNIN"] = "CHECKOUT_SIGNIN";
  IdentityAuthenticationScenario["CHECKOUT_SIGNUP"] = "CHECKOUT_SIGNUP";
  IdentityAuthenticationScenario["PROFILE"] = "PROFILE";
  IdentityAuthenticationScenario["SIGNIN"] = "SIGNIN";
  IdentityAuthenticationScenario["SIGNUP"] = "SIGNUP";
})(IdentityAuthenticationScenario || (IdentityAuthenticationScenario = {}));
export var IdentityChannelType;
(function (IdentityChannelType) {
  IdentityChannelType["ANDROID"] = "ANDROID";
  IdentityChannelType["DESKTOP"] = "DESKTOP";
  IdentityChannelType["IOS"] = "IOS";
})(IdentityChannelType || (IdentityChannelType = {}));
export var IdentityCustomValidationTheme;
(function (IdentityCustomValidationTheme) {
  IdentityCustomValidationTheme["ERROR"] = "ERROR";
  IdentityCustomValidationTheme["INFO"] = "INFO";
  IdentityCustomValidationTheme["WARNING"] = "WARNING";
})(IdentityCustomValidationTheme || (IdentityCustomValidationTheme = {}));
export var IdentityFlowType;
(function (IdentityFlowType) {
  IdentityFlowType["ADD"] = "ADD";
  IdentityFlowType["RE_AUTHENTICATE"] = "RE_AUTHENTICATE";
  IdentityFlowType["UPDATE"] = "UPDATE";
  IdentityFlowType["VERIFY"] = "VERIFY";
})(IdentityFlowType || (IdentityFlowType = {}));
export var IdentityLayout;
(function (IdentityLayout) {
  IdentityLayout["APP_ONBOARDING"] = "APP_ONBOARDING";
  IdentityLayout["FORGOT_PASSWORD"] = "FORGOT_PASSWORD";
  IdentityLayout["GET_RESENT_OTP_ATO"] = "GET_RESENT_OTP_ATO";
  IdentityLayout["GET_SEND_OTP_ATO"] = "GET_SEND_OTP_ATO";
  IdentityLayout["GET_SET_PASSWORD_ATO"] = "GET_SET_PASSWORD_ATO";
  IdentityLayout["GET_SIGN_IN_ATO"] = "GET_SIGN_IN_ATO";
  IdentityLayout["GET_SIGN_IN_VERIFY_OTP_ATO"] = "GET_SIGN_IN_VERIFY_OTP_ATO";
  IdentityLayout["GET_SIGN_UP_VERIFY_OTP_ATO"] = "GET_SIGN_UP_VERIFY_OTP_ATO";
  IdentityLayout["GET_SOCIAL_LOGIN_APPLE_ATO"] = "GET_SOCIAL_LOGIN_APPLE_ATO";
  IdentityLayout["GET_SOCIAL_LOGIN_FACEBOOK_ATO"] = "GET_SOCIAL_LOGIN_FACEBOOK_ATO";
  IdentityLayout["GET_SOCIAL_LOGIN_GOOGLE_ATO"] = "GET_SOCIAL_LOGIN_GOOGLE_ATO";
  IdentityLayout["GET_USER_DETAILS_ATO"] = "GET_USER_DETAILS_ATO";
  IdentityLayout["HYBRID_LOGIN"] = "HYBRID_LOGIN";
  IdentityLayout["LAUNCH_ONE_IDENTITY"] = "LAUNCH_ONE_IDENTITY";
  IdentityLayout["RESET_PASSWORD"] = "RESET_PASSWORD";
  IdentityLayout["SIGNIN"] = "SIGNIN";
  IdentityLayout["SIGNUP"] = "SIGNUP";
})(IdentityLayout || (IdentityLayout = {}));
export var IdentityLoginScenario;
(function (IdentityLoginScenario) {
  IdentityLoginScenario["SIGN_IN"] = "SIGN_IN";
  IdentityLoginScenario["SIGN_UP"] = "SIGN_UP";
})(IdentityLoginScenario || (IdentityLoginScenario = {}));
export var IdentityLoginType;
(function (IdentityLoginType) {
  IdentityLoginType["MANAGE"] = "MANAGE";
  /** @deprecated Use Manage as LoginType and PageName+FlowType instead */
  IdentityLoginType["PROFILE"] = "PROFILE";
  /** @deprecated Use Manage as LoginType and PageName+FlowType instead */
  IdentityLoginType["SETTINGS"] = "SETTINGS";
  IdentityLoginType["SIGN_IN"] = "SIGN_IN";
  IdentityLoginType["SIGN_UP"] = "SIGN_UP";
  /** @deprecated Use Manage as LoginType and PageName+FlowType instead */
  IdentityLoginType["UPDATE"] = "UPDATE";
})(IdentityLoginType || (IdentityLoginType = {}));
export var IdentityPageName;
(function (IdentityPageName) {
  IdentityPageName["PROFILE"] = "PROFILE";
  IdentityPageName["SETTINGS"] = "SETTINGS";
})(IdentityPageName || (IdentityPageName = {}));
export var IdentitySocialButtonType;
(function (IdentitySocialButtonType) {
  IdentitySocialButtonType["PRIMARY"] = "PRIMARY";
  IdentitySocialButtonType["SECONDARY"] = "SECONDARY";
})(IdentitySocialButtonType || (IdentitySocialButtonType = {}));
export var IdentitySocialTokenType;
(function (IdentitySocialTokenType) {
  IdentitySocialTokenType["ACCESS"] = "Access";
  IdentitySocialTokenType["AUTHCODE"] = "AuthCode";
  IdentitySocialTokenType["ID"] = "ID";
})(IdentitySocialTokenType || (IdentitySocialTokenType = {}));
export var IdentitySocialType;
(function (IdentitySocialType) {
  IdentitySocialType["APPLE"] = "APPLE";
  IdentitySocialType["FACEBOOK"] = "FACEBOOK";
  IdentitySocialType["GOOGLE"] = "GOOGLE";
  IdentitySocialType["NAVER"] = "NAVER";
})(IdentitySocialType || (IdentitySocialType = {}));
/** EG Universal Login spacing definition */
export var IdentitySpaceSize;
(function (IdentitySpaceSize) {
  IdentitySpaceSize["S0X"] = "S0X";
  IdentitySpaceSize["S0XH"] = "S0XH";
  IdentitySpaceSize["S1X"] = "S1X";
  IdentitySpaceSize["S2X"] = "S2X";
  IdentitySpaceSize["S3X"] = "S3X";
  IdentitySpaceSize["S4X"] = "S4X";
  IdentitySpaceSize["S5X"] = "S5X";
  IdentitySpaceSize["S6X"] = "S6X";
  IdentitySpaceSize["S8X"] = "S8X";
  IdentitySpaceSize["S10X"] = "S10X";
  IdentitySpaceSize["S11X"] = "S11X";
  IdentitySpaceSize["S12X"] = "S12X";
  IdentitySpaceSize["S14X"] = "S14X";
  IdentitySpaceSize["S15X"] = "S15X";
  IdentitySpaceSize["S16X"] = "S16X";
  IdentitySpaceSize["S18X"] = "S18X";
  IdentitySpaceSize["S150X"] = "S150X";
})(IdentitySpaceSize || (IdentitySpaceSize = {}));
export var IdentitySuccessType;
(function (IdentitySuccessType) {
  IdentitySuccessType["ONE_KEY_ONBOARDING"] = "ONE_KEY_ONBOARDING";
  IdentitySuccessType["ORIGIN"] = "ORIGIN";
})(IdentitySuccessType || (IdentitySuccessType = {}));
/** Represents supported areas to place an image within a card. TOP should be the default value */
export var ImagePosition;
(function (ImagePosition) {
  ImagePosition["LEFT"] = "LEFT";
  ImagePosition["TOP"] = "TOP";
})(ImagePosition || (ImagePosition = {}));
export var ImmersiveViewNavigationType;
(function (ImmersiveViewNavigationType) {
  ImmersiveViewNavigationType["SWIPE_HORIZONTAL"] = "SWIPE_HORIZONTAL";
  ImmersiveViewNavigationType["SWIPE_VERTICAL"] = "SWIPE_VERTICAL";
})(ImmersiveViewNavigationType || (ImmersiveViewNavigationType = {}));
/** Represents where in to justify elements along the horizontal axis of a row. Terminology is the same as Flexbox - see https://developer.mozilla.org/en-US/docs/Web/CSS/justify-content */
export var InlineJustify;
(function (InlineJustify) {
  InlineJustify["END"] = "END";
  InlineJustify["SPACE"] = "SPACE";
  InlineJustify["START"] = "START";
})(InlineJustify || (InlineJustify = {}));
export var InquiryProminence;
(function (InquiryProminence) {
  InquiryProminence["HIGH"] = "HIGH";
  InquiryProminence["LOW"] = "LOW";
  InquiryProminence["MEDIUM"] = "MEDIUM";
})(InquiryProminence || (InquiryProminence = {}));
/** Represent the type of tracking cards */
export var InsightsTrackingCardType;
(function (InsightsTrackingCardType) {
  InsightsTrackingCardType["DEALS_TRACKING"] = "DEALS_TRACKING";
  InsightsTrackingCardType["PRICE_TRACKING"] = "PRICE_TRACKING";
})(InsightsTrackingCardType || (InsightsTrackingCardType = {}));
/** Represents insurance dialog action types */
export var InsurTechDialogActionType;
(function (InsurTechDialogActionType) {
  InsurTechDialogActionType["CLOSE"] = "CLOSE";
  InsurTechDialogActionType["OPEN"] = "OPEN";
  InsurTechDialogActionType["OPEN_QUERY"] = "OPEN_QUERY";
})(InsurTechDialogActionType || (InsurTechDialogActionType = {}));
/** Represents insurance dialog trigger types link or button */
export var InsurTechExperienceDialogTriggerType;
(function (InsurTechExperienceDialogTriggerType) {
  InsurTechExperienceDialogTriggerType["BUTTON"] = "BUTTON";
  InsurTechExperienceDialogTriggerType["LINK"] = "LINK";
})(InsurTechExperienceDialogTriggerType || (InsurTechExperienceDialogTriggerType = {}));
/** Placement of the component inside the page */
export var InsurTechPagePlacementType;
(function (InsurTechPagePlacementType) {
  InsurTechPagePlacementType["LISTING"] = "LISTING";
  InsurTechPagePlacementType["LISTING_ONE_WAY"] = "LISTING_ONE_WAY";
})(InsurTechPagePlacementType || (InsurTechPagePlacementType = {}));
export var InsuranceMessageType;
(function (InsuranceMessageType) {
  InsuranceMessageType["ERROR"] = "ERROR";
  InsuranceMessageType["INFO"] = "INFO";
  InsuranceMessageType["WARNING"] = "WARNING";
})(InsuranceMessageType || (InsuranceMessageType = {}));
export var InsuranceRewardsPointSelectionEnum;
(function (InsuranceRewardsPointSelectionEnum) {
  InsuranceRewardsPointSelectionEnum["APPLY_REWARD_POINTS"] = "APPLY_REWARD_POINTS";
  InsuranceRewardsPointSelectionEnum["DO_NOT_APPLY_REWARD_POINTS"] = "DO_NOT_APPLY_REWARD_POINTS";
})(InsuranceRewardsPointSelectionEnum || (InsuranceRewardsPointSelectionEnum = {}));
export var InsurtechAlertTheme;
(function (InsurtechAlertTheme) {
  InsurtechAlertTheme["INFO"] = "INFO";
  InsurtechAlertTheme["SUCCESS"] = "SUCCESS";
  InsurtechAlertTheme["WARNING"] = "WARNING";
})(InsurtechAlertTheme || (InsurtechAlertTheme = {}));
/** Client Id Possibilities */
export var InsurtechClientId;
(function (InsurtechClientId) {
  InsurtechClientId["CAR_INFO_SITE"] = "CAR_INFO_SITE";
  InsurtechClientId["EG_CHECKOUT"] = "EG_CHECKOUT";
  InsurtechClientId["FCR_CHECKOUT"] = "FCR_CHECKOUT";
})(InsurtechClientId || (InsurtechClientId = {}));
/** Insurtech Page Level Error Type */
export var InsurtechCommonErrorType;
(function (InsurtechCommonErrorType) {
  InsurtechCommonErrorType["ABACUS_DISABLED_FOR_USER"] = "ABACUS_DISABLED_FOR_USER";
  InsurtechCommonErrorType["ANONYMOUS_TRIP_USER"] = "ANONYMOUS_TRIP_USER";
  InsurtechCommonErrorType["BOOKING_CANCELLED"] = "BOOKING_CANCELLED";
  InsurtechCommonErrorType["CHANGE_RESIDENCY_FAILURE"] = "CHANGE_RESIDENCY_FAILURE";
  InsurtechCommonErrorType["ERROR_CARD_LIMIT"] = "ERROR_CARD_LIMIT";
  InsurtechCommonErrorType["ERROR_MAPPING_PAYMENT_INSTRUMENT_DETAILS"] = "ERROR_MAPPING_PAYMENT_INSTRUMENT_DETAILS";
  InsurtechCommonErrorType["ERROR_OMS_RECOVERABLE"] = "ERROR_OMS_RECOVERABLE";
  InsurtechCommonErrorType["FAILURE_SELECT_INSURANCE_PRODUCT"] = "FAILURE_SELECT_INSURANCE_PRODUCT";
  InsurtechCommonErrorType["INSURANCE_ADD_FAILURE"] = "INSURANCE_ADD_FAILURE";
  InsurtechCommonErrorType["INSURANCE_ALREADY_PURCHASED"] = "INSURANCE_ALREADY_PURCHASED";
  InsurtechCommonErrorType["INSURANCE_OFFER_EXPIRED"] = "INSURANCE_OFFER_EXPIRED";
  InsurtechCommonErrorType["INVALID_ACCOUNT_NUMBER"] = "INVALID_ACCOUNT_NUMBER";
  InsurtechCommonErrorType["INVALID_EDGE_TOKEN"] = "INVALID_EDGE_TOKEN";
  InsurtechCommonErrorType["INVALID_EXPIRATION_DATE"] = "INVALID_EXPIRATION_DATE";
  InsurtechCommonErrorType["INVALID_FORM"] = "INVALID_FORM";
  InsurtechCommonErrorType["NO_PRODUCT_FOUND"] = "NO_PRODUCT_FOUND";
  InsurtechCommonErrorType["PAYMENT_CARD_ISSUE"] = "PAYMENT_CARD_ISSUE";
  InsurtechCommonErrorType["PAYMENT_SESSION_SERVICE_ERROR"] = "PAYMENT_SESSION_SERVICE_ERROR";
  InsurtechCommonErrorType["RESPONSE_ID_NOT_FOUND_IN_RECORD"] = "RESPONSE_ID_NOT_FOUND_IN_RECORD";
  InsurtechCommonErrorType["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
  InsurtechCommonErrorType["USER_ACCOUNT_MISMATCH"] = "USER_ACCOUNT_MISMATCH";
  InsurtechCommonErrorType["USER_BUCKETED_FOR_LEGACY_PAGE"] = "USER_BUCKETED_FOR_LEGACY_PAGE";
})(InsurtechCommonErrorType || (InsurtechCommonErrorType = {}));
export var InsurtechCustomErrorType;
(function (InsurtechCustomErrorType) {
  InsurtechCustomErrorType["CACHED_PRODUCT_UNAVAILABLE"] = "CACHED_PRODUCT_UNAVAILABLE";
  InsurtechCustomErrorType["GENERIC_ERROR"] = "GENERIC_ERROR";
  InsurtechCustomErrorType["INVALID_USER"] = "INVALID_USER";
  InsurtechCustomErrorType["USER_BUCKETED_FOR_LEGACY_PAGE"] = "USER_BUCKETED_FOR_LEGACY_PAGE";
})(InsurtechCustomErrorType || (InsurtechCustomErrorType = {}));
/** Enum having action type details available to execute */
export var InsurtechGenericActionType;
(function (InsurtechGenericActionType) {
  InsurtechGenericActionType["REDIRECT_CHECKOUT_URL"] = "REDIRECT_CHECKOUT_URL";
  InsurtechGenericActionType["RELOAD_PAGE"] = "RELOAD_PAGE";
})(InsurtechGenericActionType || (InsurtechGenericActionType = {}));
/** Insurtech Link Type */
export var InsurtechLinkType;
(function (InsurtechLinkType) {
  InsurtechLinkType["EXTERNAL_LINK"] = "EXTERNAL_LINK";
  InsurtechLinkType["MORE_INFO"] = "MORE_INFO";
  InsurtechLinkType["STANDARD_LINK"] = "STANDARD_LINK";
})(InsurtechLinkType || (InsurtechLinkType = {}));
/** Themes for insurtech list items */
export var InsurtechListItemTheme;
(function (InsurtechListItemTheme) {
  InsurtechListItemTheme["HEADED_LIST_ITEM"] = "HEADED_LIST_ITEM";
  InsurtechListItemTheme["LIST_ITEM"] = "LIST_ITEM";
})(InsurtechListItemTheme || (InsurtechListItemTheme = {}));
/** It is expandable to NUMBER_LIST based on other templates. */
export var InsurtechListType;
(function (InsurtechListType) {
  InsurtechListType["BULLET_LIST"] = "BULLET_LIST";
  InsurtechListType["GRAPHIC_LIST"] = "GRAPHIC_LIST";
})(InsurtechListType || (InsurtechListType = {}));
export var InsurtechModuleHeadingViewType;
(function (InsurtechModuleHeadingViewType) {
  /** Theme indicating heading and badge inlined */
  InsurtechModuleHeadingViewType["INLINE_BADGE"] = "INLINE_BADGE";
  /** Theme indicating badge followed by heading and graphic inlined in a new line */
  InsurtechModuleHeadingViewType["PRIMARY"] = "PRIMARY";
})(InsurtechModuleHeadingViewType || (InsurtechModuleHeadingViewType = {}));
/** Status Possibilities */
export var InsurtechMutationStatus;
(function (InsurtechMutationStatus) {
  InsurtechMutationStatus["FAILED"] = "FAILED";
  InsurtechMutationStatus["SUCCESS"] = "SUCCESS";
})(InsurtechMutationStatus || (InsurtechMutationStatus = {}));
/** State represents teh status whether offer is already added, not added or some different offer is added */
export var InsurtechOfferState;
(function (InsurtechOfferState) {
  InsurtechOfferState["CHANGED_OFFER"] = "CHANGED_OFFER";
  InsurtechOfferState["NOT_SELECTED"] = "NOT_SELECTED";
  InsurtechOfferState["UNCHANGED_OFFER"] = "UNCHANGED_OFFER";
})(InsurtechOfferState || (InsurtechOfferState = {}));
export var InsurtechPrimingCardViewType;
(function (InsurtechPrimingCardViewType) {
  InsurtechPrimingCardViewType["BASIC_PRIMING_CARD"] = "BASIC_PRIMING_CARD";
})(InsurtechPrimingCardViewType || (InsurtechPrimingCardViewType = {}));
/** Enum having Insurtech product types */
export var InsurtechProductTypeInput;
(function (InsurtechProductTypeInput) {
  /** Trip assurance Cancel For Any Reason product type */
  InsurtechProductTypeInput["CANCEL_FOR_ANY_REASON"] = "CANCEL_FOR_ANY_REASON";
  /** Trip insurance product type */
  InsurtechProductTypeInput["INSURANCE"] = "INSURANCE";
  /** Trip assurance Price Drop Protection product type */
  InsurtechProductTypeInput["PRICE_DROP_PROTECTION"] = "PRICE_DROP_PROTECTION";
})(InsurtechProductTypeInput || (InsurtechProductTypeInput = {}));
/** Status Possibilities */
export var InsurtechQueryStatus;
(function (InsurtechQueryStatus) {
  InsurtechQueryStatus["FAILED"] = "FAILED";
  InsurtechQueryStatus["SUCCESS"] = "SUCCESS";
})(InsurtechQueryStatus || (InsurtechQueryStatus = {}));
/** Enum having criteria type details available for trip */
export var InsurtechShoppingIdentifierType;
(function (InsurtechShoppingIdentifierType) {
  InsurtechShoppingIdentifierType["CHECKOUT_SESSION_ID"] = "CHECKOUT_SESSION_ID";
  InsurtechShoppingIdentifierType["JCID"] = "JCID";
  InsurtechShoppingIdentifierType["OFFER_TOKEN"] = "OFFER_TOKEN";
  InsurtechShoppingIdentifierType["RESPONSE_ID"] = "RESPONSE_ID";
  InsurtechShoppingIdentifierType["TRIP_ID"] = "TRIP_ID";
})(InsurtechShoppingIdentifierType || (InsurtechShoppingIdentifierType = {}));
/** Enum having shopping view type details */
export var InsurtechShoppingViewType;
(function (InsurtechShoppingViewType) {
  InsurtechShoppingViewType["CHECKOUT_SHOPPING"] = "CHECKOUT_SHOPPING";
  InsurtechShoppingViewType["DETAILS_SHOPPING"] = "DETAILS_SHOPPING";
  InsurtechShoppingViewType["EXPWEB_CHECKOUT_SHOPPING"] = "EXPWEB_CHECKOUT_SHOPPING";
  InsurtechShoppingViewType["POST_PURCHASE"] = "POST_PURCHASE";
  InsurtechShoppingViewType["SUMMARY"] = "SUMMARY";
})(InsurtechShoppingViewType || (InsurtechShoppingViewType = {}));
/** Insurtech Testimonial Type */
export var InsurtechTestimonialType;
(function (InsurtechTestimonialType) {
  InsurtechTestimonialType["TESTIMONIAL"] = "TESTIMONIAL";
  InsurtechTestimonialType["TESTIMONIAL_WITH_SOCIAL_PROOF"] = "TESTIMONIAL_WITH_SOCIAL_PROOF";
})(InsurtechTestimonialType || (InsurtechTestimonialType = {}));
/** Enum having criteria type details available for trip */
export var InsurtechTransactionIdentifierType;
(function (InsurtechTransactionIdentifierType) {
  InsurtechTransactionIdentifierType["RESPONSE_ID"] = "RESPONSE_ID";
  InsurtechTransactionIdentifierType["TRIP_ID"] = "TRIP_ID";
})(InsurtechTransactionIdentifierType || (InsurtechTransactionIdentifierType = {}));
/** Enum having operation type details */
export var InsurtechUpdateOperationType;
(function (InsurtechUpdateOperationType) {
  InsurtechUpdateOperationType["ADD"] = "ADD";
  InsurtechUpdateOperationType["MODAL"] = "MODAL";
  InsurtechUpdateOperationType["REMOVE"] = "REMOVE";
})(InsurtechUpdateOperationType || (InsurtechUpdateOperationType = {}));
/** view Id Possibilities */
export var InsurtechView;
(function (InsurtechView) {
  InsurtechView["COMPACT_ACCEPTANCE_VIEW"] = "COMPACT_ACCEPTANCE_VIEW";
  InsurtechView["COMPACT_REJECTED_COLLAPSED_VIEW"] = "COMPACT_REJECTED_COLLAPSED_VIEW";
  InsurtechView["COMPACT_REJECTED_VIEW"] = "COMPACT_REJECTED_VIEW";
  InsurtechView["DEFAULT_VIEW"] = "DEFAULT_VIEW";
  InsurtechView["HYBRID_INTERACTION_VIEW"] = "HYBRID_INTERACTION_VIEW";
  InsurtechView["NUDGE_ACCEPTANCE_VIEW"] = "NUDGE_ACCEPTANCE_VIEW";
  InsurtechView["NUDGE_REJECTED_VIEW"] = "NUDGE_REJECTED_VIEW";
})(InsurtechView || (InsurtechView = {}));
/** Interaction to publish an event for */
export var InteractionEventName;
(function (InteractionEventName) {
  InteractionEventName["BOOK"] = "BOOK";
  InteractionEventName["CHECKOUT_CLIENT_SIDE_LOAD_ATTEMPT"] = "CHECKOUT_CLIENT_SIDE_LOAD_ATTEMPT";
  InteractionEventName["CHECKOUT_CLIENT_SIDE_LOAD_OUTCOME"] = "CHECKOUT_CLIENT_SIDE_LOAD_OUTCOME";
  InteractionEventName["CHECKOUT_PAGE_LOAD"] = "CHECKOUT_PAGE_LOAD";
  InteractionEventName["CONFIRMATION_PAGE_LOAD"] = "CONFIRMATION_PAGE_LOAD";
})(InteractionEventName || (InteractionEventName = {}));
/** InteractionMode will hold status of input for the session  */
export var InteractionMode;
(function (InteractionMode) {
  InteractionMode["FREE"] = "FREE";
  InteractionMode["RESTRICTED"] = "RESTRICTED";
})(InteractionMode || (InteractionMode = {}));
/** Indicate the inventory type of a given offer */
export var InventoryType;
(function (InventoryType) {
  InventoryType["AICTRAVELGROUP"] = "AICTRAVELGROUP";
  InventoryType["AMOMA"] = "AMOMA";
  InventoryType["ANA"] = "ANA";
  InventoryType["BESTBUYHOTEL"] = "BESTBUYHOTEL";
  InventoryType["BONOTEL"] = "BONOTEL";
  InventoryType["CNTRAVEL"] = "CNTRAVEL";
  /** @deprecated Replaced by TRIPCOM */
  InventoryType["CTRIP"] = "CTRIP";
  InventoryType["DESPEGAR"] = "DESPEGAR";
  InventoryType["DIDATRAVEL"] = "DIDATRAVEL";
  InventoryType["DIRECT_AGENCY"] = "DIRECT_AGENCY";
  InventoryType["EUROPLAYAS"] = "EUROPLAYAS";
  InventoryType["EXCITEHOLIDAYS"] = "EXCITEHOLIDAYS";
  InventoryType["EZZEGO_1"] = "EZZEGO_1";
  InventoryType["GETAROOM"] = "GETAROOM";
  InventoryType["HOME_AWAY"] = "HOME_AWAY";
  InventoryType["HOTELDOBESTDAYTRAVEL"] = "HOTELDOBESTDAYTRAVEL";
  InventoryType["HOTEL_BEDS"] = "HOTEL_BEDS";
  /** @deprecated Replaced by THOMASCOOK_EUR */
  InventoryType["HRS"] = "HRS";
  InventoryType["JAC_TRAVEL"] = "JAC_TRAVEL";
  InventoryType["JAL"] = "JAL";
  InventoryType["JALAN"] = "JALAN";
  InventoryType["JTB"] = "JTB";
  InventoryType["JUMBOTOURS"] = "JUMBOTOURS";
  InventoryType["MAGICROOMS"] = "MAGICROOMS";
  InventoryType["MERCHANT"] = "MERCHANT";
  InventoryType["MGBEDBANK"] = "MGBEDBANK";
  InventoryType["MIKI"] = "MIKI";
  InventoryType["MTS"] = "MTS";
  InventoryType["NTA"] = "NTA";
  InventoryType["NUITEE"] = "NUITEE";
  InventoryType["OPAQUE"] = "OPAQUE";
  InventoryType["OSTROVOK"] = "OSTROVOK";
  InventoryType["PEGASUS"] = "PEGASUS";
  InventoryType["RAKUTEN"] = "RAKUTEN";
  InventoryType["RESTEL"] = "RESTEL";
  InventoryType["ROOMER"] = "ROOMER";
  InventoryType["SMYROOMS"] = "SMYROOMS";
  InventoryType["SUNHOTELS"] = "SUNHOTELS";
  InventoryType["THOMASCOOK_EUR"] = "THOMASCOOK_EUR";
  InventoryType["THOMASCOOK_UK"] = "THOMASCOOK_UK";
  InventoryType["TOURICO"] = "TOURICO";
  InventoryType["TRAVELLANDA"] = "TRAVELLANDA";
  InventoryType["TRAVELREPUBLIC"] = "TRAVELREPUBLIC";
  InventoryType["TRIPCOM"] = "TRIPCOM";
  InventoryType["VENERE"] = "VENERE";
  InventoryType["VRBO"] = "VRBO";
  InventoryType["VRBO_MUVR"] = "VRBO_MUVR";
  InventoryType["WELCOME_BEDS"] = "WELCOME_BEDS";
  InventoryType["WOORI"] = "WOORI";
  InventoryType["WORLDHOTELLINK"] = "WORLDHOTELLINK";
  InventoryType["WORLDSPAN"] = "WORLDSPAN";
  InventoryType["WOTIF"] = "WOTIF";
  InventoryType["YOUTRAVEL"] = "YOUTRAVEL";
  InventoryType["ZUMATA"] = "ZUMATA";
})(InventoryType || (InventoryType = {}));
export var JourneyExperience;
(function (JourneyExperience) {
  JourneyExperience["NEW_JOURNEY_PLAYBACK"] = "NEW_JOURNEY_PLAYBACK";
  JourneyExperience["OLD_JOURNEY_PLAYBACK"] = "OLD_JOURNEY_PLAYBACK";
})(JourneyExperience || (JourneyExperience = {}));
export var KeyPhrasesClientType;
(function (KeyPhrasesClientType) {
  KeyPhrasesClientType["DEFAULT"] = "DEFAULT";
  KeyPhrasesClientType["FILTER"] = "FILTER";
  KeyPhrasesClientType["SNIPPET"] = "SNIPPET";
})(KeyPhrasesClientType || (KeyPhrasesClientType = {}));
export var LayoutPosition;
(function (LayoutPosition) {
  LayoutPosition["CENTER"] = "CENTER";
  LayoutPosition["LEFT"] = "LEFT";
  LayoutPosition["TOP"] = "TOP";
})(LayoutPosition || (LayoutPosition = {}));
/** Controls the type of layout theme */
export var LayoutTheme;
(function (LayoutTheme) {
  LayoutTheme["ADAPTIVE"] = "ADAPTIVE";
  LayoutTheme["DEFAULT"] = "DEFAULT";
})(LayoutTheme || (LayoutTheme = {}));
export var LegalConcept;
(function (LegalConcept) {
  LegalConcept["LEGAL_CONCEPT_COOKIES"] = "LEGAL_CONCEPT_COOKIES";
  LegalConcept["LEGAL_CONCEPT_INVALID"] = "LEGAL_CONCEPT_INVALID";
  LegalConcept["LEGAL_CONCEPT_PRIVACY"] = "LEGAL_CONCEPT_PRIVACY";
  LegalConcept["LEGAL_CONCEPT_SORT_AND_FILTER"] = "LEGAL_CONCEPT_SORT_AND_FILTER";
  LegalConcept["LEGAL_CONCEPT_TERMS_AND_CONDITIONS"] = "LEGAL_CONCEPT_TERMS_AND_CONDITIONS";
})(LegalConcept || (LegalConcept = {}));
export var LegalSheetType;
(function (LegalSheetType) {
  LegalSheetType["LEGAL_SHEET"] = "LEGAL_SHEET";
})(LegalSheetType || (LegalSheetType = {}));
export var LikeUnlikeSocialInteractionAction;
(function (LikeUnlikeSocialInteractionAction) {
  LikeUnlikeSocialInteractionAction["LIKE"] = "LIKE";
  LikeUnlikeSocialInteractionAction["UNLIKE"] = "UNLIKE";
})(LikeUnlikeSocialInteractionAction || (LikeUnlikeSocialInteractionAction = {}));
export var LimitToCertainTravelersOptions;
(function (LimitToCertainTravelersOptions) {
  LimitToCertainTravelersOptions["HOTWIRE_USERS_ONLY"] = "HOTWIRE_USERS_ONLY";
  LimitToCertainTravelersOptions["MEMBERS_ONLY"] = "MEMBERS_ONLY";
  LimitToCertainTravelersOptions["MOBILE_AND_TABLET_USERS_ONLY"] = "MOBILE_AND_TABLET_USERS_ONLY";
  LimitToCertainTravelersOptions["TRAVELERS_IN_CERTAIN_LOCATIONS"] = "TRAVELERS_IN_CERTAIN_LOCATIONS";
})(LimitToCertainTravelersOptions || (LimitToCertainTravelersOptions = {}));
/** Line of business */
export var LineOfBusinessDomain;
(function (LineOfBusinessDomain) {
  LineOfBusinessDomain["ACTIVITIES"] = "ACTIVITIES";
  LineOfBusinessDomain["CAR"] = "CAR";
  LineOfBusinessDomain["CRUISES"] = "CRUISES";
  LineOfBusinessDomain["FLIGHT"] = "FLIGHT";
  LineOfBusinessDomain["GROUNDTRANSFERS"] = "GROUNDTRANSFERS";
  LineOfBusinessDomain["LODGING"] = "LODGING";
  LineOfBusinessDomain["PACKAGES"] = "PACKAGES";
  LineOfBusinessDomain["RAILS"] = "RAILS";
  LineOfBusinessDomain["UNCLASSIFIED"] = "UNCLASSIFIED";
})(LineOfBusinessDomain || (LineOfBusinessDomain = {}));
export var LineOfBusinessType;
(function (LineOfBusinessType) {
  LineOfBusinessType["ACTIVITY"] = "ACTIVITY";
  LineOfBusinessType["AIR"] = "AIR";
  LineOfBusinessType["CAR"] = "CAR";
  LineOfBusinessType["CRUISE"] = "CRUISE";
  LineOfBusinessType["FEE"] = "FEE";
  LineOfBusinessType["INSURANCE"] = "INSURANCE";
  LineOfBusinessType["ITINERARY"] = "ITINERARY";
  LineOfBusinessType["LODGING"] = "LODGING";
  LineOfBusinessType["TRAIN"] = "TRAIN";
})(LineOfBusinessType || (LineOfBusinessType = {}));
export var Listings;
(function (Listings) {
  /** Only return travelAds */
  Listings["ADS_ONLY"] = "ADS_ONLY";
})(Listings || (Listings = {}));
export var LiveAnnouncePoliteness;
(function (LiveAnnouncePoliteness) {
  LiveAnnouncePoliteness["ASSERTIVE"] = "ASSERTIVE";
  LiveAnnouncePoliteness["OFF"] = "OFF";
  LiveAnnouncePoliteness["POLITE"] = "POLITE";
})(LiveAnnouncePoliteness || (LiveAnnouncePoliteness = {}));
export var LoaderSize;
(function (LoaderSize) {
  LoaderSize["LARGE"] = "LARGE";
  LoaderSize["MEDIUM"] = "MEDIUM";
  LoaderSize["SMALL"] = "SMALL";
})(LoaderSize || (LoaderSize = {}));
export var Location;
(function (Location) {
  Location["CHECKOUT_AFTER_HEADER"] = "CHECKOUT_AFTER_HEADER";
  Location["CHECKOUT_AFTER_IMPORTANT_INFORMATION"] = "CHECKOUT_AFTER_IMPORTANT_INFORMATION";
  Location["CHECKOUT_BEFORE_LEGAL"] = "CHECKOUT_BEFORE_LEGAL";
  Location["CHECKOUT_BEFORE_SMARTFORM"] = "CHECKOUT_BEFORE_SMARTFORM";
  Location["CHECKOUT_ON_TOP_OF_CPM"] = "CHECKOUT_ON_TOP_OF_CPM";
  Location["CHECKOUT_REDIRECT"] = "CHECKOUT_REDIRECT";
  Location["CHECKOUT_RIGHT_SIDE_PAGE"] = "CHECKOUT_RIGHT_SIDE_PAGE";
  Location["CHECKOUT_RIGHT_SIDE_PAGE_AFTER_PRICE_DETAILS"] = "CHECKOUT_RIGHT_SIDE_PAGE_AFTER_PRICE_DETAILS";
  Location["CHECKOUT_TOP_OF_PAGE"] = "CHECKOUT_TOP_OF_PAGE";
  Location["CHECKOUT_TOP_OF_PAGE_AFTER_SECURE_HEADLINE"] = "CHECKOUT_TOP_OF_PAGE_AFTER_SECURE_HEADLINE";
  Location["CONFIRMATION_SUMMARY_IN_MODULE"] = "CONFIRMATION_SUMMARY_IN_MODULE";
  Location["COUPON_IN_MODULE"] = "COUPON_IN_MODULE";
  Location["CPM_IN_MODULE"] = "CPM_IN_MODULE";
  Location["ERROR_PAGE_AFTER_HEADER"] = "ERROR_PAGE_AFTER_HEADER";
  Location["GIFTCARD_IN_MODULE"] = "GIFTCARD_IN_MODULE";
  /** @deprecated Please use CPM_IN_MODULE instead PAYMENT_IN_MODULE */
  Location["PAYMENT_IN_MODULE"] = "PAYMENT_IN_MODULE";
})(Location || (Location = {}));
/** Represents the entry point for the location scout experience queries */
export var LocationScoutProductId;
(function (LocationScoutProductId) {
  LocationScoutProductId["SRP"] = "SRP";
  LocationScoutProductId["TRAVEL_SHOP"] = "TRAVEL_SHOP";
})(LocationScoutProductId || (LocationScoutProductId = {}));
export var LodgingBookingPlaybackType;
(function (LodgingBookingPlaybackType) {
  /** Playback type for both original and new booking playback */
  LodgingBookingPlaybackType["COMBINED"] = "COMBINED";
  /** Playback type for new booking playback */
  LodgingBookingPlaybackType["NEW"] = "NEW";
  /** Playback type for original booking playback */
  LodgingBookingPlaybackType["ORIGINAL"] = "ORIGINAL";
})(LodgingBookingPlaybackType || (LodgingBookingPlaybackType = {}));
export var LodgingCancelStatus;
(function (LodgingCancelStatus) {
  LodgingCancelStatus["FAILURE"] = "Failure";
  LodgingCancelStatus["SUCCESS"] = "Success";
})(LodgingCancelStatus || (LodgingCancelStatus = {}));
export var LodgingChangeStatus;
(function (LodgingChangeStatus) {
  LodgingChangeStatus["FAILURE"] = "Failure";
  LodgingChangeStatus["PENDING"] = "Pending";
  LodgingChangeStatus["SUCCESS"] = "Success";
})(LodgingChangeStatus || (LodgingChangeStatus = {}));
export var LodgingCompareRowTheme;
(function (LodgingCompareRowTheme) {
  LodgingCompareRowTheme["COMBINE_NEXT"] = "COMBINE_NEXT";
  LodgingCompareRowTheme["SPOTLIGHT"] = "SPOTLIGHT";
  LodgingCompareRowTheme["STANDARD"] = "STANDARD";
})(LodgingCompareRowTheme || (LodgingCompareRowTheme = {}));
/** Describes the type of product (line of business) that is being sold */
export var LodgingCrossSellProductType;
(function (LodgingCrossSellProductType) {
  LodgingCrossSellProductType["CAR"] = "CAR";
})(LodgingCrossSellProductType || (LodgingCrossSellProductType = {}));
export var LodgingFormMethod;
(function (LodgingFormMethod) {
  LodgingFormMethod["GET"] = "GET";
  LodgingFormMethod["POST"] = "POST";
})(LodgingFormMethod || (LodgingFormMethod = {}));
export var LodgingInputType;
(function (LodgingInputType) {
  LodgingInputType["EMAIL"] = "EMAIL";
  LodgingInputType["HIDDEN"] = "HIDDEN";
  LodgingInputType["PASSWORD"] = "PASSWORD";
  LodgingInputType["TEL"] = "TEL";
  LodgingInputType["TEXT"] = "TEXT";
  LodgingInputType["URL"] = "URL";
})(LodgingInputType || (LodgingInputType = {}));
/** Theme information for a message. */
export var LodgingMessageTheme;
(function (LodgingMessageTheme) {
  /** To be used for warnings/errors; typically red. */
  LodgingMessageTheme["AGGRESSIVE"] = "AGGRESSIVE";
  /** To be used for emphasis; typically both bold and larger font. */
  LodgingMessageTheme["EMPHASIS"] = "EMPHASIS";
  /** To be used for success/perks; typically green. */
  LodgingMessageTheme["HIGHLIGHT"] = "HIGHLIGHT";
  /** To be used for emphasis; typically bold. */
  LodgingMessageTheme["STRONG"] = "STRONG";
})(LodgingMessageTheme || (LodgingMessageTheme = {}));
/** Different set of label and icon combo will be displayed based on the type */
export var LodgingPriceInsightTrackingActionType;
(function (LodgingPriceInsightTrackingActionType) {
  /** When user is not subscribed, ui will display subscribe action text and icon */
  LodgingPriceInsightTrackingActionType["SUBSCRIBE_ACTION"] = "SUBSCRIBE_ACTION";
  /** When user is subscribed, ui will display unsubscribe action text and icon */
  LodgingPriceInsightTrackingActionType["UNSUBSCRIBE_ACTION"] = "UNSUBSCRIBE_ACTION";
})(LodgingPriceInsightTrackingActionType || (LodgingPriceInsightTrackingActionType = {}));
/** Different types of toast messages */
export var LodgingPriceInsightTrackingToastType;
(function (LodgingPriceInsightTrackingToastType) {
  /** Mutation is unsuccessful */
  LodgingPriceInsightTrackingToastType["ERROR"] = "ERROR";
  /** Mutation is successful */
  LodgingPriceInsightTrackingToastType["SUCCESS"] = "SUCCESS";
})(LodgingPriceInsightTrackingToastType || (LodgingPriceInsightTrackingToastType = {}));
export var LodgingPriceTrackingMutationType;
(function (LodgingPriceTrackingMutationType) {
  /** opt in - create subscription based on search criteria */
  LodgingPriceTrackingMutationType["CREATE_SUBSCRIPTION"] = "CREATE_SUBSCRIPTION";
  /** opt out - inactivate subscription based on subscription id */
  LodgingPriceTrackingMutationType["DELETE_SUBSCRIPTION"] = "DELETE_SUBSCRIPTION";
  /** triggered by onscroll - update last seen price */
  LodgingPriceTrackingMutationType["UPDATE_PRICE"] = "UPDATE_PRICE";
})(LodgingPriceTrackingMutationType || (LodgingPriceTrackingMutationType = {}));
export var LodgingStepperState;
(function (LodgingStepperState) {
  LodgingStepperState["COMPLETE"] = "COMPLETE";
  LodgingStepperState["CURRENT"] = "CURRENT";
  LodgingStepperState["INCOMPLETE"] = "INCOMPLETE";
})(LodgingStepperState || (LodgingStepperState = {}));
export var LodgingSubscriptionStatusType;
(function (LodgingSubscriptionStatusType) {
  LodgingSubscriptionStatusType["SUBSCRIBED"] = "SUBSCRIBED";
  LodgingSubscriptionStatusType["UNKNOWN"] = "UNKNOWN";
  LodgingSubscriptionStatusType["UNSUBSCRIBED"] = "UNSUBSCRIBED";
})(LodgingSubscriptionStatusType || (LodgingSubscriptionStatusType = {}));
export var LodgingSupplierRemittanceType;
(function (LodgingSupplierRemittanceType) {
  LodgingSupplierRemittanceType["GROSS"] = "GROSS";
  LodgingSupplierRemittanceType["INVALID"] = "INVALID";
  LodgingSupplierRemittanceType["NET"] = "NET";
})(LodgingSupplierRemittanceType || (LodgingSupplierRemittanceType = {}));
export var LodgingTrackPosition;
(function (LodgingTrackPosition) {
  LodgingTrackPosition["END"] = "END";
  LodgingTrackPosition["STANDARD"] = "STANDARD";
  LodgingTrackPosition["START"] = "START";
})(LodgingTrackPosition || (LodgingTrackPosition = {}));
export var LogoLockupOrientation;
(function (LogoLockupOrientation) {
  /** Horizontal orientation */
  LogoLockupOrientation["HORIZONTAL"] = "HORIZONTAL";
  /** Vertical orientation */
  LogoLockupOrientation["VERTICAL"] = "VERTICAL";
})(LogoLockupOrientation || (LogoLockupOrientation = {}));
export var LogoutStatus;
(function (LogoutStatus) {
  LogoutStatus["FAILURE"] = "FAILURE";
  LogoutStatus["SUCCESS"] = "SUCCESS";
})(LogoutStatus || (LogoutStatus = {}));
/** Represents different ways to align text content */
export var LoyaltyAlignment;
(function (LoyaltyAlignment) {
  LoyaltyAlignment["CENTER"] = "CENTER";
  LoyaltyAlignment["LEFT"] = "LEFT";
  LoyaltyAlignment["RIGHT"] = "RIGHT";
})(LoyaltyAlignment || (LoyaltyAlignment = {}));
/** Represents the different ways an image can be positioned in a LoyaltyDialogSection */
export var LoyaltyDialogSectionImagePosition;
(function (LoyaltyDialogSectionImagePosition) {
  LoyaltyDialogSectionImagePosition["BOTTOM"] = "BOTTOM";
  LoyaltyDialogSectionImagePosition["TOP"] = "TOP";
})(LoyaltyDialogSectionImagePosition || (LoyaltyDialogSectionImagePosition = {}));
export var LoyaltyExperienceStrategy;
(function (LoyaltyExperienceStrategy) {
  LoyaltyExperienceStrategy["HIDE_TRAVELER_INFO_AND_REWARDS_LINK"] = "HIDE_TRAVELER_INFO_AND_REWARDS_LINK";
  LoyaltyExperienceStrategy["SHOW_TRAVELER_INFO_AND_REWARDS_LINK"] = "SHOW_TRAVELER_INFO_AND_REWARDS_LINK";
})(LoyaltyExperienceStrategy || (LoyaltyExperienceStrategy = {}));
/** Enumeration for 2fa/mfa verification method */
export var MfaVerificationMethod;
(function (MfaVerificationMethod) {
  MfaVerificationMethod["CALL"] = "CALL";
  MfaVerificationMethod["SMS"] = "SMS";
})(MfaVerificationMethod || (MfaVerificationMethod = {}));
export var Moderation_Rule;
(function (Moderation_Rule) {
  Moderation_Rule["ADVISE"] = "ADVISE";
  Moderation_Rule["BLOCK"] = "BLOCK";
})(Moderation_Rule || (Moderation_Rule = {}));
export var Moderation_Type;
(function (Moderation_Type) {
  Moderation_Type["CHARACTER"] = "CHARACTER";
  Moderation_Type["WORD"] = "WORD";
})(Moderation_Type || (Moderation_Type = {}));
export var ManagedBannerContentBgTheme;
(function (ManagedBannerContentBgTheme) {
  ManagedBannerContentBgTheme["CRITICAL"] = "CRITICAL";
  ManagedBannerContentBgTheme["ERROR"] = "ERROR";
  ManagedBannerContentBgTheme["GLOBAL_LOYALTY_EXTRAHIGH"] = "GLOBAL_LOYALTY_EXTRAHIGH";
  ManagedBannerContentBgTheme["GLOBAL_LOYALTY_HIGH"] = "GLOBAL_LOYALTY_HIGH";
  ManagedBannerContentBgTheme["GLOBAL_LOYALTY_LOW"] = "GLOBAL_LOYALTY_LOW";
  ManagedBannerContentBgTheme["GLOBAL_LOYALTY_MIDDLE"] = "GLOBAL_LOYALTY_MIDDLE";
  ManagedBannerContentBgTheme["GLOBAL_LOYALTY_STANDARD"] = "GLOBAL_LOYALTY_STANDARD";
  ManagedBannerContentBgTheme["HIGHLIGHT"] = "HIGHLIGHT";
  ManagedBannerContentBgTheme["PRIMARY"] = "PRIMARY";
  ManagedBannerContentBgTheme["SECONDARY"] = "SECONDARY";
})(ManagedBannerContentBgTheme || (ManagedBannerContentBgTheme = {}));
/** The UDS icon used for the map marker */
export var MapIconType;
(function (MapIconType) {
  MapIconType["AIRPORT"] = "AIRPORT";
  MapIconType["CIRCLE"] = "CIRCLE";
  MapIconType["GROCERY"] = "GROCERY";
  MapIconType["HOTEL"] = "HOTEL";
  MapIconType["LANDMARK"] = "LANDMARK";
  MapIconType["METRO"] = "METRO";
  MapIconType["RESTAURANT"] = "RESTAURANT";
  MapIconType["SOLD_OUT"] = "SOLD_OUT";
  MapIconType["TRAIN"] = "TRAIN";
  MapIconType["VACATION_RENTAL"] = "VACATION_RENTAL";
})(MapIconType || (MapIconType = {}));
/** Toolbar action type */
export var MapToolbarActionsType;
(function (MapToolbarActionsType) {
  /** Show filters button in the toolbar */
  MapToolbarActionsType["FILTERS"] = "FILTERS";
})(MapToolbarActionsType || (MapToolbarActionsType = {}));
/** Placement of loyalty mark in the member wallet details item */
export var MarkItemPosition;
(function (MarkItemPosition) {
  MarkItemPosition["LEFT"] = "LEFT";
  MarkItemPosition["RIGHT"] = "RIGHT";
})(MarkItemPosition || (MarkItemPosition = {}));
/** The type of map marker */
export var MarkerType;
(function (MarkerType) {
  MarkerType["HOTEL"] = "HOTEL";
  MarkerType["POI"] = "POI";
})(MarkerType || (MarkerType = {}));
export var MarketGoal;
(function (MarketGoal) {
  MarketGoal["LEADER"] = "LEADER";
  MarketGoal["PLAYER"] = "PLAYER";
  MarketGoal["TRACKER"] = "TRACKER";
  MarketGoal["UNKNOWN"] = "UNKNOWN";
})(MarketGoal || (MarketGoal = {}));
export var MarketingFeedCardStatus;
(function (MarketingFeedCardStatus) {
  MarketingFeedCardStatus["ACTIVE"] = "ACTIVE";
  MarketingFeedCardStatus["DELETED"] = "DELETED";
  MarketingFeedCardStatus["INACTIVE"] = "INACTIVE";
})(MarketingFeedCardStatus || (MarketingFeedCardStatus = {}));
export var MarketplaceDesignRankingMetricsBadgeThemes;
(function (MarketplaceDesignRankingMetricsBadgeThemes) {
  MarketplaceDesignRankingMetricsBadgeThemes["DEFAULT"] = "DEFAULT";
  MarketplaceDesignRankingMetricsBadgeThemes["FEATURED"] = "FEATURED";
  MarketplaceDesignRankingMetricsBadgeThemes["INFO"] = "INFO";
  MarketplaceDesignRankingMetricsBadgeThemes["POSITIVE"] = "POSITIVE";
  MarketplaceDesignRankingMetricsBadgeThemes["WARNING"] = "WARNING";
})(MarketplaceDesignRankingMetricsBadgeThemes || (MarketplaceDesignRankingMetricsBadgeThemes = {}));
/** Used to indicate what type of markup a field contains */
export var MarkupTextType;
(function (MarkupTextType) {
  /** Hypertext markup language */
  MarkupTextType["HTML"] = "HTML";
})(MarkupTextType || (MarkupTextType = {}));
export var MarqueeCardType;
(function (MarqueeCardType) {
  MarqueeCardType["CENTER_STAGE"] = "CENTER_STAGE";
  MarqueeCardType["COLLECTION"] = "COLLECTION";
  MarqueeCardType["FULL_BLEED"] = "FULL_BLEED";
})(MarqueeCardType || (MarqueeCardType = {}));
export var MealPlanFilterAmenity;
(function (MealPlanFilterAmenity) {
  MealPlanFilterAmenity["ALL_INCLUSIVE"] = "ALL_INCLUSIVE";
  MealPlanFilterAmenity["FREE_BREAKFAST"] = "FREE_BREAKFAST";
  MealPlanFilterAmenity["FULL_BOARD"] = "FULL_BOARD";
  MealPlanFilterAmenity["HALF_BOARD"] = "HALF_BOARD";
})(MealPlanFilterAmenity || (MealPlanFilterAmenity = {}));
export var MediaContentType;
(function (MediaContentType) {
  MediaContentType["IMAGE"] = "IMAGE";
  MediaContentType["VIDEO"] = "VIDEO";
})(MediaContentType || (MediaContentType = {}));
export var MediaType;
(function (MediaType) {
  MediaType["IMAGE"] = "IMAGE";
  MediaType["VIDEO"] = "VIDEO";
})(MediaType || (MediaType = {}));
export var MemberWalletBadgeTheme;
(function (MemberWalletBadgeTheme) {
  MemberWalletBadgeTheme["LOYALTY_HIGH_TIER"] = "LOYALTY_HIGH_TIER";
  MemberWalletBadgeTheme["LOYALTY_LOW_TIER"] = "LOYALTY_LOW_TIER";
  MemberWalletBadgeTheme["LOYALTY_MIDDLE_TIER"] = "LOYALTY_MIDDLE_TIER";
})(MemberWalletBadgeTheme || (MemberWalletBadgeTheme = {}));
/** Represents path where merchandising details card component to be use. */
export var MerchandisingDetailsCardPath;
(function (MerchandisingDetailsCardPath) {
  MerchandisingDetailsCardPath["CHECKOUT"] = "CHECKOUT";
  MerchandisingDetailsCardPath["CONFIRMATION"] = "CONFIRMATION";
})(MerchandisingDetailsCardPath || (MerchandisingDetailsCardPath = {}));
/** Enum for MessageContent banner theme */
export var MessageContentTheme;
(function (MessageContentTheme) {
  MessageContentTheme["CRITICAL"] = "CRITICAL";
  MessageContentTheme["ERROR"] = "ERROR";
})(MessageContentTheme || (MessageContentTheme = {}));
/** Unique identifier for a message if one needs to identify the reason for the message creation */
export var MessageType;
(function (MessageType) {
  MessageType["ADDON"] = "ADDON";
  MessageType["BRANDED_THEME_ACCENT"] = "BRANDED_THEME_ACCENT";
  MessageType["BRANDED_THEME_DARK"] = "BRANDED_THEME_DARK";
  MessageType["BRANDED_THEME_LIGHT"] = "BRANDED_THEME_LIGHT";
  MessageType["COMPRESSION"] = "COMPRESSION";
  MessageType["COUPON"] = "COUPON";
  MessageType["DOUBLE_POINTS"] = "DOUBLE_POINTS";
  MessageType["FREE_CANCELLATION"] = "FREE_CANCELLATION";
  MessageType["FREE_LX"] = "FREE_LX";
  MessageType["HOTRATE"] = "HOTRATE";
  MessageType["LEGAL"] = "LEGAL";
  MessageType["LOGIN"] = "LOGIN";
  MessageType["LOYALTY"] = "LOYALTY";
  MessageType["NO_CC"] = "NO_CC";
  MessageType["OVERFILTERED"] = "OVERFILTERED";
  MessageType["PARTNER_LINKOFF"] = "PARTNER_LINKOFF";
  MessageType["VACATION_RENTALS"] = "VACATION_RENTALS";
})(MessageType || (MessageType = {}));
export var MessagingCardTheme;
(function (MessagingCardTheme) {
  MessagingCardTheme["HIGHLIGHT"] = "HIGHLIGHT";
  MessagingCardTheme["PRIMARY"] = "PRIMARY";
  MessagingCardTheme["SECONDARY"] = "SECONDARY";
})(MessagingCardTheme || (MessagingCardTheme = {}));
export var MigrationFlightsQueryState;
(function (MigrationFlightsQueryState) {
  MigrationFlightsQueryState["LOADED"] = "LOADED";
  MigrationFlightsQueryState["LOADING"] = "LOADING";
})(MigrationFlightsQueryState || (MigrationFlightsQueryState = {}));
export var MigrationFlowIdentifier;
(function (MigrationFlowIdentifier) {
  MigrationFlowIdentifier["EMAIL_OTP"] = "EMAIL_OTP";
  MigrationFlowIdentifier["NONE"] = "NONE";
  MigrationFlowIdentifier["PASSWORD"] = "PASSWORD";
  MigrationFlowIdentifier["PRE_OI_SIGNIN"] = "PRE_OI_SIGNIN";
  MigrationFlowIdentifier["PROFILE_DETAIL"] = "PROFILE_DETAIL";
})(MigrationFlowIdentifier || (MigrationFlowIdentifier = {}));
export var MigrationPackageType;
(function (MigrationPackageType) {
  MigrationPackageType["FLIGHT_CAR"] = "FLIGHT_CAR";
  MigrationPackageType["FLIGHT_HOTEL"] = "FLIGHT_HOTEL";
  MigrationPackageType["FLIGHT_HOTEL_CAR"] = "FLIGHT_HOTEL_CAR";
  MigrationPackageType["HOTEL_ACTIVITY"] = "HOTEL_ACTIVITY";
  MigrationPackageType["HOTEL_CAR"] = "HOTEL_CAR";
})(MigrationPackageType || (MigrationPackageType = {}));
/** The type of button to display */
export var MishopUiDialogButtonType;
(function (MishopUiDialogButtonType) {
  MishopUiDialogButtonType["PRIMARY"] = "PRIMARY";
  MishopUiDialogButtonType["TERTIARY"] = "TERTIARY";
})(MishopUiDialogButtonType || (MishopUiDialogButtonType = {}));
export var MishopUiPlacardType;
(function (MishopUiPlacardType) {
  MishopUiPlacardType["PRICE_CHANGE"] = "PRICE_CHANGE";
})(MishopUiPlacardType || (MishopUiPlacardType = {}));
export var MishopUiProductType;
(function (MishopUiProductType) {
  MishopUiProductType["ACTIVITY"] = "ACTIVITY";
  MishopUiProductType["CAR"] = "CAR";
  MishopUiProductType["FLIGHT"] = "FLIGHT";
  MishopUiProductType["GROUND_TRANSFER"] = "GROUND_TRANSFER";
  MishopUiProductType["PROPERTY"] = "PROPERTY";
})(MishopUiProductType || (MishopUiProductType = {}));
export var ModalNavType;
(function (ModalNavType) {
  ModalNavType["BACK"] = "BACK";
  ModalNavType["CLOSE"] = "CLOSE";
  ModalNavType["EXPAND_DOWN"] = "EXPAND_DOWN";
  ModalNavType["EXPAND_UP"] = "EXPAND_UP";
})(ModalNavType || (ModalNavType = {}));
export var ModalSideSheetLayout;
(function (ModalSideSheetLayout) {
  ModalSideSheetLayout["EIGHT"] = "EIGHT";
  ModalSideSheetLayout["FOUR"] = "FOUR";
  ModalSideSheetLayout["ONE"] = "ONE";
  ModalSideSheetLayout["SIX"] = "SIX";
  ModalSideSheetLayout["THREE"] = "THREE";
  ModalSideSheetLayout["TWELVE"] = "TWELVE";
  ModalSideSheetLayout["TWO"] = "TWO";
})(ModalSideSheetLayout || (ModalSideSheetLayout = {}));
export var ModuleName;
(function (ModuleName) {
  ModuleName["COUPON_MODULE"] = "COUPON_MODULE";
})(ModuleName || (ModuleName = {}));
export var ModuleNames;
(function (ModuleNames) {
  ModuleNames["DISCOVER"] = "DISCOVER";
  ModuleNames["HOME"] = "HOME";
})(ModuleNames || (ModuleNames = {}));
/** ID used to identify a month for queries that bucket data by month */
export var MonthId;
(function (MonthId) {
  MonthId["APRIL"] = "APRIL";
  MonthId["AUGUST"] = "AUGUST";
  MonthId["DECEMBER"] = "DECEMBER";
  MonthId["FEBRUARY"] = "FEBRUARY";
  MonthId["JANUARY"] = "JANUARY";
  MonthId["JULY"] = "JULY";
  MonthId["JUNE"] = "JUNE";
  MonthId["MARCH"] = "MARCH";
  MonthId["MAY"] = "MAY";
  MonthId["NOVEMBER"] = "NOVEMBER";
  MonthId["OCTOBER"] = "OCTOBER";
  MonthId["SEPTEMBER"] = "SEPTEMBER";
})(MonthId || (MonthId = {}));
/** Input to update the product in the session */
export var MultiItemShoppingActionType;
(function (MultiItemShoppingActionType) {
  MultiItemShoppingActionType["CAR_SEARCH"] = "CAR_SEARCH";
  MultiItemShoppingActionType["FLIGHT_SEARCH"] = "FLIGHT_SEARCH";
  MultiItemShoppingActionType["PROPERTY_SEARCH"] = "PROPERTY_SEARCH";
})(MultiItemShoppingActionType || (MultiItemShoppingActionType = {}));
/** NavigationType provides collapse/expanded state of toolbar, specific to bottom sheet */
export var NavigationType;
(function (NavigationType) {
  NavigationType["COLLAPSE"] = "COLLAPSE";
  NavigationType["EXPAND"] = "EXPAND";
})(NavigationType || (NavigationType = {}));
/** Enum class to represent the type of no cancel fee */
export var NoCancelFeeType;
(function (NoCancelFeeType) {
  NoCancelFeeType["NO_CANCEL_FEE"] = "NO_CANCEL_FEE";
})(NoCancelFeeType || (NoCancelFeeType = {}));
/** Enum class to represent the type of no change fee */
export var NoChangeFeeType;
(function (NoChangeFeeType) {
  NoChangeFeeType["NO_CHANGE_FEE"] = "NO_CHANGE_FEE";
})(NoChangeFeeType || (NoChangeFeeType = {}));
/** The button type of the Customer notification submit button */
export var NotificationFormButtonType;
(function (NotificationFormButtonType) {
  /** Type of floating action button */
  NotificationFormButtonType["FLOATING_ACTION_BUTTON"] = "FLOATING_ACTION_BUTTON";
  /** Type of primary button */
  NotificationFormButtonType["PRIMARY_BUTTON"] = "PRIMARY_BUTTON";
  /** Type of secondary button */
  NotificationFormButtonType["SECONDARY_BUTTON"] = "SECONDARY_BUTTON";
  /** Type of tertiary button */
  NotificationFormButtonType["TERTIARY_BUTTON"] = "TERTIARY_BUTTON";
})(NotificationFormButtonType || (NotificationFormButtonType = {}));
export var NotificationInModuleMessageName;
(function (NotificationInModuleMessageName) {
  NotificationInModuleMessageName["COUPON_REMOVAL_FAILED_MESSAGE"] = "COUPON_REMOVAL_FAILED_MESSAGE";
  NotificationInModuleMessageName["CPM_CC_ON_FILE_MESSAGE"] = "CPM_CC_ON_FILE_MESSAGE";
  NotificationInModuleMessageName["CPM_CC_ON_FILE_MESSAGE_CAR"] = "CPM_CC_ON_FILE_MESSAGE_CAR";
  NotificationInModuleMessageName["CPM_CC_ON_FILE_ONLY_INSURANCE_PAYMENT_MESSAGE"] = "CPM_CC_ON_FILE_ONLY_INSURANCE_PAYMENT_MESSAGE";
  NotificationInModuleMessageName["CPM_NO_PAYMENT_DUE_MESSAGE"] = "CPM_NO_PAYMENT_DUE_MESSAGE";
  NotificationInModuleMessageName["CPM_NO_PAYMENT_DUE_MESSAGE_CAR"] = "CPM_NO_PAYMENT_DUE_MESSAGE_CAR";
  NotificationInModuleMessageName["CPM_ONLY_INSURANCE_PAYMENT_DUE_MESSAGE"] = "CPM_ONLY_INSURANCE_PAYMENT_DUE_MESSAGE";
  NotificationInModuleMessageName["OKC_ADD_FAILED_MESSAGE"] = "OKC_ADD_FAILED_MESSAGE";
  NotificationInModuleMessageName["OKC_REMOVAL_FAILED_MESSAGE"] = "OKC_REMOVAL_FAILED_MESSAGE";
  NotificationInModuleMessageName["PAY_NOW_CC_ON_FILE_GIFT_CARD_COUPON_TOTAL_AMOUNT"] = "PAY_NOW_CC_ON_FILE_GIFT_CARD_COUPON_TOTAL_AMOUNT";
  NotificationInModuleMessageName["PAY_NOW_CC_ON_FILE_GIFT_CARD_TOTAL_AMOUNT"] = "PAY_NOW_CC_ON_FILE_GIFT_CARD_TOTAL_AMOUNT";
  NotificationInModuleMessageName["PAY_NOW_CC_ON_FILE_OKC_COUPON_TOTAL_AMOUNT"] = "PAY_NOW_CC_ON_FILE_OKC_COUPON_TOTAL_AMOUNT";
  NotificationInModuleMessageName["PAY_NOW_CC_ON_FILE_OKC_GIFT_CARD_COUPON_TOTAL_AMOUNT"] = "PAY_NOW_CC_ON_FILE_OKC_GIFT_CARD_COUPON_TOTAL_AMOUNT";
  NotificationInModuleMessageName["PAY_NOW_CC_ON_FILE_OKC_GIFT_CARD_TOTAL_AMOUNT"] = "PAY_NOW_CC_ON_FILE_OKC_GIFT_CARD_TOTAL_AMOUNT";
  NotificationInModuleMessageName["PAY_NOW_CC_ON_FILE_OKC_TOTAL_AMOUNT"] = "PAY_NOW_CC_ON_FILE_OKC_TOTAL_AMOUNT";
  NotificationInModuleMessageName["PAY_NOW_GIFT_CARD_COUPON_TOTAL_AMOUNT"] = "PAY_NOW_GIFT_CARD_COUPON_TOTAL_AMOUNT";
  NotificationInModuleMessageName["PAY_NOW_GIFT_CARD_TOTAL_AMOUNT"] = "PAY_NOW_GIFT_CARD_TOTAL_AMOUNT";
  NotificationInModuleMessageName["PAY_NOW_OKC_COUPON_TOTAL_AMOUNT"] = "PAY_NOW_OKC_COUPON_TOTAL_AMOUNT";
  NotificationInModuleMessageName["PAY_NOW_OKC_GIFT_CARD_COUPON_TOTAL_AMOUNT"] = "PAY_NOW_OKC_GIFT_CARD_COUPON_TOTAL_AMOUNT";
  NotificationInModuleMessageName["PAY_NOW_OKC_GIFT_CARD_TOTAL_AMOUNT"] = "PAY_NOW_OKC_GIFT_CARD_TOTAL_AMOUNT";
  NotificationInModuleMessageName["PAY_NOW_OKC_TOTAL_AMOUNT"] = "PAY_NOW_OKC_TOTAL_AMOUNT";
  NotificationInModuleMessageName["PROMOTION_CHANGED_MESSAGE"] = "PROMOTION_CHANGED_MESSAGE";
})(NotificationInModuleMessageName || (NotificationInModuleMessageName = {}));
export var NotificationInModuleModuleName;
(function (NotificationInModuleModuleName) {
  NotificationInModuleModuleName["COMMON_PAYMENT_MODULE"] = "COMMON_PAYMENT_MODULE";
  NotificationInModuleModuleName["COUPON_MODULE"] = "COUPON_MODULE";
  NotificationInModuleModuleName["LOYALTY_BURN_MODULE"] = "LOYALTY_BURN_MODULE";
  NotificationInModuleModuleName["PROMOTION_CHANGED_MODULE"] = "PROMOTION_CHANGED_MODULE";
})(NotificationInModuleModuleName || (NotificationInModuleModuleName = {}));
/** Represents the target of the link */
export var NotificationLinkTarget;
(function (NotificationLinkTarget) {
  NotificationLinkTarget["NEW_TAB"] = "NEW_TAB";
  NotificationLinkTarget["SAME_TAB"] = "SAME_TAB";
})(NotificationLinkTarget || (NotificationLinkTarget = {}));
/** Represents the link type */
export var NotificationLinkType;
(function (NotificationLinkType) {
  NotificationLinkType["ANCHOR"] = "ANCHOR";
  NotificationLinkType["APP_DOWNLOAD_LINK"] = "APP_DOWNLOAD_LINK";
  NotificationLinkType["BUTTON"] = "BUTTON";
  NotificationLinkType["FLOATING_ACTION_BUTTON"] = "FLOATING_ACTION_BUTTON";
  NotificationLinkType["PRIMARY_BUTTON"] = "PRIMARY_BUTTON";
  NotificationLinkType["SECONDARY_BUTTON"] = "SECONDARY_BUTTON";
  NotificationLinkType["TERTIARY_BUTTON"] = "TERTIARY_BUTTON";
})(NotificationLinkType || (NotificationLinkType = {}));
export var NotificationLocation;
(function (NotificationLocation) {
  NotificationLocation["AFTER_HEADER"] = "AFTER_HEADER";
  NotificationLocation["AFTER_WIZARD"] = "AFTER_WIZARD";
  NotificationLocation["FOOTER"] = "FOOTER";
  NotificationLocation["IN_PAGE"] = "IN_PAGE";
  NotificationLocation["IN_PAGE_AD"] = "IN_PAGE_AD";
  NotificationLocation["LEGAL"] = "LEGAL";
  NotificationLocation["POPUP"] = "POPUP";
  NotificationLocation["PRE_HEADER"] = "PRE_HEADER";
})(NotificationLocation || (NotificationLocation = {}));
export var NotificationLocationOnPage;
(function (NotificationLocationOnPage) {
  NotificationLocationOnPage["AFTER_HEADER"] = "AFTER_HEADER";
  NotificationLocationOnPage["AFTER_WIZARD"] = "AFTER_WIZARD";
  NotificationLocationOnPage["ERROR"] = "ERROR";
  NotificationLocationOnPage["FOOTER"] = "FOOTER";
  NotificationLocationOnPage["FULL_PAGE"] = "FULL_PAGE";
  NotificationLocationOnPage["IN_MODAL"] = "IN_MODAL";
  NotificationLocationOnPage["IN_MODULE"] = "IN_MODULE";
  NotificationLocationOnPage["IN_PAGE"] = "IN_PAGE";
  NotificationLocationOnPage["IN_PAGE_AD"] = "IN_PAGE_AD";
  NotificationLocationOnPage["LEGAL"] = "LEGAL";
  NotificationLocationOnPage["POPUP"] = "POPUP";
  NotificationLocationOnPage["PRE_HEADER"] = "PRE_HEADER";
})(NotificationLocationOnPage || (NotificationLocationOnPage = {}));
/** Enumeration of possible layout types */
export var NotificationMessageCardLayout;
(function (NotificationMessageCardLayout) {
  NotificationMessageCardLayout["ICON_ON_SIDE"] = "ICON_ON_SIDE";
  NotificationMessageCardLayout["ICON_ON_TOP"] = "ICON_ON_TOP";
  NotificationMessageCardLayout["WITH_BORDER"] = "WITH_BORDER";
})(NotificationMessageCardLayout || (NotificationMessageCardLayout = {}));
/** The display type of the Customer notification message */
export var NotificationMessageDisplayType;
(function (NotificationMessageDisplayType) {
  /** Display the message for the form */
  NotificationMessageDisplayType["FORM"] = "FORM";
  /** Dislay message on the page level, eg: fly-in message on the page */
  NotificationMessageDisplayType["PAGE"] = "PAGE";
})(NotificationMessageDisplayType || (NotificationMessageDisplayType = {}));
/** The level type of the Customer notification message */
export var NotificationMessageLevel;
(function (NotificationMessageLevel) {
  /** Type of error for the message */
  NotificationMessageLevel["ERROR"] = "ERROR";
  /** Type of info for the message */
  NotificationMessageLevel["INFO"] = "INFO";
  /** Type of success for the message */
  NotificationMessageLevel["SUCCESS"] = "SUCCESS";
  /** Type of warning for the message */
  NotificationMessageLevel["WARNING"] = "WARNING";
})(NotificationMessageLevel || (NotificationMessageLevel = {}));
export var NotificationMessageType;
(function (NotificationMessageType) {
  /** INVALID_INPUT message */
  NotificationMessageType["INVALID_INPUT"] = "INVALID_INPUT";
  /** SERVICE_ERROR message */
  NotificationMessageType["SERVICE_ERROR"] = "SERVICE_ERROR";
  /** SUCCESS message */
  NotificationMessageType["SUCCESS"] = "SUCCESS";
})(NotificationMessageType || (NotificationMessageType = {}));
/** The style to apply to phrase links */
export var NotificationPhraseLinkStyle;
(function (NotificationPhraseLinkStyle) {
  NotificationPhraseLinkStyle["FLOATING_ACTION_BUTTON"] = "FLOATING_ACTION_BUTTON";
  NotificationPhraseLinkStyle["PRIMARY_BUTTON"] = "PRIMARY_BUTTON";
  NotificationPhraseLinkStyle["SECONDARY_BUTTON"] = "SECONDARY_BUTTON";
  NotificationPhraseLinkStyle["TERTIARY_BUTTON"] = "TERTIARY_BUTTON";
})(NotificationPhraseLinkStyle || (NotificationPhraseLinkStyle = {}));
/** The theme to apply to phrase links */
export var NotificationPhraseLinkTheme;
(function (NotificationPhraseLinkTheme) {
  NotificationPhraseLinkTheme["DEFAULT"] = "DEFAULT";
  NotificationPhraseLinkTheme["INVERSE"] = "INVERSE";
})(NotificationPhraseLinkTheme || (NotificationPhraseLinkTheme = {}));
/** The text style to apply to strings */
export var NotificationPhrasePartStyle;
(function (NotificationPhrasePartStyle) {
  /** Italic styling */
  NotificationPhrasePartStyle["EMPHASIS"] = "EMPHASIS";
  /** Bold styling */
  NotificationPhrasePartStyle["IMPORTANT"] = "IMPORTANT";
  /** Medium styling */
  NotificationPhrasePartStyle["MEDIUM"] = "MEDIUM";
  /** Represents no style or regular text */
  NotificationPhrasePartStyle["STANDARD"] = "STANDARD";
})(NotificationPhrasePartStyle || (NotificationPhrasePartStyle = {}));
/** Represent notification preference */
export var NotificationPreferenceType;
(function (NotificationPreferenceType) {
  NotificationPreferenceType["EMAIL"] = "EMAIL";
  NotificationPreferenceType["PUSH"] = "PUSH";
})(NotificationPreferenceType || (NotificationPreferenceType = {}));
export var NotificationState;
(function (NotificationState) {
  NotificationState["READ"] = "READ";
  NotificationState["SEEN"] = "SEEN";
  NotificationState["UNKNOWN"] = "UNKNOWN";
  NotificationState["UNSEEN"] = "UNSEEN";
})(NotificationState || (NotificationState = {}));
export var NotificationSubType;
(function (NotificationSubType) {
  NotificationSubType["COUPON_CAMPAIGN"] = "COUPON_CAMPAIGN";
  NotificationSubType["DEFAULT"] = "DEFAULT";
})(NotificationSubType || (NotificationSubType = {}));
export var NotificationType;
(function (NotificationType) {
  NotificationType["ALERT"] = "ALERT";
  NotificationType["APP_DOWNLOAD"] = "APP_DOWNLOAD";
  NotificationType["APP_HERO"] = "APP_HERO";
  NotificationType["BOTTOM_SHEET"] = "BOTTOM_SHEET";
  NotificationType["CENTERED_SHEET"] = "CENTERED_SHEET";
  NotificationType["CITI_COBRAND"] = "CITI_COBRAND";
  NotificationType["CITI_COBRAND_VERTICAL"] = "CITI_COBRAND_VERTICAL";
  NotificationType["CLEANLINESS"] = "CLEANLINESS";
  NotificationType["CONFIGURABLE"] = "CONFIGURABLE";
  NotificationType["ERROR"] = "ERROR";
  NotificationType["FULL_PAGE"] = "FULL_PAGE";
  NotificationType["FULL_SHEET"] = "FULL_SHEET";
  NotificationType["FULL_SHEET_MEDIA"] = "FULL_SHEET_MEDIA";
  NotificationType["GENERIC"] = "GENERIC";
  NotificationType["HEADER"] = "HEADER";
  NotificationType["INBOX"] = "INBOX";
  NotificationType["MAD_MARQUEE"] = "MAD_MARQUEE";
  NotificationType["NONE"] = "NONE";
  NotificationType["ONETRUST"] = "ONETRUST";
  NotificationType["ONE_KEY"] = "ONE_KEY";
  NotificationType["OSANO"] = "OSANO";
  NotificationType["POPOVER"] = "POPOVER";
  NotificationType["RAF_BANNER"] = "RAF_BANNER";
  NotificationType["TAKEOVER"] = "TAKEOVER";
  NotificationType["TRAVEL_ADVISORY"] = "TRAVEL_ADVISORY";
  NotificationType["TRUST_MSG_BANNER"] = "TRUST_MSG_BANNER";
  NotificationType["UNRECOVERABLE_ERROR"] = "UNRECOVERABLE_ERROR";
})(NotificationType || (NotificationType = {}));
export var NotificationUserActionType;
(function (NotificationUserActionType) {
  NotificationUserActionType["DELETE"] = "DELETE";
  NotificationUserActionType["MARK_AS_READ"] = "MARK_AS_READ";
  NotificationUserActionType["MARK_AS_UNREAD"] = "MARK_AS_UNREAD";
  NotificationUserActionType["UNKNOWN"] = "UNKNOWN";
})(NotificationUserActionType || (NotificationUserActionType = {}));
/** This enum scope is to communicate to client if the banner should be render as a CAROUSEL or GRID */
export var NotificationView;
(function (NotificationView) {
  NotificationView["CAROUSEL"] = "CAROUSEL";
  NotificationView["GRID"] = "GRID";
})(NotificationView || (NotificationView = {}));
export var NotificationsType;
(function (NotificationsType) {
  NotificationsType["ALL"] = "ALL";
})(NotificationsType || (NotificationsType = {}));
export var OfferAttributeType;
(function (OfferAttributeType) {
  OfferAttributeType["FREE_BREAKFAST"] = "FREE_BREAKFAST";
  OfferAttributeType["FREE_CANCELLATION"] = "FREE_CANCELLATION";
  OfferAttributeType["NO_CC_REQUIRED"] = "NO_CC_REQUIRED";
  OfferAttributeType["PAYMENT_CHOICE"] = "PAYMENT_CHOICE";
  OfferAttributeType["VIP"] = "VIP";
})(OfferAttributeType || (OfferAttributeType = {}));
/** The identity to get or update insurtech offers could be both */
export var OfferIdentityType;
(function (OfferIdentityType) {
  OfferIdentityType["EG_OFFER_ID"] = "EG_OFFER_ID";
  OfferIdentityType["EG_OFFER_TOKEN"] = "EG_OFFER_TOKEN";
})(OfferIdentityType || (OfferIdentityType = {}));
export var OffersInquiryProminence;
(function (OffersInquiryProminence) {
  OffersInquiryProminence["HIGH"] = "HIGH";
  OffersInquiryProminence["LOW"] = "LOW";
  OffersInquiryProminence["MEDIUM"] = "MEDIUM";
})(OffersInquiryProminence || (OffersInquiryProminence = {}));
export var OffersRecommendationContainerType;
(function (OffersRecommendationContainerType) {
  OffersRecommendationContainerType["CAROUSEL"] = "CAROUSEL";
  OffersRecommendationContainerType["GRID"] = "GRID";
})(OffersRecommendationContainerType || (OffersRecommendationContainerType = {}));
export var OffersRecommendationStrategy;
(function (OffersRecommendationStrategy) {
  OffersRecommendationStrategy["ALTERNATE"] = "ALTERNATE";
  OffersRecommendationStrategy["ATTACH"] = "ATTACH";
  OffersRecommendationStrategy["CO_CLICK"] = "CO_CLICK";
  OffersRecommendationStrategy["NEARBY"] = "NEARBY";
  OffersRecommendationStrategy["POPULAR"] = "POPULAR";
  OffersRecommendationStrategy["TRENDING"] = "TRENDING";
})(OffersRecommendationStrategy || (OffersRecommendationStrategy = {}));
export var OnboardStep;
(function (OnboardStep) {
  OnboardStep["PARTNER"] = "PARTNER";
  OnboardStep["PAYMENT"] = "PAYMENT";
  OnboardStep["REVIEW"] = "REVIEW";
  OnboardStep["TAX"] = "TAX";
})(OnboardStep || (OnboardStep = {}));
export var OneIdentityOnboardingClientAction;
(function (OneIdentityOnboardingClientAction) {
  OneIdentityOnboardingClientAction["IDENTITY_MERGE"] = "IDENTITY_MERGE";
  OneIdentityOnboardingClientAction["LOGOUT"] = "LOGOUT";
  OneIdentityOnboardingClientAction["NONE"] = "NONE";
  OneIdentityOnboardingClientAction["NONE_JOURNEY_IS_COMPLETE"] = "NONE_JOURNEY_IS_COMPLETE";
})(OneIdentityOnboardingClientAction || (OneIdentityOnboardingClientAction = {}));
export var OneKeyOnboardingOperationStatus;
(function (OneKeyOnboardingOperationStatus) {
  OneKeyOnboardingOperationStatus["FAILED"] = "FAILED";
  OneKeyOnboardingOperationStatus["SUCCEEDED"] = "SUCCEEDED";
  OneKeyOnboardingOperationStatus["TIMED_OUT"] = "TIMED_OUT";
})(OneKeyOnboardingOperationStatus || (OneKeyOnboardingOperationStatus = {}));
export var OneKeyUniversalOnboardingOperationStatus;
(function (OneKeyUniversalOnboardingOperationStatus) {
  OneKeyUniversalOnboardingOperationStatus["FAILED"] = "FAILED";
  OneKeyUniversalOnboardingOperationStatus["FAILED_BLOCKING"] = "FAILED_BLOCKING";
  OneKeyUniversalOnboardingOperationStatus["SUCCEEDED"] = "SUCCEEDED";
  OneKeyUniversalOnboardingOperationStatus["UNKNOWN_OPERATION"] = "UNKNOWN_OPERATION";
})(OneKeyUniversalOnboardingOperationStatus || (OneKeyUniversalOnboardingOperationStatus = {}));
export var Operation;
(function (Operation) {
  Operation["ADDITION"] = "ADDITION";
  Operation["MULTIPLICATION"] = "MULTIPLICATION";
})(Operation || (Operation = {}));
export var OperationStatus;
(function (OperationStatus) {
  OperationStatus["FAILURE"] = "FAILURE";
  OperationStatus["INVALID_INPUT"] = "INVALID_INPUT";
  OperationStatus["SUCCESS"] = "SUCCESS";
})(OperationStatus || (OperationStatus = {}));
export var OperationType;
(function (OperationType) {
  OperationType["SMART_FORM_LOAD"] = "SMART_FORM_LOAD";
  OperationType["SMART_FORM_SUBMIT"] = "SMART_FORM_SUBMIT";
})(OperationType || (OperationType = {}));
export var OrderStatus;
(function (OrderStatus) {
  OrderStatus["INVALID"] = "INVALID";
  OrderStatus["PENDING"] = "PENDING";
  OrderStatus["SUCCESS"] = "SUCCESS";
})(OrderStatus || (OrderStatus = {}));
/** Possible values for UITK mark's orientation prop */
export var Orientation;
(function (Orientation) {
  /** Landscape orientation */
  Orientation["LANDSCAPE"] = "LANDSCAPE";
  /** Portrait orientation */
  Orientation["PORTRAIT"] = "PORTRAIT";
})(Orientation || (Orientation = {}));
/** Supported EGDSText Overflow types */
export var Overflow;
(function (Overflow) {
  Overflow["TRUNCATE"] = "TRUNCATE";
  Overflow["TRUNCATE_TWO_LINES"] = "TRUNCATE_TWO_LINES";
})(Overflow || (Overflow = {}));
export var PackageOfferingType;
(function (PackageOfferingType) {
  PackageOfferingType["FLIGHT_CAR"] = "FLIGHT_CAR";
  PackageOfferingType["FLIGHT_HOTEL"] = "FLIGHT_HOTEL";
  PackageOfferingType["FLIGHT_HOTEL_CAR"] = "FLIGHT_HOTEL_CAR";
  PackageOfferingType["HOTEL_CAR"] = "HOTEL_CAR";
})(PackageOfferingType || (PackageOfferingType = {}));
export var PackageSort;
(function (PackageSort) {
  PackageSort["PRICE_HIGH_TO_LOW"] = "PRICE_HIGH_TO_LOW";
  PackageSort["PRICE_LOW_TO_HIGH"] = "PRICE_LOW_TO_HIGH";
  PackageSort["RECOMMENDED"] = "RECOMMENDED";
})(PackageSort || (PackageSort = {}));
export var PackageType;
(function (PackageType) {
  PackageType["FLIGHT_CAR"] = "FLIGHT_CAR";
  PackageType["FLIGHT_HOTEL"] = "FLIGHT_HOTEL";
  PackageType["FLIGHT_HOTEL_CAR"] = "FLIGHT_HOTEL_CAR";
  PackageType["HOTEL_ACTIVITY"] = "HOTEL_ACTIVITY";
  PackageType["HOTEL_CAR"] = "HOTEL_CAR";
})(PackageType || (PackageType = {}));
/** The enum for types of MishopUIMessagingCards. Eg: Jumplink card. */
export var PackageUiMessagingCardType;
(function (PackageUiMessagingCardType) {
  PackageUiMessagingCardType["GT_JUMP_LINK"] = "GT_JUMP_LINK";
  PackageUiMessagingCardType["INVALID"] = "INVALID";
})(PackageUiMessagingCardType || (PackageUiMessagingCardType = {}));
export var Page;
(function (Page) {
  Page["ACTIVITY_SEARCH"] = "ACTIVITY_SEARCH";
  Page["APP_LAUNCHSCREEN"] = "APP_LAUNCHSCREEN";
  Page["CAR_INFOSITE"] = "CAR_INFOSITE";
  Page["CAR_SEARCH"] = "CAR_SEARCH";
  Page["CONFIRMATION"] = "CONFIRMATION";
  Page["FLIGHT_SEARCH"] = "FLIGHT_SEARCH";
  Page["HOME_PAGE"] = "HOME_PAGE";
  Page["HOTEL_INFOSITE"] = "HOTEL_INFOSITE";
  Page["HOTEL_SEARCH"] = "HOTEL_SEARCH";
  Page["INVITE_LANDING_PAGE"] = "INVITE_LANDING_PAGE";
  Page["LANDING_PAGE"] = "LANDING_PAGE";
  Page["PRODUCT_DETAILS_PAGE"] = "PRODUCT_DETAILS_PAGE";
  Page["PUBLIC_TRIP_BOARD"] = "PUBLIC_TRIP_BOARD";
  Page["STOREFRONT"] = "STOREFRONT";
  Page["TRIPS"] = "TRIPS";
  Page["TRIPS_FILTERED"] = "TRIPS_FILTERED";
  Page["TRIP_FIND_ITINERARY"] = "TRIP_FIND_ITINERARY";
  Page["TRIP_FIND_ITINERARY_RESULT"] = "TRIP_FIND_ITINERARY_RESULT";
  Page["TRIP_ITEM_DETAILS"] = "TRIP_ITEM_DETAILS";
  Page["TRIP_ITEM_DETAILS_CANCELLED"] = "TRIP_ITEM_DETAILS_CANCELLED";
  Page["TRIP_ITEM_ESSENTIAL_INFO"] = "TRIP_ITEM_ESSENTIAL_INFO";
  Page["TRIP_ITEM_ITINERARY"] = "TRIP_ITEM_ITINERARY";
  Page["TRIP_ITEM_MANAGE_BOOKING"] = "TRIP_ITEM_MANAGE_BOOKING";
  Page["TRIP_ITEM_PRICING_REWARDS"] = "TRIP_ITEM_PRICING_REWARDS";
  Page["TRIP_ITEM_RECEIPT"] = "TRIP_ITEM_RECEIPT";
  Page["TRIP_ITEM_VOUCHER"] = "TRIP_ITEM_VOUCHER";
  Page["TRIP_ITEM_VOUCHER_PRINT"] = "TRIP_ITEM_VOUCHER_PRINT";
  Page["TRIP_MANAGE_GUESTS"] = "TRIP_MANAGE_GUESTS";
  Page["TRIP_OVERVIEW"] = "TRIP_OVERVIEW";
  Page["TRIP_OVERVIEW_ITINERARY"] = "TRIP_OVERVIEW_ITINERARY";
  Page["TRIP_SEARCH_BOOKING"] = "TRIP_SEARCH_BOOKING";
  Page["TRIP_SEARCH_BOOKING_RESULT"] = "TRIP_SEARCH_BOOKING_RESULT";
  Page["UDP"] = "UDP";
})(Page || (Page = {}));
/** Page identity */
export var PageLocation;
(function (PageLocation) {
  /** Cancel For Any Reason assurance details page that comes after LOB details pages */
  PageLocation["CFAR_DETAILS"] = "CFAR_DETAILS";
  /** All checkout related pages */
  PageLocation["CHECKOUT"] = "CHECKOUT";
  /** Checkout error pages for all LOBs */
  PageLocation["CHECKOUT_ERROR"] = "CHECKOUT_ERROR";
  /** Order confirmation pages for all LOBs */
  PageLocation["CONFIRMATION"] = "CONFIRMATION";
  /** All product detail pages are identified as DETAILS */
  PageLocation["DETAILS"] = "DETAILS";
  /** All landing, launch, published and any other page that will lead a user down to a search or detail page regardless of LOB */
  PageLocation["ENTRY"] = "ENTRY";
  /** Pages that are not in the main shopping flow or that show up all across the flow such as Ads, Recommendation, Urgency, Scratchpad, etc. */
  PageLocation["FEATURES"] = "FEATURES";
  /** Insurance details page that comes after LOB details pages */
  PageLocation["INSURANCE_DETAILS"] = "INSURANCE_DETAILS";
  /** The Itinerary page provides information about booked, saved, and unsaved trips, as well as recommendations for activities based on ChatGPT. */
  PageLocation["ITINERARY"] = "ITINERARY";
  /** Payment error pages for all LOBs */
  PageLocation["PAYMENT_ERROR"] = "PAYMENT_ERROR";
  /** Post booking pages including itin, trip summary, trip details, customer service etc */
  PageLocation["POST_BOOKING"] = "POST_BOOKING";
  /** All LOB search result pages are identified as SEARCH_RESULTS */
  PageLocation["SEARCH_RESULTS"] = "SEARCH_RESULTS";
  /** All pages that are not customer facing, that are for internal system or monitoring such as isWorking, health check, dev tools page, etc */
  PageLocation["SYSTEM"] = "SYSTEM";
  /** User pages including sign-in, my account and rewards */
  PageLocation["USER"] = "USER";
})(PageLocation || (PageLocation = {}));
/** Input for travelGuidePageContextInput pageType parameter */
export var PageType;
(function (PageType) {
  PageType["DISCOVER_TAB"] = "DISCOVER_TAB";
  PageType["HOME_PAGE"] = "HOME_PAGE";
  PageType["TRAVEL_GUIDE"] = "TRAVEL_GUIDE";
  PageType["TRIP_OVERVIEW"] = "TRIP_OVERVIEW";
  PageType["WISH_LIST"] = "WISH_LIST";
})(PageType || (PageType = {}));
export var ParticipantState;
(function (ParticipantState) {
  ParticipantState["EXPIRED"] = "EXPIRED";
  ParticipantState["INVITED"] = "INVITED";
  ParticipantState["JOINED"] = "JOINED";
  ParticipantState["LEFT"] = "LEFT";
})(ParticipantState || (ParticipantState = {}));
export var Partner;
(function (Partner) {
  Partner["AGENCY"] = "AGENCY";
  Partner["MERCHANT"] = "MERCHANT";
  Partner["MERCHANT_AGENCY"] = "MERCHANT_AGENCY";
})(Partner || (Partner = {}));
export var PasswordWithStrengthMeterInputStrength;
(function (PasswordWithStrengthMeterInputStrength) {
  PasswordWithStrengthMeterInputStrength["STRONG"] = "STRONG";
  PasswordWithStrengthMeterInputStrength["VERY_STRONG"] = "VERY_STRONG";
  PasswordWithStrengthMeterInputStrength["WEAK"] = "WEAK";
})(PasswordWithStrengthMeterInputStrength || (PasswordWithStrengthMeterInputStrength = {}));
export var PasswordWithStrengthMeterProgressBarTheme;
(function (PasswordWithStrengthMeterProgressBarTheme) {
  PasswordWithStrengthMeterProgressBarTheme["MUTED"] = "MUTED";
  PasswordWithStrengthMeterProgressBarTheme["POSITIVE"] = "POSITIVE";
})(PasswordWithStrengthMeterProgressBarTheme || (PasswordWithStrengthMeterProgressBarTheme = {}));
export var PaymentAssistCardTypeInput;
(function (PaymentAssistCardTypeInput) {
  PaymentAssistCardTypeInput["NEW"] = "NEW";
  PaymentAssistCardTypeInput["ORIGINAL"] = "ORIGINAL";
  PaymentAssistCardTypeInput["SAVED"] = "SAVED";
})(PaymentAssistCardTypeInput || (PaymentAssistCardTypeInput = {}));
export var PaymentAssistChatMessageType;
(function (PaymentAssistChatMessageType) {
  PaymentAssistChatMessageType["CHALLENGE_FORM"] = "CHALLENGE_FORM";
  PaymentAssistChatMessageType["HOW_TO_PAY"] = "HOW_TO_PAY";
  PaymentAssistChatMessageType["PAYMENT_DETAILS_SUBMITTED"] = "PAYMENT_DETAILS_SUBMITTED";
  PaymentAssistChatMessageType["PAYMENT_FORM"] = "PAYMENT_FORM";
})(PaymentAssistChatMessageType || (PaymentAssistChatMessageType = {}));
export var PaymentAssistTransactionTypeInput;
(function (PaymentAssistTransactionTypeInput) {
  PaymentAssistTransactionTypeInput["CHARGE"] = "CHARGE";
  PaymentAssistTransactionTypeInput["REFUND"] = "REFUND";
})(PaymentAssistTransactionTypeInput || (PaymentAssistTransactionTypeInput = {}));
export var PaymentAssistTransactionTypeOutput;
(function (PaymentAssistTransactionTypeOutput) {
  PaymentAssistTransactionTypeOutput["CHARGE"] = "CHARGE";
  PaymentAssistTransactionTypeOutput["REFUND"] = "REFUND";
})(PaymentAssistTransactionTypeOutput || (PaymentAssistTransactionTypeOutput = {}));
export var PaymentDeviceType;
(function (PaymentDeviceType) {
  PaymentDeviceType["APP_PHONE"] = "APP_PHONE";
  PaymentDeviceType["APP_TABLET"] = "APP_TABLET";
  PaymentDeviceType["DESKTOP"] = "DESKTOP";
  PaymentDeviceType["DEVICE_TYPE_INVALID"] = "DEVICE_TYPE_INVALID";
  PaymentDeviceType["MOBILE_PHONE"] = "MOBILE_PHONE";
  PaymentDeviceType["MOBILE_TABLET"] = "MOBILE_TABLET";
})(PaymentDeviceType || (PaymentDeviceType = {}));
export var PaymentEntryUrn;
(function (PaymentEntryUrn) {
  PaymentEntryUrn["PAYMENT_APPLE_PAY_COUNTRY_CODE"] = "PAYMENT_APPLE_PAY_COUNTRY_CODE";
  PaymentEntryUrn["PAYMENT_APPLE_PAY_EMAIL_ADDRESS"] = "PAYMENT_APPLE_PAY_EMAIL_ADDRESS";
  PaymentEntryUrn["PAYMENT_APPLE_PAY_FIRST_NAME"] = "PAYMENT_APPLE_PAY_FIRST_NAME";
  PaymentEntryUrn["PAYMENT_APPLE_PAY_LAST_NAME"] = "PAYMENT_APPLE_PAY_LAST_NAME";
  PaymentEntryUrn["PAYMENT_APPLE_PAY_PHONE_NUMBER"] = "PAYMENT_APPLE_PAY_PHONE_NUMBER";
  PaymentEntryUrn["PAYMENT_APPLE_PAY_POSTAL_CODE"] = "PAYMENT_APPLE_PAY_POSTAL_CODE";
  PaymentEntryUrn["PAYMENT_BILLING_ZIPCODE"] = "PAYMENT_BILLING_ZIPCODE";
  PaymentEntryUrn["PAYMENT_CONTACT_EMAIL"] = "PAYMENT_CONTACT_EMAIL";
  PaymentEntryUrn["PAYMENT_CONTACT_PHONE"] = "PAYMENT_CONTACT_PHONE";
  PaymentEntryUrn["UNKNOWN"] = "UNKNOWN";
})(PaymentEntryUrn || (PaymentEntryUrn = {}));
export var PaymentMethodType;
(function (PaymentMethodType) {
  PaymentMethodType["ADYEN"] = "ADYEN";
  PaymentMethodType["AFFIRM"] = "AFFIRM";
  PaymentMethodType["APPLE_PAY"] = "APPLE_PAY";
  PaymentMethodType["CREDIT_CARD"] = "CREDIT_CARD";
  PaymentMethodType["GIFT_CARD"] = "GIFT_CARD";
  PaymentMethodType["INVALID"] = "INVALID";
  PaymentMethodType["KLARNA"] = "KLARNA";
  PaymentMethodType["LOYALTY"] = "LOYALTY";
  PaymentMethodType["NAVER_PAY"] = "NAVER_PAY";
  PaymentMethodType["PAYPAL"] = "PAYPAL";
  PaymentMethodType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(PaymentMethodType || (PaymentMethodType = {}));
export var PaymentNotificationLocation;
(function (PaymentNotificationLocation) {
  PaymentNotificationLocation["IN_MODULE"] = "IN_MODULE";
})(PaymentNotificationLocation || (PaymentNotificationLocation = {}));
export var PaymentNotificationMessageName;
(function (PaymentNotificationMessageName) {
  PaymentNotificationMessageName["CPM_CC_ON_FILE_MESSAGE"] = "CPM_CC_ON_FILE_MESSAGE";
  PaymentNotificationMessageName["CPM_CC_ON_FILE_MESSAGE_CAR"] = "CPM_CC_ON_FILE_MESSAGE_CAR";
  PaymentNotificationMessageName["CPM_CC_ON_FILE_ONLY_INSURANCE_PAYMENT_MESSAGE"] = "CPM_CC_ON_FILE_ONLY_INSURANCE_PAYMENT_MESSAGE";
  PaymentNotificationMessageName["CPM_NO_PAYMENT_DUE_MESSAGE"] = "CPM_NO_PAYMENT_DUE_MESSAGE";
  PaymentNotificationMessageName["CPM_NO_PAYMENT_DUE_MESSAGE_CAR"] = "CPM_NO_PAYMENT_DUE_MESSAGE_CAR";
  PaymentNotificationMessageName["CPM_ONLY_INSURANCE_PAYMENT_DUE_MESSAGE"] = "CPM_ONLY_INSURANCE_PAYMENT_DUE_MESSAGE";
  PaymentNotificationMessageName["INVALID_MESSAGE"] = "INVALID_MESSAGE";
  PaymentNotificationMessageName["PAY_NOW_GIFT_CARD_COUPON_TOTAL_AMOUNT"] = "PAY_NOW_GIFT_CARD_COUPON_TOTAL_AMOUNT";
  PaymentNotificationMessageName["PAY_NOW_GIFT_CARD_TOTAL_AMOUNT"] = "PAY_NOW_GIFT_CARD_TOTAL_AMOUNT";
  PaymentNotificationMessageName["PAY_NOW_OKC_COUPON_TOTAL_AMOUNT"] = "PAY_NOW_OKC_COUPON_TOTAL_AMOUNT";
  PaymentNotificationMessageName["PAY_NOW_OKC_TOTAL_AMOUNT"] = "PAY_NOW_OKC_TOTAL_AMOUNT";
})(PaymentNotificationMessageName || (PaymentNotificationMessageName = {}));
export var PaymentNotificationModuleName;
(function (PaymentNotificationModuleName) {
  PaymentNotificationModuleName["COMMON_PAYMENT_MODULE"] = "COMMON_PAYMENT_MODULE";
})(PaymentNotificationModuleName || (PaymentNotificationModuleName = {}));
export var PaymentPayType;
(function (PaymentPayType) {
  PaymentPayType["PAY_LATER"] = "PAY_LATER";
  PaymentPayType["PAY_NOW"] = "PAY_NOW";
})(PaymentPayType || (PaymentPayType = {}));
export var PaymentState;
(function (PaymentState) {
  PaymentState["STATE_CANCELLED"] = "STATE_CANCELLED";
  PaymentState["STATE_DISABLED"] = "STATE_DISABLED";
  PaymentState["STATE_INVALID"] = "STATE_INVALID";
  PaymentState["STATE_REMOVED"] = "STATE_REMOVED";
  PaymentState["STATE_SELECTED"] = "STATE_SELECTED";
  PaymentState["STATE_UNSELECTED"] = "STATE_UNSELECTED";
  PaymentState["UNRECOGNIZED"] = "UNRECOGNIZED";
})(PaymentState || (PaymentState = {}));
export var PaymentType;
(function (PaymentType) {
  PaymentType["COUPON_ELIGIBLE"] = "COUPON_ELIGIBLE";
  PaymentType["FREE_CANCELLATION"] = "FREE_CANCELLATION";
  PaymentType["GIFT_CARD"] = "GIFT_CARD";
  PaymentType["PAY_LATER"] = "PAY_LATER";
  PaymentType["PAY_LATER_WITH_DEPOSIT"] = "PAY_LATER_WITH_DEPOSIT";
  PaymentType["PAY_WITHOUT_CREDITCARD"] = "PAY_WITHOUT_CREDITCARD";
  PaymentType["PAY_WITH_AFFIRM"] = "PAY_WITH_AFFIRM";
  PaymentType["PAY_WITH_AFTERPAY"] = "PAY_WITH_AFTERPAY";
  PaymentType["PAY_WITH_KLARNA"] = "PAY_WITH_KLARNA";
})(PaymentType || (PaymentType = {}));
/** Represents the logo size used by the client to render */
export var PaymentTypeLogoSize;
(function (PaymentTypeLogoSize) {
  PaymentTypeLogoSize["LARGE"] = "LARGE";
  PaymentTypeLogoSize["SMALL"] = "SMALL";
})(PaymentTypeLogoSize || (PaymentTypeLogoSize = {}));
/** This enum scope is to communicate to client if is a different card theme defined by CardTheme enum is needed.see https://uitk.expedia.biz/expedia/en_US/components/utils#theme_provide */
export var PersonalizedTheme;
(function (PersonalizedTheme) {
  PersonalizedTheme["BRIGHT_1"] = "BRIGHT_1";
  PersonalizedTheme["DARK_1"] = "DARK_1";
  PersonalizedTheme["GLOBAL_LOYALTY_EXTRA_HIGH"] = "GLOBAL_LOYALTY_EXTRA_HIGH";
  PersonalizedTheme["GLOBAL_LOYALTY_HIGH"] = "GLOBAL_LOYALTY_HIGH";
  PersonalizedTheme["GLOBAL_LOYALTY_LOW"] = "GLOBAL_LOYALTY_LOW";
  PersonalizedTheme["GLOBAL_LOYALTY_MID"] = "GLOBAL_LOYALTY_MID";
  PersonalizedTheme["LIGHT_1"] = "LIGHT_1";
})(PersonalizedTheme || (PersonalizedTheme = {}));
export var PickerTriggerDisplayType;
(function (PickerTriggerDisplayType) {
  PickerTriggerDisplayType["GLOBAL_NAV_BUTTON"] = "GLOBAL_NAV_BUTTON";
  PickerTriggerDisplayType["GLOBAL_NAV_LINK"] = "GLOBAL_NAV_LINK";
})(PickerTriggerDisplayType || (PickerTriggerDisplayType = {}));
export var PickerTriggerPlacementType;
(function (PickerTriggerPlacementType) {
  PickerTriggerPlacementType["MENU_ITEM"] = "MENU_ITEM";
  PickerTriggerPlacementType["NAV_LINK"] = "NAV_LINK";
})(PickerTriggerPlacementType || (PickerTriggerPlacementType = {}));
export var Placement;
(function (Placement) {
  /** Horizontal Orientation of Images in the List */
  Placement["HORIZONTAL"] = "Horizontal";
  /** Vertical Orientation of Images in the List */
  Placement["VERTICAL"] = "Vertical";
})(Placement || (Placement = {}));
export var PlatformType;
(function (PlatformType) {
  PlatformType["ANDROID"] = "ANDROID";
  PlatformType["IOS"] = "IOS";
  PlatformType["WEB"] = "WEB";
})(PlatformType || (PlatformType = {}));
/**
 * Languages vary in how they handle plurals of nouns or unit expressions ("hour" vs "hours", and so on).
 * Some languages have two forms, like English; some languages have only a single form; and some languages have multiple forms. CLDR uses short, mnemonic tags for these plural categories.
 * http://cldr.unicode.org/index/cldr-spec/plural-rules
 */
export var PluralCategory;
(function (PluralCategory) {
  PluralCategory["FEW"] = "FEW";
  PluralCategory["MANY"] = "MANY";
  PluralCategory["ONE"] = "ONE";
  PluralCategory["OTHER"] = "OTHER";
  PluralCategory["TWO"] = "TWO";
  PluralCategory["ZERO"] = "ZERO";
})(PluralCategory || (PluralCategory = {}));
export var Points;
(function (Points) {
  /** Don't use loyalty points to calculate the strikeout price. */
  Points["SHOP_WITHOUT_POINTS"] = "SHOP_WITHOUT_POINTS";
  /** Use loyalty points to calculate the strikeout price. aka `swpApplied=true` */
  Points["SHOP_WITH_POINTS"] = "SHOP_WITH_POINTS";
})(Points || (Points = {}));
/** Options that alter behavior of mutation - for backward compatibility */
export var PrepareCheckoutResponseOption;
(function (PrepareCheckoutResponseOption) {
  PrepareCheckoutResponseOption["ALTERNATIVE_ACTION_ON_FAILURE"] = "ALTERNATIVE_ACTION_ON_FAILURE";
})(PrepareCheckoutResponseOption || (PrepareCheckoutResponseOption = {}));
export var PrequalificationStatus;
(function (PrequalificationStatus) {
  PrequalificationStatus["APPROVED"] = "APPROVED";
  PrequalificationStatus["DECLINED"] = "DECLINED";
})(PrequalificationStatus || (PrequalificationStatus = {}));
export var PriceMatchPromiseChartType;
(function (PriceMatchPromiseChartType) {
  PriceMatchPromiseChartType["BAR"] = "BAR";
  PriceMatchPromiseChartType["LINE"] = "LINE";
})(PriceMatchPromiseChartType || (PriceMatchPromiseChartType = {}));
export var PriceMatchPromiseScaleType;
(function (PriceMatchPromiseScaleType) {
  PriceMatchPromiseScaleType["DATE"] = "DATE";
  PriceMatchPromiseScaleType["LABEL"] = "LABEL";
  PriceMatchPromiseScaleType["TIME"] = "TIME";
})(PriceMatchPromiseScaleType || (PriceMatchPromiseScaleType = {}));
/** Represents the state for the PMP module */
export var PriceMatchPromiseState;
(function (PriceMatchPromiseState) {
  /** Represents when the PMP module is removable */
  PriceMatchPromiseState["REMOVABLE"] = "REMOVABLE";
  /** Represents when the PMP module is selectable */
  PriceMatchPromiseState["SELECTABLE"] = "SELECTABLE";
  /** Represents when the PMP module is static */
  PriceMatchPromiseState["STATIC"] = "STATIC";
  /** Represents when the PMP module is toggleable */
  PriceMatchPromiseState["TOGGLEABLE"] = "TOGGLEABLE";
})(PriceMatchPromiseState || (PriceMatchPromiseState = {}));
export var PricingSchemeType;
(function (PricingSchemeType) {
  PricingSchemeType["DAILY_RATE"] = "DAILY_RATE";
  PricingSchemeType["TOTAL_RATE"] = "TOTAL_RATE";
})(PricingSchemeType || (PricingSchemeType = {}));
export var PricingType;
(function (PricingType) {
  PricingType["OCCUPANCYBASEDPRICING"] = "OccupancyBasedPricing";
  PricingType["PERDAYPRICING"] = "PerDayPricing";
})(PricingType || (PricingType = {}));
/** User preference for data sharing with third parties which users may update */
export var PrivacySellState;
(function (PrivacySellState) {
  PrivacySellState["CAN_NOT_SELL"] = "CAN_NOT_SELL";
  PrivacySellState["CAN_SELL"] = "CAN_SELL";
})(PrivacySellState || (PrivacySellState = {}));
/** Privacy tracking user preference. We can retrieve info on if the site allows tracking from Site Info and null can also be used to represent a selection or not */
export var PrivacyTrackingState;
(function (PrivacyTrackingState) {
  PrivacyTrackingState["CAN_NOT_TRACK"] = "CAN_NOT_TRACK";
  PrivacyTrackingState["CAN_TRACK"] = "CAN_TRACK";
})(PrivacyTrackingState || (PrivacyTrackingState = {}));
export var ProductAssociationOperation;
(function (ProductAssociationOperation) {
  ProductAssociationOperation["ADD_PREFERRED_PRODUCTS"] = "ADD_PREFERRED_PRODUCTS";
  ProductAssociationOperation["UPDATE_ALL_PREFERRED_PRODUCTS"] = "UPDATE_ALL_PREFERRED_PRODUCTS";
})(ProductAssociationOperation || (ProductAssociationOperation = {}));
export var ProductContext;
(function (ProductContext) {
  ProductContext["BRAND_RESULT_LISTING"] = "BRAND_RESULT_LISTING";
  ProductContext["FLIGHT_SPONSORED_LISTING"] = "FLIGHT_SPONSORED_LISTING";
  ProductContext["LODGING_SPONSORED_LISTING"] = "LODGING_SPONSORED_LISTING";
})(ProductContext || (ProductContext = {}));
export var ProductEntityAssetSelection;
(function (ProductEntityAssetSelection) {
  ProductEntityAssetSelection["ABOUT_PROPERTY"] = "ABOUT_PROPERTY";
  ProductEntityAssetSelection["ACCESSIBILITY_CONTENT"] = "ACCESSIBILITY_CONTENT";
  ProductEntityAssetSelection["AMENITY"] = "AMENITY";
  ProductEntityAssetSelection["AMENITY_SPOTLIGHT"] = "AMENITY_SPOTLIGHT";
  ProductEntityAssetSelection["AT_A_GLANCE_AMENITIES"] = "AT_A_GLANCE_AMENITIES";
  ProductEntityAssetSelection["EXPERIENCE_SCORE"] = "EXPERIENCE_SCORE";
  ProductEntityAssetSelection["EXPERIENCE_SCORE_WITH_TOP_RATED_ATTRIBUTES"] = "EXPERIENCE_SCORE_WITH_TOP_RATED_ATTRIBUTES";
  ProductEntityAssetSelection["FAMILY_HIGHLIGHTS"] = "FAMILY_HIGHLIGHTS";
  ProductEntityAssetSelection["GUEST_CHOICE"] = "GUEST_CHOICE";
  ProductEntityAssetSelection["HEADLINE"] = "HEADLINE";
  ProductEntityAssetSelection["HOST_TEXTS"] = "HOST_TEXTS";
  ProductEntityAssetSelection["IMAGE"] = "IMAGE";
  ProductEntityAssetSelection["IMAGE_RICH_AMENITY"] = "IMAGE_RICH_AMENITY";
  ProductEntityAssetSelection["LOCATION_DESCRIPTION"] = "LOCATION_DESCRIPTION";
  ProductEntityAssetSelection["LUXURY_STAYS"] = "LUXURY_STAYS";
  ProductEntityAssetSelection["PLACE"] = "PLACE";
  ProductEntityAssetSelection["POLICY"] = "POLICY";
  ProductEntityAssetSelection["PRODUCT_ATTRIBUTE"] = "PRODUCT_ATTRIBUTE";
  ProductEntityAssetSelection["PRODUCT_HIGHLIGHTS"] = "PRODUCT_HIGHLIGHTS";
  ProductEntityAssetSelection["PRODUCT_UNIQUENESS_HIGHLIGHTS"] = "PRODUCT_UNIQUENESS_HIGHLIGHTS";
  ProductEntityAssetSelection["PROPERTY_AMENITY_GROUPS"] = "PROPERTY_AMENITY_GROUPS";
  ProductEntityAssetSelection["PROPERTY_DESCRIPTION"] = "PROPERTY_DESCRIPTION";
  ProductEntityAssetSelection["RELEVANT_AMENITY_DETAILS"] = "RELEVANT_AMENITY_DETAILS";
  ProductEntityAssetSelection["REVIEW_DETAILS"] = "REVIEW_DETAILS";
  ProductEntityAssetSelection["REVIEW_IMAGES"] = "REVIEW_IMAGES";
  ProductEntityAssetSelection["REVIEW_SUMMARY"] = "REVIEW_SUMMARY";
  ProductEntityAssetSelection["REVIEW_SUMMARY_HIGHLIGHTS"] = "REVIEW_SUMMARY_HIGHLIGHTS";
  ProductEntityAssetSelection["REVIEW_SUMMARY_WITH_UGC_CONTENT"] = "REVIEW_SUMMARY_WITH_UGC_CONTENT";
  ProductEntityAssetSelection["SUPPLY_SCORE"] = "SUPPLY_SCORE";
  ProductEntityAssetSelection["TOP_RATED_DETAILS"] = "TOP_RATED_DETAILS";
  ProductEntityAssetSelection["VIBE_TAGLINE"] = "VIBE_TAGLINE";
  ProductEntityAssetSelection["VIRTUAL_TOUR"] = "VIRTUAL_TOUR";
})(ProductEntityAssetSelection || (ProductEntityAssetSelection = {}));
export var ProductEntityRefinementSelection;
(function (ProductEntityRefinementSelection) {
  ProductEntityRefinementSelection["EMBARGO"] = "EMBARGO";
})(ProductEntityRefinementSelection || (ProductEntityRefinementSelection = {}));
/** Enum to specify image width for product image */
export var ProductImageFitment;
(function (ProductImageFitment) {
  ProductImageFitment["CONTAIN"] = "CONTAIN";
  ProductImageFitment["COVER"] = "COVER";
})(ProductImageFitment || (ProductImageFitment = {}));
/** Enum to specify image width for product image */
export var ProductImageWidth;
(function (ProductImageWidth) {
  ProductImageWidth["FULL_WIDTH"] = "FULL_WIDTH";
  ProductImageWidth["HALF_WIDTH"] = "HALF_WIDTH";
  ProductImageWidth["QUARTER_WIDTH"] = "QUARTER_WIDTH";
  ProductImageWidth["THIRD_WIDTH"] = "THIRD_WIDTH";
})(ProductImageWidth || (ProductImageWidth = {}));
/** Product line. This should not be used outside of ProductIdentifier class. */
export var ProductLine;
(function (ProductLine) {
  ProductLine["ACTIVITY"] = "ACTIVITY";
  ProductLine["CAR"] = "CAR";
  ProductLine["CRUISE"] = "CRUISE";
  ProductLine["FLIGHT"] = "FLIGHT";
  ProductLine["GROUND_TRANSFER"] = "GROUND_TRANSFER";
  ProductLine["INSURANCE"] = "INSURANCE";
  ProductLine["LODGING"] = "LODGING";
  ProductLine["PACKAGE"] = "PACKAGE";
  ProductLine["PRODUCT_LINE_INVALID"] = "PRODUCT_LINE_INVALID";
  ProductLine["RAIL"] = "RAIL";
  ProductLine["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ProductLine || (ProductLine = {}));
export var ProductQuestionTopic;
(function (ProductQuestionTopic) {
  ProductQuestionTopic["HOTEL"] = "HOTEL";
})(ProductQuestionTopic || (ProductQuestionTopic = {}));
export var ProductType;
(function (ProductType) {
  ProductType["ARTICLE"] = "ARTICLE";
  ProductType["CAR_DETAILS"] = "CAR_DETAILS";
  ProductType["DESTINATION"] = "DESTINATION";
  ProductType["DESTINATION_EXPERIENCE"] = "DESTINATION_EXPERIENCE";
  ProductType["EXPERIENCE"] = "EXPERIENCE";
  ProductType["EXPERT_TIP"] = "EXPERT_TIP";
  ProductType["FLIGHT_SEARCH"] = "FLIGHT_SEARCH";
  ProductType["LX_DETAILS"] = "LX_DETAILS";
  ProductType["NEIGHBORHOOD"] = "NEIGHBORHOOD";
  ProductType["POI_GAIA"] = "POI_GAIA";
  ProductType["PROPERTY_DETAILS"] = "PROPERTY_DETAILS";
})(ProductType || (ProductType = {}));
export var ProductVideoActionType;
(function (ProductVideoActionType) {
  ProductVideoActionType["ENTER_FULLSCREEN"] = "ENTER_FULLSCREEN";
  ProductVideoActionType["EXIT_FULLSCREEN"] = "EXIT_FULLSCREEN";
  ProductVideoActionType["MUTE"] = "MUTE";
  ProductVideoActionType["PAUSE"] = "PAUSE";
  ProductVideoActionType["PLAY"] = "PLAY";
  ProductVideoActionType["UNMUTE"] = "UNMUTE";
})(ProductVideoActionType || (ProductVideoActionType = {}));
export var ProductVideoType;
(function (ProductVideoType) {
  ProductVideoType["BASIC"] = "BASIC";
  ProductVideoType["EMBED"] = "EMBED";
})(ProductVideoType || (ProductVideoType = {}));
/** Represents layout of buttons. */
export var ProfileButtonLayout;
(function (ProfileButtonLayout) {
  /** Horizontally stacked buttons. */
  ProfileButtonLayout["INLINE"] = "INLINE";
  /** Vertically stacked buttons. */
  ProfileButtonLayout["STACKED"] = "STACKED";
})(ProfileButtonLayout || (ProfileButtonLayout = {}));
/** Specifies whether to open the link in the same user interface context or in a different context */
export var ProfileLinkTarget;
(function (ProfileLinkTarget) {
  ProfileLinkTarget["EXTERNAL"] = "EXTERNAL";
  ProfileLinkTarget["INTERNAL"] = "INTERNAL";
})(ProfileLinkTarget || (ProfileLinkTarget = {}));
/** enum of actions where the button click can take the user to. This can be used in UI to decide the action for button click. */
export var ProgressionBarAction;
(function (ProgressionBarAction) {
  ProgressionBarAction["PDP"] = "PDP";
  ProgressionBarAction["REVIEWS"] = "REVIEWS";
  ProgressionBarAction["TRAVEL_GUIDE"] = "TRAVEL_GUIDE";
})(ProgressionBarAction || (ProgressionBarAction = {}));
export var PropertyActivitiesCrossSellActionType;
(function (PropertyActivitiesCrossSellActionType) {
  PropertyActivitiesCrossSellActionType["DISMISS"] = "DISMISS";
  PropertyActivitiesCrossSellActionType["EDIT"] = "EDIT";
  PropertyActivitiesCrossSellActionType["OPEN"] = "OPEN";
  PropertyActivitiesCrossSellActionType["REMOVE"] = "REMOVE";
})(PropertyActivitiesCrossSellActionType || (PropertyActivitiesCrossSellActionType = {}));
/** Type that represents the amenity category icons for the property */
export var PropertyAmenityCategoryType;
(function (PropertyAmenityCategoryType) {
  PropertyAmenityCategoryType["ACCESSIBLE_ROLL_IN_SHOWER"] = "ACCESSIBLE_ROLL_IN_SHOWER";
  PropertyAmenityCategoryType["AIR_CONDITIONING"] = "AIR_CONDITIONING";
  PropertyAmenityCategoryType["ALL_INCLUSIVE"] = "ALL_INCLUSIVE";
  PropertyAmenityCategoryType["ARCADE"] = "ARCADE";
  PropertyAmenityCategoryType["BABYSITTING"] = "BABYSITTING";
  PropertyAmenityCategoryType["BAR"] = "BAR";
  PropertyAmenityCategoryType["BOWLING"] = "BOWLING";
  PropertyAmenityCategoryType["BREAKFAST_AVAILABLE"] = "BREAKFAST_AVAILABLE";
  PropertyAmenityCategoryType["BUSINESS_SERVICES"] = "BUSINESS_SERVICES";
  PropertyAmenityCategoryType["CHILDREN_CLUB"] = "CHILDREN_CLUB";
  PropertyAmenityCategoryType["DAILY_HOUSEKEEPING"] = "DAILY_HOUSEKEEPING";
  PropertyAmenityCategoryType["EXTRA_BED"] = "EXTRA_BED";
  PropertyAmenityCategoryType["FITNESS_EQUIPMENT"] = "FITNESS_EQUIPMENT";
  PropertyAmenityCategoryType["FREE_AIRPORT_TRANSPORTATION"] = "FREE_AIRPORT_TRANSPORTATION";
  PropertyAmenityCategoryType["FREE_BREAKFAST"] = "FREE_BREAKFAST";
  PropertyAmenityCategoryType["FREE_PARKING"] = "FREE_PARKING";
  PropertyAmenityCategoryType["FREE_WELCOME_DRINK"] = "FREE_WELCOME_DRINK";
  PropertyAmenityCategoryType["FRONT_DESK_24_HOURS"] = "FRONT_DESK_24_HOURS";
  PropertyAmenityCategoryType["GROCERY"] = "GROCERY";
  PropertyAmenityCategoryType["HIGH_SPEED_INTERNET"] = "HIGH_SPEED_INTERNET";
  PropertyAmenityCategoryType["HOT_TUB"] = "HOT_TUB";
  PropertyAmenityCategoryType["IN_ROOM_INTERNET"] = "IN_ROOM_INTERNET";
  PropertyAmenityCategoryType["KIDS_POOL"] = "KIDS_POOL";
  PropertyAmenityCategoryType["KITCHEN"] = "KITCHEN";
  PropertyAmenityCategoryType["LAUNDRY"] = "LAUNDRY";
  PropertyAmenityCategoryType["LIVING_AREA"] = "LIVING_AREA";
  PropertyAmenityCategoryType["MICROWAVE"] = "MICROWAVE";
  PropertyAmenityCategoryType["MINI_GOLF"] = "MINI_GOLF";
  PropertyAmenityCategoryType["PARKING"] = "PARKING";
  PropertyAmenityCategoryType["PETS_ALLOWED"] = "PETS_ALLOWED";
  PropertyAmenityCategoryType["PLAYGROUND"] = "PLAYGROUND";
  PropertyAmenityCategoryType["POOL"] = "POOL";
  PropertyAmenityCategoryType["RESTAURANT_IN_HOTEL"] = "RESTAURANT_IN_HOTEL";
  PropertyAmenityCategoryType["ROOM_SERVICE"] = "ROOM_SERVICE";
  PropertyAmenityCategoryType["SMOKE_FREE"] = "SMOKE_FREE";
  PropertyAmenityCategoryType["SOUNDPROOF_ROOM"] = "SOUNDPROOF_ROOM";
  PropertyAmenityCategoryType["SPA_SERVICES_ON_SITE"] = "SPA_SERVICES_ON_SITE";
  PropertyAmenityCategoryType["SPECIAL_DEAL"] = "SPECIAL_DEAL";
  PropertyAmenityCategoryType["TENNIS_COURT"] = "TENNIS_COURT";
  PropertyAmenityCategoryType["TOYS"] = "TOYS";
  PropertyAmenityCategoryType["WATERSLIDE"] = "WATERSLIDE";
})(PropertyAmenityCategoryType || (PropertyAmenityCategoryType = {}));
export var PropertyAmenityType;
(function (PropertyAmenityType) {
  PropertyAmenityType["ACCESSIBILITY"] = "ACCESSIBILITY";
  PropertyAmenityType["BATHROOM"] = "BATHROOM";
  PropertyAmenityType["BEDROOM"] = "BEDROOM";
  PropertyAmenityType["BUSINESS_SERVICES"] = "BUSINESS_SERVICES";
  PropertyAmenityType["CONVENIENCES"] = "CONVENIENCES";
  PropertyAmenityType["ENTERTAINMENT"] = "ENTERTAINMENT";
  PropertyAmenityType["FAMILY_FRIENDLY"] = "FAMILY_FRIENDLY";
  PropertyAmenityType["FOOD_DRINK"] = "FOOD_DRINK";
  PropertyAmenityType["GUEST_SERVICES"] = "GUEST_SERVICES";
  PropertyAmenityType["INTERNET"] = "INTERNET";
  PropertyAmenityType["MORE"] = "MORE";
  PropertyAmenityType["OUTDOOR"] = "OUTDOOR";
  PropertyAmenityType["OUTDOOR_SPACE"] = "OUTDOOR_SPACE";
  PropertyAmenityType["PARKING"] = "PARKING";
  PropertyAmenityType["PROPERTY"] = "PROPERTY";
  PropertyAmenityType["ROOM"] = "ROOM";
  PropertyAmenityType["SPA"] = "SPA";
  PropertyAmenityType["THINGS_TO_DO"] = "THINGS_TO_DO";
})(PropertyAmenityType || (PropertyAmenityType = {}));
export var PropertyCalendarPriceTrend;
(function (PropertyCalendarPriceTrend) {
  /** Negative price trend */
  PropertyCalendarPriceTrend["NEGATIVE"] = "NEGATIVE";
  /** Positive price trend */
  PropertyCalendarPriceTrend["POSITIVE"] = "POSITIVE";
})(PropertyCalendarPriceTrend || (PropertyCalendarPriceTrend = {}));
export var PropertyCancellationPolicyType;
(function (PropertyCancellationPolicyType) {
  PropertyCancellationPolicyType["NON_REFUNDABLE"] = "NON_REFUNDABLE";
  PropertyCancellationPolicyType["REFUNDABLE_WITH_NO_PENALTY"] = "REFUNDABLE_WITH_NO_PENALTY";
  PropertyCancellationPolicyType["REFUNDABLE_WITH_PENALTY"] = "REFUNDABLE_WITH_PENALTY";
})(PropertyCancellationPolicyType || (PropertyCancellationPolicyType = {}));
export var PropertyContentSectionRef;
(function (PropertyContentSectionRef) {
  PropertyContentSectionRef["AVAILABILITY_CALENDAR_START_DATE"] = "AVAILABILITY_CALENDAR_START_DATE";
  PropertyContentSectionRef["PRICE_DISPLAY_SERVICE_RESPONSE"] = "PRICE_DISPLAY_SERVICE_RESPONSE";
  PropertyContentSectionRef["RECOMMENDED_OFFER"] = "RECOMMENDED_OFFER";
  PropertyContentSectionRef["ROOMS_AND_RATES"] = "ROOMS_AND_RATES";
})(PropertyContentSectionRef || (PropertyContentSectionRef = {}));
export var PropertyContentType;
(function (PropertyContentType) {
  /** Card view that appears on the page */
  PropertyContentType["CARD"] = "CARD";
  /** Detailed view that appears in expanded modal. */
  PropertyContentType["DETAILED"] = "DETAILED";
  /** Simplified view that appears flat on page. */
  PropertyContentType["SUMMARY"] = "SUMMARY";
})(PropertyContentType || (PropertyContentType = {}));
export var PropertyDetailsPropertyType;
(function (PropertyDetailsPropertyType) {
  PropertyDetailsPropertyType["HOTEL"] = "HOTEL";
  PropertyDetailsPropertyType["VACATION_RENTAL"] = "VACATION_RENTAL";
})(PropertyDetailsPropertyType || (PropertyDetailsPropertyType = {}));
export var PropertyFilterAccessibility;
(function (PropertyFilterAccessibility) {
  PropertyFilterAccessibility["ACCESSIBLE_BATHROOM"] = "ACCESSIBLE_BATHROOM";
  PropertyFilterAccessibility["ACCESSIBLE_PARKING"] = "ACCESSIBLE_PARKING";
  PropertyFilterAccessibility["ELEVATOR"] = "ELEVATOR";
  PropertyFilterAccessibility["IN_ROOM_ACCESSIBLE"] = "IN_ROOM_ACCESSIBLE";
  PropertyFilterAccessibility["ROLL_IN_SHOWER"] = "ROLL_IN_SHOWER";
  PropertyFilterAccessibility["SERVICE_ANIMAL"] = "SERVICE_ANIMAL";
  PropertyFilterAccessibility["SIGN_LANGUAGE_INTERPRETER"] = "SIGN_LANGUAGE_INTERPRETER";
  PropertyFilterAccessibility["STAIR_FREE_PATH"] = "STAIR_FREE_PATH";
})(PropertyFilterAccessibility || (PropertyFilterAccessibility = {}));
export var PropertyFilterAmenity;
(function (PropertyFilterAmenity) {
  PropertyFilterAmenity["AIR_CONDITIONING"] = "AIR_CONDITIONING";
  PropertyFilterAmenity["ALL_INCLUSIVE"] = "ALL_INCLUSIVE";
  PropertyFilterAmenity["BALCONY_OR_TERRACE"] = "BALCONY_OR_TERRACE";
  PropertyFilterAmenity["BAR"] = "BAR";
  /** Deprecated: TnL 37054 - AFFINITY_FILTERS_APPLIED_ON_HSR */
  PropertyFilterAmenity["BEACH"] = "BEACH";
  PropertyFilterAmenity["BEACH_FRONT"] = "BEACH_FRONT";
  PropertyFilterAmenity["BED_LINENS"] = "BED_LINENS";
  PropertyFilterAmenity["CASINO"] = "CASINO";
  PropertyFilterAmenity["CRIB"] = "CRIB";
  PropertyFilterAmenity["DISHWASHER"] = "DISHWASHER";
  PropertyFilterAmenity["DRYER"] = "DRYER";
  PropertyFilterAmenity["ELECTRIC_CAR"] = "ELECTRIC_CAR";
  PropertyFilterAmenity["FIREPLACE"] = "FIREPLACE";
  PropertyFilterAmenity["FREE_AIRPORT_TRANSPORTATION"] = "FREE_AIRPORT_TRANSPORTATION";
  PropertyFilterAmenity["FREE_BREAKFAST"] = "FREE_BREAKFAST";
  PropertyFilterAmenity["FREE_PARKING"] = "FREE_PARKING";
  /** Deprecated: TnL 37054 - AFFINITY_FILTERS_APPLIED_ON_HSR */
  PropertyFilterAmenity["GOLF"] = "GOLF";
  PropertyFilterAmenity["GOLF_COURSE"] = "GOLF_COURSE";
  PropertyFilterAmenity["GYM"] = "GYM";
  PropertyFilterAmenity["HOT_SPRING"] = "HOT_SPRING";
  PropertyFilterAmenity["HOT_TUB"] = "HOT_TUB";
  PropertyFilterAmenity["KITCHEN_KITCHEN"] = "KITCHEN_KITCHEN";
  PropertyFilterAmenity["KITCHEN_KITCHENETTE"] = "KITCHEN_KITCHENETTE";
  PropertyFilterAmenity["OCEAN_VIEW"] = "OCEAN_VIEW";
  PropertyFilterAmenity["PARKING"] = "PARKING";
  PropertyFilterAmenity["PETS"] = "PETS";
  PropertyFilterAmenity["POOL"] = "POOL";
  PropertyFilterAmenity["RESTAURANT_IN_HOTEL"] = "RESTAURANT_IN_HOTEL";
  PropertyFilterAmenity["SPA_ON_SITE"] = "SPA_ON_SITE";
  PropertyFilterAmenity["TELEVISION"] = "TELEVISION";
  PropertyFilterAmenity["WASHER"] = "WASHER";
  PropertyFilterAmenity["WASHER_DRYER"] = "WASHER_DRYER";
  PropertyFilterAmenity["WATER_PARK"] = "WATER_PARK";
  PropertyFilterAmenity["WIFI"] = "WIFI";
})(PropertyFilterAmenity || (PropertyFilterAmenity = {}));
/** Options that are not filters. Refer @code { SearchOptions } */
export var PropertyInfoOptions;
(function (PropertyInfoOptions) {
  /** Use loyalty points to calculate the strikeout price. aka `swpApplied=true` */
  PropertyInfoOptions["SHOP_WITH_POINTS"] = "SHOP_WITH_POINTS";
})(PropertyInfoOptions || (PropertyInfoOptions = {}));
export var PropertyPaymentFlags;
(function (PropertyPaymentFlags) {
  PropertyPaymentFlags["ARTIFICIALLY_FENCED_RATE"] = "ARTIFICIALLY_FENCED_RATE";
  PropertyPaymentFlags["MIXED_RATE_PLAN"] = "MIXED_RATE_PLAN";
  PropertyPaymentFlags["NO_CREDIT_CARD"] = "NO_CREDIT_CARD";
})(PropertyPaymentFlags || (PropertyPaymentFlags = {}));
export var PropertyPaymentModel;
(function (PropertyPaymentModel) {
  PropertyPaymentModel["PAY_LATER"] = "PAY_LATER";
  PropertyPaymentModel["PAY_LATER_WITH_DEPOSIT"] = "PAY_LATER_WITH_DEPOSIT";
  PropertyPaymentModel["PAY_NOW"] = "PAY_NOW";
})(PropertyPaymentModel || (PropertyPaymentModel = {}));
/** Indicate what are the payment options for a given offer */
export var PropertyPaymentType;
(function (PropertyPaymentType) {
  PropertyPaymentType["PAY_LATER"] = "PAY_LATER";
  PropertyPaymentType["PAY_LATER_WITH_DEPOSIT"] = "PAY_LATER_WITH_DEPOSIT";
  PropertyPaymentType["PAY_NOW"] = "PAY_NOW";
})(PropertyPaymentType || (PropertyPaymentType = {}));
export var PropertyRecommendationStrategy;
(function (PropertyRecommendationStrategy) {
  PropertyRecommendationStrategy["NEARBY_PROPERTIES"] = "NEARBY_PROPERTIES";
  PropertyRecommendationStrategy["SIMILAR_PROPERTIES"] = "SIMILAR_PROPERTIES";
})(PropertyRecommendationStrategy || (PropertyRecommendationStrategy = {}));
/** Filters review results by category type */
export var PropertyReviewCategory;
(function (PropertyReviewCategory) {
  PropertyReviewCategory["BUSINESS_TRAVELERS"] = "BUSINESS_TRAVELERS";
  PropertyReviewCategory["COUPLES"] = "COUPLES";
  PropertyReviewCategory["EVERYONE"] = "EVERYONE";
  PropertyReviewCategory["FAMILIES"] = "FAMILIES";
  PropertyReviewCategory["GETAWAY_WITH_FRIENDS"] = "GETAWAY_WITH_FRIENDS";
  PropertyReviewCategory["GOLF"] = "GOLF";
  PropertyReviewCategory["OTHER"] = "OTHER";
  PropertyReviewCategory["OVERNIGHT_STAY"] = "OVERNIGHT_STAY";
  PropertyReviewCategory["PERSONAL_EVENT"] = "PERSONAL_EVENT";
  PropertyReviewCategory["SHOPPING"] = "SHOPPING";
  PropertyReviewCategory["SPA"] = "SPA";
  PropertyReviewCategory["STUDENTS"] = "STUDENTS";
})(PropertyReviewCategory || (PropertyReviewCategory = {}));
export var PropertyReviewSort;
(function (PropertyReviewSort) {
  PropertyReviewSort["HIGHEST_TO_LOWEST_RATED"] = "HIGHEST_TO_LOWEST_RATED";
  PropertyReviewSort["LOWEST_TO_HIGHEST_RATED"] = "LOWEST_TO_HIGHEST_RATED";
  PropertyReviewSort["NEWEST_TO_OLDEST"] = "NEWEST_TO_OLDEST";
  PropertyReviewSort["NEWEST_TO_OLDEST_BY_LANGUAGE"] = "NEWEST_TO_OLDEST_BY_LANGUAGE";
  PropertyReviewSort["NEWEST_TO_OLDEST_BY_RELEVANCY"] = "NEWEST_TO_OLDEST_BY_RELEVANCY";
})(PropertyReviewSort || (PropertyReviewSort = {}));
export var PropertyReviewType;
(function (PropertyReviewType) {
  /** filter reviews by rating <= 2 */
  PropertyReviewType["CRITICAL"] = "CRITICAL";
  /** filter reviews by rating >= 3 */
  PropertyReviewType["POSITIVE"] = "POSITIVE";
  /** filter reviews by latest date */
  PropertyReviewType["RECENT"] = "RECENT";
})(PropertyReviewType || (PropertyReviewType = {}));
export var PropertySearchOptions;
(function (PropertySearchOptions) {
  /** Deprecated: Use PropertyShopOptions.listings */
  PropertySearchOptions["ADS_ONLY"] = "ADS_ONLY";
  /** Deprecated: Use PropertyShopOptions.points */
  PropertySearchOptions["SHOP_WITH_POINTS"] = "SHOP_WITH_POINTS";
})(PropertySearchOptions || (PropertySearchOptions = {}));
export var PropertySectionRef;
(function (PropertySectionRef) {
  /** @deprecated Replace with PropertyContentSectionRef.AVAILABILITY_CALENDAR_START_DATE */
  PropertySectionRef["AVAILABILITY_CALENDAR_START_DATE"] = "AVAILABILITY_CALENDAR_START_DATE";
  /** @deprecated Replace with PropertyContentSectionRef.PRICE_DISPLAY_SERVICE_RESPONSE */
  PropertySectionRef["PRICE_DISPLAY_SERVICE_RESPONSE"] = "PRICE_DISPLAY_SERVICE_RESPONSE";
  /** @deprecated Replace with PropertyContentSectionRef.RECOMMENDED_OFFER */
  PropertySectionRef["RECOMMENDED_OFFER"] = "RECOMMENDED_OFFER";
  /** @deprecated Replace with PropertyContentSectionRef.ROOMS_AND_RATES */
  PropertySectionRef["ROOMS_AND_RATES"] = "ROOMS_AND_RATES";
})(PropertySectionRef || (PropertySectionRef = {}));
/** Hotel sort types */
export var PropertySort;
(function (PropertySort) {
  PropertySort["AARP_MEMBER_DISCOUNT"] = "AARP_MEMBER_DISCOUNT";
  PropertySort["BEST"] = "BEST";
  PropertySort["BEST_DEAL"] = "BEST_DEAL";
  PropertySort["BUDGET"] = "BUDGET";
  PropertySort["DEPARTURE_EARLY_TO_LATE"] = "DEPARTURE_EARLY_TO_LATE";
  PropertySort["DEPARTURE_LATE_TO_EARLY"] = "DEPARTURE_LATE_TO_EARLY";
  PropertySort["DISTANCE"] = "DISTANCE";
  PropertySort["DURATION_LONG_TO_SHORT"] = "DURATION_LONG_TO_SHORT";
  PropertySort["DURATION_SHORT_TO_LONG"] = "DURATION_SHORT_TO_LONG";
  PropertySort["LUXURY"] = "LUXURY";
  /** Deprecated: Hackathon 2022-07 */
  PropertySort["MAXIMUM_SAVINGS"] = "MAXIMUM_SAVINGS";
  /** Deprecated: Hackathon 2022-07 */
  PropertySort["MAXIMUM_SAVINGS_PERCENT"] = "MAXIMUM_SAVINGS_PERCENT";
  PropertySort["MEMBER_PRICING"] = "MEMBER_PRICING";
  PropertySort["PACKAGE_SAVINGS"] = "PACKAGE_SAVINGS";
  PropertySort["PRICE_HIGH_TO_LOW"] = "PRICE_HIGH_TO_LOW";
  PropertySort["PRICE_LOW_TO_HIGH"] = "PRICE_LOW_TO_HIGH";
  PropertySort["PRICE_RELEVANT"] = "PRICE_RELEVANT";
  PropertySort["PROPERTY_CLASS"] = "PROPERTY_CLASS";
  PropertySort["PROPERTY_NAME"] = "PROPERTY_NAME";
  PropertySort["RECOMMENDED"] = "RECOMMENDED";
  PropertySort["REVIEW"] = "REVIEW";
  PropertySort["REVIEW_COUNT"] = "REVIEW_COUNT";
  /** tnl 49730 reverted to control */
  PropertySort["REVIEW_PRICE"] = "REVIEW_PRICE";
  PropertySort["REVIEW_RELEVANT"] = "REVIEW_RELEVANT";
  PropertySort["VACATION_RENTAL"] = "VACATION_RENTAL";
})(PropertySort || (PropertySort = {}));
export var PropertyStyle;
(function (PropertyStyle) {
  /** Deprecated: TnL 37054 - AFFINITY_FILTERS_APPLIED_ON_HSR */
  PropertyStyle["BOUTIQUE"] = "BOUTIQUE";
  PropertyStyle["HOMES"] = "HOMES";
  PropertyStyle["HOTELS"] = "HOTELS";
  /** Deprecated: TnL 37054 - AFFINITY_FILTERS_APPLIED_ON_HSR */
  PropertyStyle["LGBT"] = "LGBT";
  PropertyStyle["LUXURY"] = "LUXURY";
  PropertyStyle["OUTDOOR"] = "OUTDOOR";
  PropertyStyle["UNIQUE"] = "UNIQUE";
})(PropertyStyle || (PropertyStyle = {}));
export var PropertyTypesOffersView;
(function (PropertyTypesOffersView) {
  PropertyTypesOffersView["FULL_BLEED"] = "FULL_BLEED";
  PropertyTypesOffersView["IMAGE_GALLERY"] = "IMAGE_GALLERY";
})(PropertyTypesOffersView || (PropertyTypesOffersView = {}));
export var QuestionSortType;
(function (QuestionSortType) {
  QuestionSortType["NEWEST_TO_OLDEST"] = "NEWEST_TO_OLDEST";
  QuestionSortType["OLDEST_TO_NEWEST"] = "OLDEST_TO_NEWEST";
})(QuestionSortType || (QuestionSortType = {}));
export var QuoteBuilderType;
(function (QuoteBuilderType) {
  QuoteBuilderType["BOTTOM"] = "BOTTOM";
  QuoteBuilderType["RIGHT_SIDE"] = "RIGHT_SIDE";
  QuoteBuilderType["SIDE"] = "SIDE";
})(QuoteBuilderType || (QuoteBuilderType = {}));
export var RadialProgressionBarType;
(function (RadialProgressionBarType) {
  RadialProgressionBarType["FULL"] = "FULL";
  RadialProgressionBarType["SEGMENTED"] = "SEGMENTED";
})(RadialProgressionBarType || (RadialProgressionBarType = {}));
export var RangeIndicatorSegmentStyle;
(function (RangeIndicatorSegmentStyle) {
  RangeIndicatorSegmentStyle["EMPHASIS"] = "EMPHASIS";
})(RangeIndicatorSegmentStyle || (RangeIndicatorSegmentStyle = {}));
export var RangeIndicatorSegmentTheme;
(function (RangeIndicatorSegmentTheme) {
  RangeIndicatorSegmentTheme["NEGATIVE"] = "NEGATIVE";
  RangeIndicatorSegmentTheme["NEUTRAL"] = "NEUTRAL";
  RangeIndicatorSegmentTheme["POSITIVE"] = "POSITIVE";
  RangeIndicatorSegmentTheme["VERY_POSITIVE"] = "VERY_POSITIVE";
})(RangeIndicatorSegmentTheme || (RangeIndicatorSegmentTheme = {}));
export var RateAdjustmentType;
(function (RateAdjustmentType) {
  RateAdjustmentType["AMOUNT"] = "Amount";
  RateAdjustmentType["PERCENT"] = "Percent";
})(RateAdjustmentType || (RateAdjustmentType = {}));
export var RateDiscountType;
(function (RateDiscountType) {
  RateDiscountType["MEMBER_DEAL"] = "MEMBER_DEAL";
  RateDiscountType["MOBILE_EXCLUSIVE"] = "MOBILE_EXCLUSIVE";
  RateDiscountType["REGULAR"] = "REGULAR";
  RateDiscountType["TONIGHT_ONLY"] = "TONIGHT_ONLY";
})(RateDiscountType || (RateDiscountType = {}));
export var RatePlanType;
(function (RatePlanType) {
  RatePlanType["CORPORATE"] = "CORPORATE";
  RatePlanType["PACKAGE"] = "PACKAGE";
  RatePlanType["STANDALONE"] = "STANDALONE";
  RatePlanType["WHOLESALE"] = "WHOLESALE";
  RatePlanType["WHOLESALE_PACKAGE"] = "WHOLESALE_PACKAGE";
})(RatePlanType || (RatePlanType = {}));
export var ReasonCategory;
(function (ReasonCategory) {
  ReasonCategory["ACCOUNT_UPDATE"] = "ACCOUNT_UPDATE";
  ReasonCategory["CANCEL"] = "CANCEL";
  ReasonCategory["CANCEL_OPAQUE"] = "CANCEL_OPAQUE";
  ReasonCategory["CHANGE"] = "CHANGE";
  ReasonCategory["CHARGE"] = "CHARGE";
  ReasonCategory["FINANCIAL_ADJUSTMENT"] = "FINANCIAL_ADJUSTMENT";
  ReasonCategory["POINTS_ADJUSTMENT"] = "POINTS_ADJUSTMENT";
  ReasonCategory["PRICE_MATCH"] = "PRICE_MATCH";
})(ReasonCategory || (ReasonCategory = {}));
export var RecaptureSheetType;
(function (RecaptureSheetType) {
  RecaptureSheetType["REASON_SHEET"] = "REASON_SHEET";
  RecaptureSheetType["SUCCESS_SHEET"] = "SUCCESS_SHEET";
})(RecaptureSheetType || (RecaptureSheetType = {}));
export var RecentActivityType;
(function (RecentActivityType) {
  RecentActivityType["BROWSING_HISTORY"] = "BROWSING_HISTORY";
  RecentActivityType["RECENT_SEARCHES"] = "RECENT_SEARCHES";
  RecentActivityType["VIEWED_OFFERS"] = "VIEWED_OFFERS";
  RecentActivityType["VIEWED_PRODUCTS"] = "VIEWED_PRODUCTS";
})(RecentActivityType || (RecentActivityType = {}));
export var RecommendedType;
(function (RecommendedType) {
  RecommendedType["BESPOKE"] = "BESPOKE";
  RecommendedType["DESTINATIONS"] = "DESTINATIONS";
  RecommendedType["OFFERS"] = "OFFERS";
})(RecommendedType || (RecommendedType = {}));
export var RefreshAction;
(function (RefreshAction) {
  RefreshAction["LOGOUT"] = "LOGOUT";
  RefreshAction["NONE"] = "NONE";
})(RefreshAction || (RefreshAction = {}));
export var RefundMode;
(function (RefundMode) {
  RefundMode["FTC"] = "FTC";
  RefundMode["NO_VALUE"] = "NO_VALUE";
  RefundMode["REFUND"] = "REFUND";
})(RefundMode || (RefundMode = {}));
export var RefundStatus;
(function (RefundStatus) {
  RefundStatus["FAILURE"] = "Failure";
  RefundStatus["SUCCESS"] = "Success";
})(RefundStatus || (RefundStatus = {}));
export var RefundableType;
(function (RefundableType) {
  RefundableType["FULLY"] = "FULLY";
  RefundableType["NON"] = "NON";
  RefundableType["PARTIALLY"] = "PARTIALLY";
  RefundableType["UNKNOWN"] = "UNKNOWN";
})(RefundableType || (RefundableType = {}));
/** Enumerated Gaia geographic region types */
export var RegionType;
(function (RegionType) {
  RegionType["ADDRESS"] = "ADDRESS";
  RegionType["AIRPORT"] = "AIRPORT";
  RegionType["CITY"] = "CITY";
  RegionType["CONTINENT"] = "CONTINENT";
  RegionType["COUNTRY"] = "COUNTRY";
  RegionType["HIGH_LEVEL_REGION"] = "HIGH_LEVEL_REGION";
  RegionType["METRO_STATION"] = "METRO_STATION";
  RegionType["MULTI_CITY_VICINITY"] = "MULTI_CITY_VICINITY";
  RegionType["NEIGHBORHOOD"] = "NEIGHBORHOOD";
  RegionType["POINT_OF_INTEREST"] = "POINT_OF_INTEREST";
  RegionType["PREMISE"] = "PREMISE";
  RegionType["PROVINCE_STATE"] = "PROVINCE_STATE";
  RegionType["TRAIN_STATION"] = "TRAIN_STATION";
  RegionType["UNKNOWN"] = "UNKNOWN";
})(RegionType || (RegionType = {}));
export var RequestSourceInput;
(function (RequestSourceInput) {
  RequestSourceInput["IMPROVE_VISIBILITY_OPPORTUNITY_CARD"] = "IMPROVE_VISIBILITY_OPPORTUNITY_CARD";
})(RequestSourceInput || (RequestSourceInput = {}));
export var ReservationModifiersCancellationFeeOptionType;
(function (ReservationModifiersCancellationFeeOptionType) {
  ReservationModifiersCancellationFeeOptionType["CUSTOM_FEE"] = "CUSTOM_FEE";
  ReservationModifiersCancellationFeeOptionType["FULL_FEE"] = "FULL_FEE";
  ReservationModifiersCancellationFeeOptionType["NO_FEE"] = "NO_FEE";
})(ReservationModifiersCancellationFeeOptionType || (ReservationModifiersCancellationFeeOptionType = {}));
export var ReservationModifiersRefundAmountOptionType;
(function (ReservationModifiersRefundAmountOptionType) {
  ReservationModifiersRefundAmountOptionType["CUSTOM_AMOUNT"] = "CUSTOM_AMOUNT";
  ReservationModifiersRefundAmountOptionType["PERCENTAGE_AMOUNT"] = "PERCENTAGE_AMOUNT";
})(ReservationModifiersRefundAmountOptionType || (ReservationModifiersRefundAmountOptionType = {}));
export var ReservationModifiersScreenType;
(function (ReservationModifiersScreenType) {
  ReservationModifiersScreenType["CONFIRM_DETAILS"] = "CONFIRM_DETAILS";
  ReservationModifiersScreenType["EMPATHY"] = "EMPATHY";
  ReservationModifiersScreenType["LINK_TO_LEGACY"] = "LINK_TO_LEGACY";
  ReservationModifiersScreenType["MENU"] = "MENU";
  ReservationModifiersScreenType["REVIEW_CHANGES"] = "REVIEW_CHANGES";
  ReservationModifiersScreenType["REVIEW_DETAILS_CHANGES"] = "REVIEW_DETAILS_CHANGES";
  ReservationModifiersScreenType["REVIEW_TERMS"] = "REVIEW_TERMS";
  ReservationModifiersScreenType["SET_CANCELLATION_FEE"] = "SET_CANCELLATION_FEE";
  ReservationModifiersScreenType["SET_CANCELLATION_REASON"] = "SET_CANCELLATION_REASON";
  ReservationModifiersScreenType["SET_MESSAGE_TO_GUEST"] = "SET_MESSAGE_TO_GUEST";
  ReservationModifiersScreenType["SET_REFUND_AMOUNT"] = "SET_REFUND_AMOUNT";
  ReservationModifiersScreenType["SET_REFUND_REASON"] = "SET_REFUND_REASON";
  ReservationModifiersScreenType["SET_RESERVATION_DETAILS"] = "SET_RESERVATION_DETAILS";
  ReservationModifiersScreenType["SET_STAY_DATES"] = "SET_STAY_DATES";
  ReservationModifiersScreenType["SUCCESS"] = "SUCCESS";
  ReservationModifiersScreenType["VR_SET_REFUND_AMOUNT"] = "VR_SET_REFUND_AMOUNT";
})(ReservationModifiersScreenType || (ReservationModifiersScreenType = {}));
export var ReservationModifiersType;
(function (ReservationModifiersType) {
  ReservationModifiersType["CANCEL"] = "CANCEL";
  ReservationModifiersType["CHANGE_DATES"] = "CHANGE_DATES";
  ReservationModifiersType["GUEST_SATISFACTION_REFUND"] = "GUEST_SATISFACTION_REFUND";
  ReservationModifiersType["NO_SHOW"] = "NO_SHOW";
  ReservationModifiersType["UPDATE_DETAILS"] = "UPDATE_DETAILS";
})(ReservationModifiersType || (ReservationModifiersType = {}));
export var ReservationModifiersVrCancelRefundLevel;
(function (ReservationModifiersVrCancelRefundLevel) {
  ReservationModifiersVrCancelRefundLevel["FULL"] = "FULL";
  ReservationModifiersVrCancelRefundLevel["HALF"] = "HALF";
  ReservationModifiersVrCancelRefundLevel["ZERO"] = "ZERO";
})(ReservationModifiersVrCancelRefundLevel || (ReservationModifiersVrCancelRefundLevel = {}));
export var ResidencyState;
(function (ResidencyState) {
  ResidencyState["APPLIED"] = "APPLIED";
  ResidencyState["AVAILABLE"] = "AVAILABLE";
})(ResidencyState || (ResidencyState = {}));
export var ResponseStatus;
(function (ResponseStatus) {
  ResponseStatus["ERROR"] = "ERROR";
  ResponseStatus["SUCCESS"] = "SUCCESS";
})(ResponseStatus || (ResponseStatus = {}));
/** Tags Associated with the response */
export var ResponseTagType;
(function (ResponseTagType) {
  ResponseTagType["CACHE_SOURCE_AIRBLAZE"] = "CACHE_SOURCE_AIRBLAZE";
  ResponseTagType["CACHE_SOURCE_BYOT_AIRBLAZE"] = "CACHE_SOURCE_BYOT_AIRBLAZE";
  ResponseTagType["EXPERIENCE_SEARCH_CACHE_HYDRATOR"] = "EXPERIENCE_SEARCH_CACHE_HYDRATOR";
  ResponseTagType["LISTINGS_PAGINATED_SLICED"] = "LISTINGS_PAGINATED_SLICED";
  ResponseTagType["LISTING_CACHE_SOURCE"] = "LISTING_CACHE_SOURCE";
  ResponseTagType["LISTING_DOWNLEVEL_SOURCE"] = "LISTING_DOWNLEVEL_SOURCE";
  ResponseTagType["MAIN_SEARCH_STACK"] = "MAIN_SEARCH_STACK";
  ResponseTagType["RESPONSE_SUMMARY_CACHED_CONFIG"] = "RESPONSE_SUMMARY_CACHED_CONFIG";
  ResponseTagType["RESPONSE_SUMMARY_CACHED_ML"] = "RESPONSE_SUMMARY_CACHED_ML";
  ResponseTagType["RESPONSE_SUMMARY_HYBRID"] = "RESPONSE_SUMMARY_HYBRID";
  ResponseTagType["RESPONSE_SUMMARY_LIVE"] = "RESPONSE_SUMMARY_LIVE";
  ResponseTagType["RESPONSE_SUMMARY_REFINEMENTS_CACHE_LIVE"] = "RESPONSE_SUMMARY_REFINEMENTS_CACHE_LIVE";
  ResponseTagType["RESPONSE_SUMMARY_REFINEMENTS_CACHE_REDIS"] = "RESPONSE_SUMMARY_REFINEMENTS_CACHE_REDIS";
  ResponseTagType["RESPONSE_SUMMARY_REFINEMENTS_USER_CACHE"] = "RESPONSE_SUMMARY_REFINEMENTS_USER_CACHE";
  ResponseTagType["TEST_SEARCH_STACK"] = "TEST_SEARCH_STACK";
  ResponseTagType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ResponseTagType || (ResponseTagType = {}));
export var Result;
(function (Result) {
  Result["ERROR"] = "ERROR";
  Result["SUCCESS"] = "SUCCESS";
})(Result || (Result = {}));
/** Enum of types of review interactions */
export var ReviewInteractionType;
(function (ReviewInteractionType) {
  ReviewInteractionType["HELPFUL_REVIEW"] = "HELPFUL_REVIEW";
  ReviewInteractionType["REVIEW_COLLAPSE_LABEL"] = "REVIEW_COLLAPSE_LABEL";
  ReviewInteractionType["REVIEW_EXPAND_LABEL"] = "REVIEW_EXPAND_LABEL";
  ReviewInteractionType["REVIEW_REPORT_FLAG"] = "REVIEW_REPORT_FLAG";
})(ReviewInteractionType || (ReviewInteractionType = {}));
export var ReviewSource;
(function (ReviewSource) {
  ReviewSource["EXTERNAL_REVIEWS"] = "EXTERNAL_REVIEWS";
  ReviewSource["INTERNAL_REVIEWS"] = "INTERNAL_REVIEWS";
})(ReviewSource || (ReviewSource = {}));
export var ReviewsCarouselCtaLocation;
(function (ReviewsCarouselCtaLocation) {
  ReviewsCarouselCtaLocation["TRIPS_PAGE"] = "TRIPS_PAGE";
  ReviewsCarouselCtaLocation["UNKNOWN"] = "UNKNOWN";
})(ReviewsCarouselCtaLocation || (ReviewsCarouselCtaLocation = {}));
export var RewardsOption;
(function (RewardsOption) {
  RewardsOption["ALTAIR"] = "ALTAIR";
  RewardsOption["AVION"] = "AVION";
  RewardsOption["NONAVION"] = "NONAVION";
})(RewardsOption || (RewardsOption = {}));
export var RewardsPointSelectionEnum;
(function (RewardsPointSelectionEnum) {
  RewardsPointSelectionEnum["APPLY_REWARD_POINTS"] = "APPLY_REWARD_POINTS";
  RewardsPointSelectionEnum["DO_NOT_APPLY_REWARD_POINTS"] = "DO_NOT_APPLY_REWARD_POINTS";
})(RewardsPointSelectionEnum || (RewardsPointSelectionEnum = {}));
/** Possible user's state regarding the loyalty program */
export var RewardsProgramState;
(function (RewardsProgramState) {
  RewardsProgramState["ENROLLED"] = "ENROLLED";
  RewardsProgramState["NOT_ENROLLED"] = "NOT_ENROLLED";
})(RewardsProgramState || (RewardsProgramState = {}));
export var RouteType;
(function (RouteType) {
  RouteType["MULTI_DESTINATION"] = "MULTI_DESTINATION";
  RouteType["ONE_WAY"] = "ONE_WAY";
  RouteType["ROUND_TRIP"] = "ROUND_TRIP";
})(RouteType || (RouteType = {}));
export var Scenario;
(function (Scenario) {
  Scenario["AUTHENTICATED"] = "AUTHENTICATED";
  Scenario["CHANGE_EMAIL"] = "CHANGE_EMAIL";
  Scenario["CHANGE_PASSWORD"] = "CHANGE_PASSWORD";
  Scenario["CHECKOUT_SIGNIN"] = "CHECKOUT_SIGNIN";
  Scenario["CHECKOUT_SIGNUP"] = "CHECKOUT_SIGNUP";
  Scenario["PROFILE"] = "PROFILE";
  Scenario["SIGNIN"] = "SIGNIN";
  Scenario["SIGNUP"] = "SIGNUP";
})(Scenario || (Scenario = {}));
export var ScreenType;
(function (ScreenType) {
  ScreenType["ADJUSTMENT"] = "ADJUSTMENT";
  ScreenType["CANCEL"] = "CANCEL";
  ScreenType["REVIEW"] = "REVIEW";
})(ScreenType || (ScreenType = {}));
/** Search form product types */
export var SearchFormProductType;
(function (SearchFormProductType) {
  SearchFormProductType["ACTIVITIES"] = "ACTIVITIES";
  SearchFormProductType["ALL_INCLUSIVE"] = "ALL_INCLUSIVE";
  SearchFormProductType["CARS"] = "CARS";
  SearchFormProductType["CRUISES"] = "CRUISES";
  SearchFormProductType["EVENTS"] = "EVENTS";
  SearchFormProductType["FLIGHTS"] = "FLIGHTS";
  SearchFormProductType["LODGING"] = "LODGING";
  SearchFormProductType["PACKAGES"] = "PACKAGES";
})(SearchFormProductType || (SearchFormProductType = {}));
/** Search history grouping day range. */
export var SearchHistoryDayRange;
(function (SearchHistoryDayRange) {
  /** Grouping using searches made 7 days from most recent search in same region */
  SearchHistoryDayRange["SEVEN_DAYS"] = "SEVEN_DAYS";
  /** Grouping using searches made 3 days from most recent search in same region */
  SearchHistoryDayRange["THREE_DAYS"] = "THREE_DAYS";
})(SearchHistoryDayRange || (SearchHistoryDayRange = {}));
/** Search history grouping destination type. */
export var SearchHistoryDestinationType;
(function (SearchHistoryDestinationType) {
  /** Grouping using multi_city_vicinity destination type for searches. */
  SearchHistoryDestinationType["METRO_CITY"] = "METRO_CITY";
})(SearchHistoryDestinationType || (SearchHistoryDestinationType = {}));
/** Used to represent the response status of the search location actions */
export var SearchLocationActionStatus;
(function (SearchLocationActionStatus) {
  SearchLocationActionStatus["FAIL"] = "FAIL";
  SearchLocationActionStatus["SUCCESS"] = "SUCCESS";
})(SearchLocationActionStatus || (SearchLocationActionStatus = {}));
/**
 * Enum to represent the different source services of search location
 * in order to display/provide proper attribution
 */
export var SearchLocationSource;
(function (SearchLocationSource) {
  SearchLocationSource["EGTYPEAHEAD"] = "EGTYPEAHEAD";
  SearchLocationSource["GOOGLE"] = "GOOGLE";
  SearchLocationSource["RECOMMENDATIONS"] = "RECOMMENDATIONS";
})(SearchLocationSource || (SearchLocationSource = {}));
/** Enum class to represent the type of seat choice */
export var SeatChoiceType;
(function (SeatChoiceType) {
  SeatChoiceType["SEAT_CHOICE"] = "SEAT_CHOICE";
})(SeatChoiceType || (SeatChoiceType = {}));
/** Enum class to represent the seat type variant. */
export var SeatVariant;
(function (SeatVariant) {
  SeatVariant["ACCESSIBLE"] = "ACCESSIBLE";
  SeatVariant["AISLE"] = "AISLE";
  SeatVariant["AVAILABLE"] = "AVAILABLE";
  SeatVariant["COLUMN"] = "COLUMN";
  SeatVariant["EXIT"] = "EXIT";
  SeatVariant["GALLEY"] = "GALLEY";
  SeatVariant["PREFERRED"] = "PREFERRED";
  SeatVariant["RESTROOM"] = "RESTROOM";
  SeatVariant["ROW"] = "ROW";
  SeatVariant["SELECTED"] = "SELECTED";
  SeatVariant["UNAVAILABLE"] = "UNAVAILABLE";
})(SeatVariant || (SeatVariant = {}));
export var SectionType;
(function (SectionType) {
  SectionType["ORDERED_LIST"] = "ORDERED_LIST";
  SectionType["PARAGRAPH"] = "PARAGRAPH";
  SectionType["UNORDERED_LIST"] = "UNORDERED_LIST";
})(SectionType || (SectionType = {}));
/** Type for Selected Baggage template */
export var SelectedAncillaryTemplateType;
(function (SelectedAncillaryTemplateType) {
  SelectedAncillaryTemplateType["MULTIPLE"] = "MULTIPLE";
  SelectedAncillaryTemplateType["NONE"] = "NONE";
  SelectedAncillaryTemplateType["ONE"] = "ONE";
})(SelectedAncillaryTemplateType || (SelectedAncillaryTemplateType = {}));
export var ServiceActionType;
(function (ServiceActionType) {
  ServiceActionType["CONNECT"] = "CONNECT";
  ServiceActionType["DISCONNECT"] = "DISCONNECT";
})(ServiceActionType || (ServiceActionType = {}));
export var ServiceAutomationToolbarElevation;
(function (ServiceAutomationToolbarElevation) {
  ServiceAutomationToolbarElevation["FLAT"] = "FLAT";
  ServiceAutomationToolbarElevation["FLOATING"] = "FLOATING";
})(ServiceAutomationToolbarElevation || (ServiceAutomationToolbarElevation = {}));
export var ServiceAutomationToolbarNavType;
(function (ServiceAutomationToolbarNavType) {
  ServiceAutomationToolbarNavType["BACK"] = "BACK";
  ServiceAutomationToolbarNavType["CLOSE"] = "CLOSE";
  ServiceAutomationToolbarNavType["EXPAND_UP"] = "EXPAND_UP";
})(ServiceAutomationToolbarNavType || (ServiceAutomationToolbarNavType = {}));
export var ShareType;
(function (ShareType) {
  ShareType["REGULAR"] = "REGULAR";
  ShareType["SCREENSHOT"] = "SCREENSHOT";
})(ShareType || (ShareType = {}));
export var SharedUiCardMode;
(function (SharedUiCardMode) {
  SharedUiCardMode["CREATE"] = "CREATE";
  SharedUiCardMode["EDIT"] = "EDIT";
  SharedUiCardMode["READ"] = "READ";
})(SharedUiCardMode || (SharedUiCardMode = {}));
export var SharedUiCardType;
(function (SharedUiCardType) {
  SharedUiCardType["PARTNER_ACCOUNT"] = "PARTNER_ACCOUNT";
  SharedUiCardType["PARTNER_SELECT"] = "PARTNER_SELECT";
  SharedUiCardType["PAYMENT_PROFILE"] = "PAYMENT_PROFILE";
  SharedUiCardType["TAX_PROFILE"] = "TAX_PROFILE";
})(SharedUiCardType || (SharedUiCardType = {}));
/** SheetState represent sheet state like expanded/collapsed */
export var SheetState;
(function (SheetState) {
  SheetState["COLLAPSED"] = "COLLAPSED";
  SheetState["FULL"] = "FULL";
  SheetState["HALF"] = "HALF";
})(SheetState || (SheetState = {}));
/** An enum to represent the style of button */
export var ShoppingButtonType;
(function (ShoppingButtonType) {
  ShoppingButtonType["PRIMARY"] = "PRIMARY";
  ShoppingButtonType["SECONDARY"] = "SECONDARY";
  ShoppingButtonType["TERTIARY"] = "TERTIARY";
})(ShoppingButtonType || (ShoppingButtonType = {}));
export var ShoppingCoachmarkVersion;
(function (ShoppingCoachmarkVersion) {
  ShoppingCoachmarkVersion["V2"] = "V2";
  ShoppingCoachmarkVersion["V3"] = "V3";
})(ShoppingCoachmarkVersion || (ShoppingCoachmarkVersion = {}));
/** An enum to represent shopping function type */
export var ShoppingFunctionType;
(function (ShoppingFunctionType) {
  ShoppingFunctionType["CALLBACK"] = "CALLBACK";
  ShoppingFunctionType["SHARED_UI"] = "SHARED_UI";
})(ShoppingFunctionType || (ShoppingFunctionType = {}));
export var ShoppingPage;
(function (ShoppingPage) {
  ShoppingPage["PDP"] = "PDP";
  ShoppingPage["SRP"] = "SRP";
})(ShoppingPage || (ShoppingPage = {}));
/** Indicate the shopping path of a given offer */
export var ShoppingPathType;
(function (ShoppingPathType) {
  ShoppingPathType["ATTACH"] = "ATTACH";
  ShoppingPathType["PACKAGE"] = "PACKAGE";
  ShoppingPathType["STANDALONE"] = "STANDALONE";
})(ShoppingPathType || (ShoppingPathType = {}));
export var ShoppingPlacementType;
(function (ShoppingPlacementType) {
  ShoppingPlacementType["BOTTOM"] = "BOTTOM";
  ShoppingPlacementType["RIGHT"] = "RIGHT";
})(ShoppingPlacementType || (ShoppingPlacementType = {}));
export var ShoppingSelectableCardState;
(function (ShoppingSelectableCardState) {
  ShoppingSelectableCardState["DISABLED"] = "DISABLED";
  ShoppingSelectableCardState["SELECTED"] = "SELECTED";
  ShoppingSelectableCardState["UNSELECTED"] = "UNSELECTED";
})(ShoppingSelectableCardState || (ShoppingSelectableCardState = {}));
/** Valid actions on Sort and Filter Modal */
export var ShoppingSortAndFilterActionType;
(function (ShoppingSortAndFilterActionType) {
  /** Stay on the Sort & Filter Modal but set to default state. Eg used for clear button */
  ShoppingSortAndFilterActionType["CLEAR_DATA"] = "CLEAR_DATA";
  /** Close Sort & Filter Modal and apply user selected filters. Eg used for Apply/Done buttons */
  ShoppingSortAndFilterActionType["CLOSE_AND_APPLY"] = "CLOSE_AND_APPLY";
  /** Close Sort & Filter Modal. Eg used for Back/Cross buttons */
  ShoppingSortAndFilterActionType["CLOSE_AND_DO_NOT_APPLY"] = "CLOSE_AND_DO_NOT_APPLY";
  /**
   * Open the modal window associated with the component on which action has been performed.
   * Example: on click of Sort & Filter reveal button it should open Sort & Filter Modal and
   * on click of Input Field it should open Typeahead Modal
   */
  ShoppingSortAndFilterActionType["OPEN_MODAL"] = "OPEN_MODAL";
})(ShoppingSortAndFilterActionType || (ShoppingSortAndFilterActionType = {}));
/** Type of Slider on Sort and Filter Modal */
export var ShoppingSortAndFilterSliderType;
(function (ShoppingSortAndFilterSliderType) {
  /** Dual Sort & Filter Slider, slider will be dual Ticked and both min & max value can be adjusted */
  ShoppingSortAndFilterSliderType["DUAL"] = "DUAL";
  /** Single Sort & Filter Slider, slider will be single Ticked and only max value can be adjusted */
  ShoppingSortAndFilterSliderType["SINGLE"] = "SINGLE";
})(ShoppingSortAndFilterSliderType || (ShoppingSortAndFilterSliderType = {}));
export var ShoppingTabsNavType;
(function (ShoppingTabsNavType) {
  ShoppingTabsNavType["JUMPLINK"] = "JUMPLINK";
  ShoppingTabsNavType["NATURAL"] = "NATURAL";
})(ShoppingTabsNavType || (ShoppingTabsNavType = {}));
/** ShoppingTriggerType specifies how an action should be triggered (click, hover, etc.) */
export var ShoppingTriggerType;
(function (ShoppingTriggerType) {
  ShoppingTriggerType["CLICK"] = "CLICK";
  ShoppingTriggerType["HOVER"] = "HOVER";
  ShoppingTriggerType["LOAD"] = "LOAD";
})(ShoppingTriggerType || (ShoppingTriggerType = {}));
export var SideSheetType;
(function (SideSheetType) {
  SideSheetType["BREAKFAST"] = "BREAKFAST";
  SideSheetType["CONTRACTUAL"] = "CONTRACTUAL";
  SideSheetType["NONREFUNDABLE"] = "NONREFUNDABLE";
  SideSheetType["PACKAGE"] = "PACKAGE";
  SideSheetType["REFUNDABLE"] = "REFUNDABLE";
})(SideSheetType || (SideSheetType = {}));
export var SignalType;
(function (SignalType) {
  SignalType["BOOKING_SUCCESS"] = "BOOKING_SUCCESS";
  SignalType["CONFIGURATION_ADDED"] = "CONFIGURATION_ADDED";
  SignalType["DUPLICATE_REQUEST"] = "DUPLICATE_REQUEST";
  SignalType["INVALID_EMAIL"] = "INVALID_EMAIL";
  SignalType["OFFER_ADDED"] = "OFFER_ADDED";
  SignalType["OFFER_CHANGED"] = "OFFER_CHANGED";
  SignalType["OFFER_REMOVED"] = "OFFER_REMOVED";
  SignalType["OFFER_UNAVAILABLE"] = "OFFER_UNAVAILABLE";
  SignalType["OPERATION_FAILED"] = "OPERATION_FAILED";
  SignalType["PAYMENT_ERROR"] = "PAYMENT_ERROR";
  SignalType["PAYMENT_METHODS_APPLIED"] = "PAYMENT_METHODS_APPLIED";
  SignalType["PAYMENT_METHOD_UPDATED"] = "PAYMENT_METHOD_UPDATED";
  SignalType["PRICE_ADJUSTED"] = "PRICE_ADJUSTED";
  SignalType["PRICE_CHANGED"] = "PRICE_CHANGED";
  SignalType["REQUEST_CONFLICT"] = "REQUEST_CONFLICT";
  SignalType["SESSION_EXPIRED"] = "SESSION_EXPIRED";
  SignalType["SESSION_TOKEN_UPDATED"] = "SESSION_TOKEN_UPDATED";
  SignalType["SIGNAL_TYPE_INVALID"] = "SIGNAL_TYPE_INVALID";
  SignalType["UNRECOGNIZED"] = "UNRECOGNIZED";
  SignalType["UNRECOVERABLE_FAILURE"] = "UNRECOVERABLE_FAILURE";
})(SignalType || (SignalType = {}));
export var SmartFormHeadingSizeInput;
(function (SmartFormHeadingSizeInput) {
  SmartFormHeadingSizeInput["EIGHT"] = "EIGHT";
  SmartFormHeadingSizeInput["FIVE"] = "FIVE";
  SmartFormHeadingSizeInput["FOUR"] = "FOUR";
  SmartFormHeadingSizeInput["ONE"] = "ONE";
  SmartFormHeadingSizeInput["SEVEN"] = "SEVEN";
  SmartFormHeadingSizeInput["SIX"] = "SIX";
  SmartFormHeadingSizeInput["THREE"] = "THREE";
  SmartFormHeadingSizeInput["TWO"] = "TWO";
})(SmartFormHeadingSizeInput || (SmartFormHeadingSizeInput = {}));
export var SmartFormHeadingTagInput;
(function (SmartFormHeadingTagInput) {
  SmartFormHeadingTagInput["H1"] = "H1";
  SmartFormHeadingTagInput["H2"] = "H2";
  SmartFormHeadingTagInput["H3"] = "H3";
  SmartFormHeadingTagInput["H4"] = "H4";
  SmartFormHeadingTagInput["H5"] = "H5";
  SmartFormHeadingTagInput["H6"] = "H6";
})(SmartFormHeadingTagInput || (SmartFormHeadingTagInput = {}));
/** To define which type of keystrokes will be considered by this input. */
export var SmartFormTextInputVariant;
(function (SmartFormTextInputVariant) {
  SmartFormTextInputVariant["EMAIL"] = "EMAIL";
  SmartFormTextInputVariant["NUMERIC"] = "NUMERIC";
  SmartFormTextInputVariant["TEL"] = "TEL";
  SmartFormTextInputVariant["TEXT"] = "TEXT";
  SmartFormTextInputVariant["TEXTAREA"] = "TEXTAREA";
})(SmartFormTextInputVariant || (SmartFormTextInputVariant = {}));
export var SmartFormType;
(function (SmartFormType) {
  SmartFormType["BILLING_ADDRESS"] = "BILLING_ADDRESS";
  SmartFormType["CONTACT_INFORMATION"] = "CONTACT_INFORMATION";
  SmartFormType["SPECIAL_REQUEST"] = "SPECIAL_REQUEST";
})(SmartFormType || (SmartFormType = {}));
export var SocialConnectionsManageConnectionRequestType;
(function (SocialConnectionsManageConnectionRequestType) {
  SocialConnectionsManageConnectionRequestType["ACCEPT"] = "ACCEPT";
  SocialConnectionsManageConnectionRequestType["REJECT"] = "REJECT";
  SocialConnectionsManageConnectionRequestType["REMOVE"] = "REMOVE";
  SocialConnectionsManageConnectionRequestType["REQUEST"] = "REQUEST";
})(SocialConnectionsManageConnectionRequestType || (SocialConnectionsManageConnectionRequestType = {}));
export var SocialInteractionPostType;
(function (SocialInteractionPostType) {
  SocialInteractionPostType["VIDEO"] = "VIDEO";
})(SocialInteractionPostType || (SocialInteractionPostType = {}));
export var SocialShareStrategy;
(function (SocialShareStrategy) {
  SocialShareStrategy["ACTIVITY"] = "ACTIVITY";
  SocialShareStrategy["FLIGHT"] = "FLIGHT";
  SocialShareStrategy["FLIGHT_SEARCH"] = "FLIGHT_SEARCH";
  SocialShareStrategy["PACKAGE_DETAILS"] = "PACKAGE_DETAILS";
  SocialShareStrategy["PROPERTY"] = "PROPERTY";
  SocialShareStrategy["PROPERTY_SEARCH"] = "PROPERTY_SEARCH";
  SocialShareStrategy["REQUEST_TO_JOIN_TRIP"] = "REQUEST_TO_JOIN_TRIP";
  SocialShareStrategy["TRIP_INVITE"] = "TRIP_INVITE";
})(SocialShareStrategy || (SocialShareStrategy = {}));
/**
 * "
 * Type of operation to perform.
 */
export var SortAndFilterBasicFilterPayloadType;
(function (SortAndFilterBasicFilterPayloadType) {
  /** Check selected filter option */
  SortAndFilterBasicFilterPayloadType["OPTION"] = "OPTION";
  /** Remove selected filter */
  SortAndFilterBasicFilterPayloadType["REMOVE"] = "REMOVE";
})(SortAndFilterBasicFilterPayloadType || (SortAndFilterBasicFilterPayloadType = {}));
/** Specifies when a signal should be emitted */
export var SortAndFilterSignalCondition;
(function (SortAndFilterSignalCondition) {
  /** When a filter value changes from the default value to a non default value */
  SortAndFilterSignalCondition["DEFAULT_TO_NON_DEFAULT"] = "DEFAULT_TO_NON_DEFAULT";
  /** When a filter value changes from a non default value to the default value */
  SortAndFilterSignalCondition["NON_DEFAULT_TO_DEFAULT"] = "NON_DEFAULT_TO_DEFAULT";
  /** When a filter value changes from a non default value to a different non default value */
  SortAndFilterSignalCondition["NON_DEFAULT_TO_NON_DEFAULT"] = "NON_DEFAULT_TO_NON_DEFAULT";
  /** When a filter state changes from unselected to selected */
  SortAndFilterSignalCondition["SELECTED"] = "SELECTED";
  /** When a filter state changes from selected to unselected */
  SortAndFilterSignalCondition["UNSELECTED"] = "UNSELECTED";
})(SortAndFilterSignalCondition || (SortAndFilterSignalCondition = {}));
/** Contains the different views for Sort and Filters, where each of them is meant to be on a specific page section or viewport. */
export var SortAndFiltersViewType;
(function (SortAndFiltersViewType) {
  /**
   * Represent a view where it's displayed applied filters as removable pills.
   * Used for `SMALL` and `MEDIUM` viewport sizes, above the results in a Search Results Page.
   */
  SortAndFiltersViewType["APPLIED_FILTERS"] = "APPLIED_FILTERS";
  /**
   * Represent a view where it's only displayed a list of filters.
   * Used for `LARGE` and `EXTRA_LARGE` viewport sizes, in the left side of the results on a Search Results Page.
   */
  SortAndFiltersViewType["FILTERS"] = "FILTERS";
  /**
   * Represent a view where the list of filters are displayed as pills.
   * Used for all viewport sizes, on top of the results on a Search Results Page.
   */
  SortAndFiltersViewType["FILTERS_PILLS"] = "FILTERS_PILLS";
  /**
   * Represent a view where it displays a filter bar with an All Filters button.
   * Used for all viewport sizes, above the results in the Vrbex SRP split view template.
   */
  SortAndFiltersViewType["FILTER_BAR"] = "FILTER_BAR";
  /**
   * Represent a view where it displays a dialog with only `filters` sections, which are hidden and will be displayed (within a Dialog) once a trigger is clicked by the user.
   * Used for all viewport sizes, inside toolbars.
   */
  SortAndFiltersViewType["FILTER_DIALOG"] = "FILTER_DIALOG";
  /**
   * Represent a view where it's only displayed a list of sort fields, it usually contains a single section with a sort field.
   * Used for `LARGE` and `EXTRA_LARGE` viewport sizes, above the results in a Search Results Page.
   */
  SortAndFiltersViewType["SORT"] = "SORT";
  /**
   * Represent a view of a combined list of the `sort` and `filters` sections, which are hidden and will be displayed (within a Dialog) once a trigger is clicked by the user.
   * Used for `SMALL` and `MEDIUM` viewport sizes, above the results in a Search Results Page.
   */
  SortAndFiltersViewType["SORT_AND_FILTERS"] = "SORT_AND_FILTERS";
  /**
   * Represent a view where sort options are displayed as tabs with each tab displaying the sorted results based on the selected tab.
   * Used for all viewport sizes.
   */
  SortAndFiltersViewType["SORT_TABS"] = "SORT_TABS";
  /**
   * Represent a view where apply rewards is displayed as a toggle.
   * Used for `SMALL` and `MEDIUM` viewport sizes, above the results in a Search Results Page.
   */
  SortAndFiltersViewType["USE_REWARDS"] = "USE_REWARDS";
})(SortAndFiltersViewType || (SortAndFiltersViewType = {}));
export var SourceType;
(function (SourceType) {
  SourceType["ESR"] = "ESR";
  SourceType["GDS"] = "GDS";
})(SourceType || (SourceType = {}));
export var Spacing;
(function (Spacing) {
  Spacing["FOUR"] = "four";
  Spacing["HALF"] = "half";
  Spacing["ONE"] = "one";
  Spacing["SIX"] = "six";
  Spacing["SIXTEEN"] = "sixteen";
  Spacing["THREE"] = "three";
  Spacing["TWELVE"] = "twelve";
  Spacing["TWO"] = "two";
  Spacing["UNSET"] = "unset";
})(Spacing || (Spacing = {}));
export var SpacingOptions;
(function (SpacingOptions) {
  SpacingOptions["FOUR"] = "FOUR";
  SpacingOptions["HALF"] = "HALF";
  SpacingOptions["ONE"] = "ONE";
  SpacingOptions["SIX"] = "SIX";
  SpacingOptions["SIXTEEN"] = "SIXTEEN";
  SpacingOptions["THREE"] = "THREE";
  SpacingOptions["TWELVE"] = "TWELVE";
  SpacingOptions["TWO"] = "TWO";
  SpacingOptions["UNSET"] = "UNSET";
})(SpacingOptions || (SpacingOptions = {}));
/** Possible equipment requested by the customer */
export var SpecialEquipment;
(function (SpecialEquipment) {
  SpecialEquipment["ADDITIONAL_DRIVER"] = "ADDITIONAL_DRIVER";
  SpecialEquipment["BICYCLE_RACK"] = "BICYCLE_RACK";
  SpecialEquipment["BOOSTER_SEAT"] = "BOOSTER_SEAT";
  SpecialEquipment["INFANT_SEAT"] = "INFANT_SEAT";
  SpecialEquipment["LEFT_HAND_CONTROL"] = "LEFT_HAND_CONTROL";
  SpecialEquipment["LUGGAGE_RACK"] = "LUGGAGE_RACK";
  SpecialEquipment["NAV_SYSTEM"] = "NAV_SYSTEM";
  SpecialEquipment["RIGHT_HAND_CONTROL"] = "RIGHT_HAND_CONTROL";
  SpecialEquipment["ROAD_CONGESTION_PAYMENT_SCHEME"] = "ROAD_CONGESTION_PAYMENT_SCHEME";
  SpecialEquipment["SATELLITE_RADIO"] = "SATELLITE_RADIO";
  SpecialEquipment["SKI_RACK"] = "SKI_RACK";
  SpecialEquipment["SNOW_CHAINS"] = "SNOW_CHAINS";
  SpecialEquipment["SNOW_TIRES"] = "SNOW_TIRES";
  SpecialEquipment["TODDLER_SEAT"] = "TODDLER_SEAT";
  SpecialEquipment["TOLL_PAYMENT_TAG_PASS"] = "TOLL_PAYMENT_TAG_PASS";
  SpecialEquipment["TRAILER_HITCH"] = "TRAILER_HITCH";
  SpecialEquipment["WIFI_ACCESS"] = "WIFI_ACCESS";
  SpecialEquipment["WINTER_PACKAGE"] = "WINTER_PACKAGE";
})(SpecialEquipment || (SpecialEquipment = {}));
/** Location resolution by type */
export var SponsoredContentLocationResolver;
(function (SponsoredContentLocationResolver) {
  /** Gaia regionId. Ex. 178248 (Chicago (and vicinity)) */
  SponsoredContentLocationResolver["GAIA"] = "GAIA";
  /** Airport code. Ex. ORD (TLA code for Chicago O'Hare Airport) */
  SponsoredContentLocationResolver["TLA"] = "TLA";
})(SponsoredContentLocationResolver || (SponsoredContentLocationResolver = {}));
/** Location resolution by type */
export var SponsoredContentLocationResolverInput;
(function (SponsoredContentLocationResolverInput) {
  /** Gaia regionId. Ex. 178248 (Chicago (and vicinity)) */
  SponsoredContentLocationResolverInput["GAIA"] = "GAIA";
  /** Airport code. Ex. ORD (TLA code for Chicago O'Hare Airport) */
  SponsoredContentLocationResolverInput["TLA"] = "TLA";
})(SponsoredContentLocationResolverInput || (SponsoredContentLocationResolverInput = {}));
/** The type of the ad placement */
export var SponsoredContentProductType;
(function (SponsoredContentProductType) {
  SponsoredContentProductType["ALTERNATE_DESTINATIONS_CAROUSEL"] = "ALTERNATE_DESTINATIONS_CAROUSEL";
  SponsoredContentProductType["BRAND_RESULT_LISTING"] = "BRAND_RESULT_LISTING";
  SponsoredContentProductType["BRAND_RESULT_LISTING_CARS"] = "BRAND_RESULT_LISTING_CARS";
  SponsoredContentProductType["BRAND_RESULT_LISTING_CRUISES"] = "BRAND_RESULT_LISTING_CRUISES";
  SponsoredContentProductType["BRAND_RESULT_LISTING_FLIGHTS"] = "BRAND_RESULT_LISTING_FLIGHTS";
  SponsoredContentProductType["BRAND_RESULT_LISTING_LODGING"] = "BRAND_RESULT_LISTING_LODGING";
  SponsoredContentProductType["BRAND_RESULT_LISTING_LX"] = "BRAND_RESULT_LISTING_LX";
  SponsoredContentProductType["DESTINATION_EXPERIENCE"] = "DESTINATION_EXPERIENCE";
  SponsoredContentProductType["MULTI_LISTING_AD"] = "MULTI_LISTING_AD";
  SponsoredContentProductType["SPONSORED_PROPERTIES_CAROUSEL"] = "SPONSORED_PROPERTIES_CAROUSEL";
})(SponsoredContentProductType || (SponsoredContentProductType = {}));
export var StayType;
(function (StayType) {
  StayType["CONVENTIONAL"] = "CONVENTIONAL";
  StayType["VACATION_RENTALS"] = "VACATION_RENTALS";
})(StayType || (StayType = {}));
export var StepReviewInlineEditingSheetButtonType;
(function (StepReviewInlineEditingSheetButtonType) {
  StepReviewInlineEditingSheetButtonType["PRIMARY"] = "PRIMARY";
  StepReviewInlineEditingSheetButtonType["SECONDARY"] = "SECONDARY";
})(StepReviewInlineEditingSheetButtonType || (StepReviewInlineEditingSheetButtonType = {}));
export var Strategy;
(function (Strategy) {
  Strategy["CHEAPEST_PACKAGE_PRICE"] = "CHEAPEST_PACKAGE_PRICE";
})(Strategy || (Strategy = {}));
export var StrikeOutType;
(function (StrikeOutType) {
  StrikeOutType["ATTACH"] = "ATTACH";
  StrikeOutType["INVALID"] = "INVALID";
  StrikeOutType["LOYALTY"] = "LOYALTY";
  StrikeOutType["PACKAGE"] = "PACKAGE";
  StrikeOutType["PRICE_SURVEY"] = "PRICE_SURVEY";
  StrikeOutType["STANDALONE"] = "STANDALONE";
})(StrikeOutType || (StrikeOutType = {}));
export var StructureType;
(function (StructureType) {
  StructureType["AGRITOURISM"] = "AGRITOURISM";
  StructureType["ALL_INCLUSIVE"] = "ALL_INCLUSIVE";
  StructureType["APARTMENT"] = "APARTMENT";
  StructureType["APART_HOTEL"] = "APART_HOTEL";
  StructureType["BED_AND_BREAKFAST"] = "BED_AND_BREAKFAST";
  StructureType["CABIN"] = "CABIN";
  StructureType["CAPSULE_HOTEL"] = "CAPSULE_HOTEL";
  StructureType["CARAVAN_PARK"] = "CARAVAN_PARK";
  StructureType["CASTLE"] = "CASTLE";
  StructureType["CHALET"] = "CHALET";
  StructureType["CONDO"] = "CONDO";
  StructureType["CONDO_RESORT"] = "CONDO_RESORT";
  StructureType["COTTAGE"] = "COTTAGE";
  StructureType["COUNTRY_HOUSE"] = "COUNTRY_HOUSE";
  StructureType["CRUISE"] = "CRUISE";
  StructureType["ECO_HOTEL"] = "ECO_HOTEL";
  StructureType["GUEST_HOUSE"] = "GUEST_HOUSE";
  StructureType["HOLIDAY_PARK"] = "HOLIDAY_PARK";
  StructureType["HOSTAL"] = "HOSTAL";
  StructureType["HOSTEL"] = "HOSTEL";
  StructureType["HOTEL"] = "HOTEL";
  StructureType["HOTEL_RESORT"] = "HOTEL_RESORT";
  StructureType["HOUSE_BOAT"] = "HOUSE_BOAT";
  StructureType["INN"] = "INN";
  StructureType["LODGE"] = "LODGE";
  StructureType["LONGHOUSE"] = "LONGHOUSE";
  StructureType["MOBILE_HOME"] = "MOBILE_HOME";
  StructureType["MOTEL"] = "MOTEL";
  StructureType["OVERWATER"] = "OVERWATER";
  StructureType["PALACE"] = "PALACE";
  StructureType["PENSION"] = "PENSION";
  StructureType["POUSADA_BRAZIL"] = "POUSADA_BRAZIL";
  StructureType["POUSADA_PORTUGAL"] = "POUSADA_PORTUGAL";
  StructureType["RANCH"] = "RANCH";
  StructureType["RESIDENCE"] = "RESIDENCE";
  StructureType["RIAD"] = "RIAD";
  StructureType["RYOKAN"] = "RYOKAN";
  StructureType["SAFARI"] = "SAFARI";
  StructureType["SERVICED_APARTMENT"] = "SERVICED_APARTMENT";
  StructureType["TOWNHOUSE"] = "TOWNHOUSE";
  StructureType["TRADITIONAL_BUILDING"] = "TRADITIONAL_BUILDING";
  StructureType["TREE_HOUSE"] = "TREE_HOUSE";
  StructureType["UNKNOWN"] = "UNKNOWN";
  StructureType["VACATION_HOME"] = "VACATION_HOME";
  StructureType["VACATION_RENTAL"] = "VACATION_RENTAL";
  StructureType["VACATION_RENTALS"] = "VACATION_RENTALS";
  StructureType["VILLA"] = "VILLA";
  StructureType["VIP"] = "VIP";
})(StructureType || (StructureType = {}));
export var SupplyArchiveOperation;
(function (SupplyArchiveOperation) {
  SupplyArchiveOperation["ARCHIVE"] = "ARCHIVE";
  SupplyArchiveOperation["NONE"] = "NONE";
  SupplyArchiveOperation["UNARCHIVE"] = "UNARCHIVE";
})(SupplyArchiveOperation || (SupplyArchiveOperation = {}));
export var SupplyContentDescriptionSectionName;
(function (SupplyContentDescriptionSectionName) {
  SupplyContentDescriptionSectionName["ABOUT_YOU"] = "ABOUT_YOU";
  SupplyContentDescriptionSectionName["BATHROOMS_ADDITIONAL_INFO"] = "BATHROOMS_ADDITIONAL_INFO";
  SupplyContentDescriptionSectionName["BEDROOMS_ADDITIONAL_INFO"] = "BEDROOMS_ADDITIONAL_INFO";
  SupplyContentDescriptionSectionName["DESCRIPTION"] = "DESCRIPTION";
  SupplyContentDescriptionSectionName["HEADLINE"] = "HEADLINE";
  SupplyContentDescriptionSectionName["INTERIOR_SIZE"] = "INTERIOR_SIZE";
  SupplyContentDescriptionSectionName["MANUAL_TRANSLATION"] = "MANUAL_TRANSLATION";
  SupplyContentDescriptionSectionName["PROPERTY_ADDITIONAL_INFO"] = "PROPERTY_ADDITIONAL_INFO";
  SupplyContentDescriptionSectionName["PROPERTY_NAME"] = "PROPERTY_NAME";
  SupplyContentDescriptionSectionName["PROPERTY_TYPE"] = "PROPERTY_TYPE";
  SupplyContentDescriptionSectionName["SUITABILITY_AMENITY"] = "SUITABILITY_AMENITY";
  SupplyContentDescriptionSectionName["UNIQUE_BENEFITS"] = "UNIQUE_BENEFITS";
  SupplyContentDescriptionSectionName["WHY_THIS_PROPERTY"] = "WHY_THIS_PROPERTY";
})(SupplyContentDescriptionSectionName || (SupplyContentDescriptionSectionName = {}));
export var SupplyContentManualTranslationOperation;
(function (SupplyContentManualTranslationOperation) {
  SupplyContentManualTranslationOperation["ADD"] = "ADD";
  SupplyContentManualTranslationOperation["DELETE"] = "DELETE";
  SupplyContentManualTranslationOperation["UPDATE"] = "UPDATE";
})(SupplyContentManualTranslationOperation || (SupplyContentManualTranslationOperation = {}));
export var SupplyContractingBannerTheme;
(function (SupplyContractingBannerTheme) {
  SupplyContractingBannerTheme["CRITICAL"] = "CRITICAL";
  SupplyContractingBannerTheme["ERROR"] = "ERROR";
})(SupplyContractingBannerTheme || (SupplyContractingBannerTheme = {}));
export var SupplyContractingResponseStatus;
(function (SupplyContractingResponseStatus) {
  SupplyContractingResponseStatus["FAIL"] = "FAIL";
  SupplyContractingResponseStatus["SUCCESS"] = "SUCCESS";
})(SupplyContractingResponseStatus || (SupplyContractingResponseStatus = {}));
export var SupplyContractingSheetType;
(function (SupplyContractingSheetType) {
  SupplyContractingSheetType["FENCED_BOOKING_DISCOUNTS_OPT_OUT"] = "FENCED_BOOKING_DISCOUNTS_OPT_OUT";
})(SupplyContractingSheetType || (SupplyContractingSheetType = {}));
export var SupplyContractingToolbarNavType;
(function (SupplyContractingToolbarNavType) {
  SupplyContractingToolbarNavType["BACK"] = "BACK";
  SupplyContractingToolbarNavType["CLOSE"] = "CLOSE";
})(SupplyContractingToolbarNavType || (SupplyContractingToolbarNavType = {}));
export var SupplyDashboardType;
(function (SupplyDashboardType) {
  SupplyDashboardType["DASHBOARD"] = "DASHBOARD";
  SupplyDashboardType["LEGACY"] = "LEGACY";
})(SupplyDashboardType || (SupplyDashboardType = {}));
export var SupplyEditAvailabilityTag;
(function (SupplyEditAvailabilityTag) {
  SupplyEditAvailabilityTag["BLOCK"] = "BLOCK";
  SupplyEditAvailabilityTag["OPEN"] = "OPEN";
})(SupplyEditAvailabilityTag || (SupplyEditAvailabilityTag = {}));
export var SupplyEpicPlaybackPerformanceResultTrend;
(function (SupplyEpicPlaybackPerformanceResultTrend) {
  SupplyEpicPlaybackPerformanceResultTrend["HIGHER"] = "HIGHER";
  SupplyEpicPlaybackPerformanceResultTrend["LOWER"] = "LOWER";
  SupplyEpicPlaybackPerformanceResultTrend["NO_CHANGE"] = "NO_CHANGE";
})(SupplyEpicPlaybackPerformanceResultTrend || (SupplyEpicPlaybackPerformanceResultTrend = {}));
export var SupplyEpicPlaybackPerformanceResultUnavailableCardType;
(function (SupplyEpicPlaybackPerformanceResultUnavailableCardType) {
  SupplyEpicPlaybackPerformanceResultUnavailableCardType["CAPTURING_DATA"] = "CAPTURING_DATA";
  SupplyEpicPlaybackPerformanceResultUnavailableCardType["ERROR"] = "ERROR";
  SupplyEpicPlaybackPerformanceResultUnavailableCardType["NO_COMPSET"] = "NO_COMPSET";
})(SupplyEpicPlaybackPerformanceResultUnavailableCardType || (SupplyEpicPlaybackPerformanceResultUnavailableCardType = {}));
export var SupplyEpicPlaybackPerformanceStage;
(function (SupplyEpicPlaybackPerformanceStage) {
  SupplyEpicPlaybackPerformanceStage["ACTIVE"] = "ACTIVE";
  SupplyEpicPlaybackPerformanceStage["COMPLETED"] = "COMPLETED";
  SupplyEpicPlaybackPerformanceStage["FAILED"] = "FAILED";
})(SupplyEpicPlaybackPerformanceStage || (SupplyEpicPlaybackPerformanceStage = {}));
export var SupplyLoyaltyActionId;
(function (SupplyLoyaltyActionId) {
  SupplyLoyaltyActionId["VIP_APPLICATION_REVIEW_SHEET"] = "VIP_APPLICATION_REVIEW_SHEET";
  SupplyLoyaltyActionId["VIP_BENEFITS_SHEET"] = "VIP_BENEFITS_SHEET";
  SupplyLoyaltyActionId["VIP_CONTACTS_SHEET"] = "VIP_CONTACTS_SHEET";
  SupplyLoyaltyActionId["VIP_CONTRACT_SHEET"] = "VIP_CONTRACT_SHEET";
  SupplyLoyaltyActionId["VIP_CONTRACT_VIEW_SHEET"] = "VIP_CONTRACT_VIEW_SHEET";
  SupplyLoyaltyActionId["VIP_MEMBERS_ONLY_DISCOUNT_SHEET"] = "VIP_MEMBERS_ONLY_DISCOUNT_SHEET";
  SupplyLoyaltyActionId["VIP_ONBOARDING_ACTIVATION_SUBMIT"] = "VIP_ONBOARDING_ACTIVATION_SUBMIT";
  SupplyLoyaltyActionId["VIP_PROGRAM_PROGRESS_SHEET"] = "VIP_PROGRAM_PROGRESS_SHEET";
  SupplyLoyaltyActionId["VIP_PROGRAM_SUBMIT"] = "VIP_PROGRAM_SUBMIT";
  SupplyLoyaltyActionId["VIP_VALUE_ADD_SHEET"] = "VIP_VALUE_ADD_SHEET";
})(SupplyLoyaltyActionId || (SupplyLoyaltyActionId = {}));
export var SupplyLoyaltyCallToActionCardVariants;
(function (SupplyLoyaltyCallToActionCardVariants) {
  SupplyLoyaltyCallToActionCardVariants["PRIMARY"] = "PRIMARY";
  SupplyLoyaltyCallToActionCardVariants["SECONDARY"] = "SECONDARY";
})(SupplyLoyaltyCallToActionCardVariants || (SupplyLoyaltyCallToActionCardVariants = {}));
export var SupplyLoyaltyCardVariants;
(function (SupplyLoyaltyCardVariants) {
  SupplyLoyaltyCardVariants["VIP_ACCESS_BENEFIT"] = "VIP_ACCESS_BENEFIT";
  SupplyLoyaltyCardVariants["VIP_HOW_IT_WORKS_REQUIREMENT"] = "VIP_HOW_IT_WORKS_REQUIREMENT";
  SupplyLoyaltyCardVariants["VIP_MESSAGE_HORIZONTAL"] = "VIP_MESSAGE_HORIZONTAL";
  SupplyLoyaltyCardVariants["VIP_TRAINING"] = "VIP_TRAINING";
})(SupplyLoyaltyCardVariants || (SupplyLoyaltyCardVariants = {}));
export var SupplyLoyaltyResponseStatus;
(function (SupplyLoyaltyResponseStatus) {
  SupplyLoyaltyResponseStatus["FAIL"] = "FAIL";
  SupplyLoyaltyResponseStatus["SUCCESS"] = "SUCCESS";
})(SupplyLoyaltyResponseStatus || (SupplyLoyaltyResponseStatus = {}));
export var SupplyLoyaltySectionVariant;
(function (SupplyLoyaltySectionVariant) {
  SupplyLoyaltySectionVariant["PRIMARY"] = "PRIMARY";
  SupplyLoyaltySectionVariant["SECONDARY"] = "SECONDARY";
})(SupplyLoyaltySectionVariant || (SupplyLoyaltySectionVariant = {}));
export var SupplyLoyaltyVipProgramApprovalDecisionInput;
(function (SupplyLoyaltyVipProgramApprovalDecisionInput) {
  SupplyLoyaltyVipProgramApprovalDecisionInput["APPROVE"] = "APPROVE";
  SupplyLoyaltyVipProgramApprovalDecisionInput["REJECT"] = "REJECT";
})(SupplyLoyaltyVipProgramApprovalDecisionInput || (SupplyLoyaltyVipProgramApprovalDecisionInput = {}));
export var SupplyNavigationHeaderMenuType;
(function (SupplyNavigationHeaderMenuType) {
  SupplyNavigationHeaderMenuType["NOTIFICATIONS"] = "NOTIFICATIONS";
  SupplyNavigationHeaderMenuType["PORTFOLIO_PROPERTY_FILTER"] = "PORTFOLIO_PROPERTY_FILTER";
  SupplyNavigationHeaderMenuType["PROPERTY_DETAILS"] = "PROPERTY_DETAILS";
  SupplyNavigationHeaderMenuType["PROPERTY_FILTER"] = "PROPERTY_FILTER";
  SupplyNavigationHeaderMenuType["SEARCH"] = "SEARCH";
})(SupplyNavigationHeaderMenuType || (SupplyNavigationHeaderMenuType = {}));
export var SupplyOnboardingAvailabilityType;
(function (SupplyOnboardingAvailabilityType) {
  SupplyOnboardingAvailabilityType["BLOCK"] = "BLOCK";
  SupplyOnboardingAvailabilityType["OPEN"] = "OPEN";
})(SupplyOnboardingAvailabilityType || (SupplyOnboardingAvailabilityType = {}));
export var SupplyOnboardingButtonType;
(function (SupplyOnboardingButtonType) {
  SupplyOnboardingButtonType["BACK"] = "BACK";
  SupplyOnboardingButtonType["DONE"] = "DONE";
  SupplyOnboardingButtonType["LINK"] = "LINK";
  SupplyOnboardingButtonType["NEXT"] = "NEXT";
  SupplyOnboardingButtonType["SKIP"] = "SKIP";
})(SupplyOnboardingButtonType || (SupplyOnboardingButtonType = {}));
export var SupplyOnboardingTipCardId;
(function (SupplyOnboardingTipCardId) {
  SupplyOnboardingTipCardId["AMENITIES"] = "AMENITIES";
  SupplyOnboardingTipCardId["DESCRIPTION"] = "DESCRIPTION";
  SupplyOnboardingTipCardId["HEADLINE"] = "HEADLINE";
  SupplyOnboardingTipCardId["PHOTOS"] = "PHOTOS";
  SupplyOnboardingTipCardId["REGULATORY"] = "REGULATORY";
})(SupplyOnboardingTipCardId || (SupplyOnboardingTipCardId = {}));
export var SupplyPcRoomManagementWorkflowPageName;
(function (SupplyPcRoomManagementWorkflowPageName) {
  SupplyPcRoomManagementWorkflowPageName["COPY_RATE_PLAN"] = "COPY_RATE_PLAN";
  SupplyPcRoomManagementWorkflowPageName["RATE_PLAN"] = "RATE_PLAN";
  SupplyPcRoomManagementWorkflowPageName["ROOM_INFO"] = "ROOM_INFO";
  SupplyPcRoomManagementWorkflowPageName["ROOM_NAME"] = "ROOM_NAME";
})(SupplyPcRoomManagementWorkflowPageName || (SupplyPcRoomManagementWorkflowPageName = {}));
export var SupplyPcRoomManagementWorkflowType;
(function (SupplyPcRoomManagementWorkflowType) {
  SupplyPcRoomManagementWorkflowType["ADD"] = "ADD";
  SupplyPcRoomManagementWorkflowType["COPY"] = "COPY";
  SupplyPcRoomManagementWorkflowType["EDIT"] = "EDIT";
})(SupplyPcRoomManagementWorkflowType || (SupplyPcRoomManagementWorkflowType = {}));
export var SupplyPartnerLifeCycleStage;
(function (SupplyPartnerLifeCycleStage) {
  SupplyPartnerLifeCycleStage["LIFE_CYCLE_STAGE_ALL_GROWN_UP"] = "LIFE_CYCLE_STAGE_ALL_GROWN_UP";
  SupplyPartnerLifeCycleStage["LIFE_CYCLE_STAGE_BABY"] = "LIFE_CYCLE_STAGE_BABY";
  SupplyPartnerLifeCycleStage["LIFE_CYCLE_STAGE_KID"] = "LIFE_CYCLE_STAGE_KID";
  SupplyPartnerLifeCycleStage["LIFE_CYCLE_STAGE_TEENAGER"] = "LIFE_CYCLE_STAGE_TEENAGER";
  SupplyPartnerLifeCycleStage["LIFE_CYCLE_STAGE_YOUNG_ADULT"] = "LIFE_CYCLE_STAGE_YOUNG_ADULT";
  SupplyPartnerLifeCycleStage["UNRECOGNIZED"] = "UNRECOGNIZED";
})(SupplyPartnerLifeCycleStage || (SupplyPartnerLifeCycleStage = {}));
export var SupplyPaymentDetailsExpandoPositioning;
(function (SupplyPaymentDetailsExpandoPositioning) {
  SupplyPaymentDetailsExpandoPositioning["LEADING"] = "LEADING";
  SupplyPaymentDetailsExpandoPositioning["TRAILING"] = "TRAILING";
})(SupplyPaymentDetailsExpandoPositioning || (SupplyPaymentDetailsExpandoPositioning = {}));
export var SupplyPaymentDisplayToolbarIcon;
(function (SupplyPaymentDisplayToolbarIcon) {
  SupplyPaymentDisplayToolbarIcon["BACK"] = "BACK";
  SupplyPaymentDisplayToolbarIcon["CLOSE"] = "CLOSE";
})(SupplyPaymentDisplayToolbarIcon || (SupplyPaymentDisplayToolbarIcon = {}));
export var SupplyPhotosActionType;
(function (SupplyPhotosActionType) {
  SupplyPhotosActionType["CARD_BUTTON"] = "CARD_BUTTON";
  SupplyPhotosActionType["LINK"] = "LINK";
  SupplyPhotosActionType["LINK_BUTTON"] = "LINK_BUTTON";
  SupplyPhotosActionType["PRIMARY_BUTTON"] = "PRIMARY_BUTTON";
  SupplyPhotosActionType["SECONDARY_BUTTON"] = "SECONDARY_BUTTON";
  SupplyPhotosActionType["TERTIARY_BUTTON"] = "TERTIARY_BUTTON";
  SupplyPhotosActionType["TOOL_BAR_BUTTON"] = "TOOL_BAR_BUTTON";
})(SupplyPhotosActionType || (SupplyPhotosActionType = {}));
export var SupplyPhotosPhotoStatus;
(function (SupplyPhotosPhotoStatus) {
  SupplyPhotosPhotoStatus["ACTIVE"] = "ACTIVE";
  SupplyPhotosPhotoStatus["PROCESSING"] = "PROCESSING";
})(SupplyPhotosPhotoStatus || (SupplyPhotosPhotoStatus = {}));
export var SupplyPremierHostDownloadType;
(function (SupplyPremierHostDownloadType) {
  SupplyPremierHostDownloadType["BOOKING_DETAILS"] = "BOOKING_DETAILS";
  SupplyPremierHostDownloadType["LISTINGS_SUMMARY"] = "LISTINGS_SUMMARY";
})(SupplyPremierHostDownloadType || (SupplyPremierHostDownloadType = {}));
export var SupplyProductCreationBannerTheme;
(function (SupplyProductCreationBannerTheme) {
  SupplyProductCreationBannerTheme["ERROR"] = "ERROR";
  SupplyProductCreationBannerTheme["INFO"] = "INFO";
  SupplyProductCreationBannerTheme["SUCCESS"] = "SUCCESS";
  SupplyProductCreationBannerTheme["WARNING"] = "WARNING";
})(SupplyProductCreationBannerTheme || (SupplyProductCreationBannerTheme = {}));
export var SupplyProductCreationContractStatus;
(function (SupplyProductCreationContractStatus) {
  SupplyProductCreationContractStatus["INVALID"] = "INVALID";
  SupplyProductCreationContractStatus["NOT_FOUND"] = "NOT_FOUND";
  SupplyProductCreationContractStatus["VALID"] = "VALID";
})(SupplyProductCreationContractStatus || (SupplyProductCreationContractStatus = {}));
export var SupplyProductCreationExtraBedChargeType;
(function (SupplyProductCreationExtraBedChargeType) {
  SupplyProductCreationExtraBedChargeType["PER_DAY"] = "PER_DAY";
  SupplyProductCreationExtraBedChargeType["PER_NIGHT"] = "PER_NIGHT";
  SupplyProductCreationExtraBedChargeType["PER_STAY"] = "PER_STAY";
  SupplyProductCreationExtraBedChargeType["PER_WEEK"] = "PER_WEEK";
})(SupplyProductCreationExtraBedChargeType || (SupplyProductCreationExtraBedChargeType = {}));
export var SupplyProductCreationNavigationType;
(function (SupplyProductCreationNavigationType) {
  SupplyProductCreationNavigationType["BACK"] = "BACK";
  SupplyProductCreationNavigationType["DONE"] = "DONE";
  SupplyProductCreationNavigationType["NEXT"] = "NEXT";
})(SupplyProductCreationNavigationType || (SupplyProductCreationNavigationType = {}));
export var SupplyProductCreationPopularRateType;
(function (SupplyProductCreationPopularRateType) {
  SupplyProductCreationPopularRateType["BREAKFAST"] = "BREAKFAST";
  SupplyProductCreationPopularRateType["CONTRACTUAL"] = "CONTRACTUAL";
  SupplyProductCreationPopularRateType["MOD"] = "MOD";
  SupplyProductCreationPopularRateType["NONREFUNDABLE"] = "NONREFUNDABLE";
  SupplyProductCreationPopularRateType["PACKAGE"] = "PACKAGE";
  SupplyProductCreationPopularRateType["REFUNDABLE"] = "REFUNDABLE";
})(SupplyProductCreationPopularRateType || (SupplyProductCreationPopularRateType = {}));
export var SupplyProductCreationRoomNameAttributeCategoryName;
(function (SupplyProductCreationRoomNameAttributeCategoryName) {
  SupplyProductCreationRoomNameAttributeCategoryName["ACCESSIBILITY"] = "ACCESSIBILITY";
  SupplyProductCreationRoomNameAttributeCategoryName["AREA"] = "AREA";
  SupplyProductCreationRoomNameAttributeCategoryName["BEDROOM_DETAILS"] = "BEDROOM_DETAILS";
  SupplyProductCreationRoomNameAttributeCategoryName["FEATURE_AMENITY"] = "FEATURE_AMENITY";
  SupplyProductCreationRoomNameAttributeCategoryName["OTHER_BEDROOM_DETAILS"] = "OTHER_BEDROOM_DETAILS";
  SupplyProductCreationRoomNameAttributeCategoryName["OUTDOOR_SPACE"] = "OUTDOOR_SPACE";
  SupplyProductCreationRoomNameAttributeCategoryName["ROOM_CLASS"] = "ROOM_CLASS";
  SupplyProductCreationRoomNameAttributeCategoryName["ROOM_TYPE"] = "ROOM_TYPE";
  SupplyProductCreationRoomNameAttributeCategoryName["SMOKING_POLICY"] = "SMOKING_POLICY";
  SupplyProductCreationRoomNameAttributeCategoryName["VIEW"] = "VIEW";
})(SupplyProductCreationRoomNameAttributeCategoryName || (SupplyProductCreationRoomNameAttributeCategoryName = {}));
export var SupplyProductCreationRoomOverviewTabName;
(function (SupplyProductCreationRoomOverviewTabName) {
  SupplyProductCreationRoomOverviewTabName["FINISHED_ROOMS"] = "FINISHED_ROOMS";
  SupplyProductCreationRoomOverviewTabName["UNFINISHED_ROOMS"] = "UNFINISHED_ROOMS";
})(SupplyProductCreationRoomOverviewTabName || (SupplyProductCreationRoomOverviewTabName = {}));
export var SupplyProgramsAlignment;
(function (SupplyProgramsAlignment) {
  SupplyProgramsAlignment["CENTER"] = "CENTER";
  SupplyProgramsAlignment["LEFT"] = "LEFT";
})(SupplyProgramsAlignment || (SupplyProgramsAlignment = {}));
export var SupplyProgramsEnrollmentStatus;
(function (SupplyProgramsEnrollmentStatus) {
  SupplyProgramsEnrollmentStatus["ACCEPTED_TERMS"] = "ACCEPTED_TERMS";
  SupplyProgramsEnrollmentStatus["ACTIVE_ENROLLMENT"] = "ACTIVE_ENROLLMENT";
  SupplyProgramsEnrollmentStatus["ELIGIBLE_TO_ENROLL"] = "ELIGIBLE_TO_ENROLL";
  SupplyProgramsEnrollmentStatus["NOT_ELIGIBLE"] = "NOT_ELIGIBLE";
})(SupplyProgramsEnrollmentStatus || (SupplyProgramsEnrollmentStatus = {}));
export var SupplyProgramsResponseStatus;
(function (SupplyProgramsResponseStatus) {
  SupplyProgramsResponseStatus["FAILURE"] = "FAILURE";
  SupplyProgramsResponseStatus["SUCCESS"] = "SUCCESS";
})(SupplyProgramsResponseStatus || (SupplyProgramsResponseStatus = {}));
export var SupplyProgramsSheetType;
(function (SupplyProgramsSheetType) {
  SupplyProgramsSheetType["ENROLLMENT"] = "ENROLLMENT";
  SupplyProgramsSheetType["HOW_IT_WORKS_POPOVER"] = "HOW_IT_WORKS_POPOVER";
  SupplyProgramsSheetType["VIEW_TERMS_AND_CONDITIONS"] = "VIEW_TERMS_AND_CONDITIONS";
  SupplyProgramsSheetType["VIEW_TERMS_AND_CONDITIONS_ONLY"] = "VIEW_TERMS_AND_CONDITIONS_ONLY";
})(SupplyProgramsSheetType || (SupplyProgramsSheetType = {}));
export var SupplyProgramsToolbarNavType;
(function (SupplyProgramsToolbarNavType) {
  SupplyProgramsToolbarNavType["BACK"] = "BACK";
  SupplyProgramsToolbarNavType["CLOSE"] = "CLOSE";
})(SupplyProgramsToolbarNavType || (SupplyProgramsToolbarNavType = {}));
export var SupplyPromotionNotificationType;
(function (SupplyPromotionNotificationType) {
  SupplyPromotionNotificationType["ERROR"] = "ERROR";
  SupplyPromotionNotificationType["SUCCESS"] = "SUCCESS";
})(SupplyPromotionNotificationType || (SupplyPromotionNotificationType = {}));
export var SupplyPromotionReservationMode;
(function (SupplyPromotionReservationMode) {
  SupplyPromotionReservationMode["ADVANCED"] = "ADVANCED";
  SupplyPromotionReservationMode["STANDARD"] = "STANDARD";
})(SupplyPromotionReservationMode || (SupplyPromotionReservationMode = {}));
export var SupplyPromotionResponseStatus;
(function (SupplyPromotionResponseStatus) {
  SupplyPromotionResponseStatus["FAIL"] = "FAIL";
  SupplyPromotionResponseStatus["SUCCESS"] = "SUCCESS";
})(SupplyPromotionResponseStatus || (SupplyPromotionResponseStatus = {}));
export var SupplyPropertyVideosActionType;
(function (SupplyPropertyVideosActionType) {
  SupplyPropertyVideosActionType["CARD_BUTTON"] = "CARD_BUTTON";
  SupplyPropertyVideosActionType["LINK"] = "LINK";
  SupplyPropertyVideosActionType["LINK_BUTTON"] = "LINK_BUTTON";
  SupplyPropertyVideosActionType["PRIMARY_BUTTON"] = "PRIMARY_BUTTON";
  SupplyPropertyVideosActionType["SECONDARY_BUTTON"] = "SECONDARY_BUTTON";
  SupplyPropertyVideosActionType["TERTIARY_BUTTON"] = "TERTIARY_BUTTON";
  SupplyPropertyVideosActionType["TOOL_BAR_BUTTON"] = "TOOL_BAR_BUTTON";
})(SupplyPropertyVideosActionType || (SupplyPropertyVideosActionType = {}));
export var SupplyPropertyVideosVideoType;
(function (SupplyPropertyVideosVideoType) {
  SupplyPropertyVideosVideoType["BASIC"] = "BASIC";
  SupplyPropertyVideosVideoType["EMBED"] = "EMBED";
})(SupplyPropertyVideosVideoType || (SupplyPropertyVideosVideoType = {}));
export var SupplyQuickActionComparisonType;
(function (SupplyQuickActionComparisonType) {
  SupplyQuickActionComparisonType["GREATER_THAN"] = "GREATER_THAN";
  SupplyQuickActionComparisonType["LESSER_THAN"] = "LESSER_THAN";
})(SupplyQuickActionComparisonType || (SupplyQuickActionComparisonType = {}));
/** Allowed operations on subscribe event */
export var SupplyQuickActionElementVisibility;
(function (SupplyQuickActionElementVisibility) {
  SupplyQuickActionElementVisibility["HIDE_SELF"] = "HIDE_SELF";
  SupplyQuickActionElementVisibility["SHOW_SELF"] = "SHOW_SELF";
})(SupplyQuickActionElementVisibility || (SupplyQuickActionElementVisibility = {}));
/** Allowed operations on subscribe event */
export var SupplyQuickActionFieldProcessorOperation;
(function (SupplyQuickActionFieldProcessorOperation) {
  SupplyQuickActionFieldProcessorOperation["PERCENT_CALC_AND_REPLACE"] = "PERCENT_CALC_AND_REPLACE";
  SupplyQuickActionFieldProcessorOperation["PLAIN_REPLACE"] = "PLAIN_REPLACE";
  SupplyQuickActionFieldProcessorOperation["SUBTRACT_AND_REPLACE"] = "SUBTRACT_AND_REPLACE";
})(SupplyQuickActionFieldProcessorOperation || (SupplyQuickActionFieldProcessorOperation = {}));
export var SupplyQuickActionFieldSetDirection;
(function (SupplyQuickActionFieldSetDirection) {
  SupplyQuickActionFieldSetDirection["HORIZONTAL"] = "HORIZONTAL";
  SupplyQuickActionFieldSetDirection["VERTICAL"] = "VERTICAL";
})(SupplyQuickActionFieldSetDirection || (SupplyQuickActionFieldSetDirection = {}));
/**
 * SupplyQuickActionSpacingSize
 * Note: only 0X_HALF, 1X, 2X, 3X, 4X, 6X, 12X, 16X are supported for desktop.
 * Using other sizes may render differently different on mobile and desktop
 */
export var SupplyQuickActionSpacingSize;
(function (SupplyQuickActionSpacingSize) {
  SupplyQuickActionSpacingSize["SPACING__0X__HALF"] = "SPACING__0X__HALF";
  SupplyQuickActionSpacingSize["SPACING__1X"] = "SPACING__1X";
  SupplyQuickActionSpacingSize["SPACING__2X"] = "SPACING__2X";
  SupplyQuickActionSpacingSize["SPACING__3X"] = "SPACING__3X";
  SupplyQuickActionSpacingSize["SPACING__4X"] = "SPACING__4X";
  SupplyQuickActionSpacingSize["SPACING__5X"] = "SPACING__5X";
  SupplyQuickActionSpacingSize["SPACING__6X"] = "SPACING__6X";
  SupplyQuickActionSpacingSize["SPACING__8X"] = "SPACING__8X";
  SupplyQuickActionSpacingSize["SPACING__10X"] = "SPACING__10X";
  SupplyQuickActionSpacingSize["SPACING__11X"] = "SPACING__11X";
  SupplyQuickActionSpacingSize["SPACING__12X"] = "SPACING__12X";
  SupplyQuickActionSpacingSize["SPACING__14X"] = "SPACING__14X";
  SupplyQuickActionSpacingSize["SPACING__16X"] = "SPACING__16X";
})(SupplyQuickActionSpacingSize || (SupplyQuickActionSpacingSize = {}));
export var SupplyQuickActionTableItemCellType;
(function (SupplyQuickActionTableItemCellType) {
  SupplyQuickActionTableItemCellType["NORMAL"] = "NORMAL";
  SupplyQuickActionTableItemCellType["STRIKETHROUGH"] = "STRIKETHROUGH";
})(SupplyQuickActionTableItemCellType || (SupplyQuickActionTableItemCellType = {}));
export var SupplyRateAvailabilityObservationSpacingSize;
(function (SupplyRateAvailabilityObservationSpacingSize) {
  SupplyRateAvailabilityObservationSpacingSize["SPACING__0X__HALF"] = "SPACING__0X__HALF";
  SupplyRateAvailabilityObservationSpacingSize["SPACING__1X"] = "SPACING__1X";
  SupplyRateAvailabilityObservationSpacingSize["SPACING__2X"] = "SPACING__2X";
  SupplyRateAvailabilityObservationSpacingSize["SPACING__3X"] = "SPACING__3X";
  SupplyRateAvailabilityObservationSpacingSize["SPACING__4X"] = "SPACING__4X";
  SupplyRateAvailabilityObservationSpacingSize["SPACING__5X"] = "SPACING__5X";
  SupplyRateAvailabilityObservationSpacingSize["SPACING__6X"] = "SPACING__6X";
  SupplyRateAvailabilityObservationSpacingSize["SPACING__8X"] = "SPACING__8X";
})(SupplyRateAvailabilityObservationSpacingSize || (SupplyRateAvailabilityObservationSpacingSize = {}));
export var SupplyRatePlanButtonType;
(function (SupplyRatePlanButtonType) {
  SupplyRatePlanButtonType["PRIMARY"] = "PRIMARY";
  SupplyRatePlanButtonType["SECONDARY"] = "SECONDARY";
})(SupplyRatePlanButtonType || (SupplyRatePlanButtonType = {}));
export var SupplyRatePlanCheckboxType;
(function (SupplyRatePlanCheckboxType) {
  SupplyRatePlanCheckboxType["ADVANCE_AND_LAST_MINUTE_BOOKING"] = "ADVANCE_AND_LAST_MINUTE_BOOKING";
  SupplyRatePlanCheckboxType["LENGTH_OF_STAY"] = "LENGTH_OF_STAY";
  SupplyRatePlanCheckboxType["LIMIT_TO_CERTAIN_TRAVELERS"] = "LIMIT_TO_CERTAIN_TRAVELERS";
  SupplyRatePlanCheckboxType["ONLY_CERTAIN_BOOKING_DATES"] = "ONLY_CERTAIN_BOOKING_DATES";
  SupplyRatePlanCheckboxType["ONLY_CERTAIN_STAY_DATES"] = "ONLY_CERTAIN_STAY_DATES";
})(SupplyRatePlanCheckboxType || (SupplyRatePlanCheckboxType = {}));
export var SupplyRatePlanCreationOption;
(function (SupplyRatePlanCreationOption) {
  SupplyRatePlanCreationOption["B2B_DISTRIBUTION_CUSTOM"] = "B2B_DISTRIBUTION_CUSTOM";
  SupplyRatePlanCreationOption["BUSINESS_CUSTOM"] = "BUSINESS_CUSTOM";
  SupplyRatePlanCreationOption["STANDARD_CUSTOM"] = "STANDARD_CUSTOM";
})(SupplyRatePlanCreationOption || (SupplyRatePlanCreationOption = {}));
export var SupplyRatePlanEditOption;
(function (SupplyRatePlanEditOption) {
  SupplyRatePlanEditOption["REACTIVATE"] = "REACTIVATE";
})(SupplyRatePlanEditOption || (SupplyRatePlanEditOption = {}));
export var SupplyRatePlanIconPosition;
(function (SupplyRatePlanIconPosition) {
  SupplyRatePlanIconPosition["LEADING"] = "LEADING";
  SupplyRatePlanIconPosition["TRAILING"] = "TRAILING";
})(SupplyRatePlanIconPosition || (SupplyRatePlanIconPosition = {}));
export var SupplyRatePlanOperationType;
(function (SupplyRatePlanOperationType) {
  SupplyRatePlanOperationType["COPY"] = "COPY";
  SupplyRatePlanOperationType["CREATE"] = "CREATE";
  SupplyRatePlanOperationType["EDIT"] = "EDIT";
})(SupplyRatePlanOperationType || (SupplyRatePlanOperationType = {}));
export var SupplyRatesEditorSettingAction;
(function (SupplyRatesEditorSettingAction) {
  SupplyRatesEditorSettingAction["CANCELLATION_POLICY"] = "CANCELLATION_POLICY";
  SupplyRatesEditorSettingAction["MIN_NIGHT_STAY"] = "MIN_NIGHT_STAY";
  SupplyRatesEditorSettingAction["PROMOTIONS"] = "PROMOTIONS";
  SupplyRatesEditorSettingAction["RESTRICTED_CHECK_IN"] = "RESTRICTED_CHECK_IN";
  SupplyRatesEditorSettingAction["RESTRICTED_CHECK_OUT"] = "RESTRICTED_CHECK_OUT";
})(SupplyRatesEditorSettingAction || (SupplyRatesEditorSettingAction = {}));
export var SupplyRatesSettingsDrawerAction;
(function (SupplyRatesSettingsDrawerAction) {
  SupplyRatesSettingsDrawerAction["DATES"] = "DATES";
  SupplyRatesSettingsDrawerAction["NOTES"] = "NOTES";
  SupplyRatesSettingsDrawerAction["RATE"] = "RATE";
  SupplyRatesSettingsDrawerAction["SETTINGS"] = "SETTINGS";
})(SupplyRatesSettingsDrawerAction || (SupplyRatesSettingsDrawerAction = {}));
export var SupplyRegulatorySpacing;
(function (SupplyRegulatorySpacing) {
  SupplyRegulatorySpacing["EIGHT"] = "eight";
  SupplyRegulatorySpacing["FOUR"] = "four";
  SupplyRegulatorySpacing["HALF"] = "half";
  SupplyRegulatorySpacing["ONE"] = "one";
  SupplyRegulatorySpacing["SIX"] = "six";
  SupplyRegulatorySpacing["SIXTEEN"] = "sixteen";
  SupplyRegulatorySpacing["THREE"] = "three";
  SupplyRegulatorySpacing["TWELVE"] = "twelve";
  SupplyRegulatorySpacing["TWO"] = "two";
  SupplyRegulatorySpacing["UNSET"] = "unset";
})(SupplyRegulatorySpacing || (SupplyRegulatorySpacing = {}));
export var SupplyRegulatoryStatus;
(function (SupplyRegulatoryStatus) {
  SupplyRegulatoryStatus["COMPLIANT"] = "COMPLIANT";
  SupplyRegulatoryStatus["NONE"] = "NONE";
  SupplyRegulatoryStatus["NOT_COMPLIANT"] = "NOT_COMPLIANT";
})(SupplyRegulatoryStatus || (SupplyRegulatoryStatus = {}));
export var SupplyReservationDetailsComponentType;
(function (SupplyReservationDetailsComponentType) {
  SupplyReservationDetailsComponentType["ACCESS_INSTRUCTIONS"] = "ACCESS_INSTRUCTIONS";
  SupplyReservationDetailsComponentType["AUTOMATED_PAYOUT_STATUSES"] = "AUTOMATED_PAYOUT_STATUSES";
  SupplyReservationDetailsComponentType["CANCELLATION_POLICY"] = "CANCELLATION_POLICY";
  SupplyReservationDetailsComponentType["DAMAGE_DEPOSIT"] = "DAMAGE_DEPOSIT";
  SupplyReservationDetailsComponentType["INVOICE_STATUSES"] = "INVOICE_STATUSES";
  SupplyReservationDetailsComponentType["MINI_AVAILABILITY_CALENDAR"] = "MINI_AVAILABILITY_CALENDAR";
  SupplyReservationDetailsComponentType["PARTNER_NOTES"] = "PARTNER_NOTES";
  SupplyReservationDetailsComponentType["PAYMENT_DETAILS"] = "PAYMENT_DETAILS";
  SupplyReservationDetailsComponentType["PAYMENT_REQUEST_STATUSES"] = "PAYMENT_REQUEST_STATUSES";
  SupplyReservationDetailsComponentType["PAYMENT_SCHEDULE"] = "PAYMENT_SCHEDULE";
  SupplyReservationDetailsComponentType["PAYMENT_SUMMARY"] = "PAYMENT_SUMMARY";
  SupplyReservationDetailsComponentType["RENTAL_AGREEMENT"] = "RENTAL_AGREEMENT";
  SupplyReservationDetailsComponentType["STAY_DETAILS"] = "STAY_DETAILS";
  SupplyReservationDetailsComponentType["TRAVELER_INFO"] = "TRAVELER_INFO";
})(SupplyReservationDetailsComponentType || (SupplyReservationDetailsComponentType = {}));
export var SupplyReservationStatusType;
(function (SupplyReservationStatusType) {
  SupplyReservationStatusType["ARRIVING_TODAY"] = "ARRIVING_TODAY";
  SupplyReservationStatusType["BOOKED"] = "BOOKED";
  SupplyReservationStatusType["BOOKING_REQUEST"] = "BOOKING_REQUEST";
  SupplyReservationStatusType["BOOKING_REQUEST_DECLINED"] = "BOOKING_REQUEST_DECLINED";
  SupplyReservationStatusType["BOOKING_REQUEST_EXPIRED"] = "BOOKING_REQUEST_EXPIRED";
  SupplyReservationStatusType["CANCELED"] = "CANCELED";
  SupplyReservationStatusType["CANCELLATION_REQUEST"] = "CANCELLATION_REQUEST";
  SupplyReservationStatusType["CURRENT_STAY"] = "CURRENT_STAY";
  SupplyReservationStatusType["INQUIRY"] = "INQUIRY";
  SupplyReservationStatusType["POST_STAY"] = "POST_STAY";
  SupplyReservationStatusType["PRE_APPROVAL_EXPIRED"] = "PRE_APPROVAL_EXPIRED";
  SupplyReservationStatusType["PRE_APPROVED"] = "PRE_APPROVED";
  SupplyReservationStatusType["REQUEST_WITHDRAWN"] = "REQUEST_WITHDRAWN";
  SupplyReservationStatusType["UNKNOWN"] = "UNKNOWN";
})(SupplyReservationStatusType || (SupplyReservationStatusType = {}));
export var SupplyReservationsAccessTypes;
(function (SupplyReservationsAccessTypes) {
  SupplyReservationsAccessTypes["DOORMAN"] = "DOORMAN";
  SupplyReservationsAccessTypes["KEYPAD"] = "KEYPAD";
  SupplyReservationsAccessTypes["LOCKBOX"] = "LOCKBOX";
  SupplyReservationsAccessTypes["OTHER"] = "OTHER";
  SupplyReservationsAccessTypes["PICKUP"] = "PICKUP";
  SupplyReservationsAccessTypes["SMART_LOCK"] = "SMART_LOCK";
})(SupplyReservationsAccessTypes || (SupplyReservationsAccessTypes = {}));
export var SupplyReservationsActionType;
(function (SupplyReservationsActionType) {
  SupplyReservationsActionType["ACCESS_INSTRUCTIONS_ADD"] = "ACCESS_INSTRUCTIONS_ADD";
  SupplyReservationsActionType["ACCESS_INSTRUCTIONS_EDIT"] = "ACCESS_INSTRUCTIONS_EDIT";
  SupplyReservationsActionType["AUTOMATED_PAYOUT_STATUS_ACTION"] = "AUTOMATED_PAYOUT_STATUS_ACTION";
  SupplyReservationsActionType["AUTO_CANCEL_WAIVERS_CANCEL_CHANGES"] = "AUTO_CANCEL_WAIVERS_CANCEL_CHANGES";
  SupplyReservationsActionType["AUTO_CANCEL_WAIVERS_SAVE_CHANGES"] = "AUTO_CANCEL_WAIVERS_SAVE_CHANGES";
  SupplyReservationsActionType["CREDIT_CARD_RECAPTURE_CLOSE"] = "CREDIT_CARD_RECAPTURE_CLOSE";
  SupplyReservationsActionType["CREDIT_CARD_RECAPTURE_REQUEST_UPDATED_CARD"] = "CREDIT_CARD_RECAPTURE_REQUEST_UPDATED_CARD";
  SupplyReservationsActionType["DAMAGE_PROTECTION_REFUND_DEPOSIT"] = "DAMAGE_PROTECTION_REFUND_DEPOSIT";
  SupplyReservationsActionType["DAMAGE_PROTECTION_REPORT_DAMAGE"] = "DAMAGE_PROTECTION_REPORT_DAMAGE";
  SupplyReservationsActionType["DAMAGE_PROTECTION_REPORT_DAMAGE_EXTERNAL"] = "DAMAGE_PROTECTION_REPORT_DAMAGE_EXTERNAL";
  SupplyReservationsActionType["DAMAGE_PROTECTION_SEE_DAMAGE_REPORT"] = "DAMAGE_PROTECTION_SEE_DAMAGE_REPORT";
  SupplyReservationsActionType["DAMAGE_PROTECTION_SEE_POLICY"] = "DAMAGE_PROTECTION_SEE_POLICY";
  SupplyReservationsActionType["EVC_MANAGE_CARD_MORE_INFO"] = "EVC_MANAGE_CARD_MORE_INFO";
  SupplyReservationsActionType["EVC_MANAGE_CARD_SEARCH"] = "EVC_MANAGE_CARD_SEARCH";
  SupplyReservationsActionType["EVC_MANAGE_FEEDBACK"] = "EVC_MANAGE_FEEDBACK";
  SupplyReservationsActionType["EVC_MANAGE_RESERVATION_DETAILS"] = "EVC_MANAGE_RESERVATION_DETAILS";
  SupplyReservationsActionType["GUEST_INFO_EMAIL"] = "GUEST_INFO_EMAIL";
  SupplyReservationsActionType["GUEST_INFO_PHONE"] = "GUEST_INFO_PHONE";
  SupplyReservationsActionType["GUEST_INFO_VIEW_PROFILE"] = "GUEST_INFO_VIEW_PROFILE";
  SupplyReservationsActionType["HEADER_ARCHIVE"] = "HEADER_ARCHIVE";
  SupplyReservationsActionType["HEADER_DETAILS"] = "HEADER_DETAILS";
  SupplyReservationsActionType["HEADER_FEEDBACK"] = "HEADER_FEEDBACK";
  SupplyReservationsActionType["HEADER_HELP_CENTER"] = "HEADER_HELP_CENTER";
  SupplyReservationsActionType["HEADER_MARK_AS_READ"] = "HEADER_MARK_AS_READ";
  SupplyReservationsActionType["HEADER_MARK_AS_SPAM"] = "HEADER_MARK_AS_SPAM";
  SupplyReservationsActionType["HEADER_MARK_AS_UNREAD"] = "HEADER_MARK_AS_UNREAD";
  SupplyReservationsActionType["HEADER_PRINT"] = "HEADER_PRINT";
  SupplyReservationsActionType["HEADER_SHARE"] = "HEADER_SHARE";
  SupplyReservationsActionType["HEADER_UNARCHIVE"] = "HEADER_UNARCHIVE";
  SupplyReservationsActionType["INVOICE_STATUS_ACTION"] = "INVOICE_STATUS_ACTION";
  SupplyReservationsActionType["NOTES_ADD"] = "NOTES_ADD";
  SupplyReservationsActionType["NOTES_CANCEL"] = "NOTES_CANCEL";
  SupplyReservationsActionType["NOTES_EDIT"] = "NOTES_EDIT";
  SupplyReservationsActionType["NOTES_SAVE"] = "NOTES_SAVE";
  SupplyReservationsActionType["PAYMENT_REQUEST_STATUS_ACTION"] = "PAYMENT_REQUEST_STATUS_ACTION";
  SupplyReservationsActionType["PAYMENT_SCHEDULE_ADD_EXTRA_CHARGE"] = "PAYMENT_SCHEDULE_ADD_EXTRA_CHARGE";
  SupplyReservationsActionType["PAYMENT_SCHEDULE_CANCEL_PAYMENT_REQUEST"] = "PAYMENT_SCHEDULE_CANCEL_PAYMENT_REQUEST";
  SupplyReservationsActionType["PAYMENT_SCHEDULE_EDIT_PAYMENT_SCHEDULE"] = "PAYMENT_SCHEDULE_EDIT_PAYMENT_SCHEDULE";
  SupplyReservationsActionType["PAYMENT_SCHEDULE_MARK_PAID"] = "PAYMENT_SCHEDULE_MARK_PAID";
  SupplyReservationsActionType["PAYMENT_SCHEDULE_RESEND_REQUEST"] = "PAYMENT_SCHEDULE_RESEND_REQUEST";
  SupplyReservationsActionType["PAYMENT_SCHEDULE_SEND_A_REFUND"] = "PAYMENT_SCHEDULE_SEND_A_REFUND";
  SupplyReservationsActionType["PAYMENT_SUMMARY_VIEW"] = "PAYMENT_SUMMARY_VIEW";
  SupplyReservationsActionType["RENTAL_AGREEMENT_VIEW"] = "RENTAL_AGREEMENT_VIEW";
  SupplyReservationsActionType["RESERVATION_MODIFIERS_BACK"] = "RESERVATION_MODIFIERS_BACK";
  SupplyReservationsActionType["RESERVATION_MODIFIERS_CLOSE"] = "RESERVATION_MODIFIERS_CLOSE";
  SupplyReservationsActionType["RESERVATION_MODIFIERS_NEXT"] = "RESERVATION_MODIFIERS_NEXT";
  SupplyReservationsActionType["RESERVATION_MODIFIERS_SAVE_CANCEL"] = "RESERVATION_MODIFIERS_SAVE_CANCEL";
  SupplyReservationsActionType["RESERVATION_MODIFIERS_SAVE_CHANGE_DATES"] = "RESERVATION_MODIFIERS_SAVE_CHANGE_DATES";
  SupplyReservationsActionType["RESERVATION_MODIFIERS_SAVE_GUEST_SATISFACTION_REFUND"] = "RESERVATION_MODIFIERS_SAVE_GUEST_SATISFACTION_REFUND";
  SupplyReservationsActionType["RESERVATION_MODIFIERS_SAVE_NO_SHOW"] = "RESERVATION_MODIFIERS_SAVE_NO_SHOW";
  SupplyReservationsActionType["STAY_DETAILS_ACCEPT"] = "STAY_DETAILS_ACCEPT";
  SupplyReservationsActionType["STAY_DETAILS_ADD_REMOVE_GUESTS"] = "STAY_DETAILS_ADD_REMOVE_GUESTS";
  SupplyReservationsActionType["STAY_DETAILS_CANCEL_PRE_APPROVAL"] = "STAY_DETAILS_CANCEL_PRE_APPROVAL";
  SupplyReservationsActionType["STAY_DETAILS_CANCEL_RESERVATION"] = "STAY_DETAILS_CANCEL_RESERVATION";
  SupplyReservationsActionType["STAY_DETAILS_CHANGE_DATES"] = "STAY_DETAILS_CHANGE_DATES";
  SupplyReservationsActionType["STAY_DETAILS_CHANGE_TIME"] = "STAY_DETAILS_CHANGE_TIME";
  SupplyReservationsActionType["STAY_DETAILS_CONFIRM_CANCELLATION"] = "STAY_DETAILS_CONFIRM_CANCELLATION";
  SupplyReservationsActionType["STAY_DETAILS_DECLINE"] = "STAY_DETAILS_DECLINE";
  SupplyReservationsActionType["STAY_DETAILS_EDIT_DATES"] = "STAY_DETAILS_EDIT_DATES";
  SupplyReservationsActionType["STAY_DETAILS_EDIT_QUOTE"] = "STAY_DETAILS_EDIT_QUOTE";
  SupplyReservationsActionType["STAY_DETAILS_EDIT_RESERVATION"] = "STAY_DETAILS_EDIT_RESERVATION";
  SupplyReservationsActionType["STAY_DETAILS_SEND_PRE_APPROVAL"] = "STAY_DETAILS_SEND_PRE_APPROVAL";
  SupplyReservationsActionType["VIEW_IN_CALENDAR"] = "VIEW_IN_CALENDAR";
})(SupplyReservationsActionType || (SupplyReservationsActionType = {}));
export var SupplyReservationsDeclineOption;
(function (SupplyReservationsDeclineOption) {
  SupplyReservationsDeclineOption["BLOCK_DATES"] = "BLOCK_DATES";
  SupplyReservationsDeclineOption["LEAVE_DATES"] = "LEAVE_DATES";
})(SupplyReservationsDeclineOption || (SupplyReservationsDeclineOption = {}));
export var SupplyReservationsDeclineStep;
(function (SupplyReservationsDeclineStep) {
  /** Move to the panel to confirm decline decision */
  SupplyReservationsDeclineStep["CONFIRM"] = "CONFIRM";
  /** Move to the panel to pick a decline reason */
  SupplyReservationsDeclineStep["REASON_AND_MESSAGE"] = "REASON_AND_MESSAGE";
})(SupplyReservationsDeclineStep || (SupplyReservationsDeclineStep = {}));
export var SupplyReservationsEvcManagerTabType;
(function (SupplyReservationsEvcManagerTabType) {
  SupplyReservationsEvcManagerTabType["EVC_LOOKUP"] = "EVC_LOOKUP";
  SupplyReservationsEvcManagerTabType["EVC_MANAGE"] = "EVC_MANAGE";
})(SupplyReservationsEvcManagerTabType || (SupplyReservationsEvcManagerTabType = {}));
export var SupplyReservationsEvcManagerTableType;
(function (SupplyReservationsEvcManagerTableType) {
  SupplyReservationsEvcManagerTableType["EVC_CARDS_TO_CHARGE"] = "EVC_CARDS_TO_CHARGE";
  SupplyReservationsEvcManagerTableType["EVC_CARDS_TO_REFUND"] = "EVC_CARDS_TO_REFUND";
})(SupplyReservationsEvcManagerTableType || (SupplyReservationsEvcManagerTableType = {}));
export var SupplyReservationsEvcSearchInputType;
(function (SupplyReservationsEvcSearchInputType) {
  SupplyReservationsEvcSearchInputType["EVC_NUMBER"] = "EVC_NUMBER";
  SupplyReservationsEvcSearchInputType["RESERVATION_ID"] = "RESERVATION_ID";
})(SupplyReservationsEvcSearchInputType || (SupplyReservationsEvcSearchInputType = {}));
export var SupplyReservationsInteractionBannerTheme;
(function (SupplyReservationsInteractionBannerTheme) {
  SupplyReservationsInteractionBannerTheme["CRITICAL"] = "CRITICAL";
  SupplyReservationsInteractionBannerTheme["ERROR"] = "ERROR";
})(SupplyReservationsInteractionBannerTheme || (SupplyReservationsInteractionBannerTheme = {}));
export var SupplyReservationsInteractionChatImageSize;
(function (SupplyReservationsInteractionChatImageSize) {
  SupplyReservationsInteractionChatImageSize["LARGE"] = "LARGE";
  SupplyReservationsInteractionChatImageSize["SMALL"] = "SMALL";
})(SupplyReservationsInteractionChatImageSize || (SupplyReservationsInteractionChatImageSize = {}));
export var SupplyReservationsInteractionListActionDialogFooterActionType;
(function (SupplyReservationsInteractionListActionDialogFooterActionType) {
  SupplyReservationsInteractionListActionDialogFooterActionType["PRIMARY"] = "PRIMARY";
  SupplyReservationsInteractionListActionDialogFooterActionType["TERTIARY"] = "TERTIARY";
})(SupplyReservationsInteractionListActionDialogFooterActionType || (SupplyReservationsInteractionListActionDialogFooterActionType = {}));
export var SupplyReservationsInteractionListColumnHorizontalAlign;
(function (SupplyReservationsInteractionListColumnHorizontalAlign) {
  SupplyReservationsInteractionListColumnHorizontalAlign["CENTER"] = "CENTER";
  SupplyReservationsInteractionListColumnHorizontalAlign["END"] = "END";
  SupplyReservationsInteractionListColumnHorizontalAlign["JUSTIFY"] = "JUSTIFY";
  SupplyReservationsInteractionListColumnHorizontalAlign["JUSTIFY_ALL"] = "JUSTIFY_ALL";
  SupplyReservationsInteractionListColumnHorizontalAlign["LEFT"] = "LEFT";
  SupplyReservationsInteractionListColumnHorizontalAlign["MATCH_PARENT"] = "MATCH_PARENT";
  SupplyReservationsInteractionListColumnHorizontalAlign["RIGHT"] = "RIGHT";
  SupplyReservationsInteractionListColumnHorizontalAlign["START"] = "START";
})(SupplyReservationsInteractionListColumnHorizontalAlign || (SupplyReservationsInteractionListColumnHorizontalAlign = {}));
export var SupplyReservationsInteractionListColumnVerticalAlign;
(function (SupplyReservationsInteractionListColumnVerticalAlign) {
  SupplyReservationsInteractionListColumnVerticalAlign["BASELINE"] = "BASELINE";
  SupplyReservationsInteractionListColumnVerticalAlign["BOTTOM"] = "BOTTOM";
  SupplyReservationsInteractionListColumnVerticalAlign["MIDDLE"] = "MIDDLE";
  SupplyReservationsInteractionListColumnVerticalAlign["SUB"] = "SUB";
  SupplyReservationsInteractionListColumnVerticalAlign["SUPER"] = "SUPER";
  SupplyReservationsInteractionListColumnVerticalAlign["TEXT_BOTTOM"] = "TEXT_BOTTOM";
  SupplyReservationsInteractionListColumnVerticalAlign["TEXT_TOP"] = "TEXT_TOP";
  SupplyReservationsInteractionListColumnVerticalAlign["TOP"] = "TOP";
})(SupplyReservationsInteractionListColumnVerticalAlign || (SupplyReservationsInteractionListColumnVerticalAlign = {}));
export var SupplyReservationsInteractionListItemAction;
(function (SupplyReservationsInteractionListItemAction) {
  SupplyReservationsInteractionListItemAction["ARCHIVE"] = "ARCHIVE";
  SupplyReservationsInteractionListItemAction["READ"] = "READ";
  SupplyReservationsInteractionListItemAction["SPAM"] = "SPAM";
  SupplyReservationsInteractionListItemAction["UNARCHIVE"] = "UNARCHIVE";
  SupplyReservationsInteractionListItemAction["UNREAD"] = "UNREAD";
})(SupplyReservationsInteractionListItemAction || (SupplyReservationsInteractionListItemAction = {}));
export var SupplyReservationsInteractionListSwipeActionEdge;
(function (SupplyReservationsInteractionListSwipeActionEdge) {
  SupplyReservationsInteractionListSwipeActionEdge["LEADING"] = "LEADING";
  SupplyReservationsInteractionListSwipeActionEdge["TRAILING"] = "TRAILING";
})(SupplyReservationsInteractionListSwipeActionEdge || (SupplyReservationsInteractionListSwipeActionEdge = {}));
export var SupplyReservationsInteractionMessageMode;
(function (SupplyReservationsInteractionMessageMode) {
  SupplyReservationsInteractionMessageMode["INCOMING"] = "INCOMING";
  SupplyReservationsInteractionMessageMode["OUTGOING"] = "OUTGOING";
})(SupplyReservationsInteractionMessageMode || (SupplyReservationsInteractionMessageMode = {}));
export var SupplyReservationsInteractionMessagesDetailsLinkType;
(function (SupplyReservationsInteractionMessagesDetailsLinkType) {
  SupplyReservationsInteractionMessagesDetailsLinkType["CHARGEBACKS"] = "CHARGEBACKS";
  SupplyReservationsInteractionMessagesDetailsLinkType["SEE_DAMAGE_REPORT"] = "SEE_DAMAGE_REPORT";
  SupplyReservationsInteractionMessagesDetailsLinkType["VIEW_CSA_CLAIM"] = "VIEW_CSA_CLAIM";
})(SupplyReservationsInteractionMessagesDetailsLinkType || (SupplyReservationsInteractionMessagesDetailsLinkType = {}));
export var SupplyReservationsInteractionMessagesDialogFooterActionType;
(function (SupplyReservationsInteractionMessagesDialogFooterActionType) {
  SupplyReservationsInteractionMessagesDialogFooterActionType["PRIMARY"] = "PRIMARY";
  SupplyReservationsInteractionMessagesDialogFooterActionType["TERTIARY"] = "TERTIARY";
})(SupplyReservationsInteractionMessagesDialogFooterActionType || (SupplyReservationsInteractionMessagesDialogFooterActionType = {}));
export var SupplyReservationsInteractionMessagesReplyAttachmentsLayout;
(function (SupplyReservationsInteractionMessagesReplyAttachmentsLayout) {
  SupplyReservationsInteractionMessagesReplyAttachmentsLayout["GRID"] = "GRID";
  SupplyReservationsInteractionMessagesReplyAttachmentsLayout["LIST"] = "LIST";
})(SupplyReservationsInteractionMessagesReplyAttachmentsLayout || (SupplyReservationsInteractionMessagesReplyAttachmentsLayout = {}));
export var SupplyReservationsInteractionViewType;
(function (SupplyReservationsInteractionViewType) {
  SupplyReservationsInteractionViewType["CAROUSEL_VIEW"] = "CAROUSEL_VIEW";
  SupplyReservationsInteractionViewType["LIST_VIEW"] = "LIST_VIEW";
})(SupplyReservationsInteractionViewType || (SupplyReservationsInteractionViewType = {}));
export var SupplyReservationsInteractionsSort;
(function (SupplyReservationsInteractionsSort) {
  SupplyReservationsInteractionsSort["CHECKIN_DATE_ASC"] = "CHECKIN_DATE_ASC";
  SupplyReservationsInteractionsSort["CHECKIN_DATE_DESC"] = "CHECKIN_DATE_DESC";
  SupplyReservationsInteractionsSort["GUEST_ASC"] = "GUEST_ASC";
  SupplyReservationsInteractionsSort["GUEST_DESC"] = "GUEST_DESC";
  SupplyReservationsInteractionsSort["RECEIVED_ON_ASC"] = "RECEIVED_ON_ASC";
  SupplyReservationsInteractionsSort["RECEIVED_ON_DESC"] = "RECEIVED_ON_DESC";
})(SupplyReservationsInteractionsSort || (SupplyReservationsInteractionsSort = {}));
export var SupplyReservationsPayment;
(function (SupplyReservationsPayment) {
  SupplyReservationsPayment["OFFLINE"] = "OFFLINE";
  SupplyReservationsPayment["ONLINE"] = "ONLINE";
})(SupplyReservationsPayment || (SupplyReservationsPayment = {}));
export var SupplyReservationsPaymentDetailsExpandoPositioning;
(function (SupplyReservationsPaymentDetailsExpandoPositioning) {
  SupplyReservationsPaymentDetailsExpandoPositioning["LEADING"] = "LEADING";
  SupplyReservationsPaymentDetailsExpandoPositioning["TRAILING"] = "TRAILING";
})(SupplyReservationsPaymentDetailsExpandoPositioning || (SupplyReservationsPaymentDetailsExpandoPositioning = {}));
export var SupplyReservationsPaymentDisplayToolbarIcon;
(function (SupplyReservationsPaymentDisplayToolbarIcon) {
  SupplyReservationsPaymentDisplayToolbarIcon["BACK"] = "BACK";
  SupplyReservationsPaymentDisplayToolbarIcon["CLOSE"] = "CLOSE";
})(SupplyReservationsPaymentDisplayToolbarIcon || (SupplyReservationsPaymentDisplayToolbarIcon = {}));
export var SupplyReservationsRenderHint;
(function (SupplyReservationsRenderHint) {
  /** Used for dropdown or bottom drawer/sheets */
  SupplyReservationsRenderHint["COLLAPSED"] = "COLLAPSED";
  /** Used to display options as a list of buttons/links */
  SupplyReservationsRenderHint["LIST"] = "LIST";
})(SupplyReservationsRenderHint || (SupplyReservationsRenderHint = {}));
export var SupplyReservationsStayDetailsMessageTimerType;
(function (SupplyReservationsStayDetailsMessageTimerType) {
  SupplyReservationsStayDetailsMessageTimerType["COUNT_DOWN"] = "COUNT_DOWN";
  SupplyReservationsStayDetailsMessageTimerType["COUNT_UP"] = "COUNT_UP";
})(SupplyReservationsStayDetailsMessageTimerType || (SupplyReservationsStayDetailsMessageTimerType = {}));
export var SupplyReservationsTimerBadgeType;
(function (SupplyReservationsTimerBadgeType) {
  SupplyReservationsTimerBadgeType["COUNT_DOWN"] = "COUNT_DOWN";
  SupplyReservationsTimerBadgeType["COUNT_UP"] = "COUNT_UP";
})(SupplyReservationsTimerBadgeType || (SupplyReservationsTimerBadgeType = {}));
export var SupplyReservationsToolbarElevation;
(function (SupplyReservationsToolbarElevation) {
  SupplyReservationsToolbarElevation["DEFAULT"] = "DEFAULT";
  SupplyReservationsToolbarElevation["FLOATING"] = "FLOATING";
})(SupplyReservationsToolbarElevation || (SupplyReservationsToolbarElevation = {}));
export var SupplyReservationsToolbarNavigationType;
(function (SupplyReservationsToolbarNavigationType) {
  SupplyReservationsToolbarNavigationType["BACK"] = "BACK";
  SupplyReservationsToolbarNavigationType["CLOSE"] = "CLOSE";
})(SupplyReservationsToolbarNavigationType || (SupplyReservationsToolbarNavigationType = {}));
export var SupplyReviewsActionId;
(function (SupplyReviewsActionId) {
  SupplyReviewsActionId["REVIEWS_DOWNLOAD_SHEET"] = "REVIEWS_DOWNLOAD_SHEET";
  SupplyReviewsActionId["REVIEWS_FILTERS_SHEET"] = "REVIEWS_FILTERS_SHEET";
  SupplyReviewsActionId["REVIEWS_RATING_GUEST_SHEET"] = "REVIEWS_RATING_GUEST_SHEET";
  SupplyReviewsActionId["REVIEWS_REQUEST_REVIEW_SHEET"] = "REVIEWS_REQUEST_REVIEW_SHEET";
  SupplyReviewsActionId["REVIEWS_RESPOND_SHEET"] = "REVIEWS_RESPOND_SHEET";
  SupplyReviewsActionId["REVIEWS_SHARE_SHEET"] = "REVIEWS_SHARE_SHEET";
})(SupplyReviewsActionId || (SupplyReviewsActionId = {}));
export var SupplyReviewsResponseStatus;
(function (SupplyReviewsResponseStatus) {
  SupplyReviewsResponseStatus["FAIL"] = "FAIL";
  SupplyReviewsResponseStatus["SUCCESS"] = "SUCCESS";
})(SupplyReviewsResponseStatus || (SupplyReviewsResponseStatus = {}));
export var SupplyRoomTypeMappingCompetitorPropertyInputType;
(function (SupplyRoomTypeMappingCompetitorPropertyInputType) {
  SupplyRoomTypeMappingCompetitorPropertyInputType["PROPERTYID"] = "PropertyID";
  SupplyRoomTypeMappingCompetitorPropertyInputType["PROPERTYURL"] = "PropertyURL";
})(SupplyRoomTypeMappingCompetitorPropertyInputType || (SupplyRoomTypeMappingCompetitorPropertyInputType = {}));
export var SupplyRoomTypeMappingSpacingSize;
(function (SupplyRoomTypeMappingSpacingSize) {
  SupplyRoomTypeMappingSpacingSize["SPACING__0X__HALF"] = "SPACING__0X__HALF";
  SupplyRoomTypeMappingSpacingSize["SPACING__1X"] = "SPACING__1X";
  SupplyRoomTypeMappingSpacingSize["SPACING__2X"] = "SPACING__2X";
  SupplyRoomTypeMappingSpacingSize["SPACING__3X"] = "SPACING__3X";
  SupplyRoomTypeMappingSpacingSize["SPACING__4X"] = "SPACING__4X";
  SupplyRoomTypeMappingSpacingSize["SPACING__5X"] = "SPACING__5X";
  SupplyRoomTypeMappingSpacingSize["SPACING__6X"] = "SPACING__6X";
  SupplyRoomTypeMappingSpacingSize["SPACING__8X"] = "SPACING__8X";
})(SupplyRoomTypeMappingSpacingSize || (SupplyRoomTypeMappingSpacingSize = {}));
export var SupplyRoomTypeMappingUserAction;
(function (SupplyRoomTypeMappingUserAction) {
  SupplyRoomTypeMappingUserAction["CONFIRM"] = "CONFIRM";
  SupplyRoomTypeMappingUserAction["REJECT"] = "REJECT";
})(SupplyRoomTypeMappingUserAction || (SupplyRoomTypeMappingUserAction = {}));
export var SupplyRoomTypeMappingViewPhase;
(function (SupplyRoomTypeMappingViewPhase) {
  SupplyRoomTypeMappingViewPhase["VIEW_PROPERTY_MAPPING"] = "VIEW_PROPERTY_MAPPING";
  SupplyRoomTypeMappingViewPhase["VIEW_PROPERTY_MAPPING_INPUT"] = "VIEW_PROPERTY_MAPPING_INPUT";
  SupplyRoomTypeMappingViewPhase["VIEW_ROOM_TYPE_MAPPING"] = "VIEW_ROOM_TYPE_MAPPING";
})(SupplyRoomTypeMappingViewPhase || (SupplyRoomTypeMappingViewPhase = {}));
export var SupplyRoomTypeMappingViewType;
(function (SupplyRoomTypeMappingViewType) {
  SupplyRoomTypeMappingViewType["DIALOG"] = "DIALOG";
})(SupplyRoomTypeMappingViewType || (SupplyRoomTypeMappingViewType = {}));
export var SupplyScoreBenefitsLadderSpacingSize;
(function (SupplyScoreBenefitsLadderSpacingSize) {
  SupplyScoreBenefitsLadderSpacingSize["SPACING__0X__HALF"] = "SPACING__0X__HALF";
  SupplyScoreBenefitsLadderSpacingSize["SPACING__1X"] = "SPACING__1X";
  SupplyScoreBenefitsLadderSpacingSize["SPACING__2X"] = "SPACING__2X";
  SupplyScoreBenefitsLadderSpacingSize["SPACING__3X"] = "SPACING__3X";
  SupplyScoreBenefitsLadderSpacingSize["SPACING__4X"] = "SPACING__4X";
  SupplyScoreBenefitsLadderSpacingSize["SPACING__5X"] = "SPACING__5X";
  SupplyScoreBenefitsLadderSpacingSize["SPACING__6X"] = "SPACING__6X";
  SupplyScoreBenefitsLadderSpacingSize["SPACING__8X"] = "SPACING__8X";
})(SupplyScoreBenefitsLadderSpacingSize || (SupplyScoreBenefitsLadderSpacingSize = {}));
export var SupplyScoreFactorBmlAuditItemObervationType;
(function (SupplyScoreFactorBmlAuditItemObervationType) {
  SupplyScoreFactorBmlAuditItemObervationType["AVAILABILITY"] = "AVAILABILITY";
  SupplyScoreFactorBmlAuditItemObervationType["RATE"] = "RATE";
})(SupplyScoreFactorBmlAuditItemObervationType || (SupplyScoreFactorBmlAuditItemObervationType = {}));
export var SupplyScoreFactorNotificationType;
(function (SupplyScoreFactorNotificationType) {
  SupplyScoreFactorNotificationType["DOING_GREAT"] = "DOING_GREAT";
  SupplyScoreFactorNotificationType["NEEDS_ATTENTION"] = "NEEDS_ATTENTION";
  SupplyScoreFactorNotificationType["NEXT_BEST_FACTOR"] = "NEXT_BEST_FACTOR";
})(SupplyScoreFactorNotificationType || (SupplyScoreFactorNotificationType = {}));
/** Description of a SupplyScoreMessaging's card */
export var SupplyScoreMessagingTheme;
(function (SupplyScoreMessagingTheme) {
  SupplyScoreMessagingTheme["INFO"] = "INFO";
  SupplyScoreMessagingTheme["MESSAGE"] = "MESSAGE";
  SupplyScoreMessagingTheme["WARNING"] = "WARNING";
})(SupplyScoreMessagingTheme || (SupplyScoreMessagingTheme = {}));
export var SupplyTaxesType;
(function (SupplyTaxesType) {
  SupplyTaxesType["AMOUNT"] = "AMOUNT";
  SupplyTaxesType["NOT_INCLUDED"] = "NOT_INCLUDED";
  SupplyTaxesType["PERCENT"] = "PERCENT";
})(SupplyTaxesType || (SupplyTaxesType = {}));
/** Represents the selection status of a tab */
export var TabStatus;
(function (TabStatus) {
  /** Represents the status of not being selected */
  TabStatus["NOT_SELECTED"] = "NOT_SELECTED";
  /** Represents the status of being selected */
  TabStatus["SELECTED"] = "SELECTED";
})(TabStatus || (TabStatus = {}));
export var TabType;
(function (TabType) {
  TabType["EQUAL_WIDTH"] = "EQUAL_WIDTH";
  TabType["NATURAL"] = "NATURAL";
})(TabType || (TabType = {}));
export var TableInput;
(function (TableInput) {
  TableInput["AD"] = "AD";
  TableInput["AD_GROUP"] = "AD_GROUP";
  TableInput["CAMPAIGN"] = "CAMPAIGN";
})(TableInput || (TableInput = {}));
export var TextDenyReasonCompliance;
(function (TextDenyReasonCompliance) {
  TextDenyReasonCompliance["COMPETITIVE_COMPARATIVE_FALSE_CLAIMS"] = "COMPETITIVE_COMPARATIVE_FALSE_CLAIMS";
  TextDenyReasonCompliance["EXPIRED_OFFER"] = "EXPIRED_OFFER";
  TextDenyReasonCompliance["ROOM_RATES_OFFERS_DISCOUNTS"] = "ROOM_RATES_OFFERS_DISCOUNTS";
  TextDenyReasonCompliance["TEST_AD_NOT_ALLOWED"] = "TEST_AD_NOT_ALLOWED";
  TextDenyReasonCompliance["UNKNOWN"] = "UNKNOWN";
})(TextDenyReasonCompliance || (TextDenyReasonCompliance = {}));
export var TextDenyReasonGuidelines;
(function (TextDenyReasonGuidelines) {
  TextDenyReasonGuidelines["CAPITALIZATION"] = "CAPITALIZATION";
  TextDenyReasonGuidelines["EXCLAMATION_POINTS"] = "EXCLAMATION_POINTS";
  TextDenyReasonGuidelines["PUNCTUATION_SYMBOLS_HASHTAGS"] = "PUNCTUATION_SYMBOLS_HASHTAGS";
  TextDenyReasonGuidelines["SPACING"] = "SPACING";
  TextDenyReasonGuidelines["UNKNOWN"] = "UNKNOWN";
})(TextDenyReasonGuidelines || (TextDenyReasonGuidelines = {}));
export var TextDenyReasonLanguage;
(function (TextDenyReasonLanguage) {
  TextDenyReasonLanguage["GRAMMAR"] = "GRAMMAR";
  TextDenyReasonLanguage["INCORRECT_LANGUAGE_OR_TRANSLATION"] = "INCORRECT_LANGUAGE_OR_TRANSLATION";
  TextDenyReasonLanguage["SPELLING"] = "SPELLING";
  TextDenyReasonLanguage["UNCLEAR_MEANING"] = "UNCLEAR_MEANING";
  TextDenyReasonLanguage["UNKNOWN"] = "UNKNOWN";
})(TextDenyReasonLanguage || (TextDenyReasonLanguage = {}));
/** The text direction of the locale e.g. ltr or rtl */
export var TextDirection;
(function (TextDirection) {
  TextDirection["LTR"] = "LTR";
  TextDirection["RTL"] = "RTL";
})(TextDirection || (TextDirection = {}));
/** Used to highlight or convey information. For example, positive messaging like free cancellation may be green. */
export var TextTheme;
(function (TextTheme) {
  TextTheme["EMPHASIS"] = "EMPHASIS";
  TextTheme["INVERSE"] = "INVERSE";
  TextTheme["LOYALTY"] = "LOYALTY";
  TextTheme["NEGATIVE"] = "NEGATIVE";
  TextTheme["POSITIVE"] = "POSITIVE";
  TextTheme["PRIMARY"] = "PRIMARY";
  TextTheme["SECONDARY"] = "SECONDARY";
})(TextTheme || (TextTheme = {}));
/** Used to highlight or convey information. For example, Payable amount in the price summary module of the checkout page. */
export var TextWeight;
(function (TextWeight) {
  TextWeight["BOLD"] = "BOLD";
  TextWeight["MEDIUM"] = "MEDIUM";
  TextWeight["REGULAR"] = "REGULAR";
})(TextWeight || (TextWeight = {}));
export var Theme;
(function (Theme) {
  Theme["BRAND"] = "BRAND";
  Theme["BRANDED_DEAL"] = "BRANDED_DEAL";
  Theme["DEAL_ADD_ON"] = "DEAL_ADD_ON";
  Theme["DEAL_BUNDLED"] = "DEAL_BUNDLED";
  Theme["DEAL_GENERIC"] = "DEAL_GENERIC";
  Theme["DEAL_MEMBER"] = "DEAL_MEMBER";
  Theme["EMPHASIS"] = "EMPHASIS";
  Theme["FAMILY_FRIENDLY"] = "FAMILY_FRIENDLY";
  Theme["INFO"] = "INFO";
  Theme["LINK"] = "LINK";
  Theme["LOYALTY"] = "LOYALTY";
  Theme["LOYALTY_EXTRA_HIGH_TIER"] = "LOYALTY_EXTRA_HIGH_TIER";
  Theme["LOYALTY_GLOBAL_EXTRA_HIGH_TIER"] = "LOYALTY_GLOBAL_EXTRA_HIGH_TIER";
  Theme["LOYALTY_GLOBAL_HIGH_TIER"] = "LOYALTY_GLOBAL_HIGH_TIER";
  Theme["LOYALTY_GLOBAL_LOW_TIER"] = "LOYALTY_GLOBAL_LOW_TIER";
  Theme["LOYALTY_GLOBAL_MIDDLE_TIER"] = "LOYALTY_GLOBAL_MIDDLE_TIER";
  Theme["LOYALTY_HIGH_TIER"] = "LOYALTY_HIGH_TIER";
  Theme["LOYALTY_LOW_TIER"] = "LOYALTY_LOW_TIER";
  Theme["LOYALTY_MIDDLE_TIER"] = "LOYALTY_MIDDLE_TIER";
  Theme["NOTIFICATION"] = "NOTIFICATION";
  Theme["PROMOTED"] = "PROMOTED";
  Theme["SAVED"] = "SAVED";
  Theme["SPONSORED"] = "SPONSORED";
  Theme["STANDARD"] = "STANDARD";
  Theme["SUCCESS"] = "SUCCESS";
  Theme["SUCCESS_MEDIUM"] = "SUCCESS_MEDIUM";
  Theme["SUPPLIER_PROMO"] = "SUPPLIER_PROMO";
  Theme["URGENT"] = "URGENT";
  Theme["VIEWED"] = "VIEWED";
  Theme["VIP"] = "VIP";
  Theme["VIP_ACCESS"] = "VIP_ACCESS";
})(Theme || (Theme = {}));
/** Toast auto dismiss duration */
export var ToastDismissDuration;
(function (ToastDismissDuration) {
  ToastDismissDuration["INDEFINITE"] = "INDEFINITE";
  ToastDismissDuration["LONG"] = "LONG";
  ToastDismissDuration["SHORT"] = "SHORT";
})(ToastDismissDuration || (ToastDismissDuration = {}));
export var ToolbarNavType;
(function (ToolbarNavType) {
  ToolbarNavType["CLOSE"] = "CLOSE";
  ToolbarNavType["EXPAND_DOWN"] = "EXPAND_DOWN";
  ToolbarNavType["EXPAND_UP"] = "EXPAND_UP";
})(ToolbarNavType || (ToolbarNavType = {}));
export var TopTaskTypes;
(function (TopTaskTypes) {
  TopTaskTypes["ACCELERATOR_OPPORTUNITY"] = "ACCELERATOR_OPPORTUNITY";
  TopTaskTypes["ADD_AMENITIES"] = "ADD_AMENITIES";
  TopTaskTypes["ADD_MINIMUM_STAY"] = "ADD_MINIMUM_STAY";
  TopTaskTypes["ADD_PHOTOS"] = "ADD_PHOTOS";
  TopTaskTypes["ADD_SAFETY_DEVICES_AMENITIES"] = "ADD_SAFETY_DEVICES_AMENITIES";
  TopTaskTypes["ARRIVING"] = "ARRIVING";
  TopTaskTypes["AUTORATEMATCH_OPPORTUNITY"] = "AUTORATEMATCH_OPPORTUNITY";
  TopTaskTypes["BANK_DETAILS"] = "BANK_DETAILS";
  TopTaskTypes["BOOKING_REQUEST"] = "BOOKING_REQUEST";
  TopTaskTypes["BOOKING_SMS_OPT_IN"] = "BOOKING_SMS_OPT_IN";
  TopTaskTypes["CANCELLATION"] = "CANCELLATION";
  TopTaskTypes["CANCELLATION_REQUEST"] = "CANCELLATION_REQUEST";
  TopTaskTypes["CONFIRM_CONTACT"] = "CONFIRM_CONTACT";
  TopTaskTypes["CONFIRM_IDENTITY"] = "CONFIRM_IDENTITY";
  TopTaskTypes["CURRENT_STAY"] = "CURRENT_STAY";
  TopTaskTypes["DIRECT_DEBIT"] = "DIRECT_DEBIT";
  TopTaskTypes["INQUIRY"] = "INQUIRY";
  TopTaskTypes["LOWER_FEES"] = "LOWER_FEES";
  TopTaskTypes["MINIMUMINVENTORY_OPPORTUNITY"] = "MINIMUMINVENTORY_OPPORTUNITY";
  TopTaskTypes["MOBILEDRR_OPPORTUNITY"] = "MOBILEDRR_OPPORTUNITY";
  TopTaskTypes["OPPORTUNITY"] = "OPPORTUNITY";
  TopTaskTypes["RATE_TRAVELER"] = "RATE_TRAVELER";
  TopTaskTypes["TAX_FORM"] = "TAX_FORM";
  TopTaskTypes["TMODDRR_OPPORTUNITY"] = "TMODDRR_OPPORTUNITY";
  TopTaskTypes["UNKNOWN"] = "UNKNOWN";
  TopTaskTypes["UNKNOWN__"] = "UNKNOWN__";
  TopTaskTypes["UPDATE_TAX_INFORMATION"] = "UPDATE_TAX_INFORMATION";
  TopTaskTypes["VRPAYMENTS_TIP"] = "VRPAYMENTS_TIP";
})(TopTaskTypes || (TopTaskTypes = {}));
export var TravelShopType;
(function (TravelShopType) {
  TravelShopType["COLLECTIONS"] = "COLLECTIONS";
  TravelShopType["SHOPS"] = "SHOPS";
})(TravelShopType || (TravelShopType = {}));
/** Possible traveler details types */
export var TravelerDetailsType;
(function (TravelerDetailsType) {
  TravelerDetailsType["ADULT"] = "ADULT";
  TravelerDetailsType["CHILD"] = "CHILD";
  TravelerDetailsType["INFANT_IN_LAP"] = "INFANT_IN_LAP";
  TravelerDetailsType["INFANT_IN_SEAT"] = "INFANT_IN_SEAT";
})(TravelerDetailsType || (TravelerDetailsType = {}));
export var TravelerType;
(function (TravelerType) {
  TravelerType["ADULTS_ONLY"] = "ADULTS_ONLY";
  TravelerType["BUSINESS"] = "BUSINESS";
  TravelerType["ECO_CERTIFIED"] = "ECO_CERTIFIED";
  TravelerType["FAMILY"] = "FAMILY";
  TravelerType["LGBT"] = "LGBT";
  /** Deprecated: TnL 37054 - AFFINITY_FILTERS_APPLIED_ON_HSR */
  TravelerType["ROMANTIC"] = "ROMANTIC";
})(TravelerType || (TravelerType = {}));
export var TripAssistGoalType;
(function (TripAssistGoalType) {
  TripAssistGoalType["BOOK"] = "BOOK";
  TripAssistGoalType["PLAN"] = "PLAN";
})(TripAssistGoalType || (TripAssistGoalType = {}));
export var TripCareButtonAction;
(function (TripCareButtonAction) {
  TripCareButtonAction["BACK"] = "BACK";
  TripCareButtonAction["CANCEL_POLICY"] = "CANCEL_POLICY";
  TripCareButtonAction["DISMISS_POPUP"] = "DISMISS_POPUP";
  TripCareButtonAction["POPUP"] = "POPUP";
  TripCareButtonAction["RELOAD"] = "RELOAD";
})(TripCareButtonAction || (TripCareButtonAction = {}));
export var TripCareButtonState;
(function (TripCareButtonState) {
  TripCareButtonState["DISABLED"] = "DISABLED";
  TripCareButtonState["ENABLED"] = "ENABLED";
})(TripCareButtonState || (TripCareButtonState = {}));
export var TripCareLayoutStyle;
(function (TripCareLayoutStyle) {
  TripCareLayoutStyle["CARD_BORDER_TOP"] = "CARD_BORDER_TOP";
})(TripCareLayoutStyle || (TripCareLayoutStyle = {}));
export var TripCareListType;
(function (TripCareListType) {
  TripCareListType["BULLET"] = "BULLET";
  TripCareListType["NO_BULLET"] = "NO_BULLET";
  TripCareListType["NUMBERED"] = "NUMBERED";
})(TripCareListType || (TripCareListType = {}));
export var TripCarePhraseStyle;
(function (TripCarePhraseStyle) {
  TripCarePhraseStyle["BOLD"] = "BOLD";
  TripCarePhraseStyle["HR_DIVIDER_BOTTOM"] = "HR_DIVIDER_BOTTOM";
  TripCarePhraseStyle["HR_DIVIDER_TOP"] = "HR_DIVIDER_TOP";
  TripCarePhraseStyle["SIZE_100"] = "SIZE_100";
  TripCarePhraseStyle["SIZE_200"] = "SIZE_200";
  TripCarePhraseStyle["SIZE_300"] = "SIZE_300";
  TripCarePhraseStyle["SIZE_400"] = "SIZE_400";
  TripCarePhraseStyle["SIZE_500"] = "SIZE_500";
  TripCarePhraseStyle["SIZE_600"] = "SIZE_600";
  TripCarePhraseStyle["SIZE_700"] = "SIZE_700";
  TripCarePhraseStyle["SIZE_800"] = "SIZE_800";
  TripCarePhraseStyle["SIZE_900"] = "SIZE_900";
  TripCarePhraseStyle["SMALL"] = "SMALL";
  TripCarePhraseStyle["SPACING_FOUR"] = "SPACING_FOUR";
  TripCarePhraseStyle["SPACING_HALF"] = "SPACING_HALF";
  TripCarePhraseStyle["SPACING_ONE"] = "SPACING_ONE";
  TripCarePhraseStyle["SPACING_SIX"] = "SPACING_SIX";
  TripCarePhraseStyle["SPACING_THREE"] = "SPACING_THREE";
  TripCarePhraseStyle["SPACING_TWO"] = "SPACING_TWO";
  TripCarePhraseStyle["THEME_EMPHASIS"] = "THEME_EMPHASIS";
  TripCarePhraseStyle["THEME_NEGATIVE"] = "THEME_NEGATIVE";
  TripCarePhraseStyle["THEME_POSITIVE"] = "THEME_POSITIVE";
  TripCarePhraseStyle["WEIGHT_BOLD"] = "WEIGHT_BOLD";
  TripCarePhraseStyle["WEIGHT_MEDIUM"] = "WEIGHT_MEDIUM";
  TripCarePhraseStyle["WEIGHT_REGULAR"] = "WEIGHT_REGULAR";
})(TripCarePhraseStyle || (TripCarePhraseStyle = {}));
export var TripCarePhraseType;
(function (TripCarePhraseType) {
  TripCarePhraseType["BUTTON"] = "BUTTON";
  TripCarePhraseType["LINK"] = "LINK";
  TripCarePhraseType["TEXT"] = "TEXT";
})(TripCarePhraseType || (TripCarePhraseType = {}));
export var TripCreationEntryPoint;
(function (TripCreationEntryPoint) {
  TripCreationEntryPoint["HOTEL_SEARCH_RESULTS"] = "HOTEL_SEARCH_RESULTS";
  TripCreationEntryPoint["TRIPS_LIST"] = "TRIPS_LIST";
  TripCreationEntryPoint["TRIP_OVERVIEW"] = "TRIP_OVERVIEW";
})(TripCreationEntryPoint || (TripCreationEntryPoint = {}));
/** The TripEntity defines a list of supported items which can be can be saved to a trip. */
export var TripEntity;
(function (TripEntity) {
  TripEntity["ACTIVITY_PRODUCT"] = "ACTIVITY_PRODUCT";
  TripEntity["CAR_PRODUCT"] = "CAR_PRODUCT";
  TripEntity["FLIGHT_SEARCH"] = "FLIGHT_SEARCH";
  TripEntity["LODGING_PRODUCT"] = "LODGING_PRODUCT";
  TripEntity["PACKAGE_PRODUCT"] = "PACKAGE_PRODUCT";
})(TripEntity || (TripEntity = {}));
export var TripIntentPersonType;
(function (TripIntentPersonType) {
  TripIntentPersonType["ADULT"] = "ADULT";
  TripIntentPersonType["CHILD"] = "CHILD";
})(TripIntentPersonType || (TripIntentPersonType = {}));
export var TripScheduleChangeStatus;
(function (TripScheduleChangeStatus) {
  TripScheduleChangeStatus["FLIGHT_SCHEDULE_CHANGE"] = "FLIGHT_SCHEDULE_CHANGE";
  TripScheduleChangeStatus["NO_CHANGE"] = "NO_CHANGE";
})(TripScheduleChangeStatus || (TripScheduleChangeStatus = {}));
export var TripStage;
(function (TripStage) {
  TripStage["MID_TRAVEL"] = "MID_TRAVEL";
  TripStage["POST_TRAVEL"] = "POST_TRAVEL";
  TripStage["PRE_TRAVEL"] = "PRE_TRAVEL";
})(TripStage || (TripStage = {}));
export var TripState;
(function (TripState) {
  TripState["CURRENT"] = "CURRENT";
  TripState["PAST"] = "PAST";
  TripState["POTENTIAL"] = "POTENTIAL";
  TripState["UPCOMING"] = "UPCOMING";
})(TripState || (TripState = {}));
export var TripViewIdType;
(function (TripViewIdType) {
  TripViewIdType["TRIP_ITEM_ID"] = "TRIP_ITEM_ID";
  TripViewIdType["TRIP_VIEW_ID"] = "TRIP_VIEW_ID";
})(TripViewIdType || (TripViewIdType = {}));
/** Represents different avatar sizes. */
export var TripsAvatarSize;
(function (TripsAvatarSize) {
  TripsAvatarSize["EXTRA_LARGE"] = "EXTRA_LARGE";
  TripsAvatarSize["LARGE"] = "LARGE";
  TripsAvatarSize["MEDIUM"] = "MEDIUM";
  TripsAvatarSize["SMALL"] = "SMALL";
})(TripsAvatarSize || (TripsAvatarSize = {}));
/** Supported Trips badge themes */
export var TripsBadgeTheme;
(function (TripsBadgeTheme) {
  TripsBadgeTheme["LOYALTY_HIGH_TIER"] = "LOYALTY_HIGH_TIER";
  TripsBadgeTheme["LOYALTY_LOW_TIER"] = "LOYALTY_LOW_TIER";
  TripsBadgeTheme["LOYALTY_MIDDLE_TIER"] = "LOYALTY_MIDDLE_TIER";
  TripsBadgeTheme["SAVED"] = "SAVED";
  TripsBadgeTheme["STATUS_NEGATIVE"] = "STATUS_NEGATIVE";
  TripsBadgeTheme["STATUS_POSITIVE"] = "STATUS_POSITIVE";
  TripsBadgeTheme["UTILITY_STANDARD"] = "UTILITY_STANDARD";
  TripsBadgeTheme["VIP"] = "VIP";
})(TripsBadgeTheme || (TripsBadgeTheme = {}));
export var TripsBookingInfoType;
(function (TripsBookingInfoType) {
  TripsBookingInfoType["CONFIRMATION_NUMBER"] = "CONFIRMATION_NUMBER";
  TripsBookingInfoType["ITINERARY_NUMBER"] = "ITINERARY_NUMBER";
  TripsBookingInfoType["RESERVATION_ID"] = "RESERVATION_ID";
})(TripsBookingInfoType || (TripsBookingInfoType = {}));
export var TripsButtonWidth;
(function (TripsButtonWidth) {
  TripsButtonWidth["MATCH_PARENT_CONTAINER"] = "MATCH_PARENT_CONTAINER";
  TripsButtonWidth["WRAP_CONTENT"] = "WRAP_CONTENT";
})(TripsButtonWidth || (TripsButtonWidth = {}));
export var TripsCalendarSelectionType;
(function (TripsCalendarSelectionType) {
  TripsCalendarSelectionType["SINGLE"] = "SINGLE";
  TripsCalendarSelectionType["START_AND_END"] = "START_AND_END";
  TripsCalendarSelectionType["START_AND_END_WITH_SAME_DATE"] = "START_AND_END_WITH_SAME_DATE";
})(TripsCalendarSelectionType || (TripsCalendarSelectionType = {}));
export var TripsCancellationTimelineIdType;
(function (TripsCancellationTimelineIdType) {
  TripsCancellationTimelineIdType["TRIP_ITEM_ID"] = "TRIP_ITEM_ID";
})(TripsCancellationTimelineIdType || (TripsCancellationTimelineIdType = {}));
export var TripsCancellationType;
(function (TripsCancellationType) {
  TripsCancellationType["ACTIVITY"] = "ACTIVITY";
  TripsCancellationType["CAR"] = "CAR";
  TripsCancellationType["CRUISE"] = "CRUISE";
  TripsCancellationType["HOTEL"] = "HOTEL";
  TripsCancellationType["INSURANCE"] = "INSURANCE";
})(TripsCancellationType || (TripsCancellationType = {}));
/** Represents a TripsCard's selection/active state */
export var TripsCardState;
(function (TripsCardState) {
  TripsCardState["SELECTED"] = "SELECTED";
  TripsCardState["UNSELECTED"] = "UNSELECTED";
})(TripsCardState || (TripsCardState = {}));
/** Type of the drawer/sheet we want the client to render. CENTER is for desktop where we want to show the drawer as a center sheet/dialogBOTTOM is for app and mweb where the drawer comes from the bottom of the screenSIDE is for desktop where the sheet comes from the right of the screen. eg. plan, moveFULL is equivalent to sidesheet on mweb where the sheet will cover the whole page */
export var TripsComposableDrawerType;
(function (TripsComposableDrawerType) {
  TripsComposableDrawerType["BOTTOM"] = "BOTTOM";
  TripsComposableDrawerType["CENTER"] = "CENTER";
  TripsComposableDrawerType["FULL"] = "FULL";
  TripsComposableDrawerType["SIDE"] = "SIDE";
})(TripsComposableDrawerType || (TripsComposableDrawerType = {}));
/** Display theme for trips content */
export var TripsContentTheme;
(function (TripsContentTheme) {
  /** The Unordered List should be displayed with bullets */
  TripsContentTheme["BULLETS"] = "BULLETS";
  /** The Unordered List should be displayed with no bullets */
  TripsContentTheme["NO_BULLETS"] = "NO_BULLETS";
  /** The ordered list should always be displayed with numbers */
  TripsContentTheme["ORDERED"] = "ORDERED";
  /** Paragraph type list */
  TripsContentTheme["PARAGRAPH"] = "PARAGRAPH";
})(TripsContentTheme || (TripsContentTheme = {}));
export var TripsContentType;
(function (TripsContentType) {
  TripsContentType["PDF"] = "PDF";
})(TripsContentType || (TripsContentType = {}));
export var TripsContentUnorderedListTheme;
(function (TripsContentUnorderedListTheme) {
  /** The Unordered List should be displayed with bullets */
  TripsContentUnorderedListTheme["BULLETS"] = "BULLETS";
  /** The Unordered List should be displayed with no bullets */
  TripsContentUnorderedListTheme["NO_BULLETS"] = "NO_BULLETS";
})(TripsContentUnorderedListTheme || (TripsContentUnorderedListTheme = {}));
export var TripsCustomerNotificationTripScheduleChangeStatus;
(function (TripsCustomerNotificationTripScheduleChangeStatus) {
  TripsCustomerNotificationTripScheduleChangeStatus["FLIGHT_SCHEDULE_CHANGE"] = "FLIGHT_SCHEDULE_CHANGE";
  TripsCustomerNotificationTripScheduleChangeStatus["NO_CHANGE"] = "NO_CHANGE";
})(TripsCustomerNotificationTripScheduleChangeStatus || (TripsCustomerNotificationTripScheduleChangeStatus = {}));
/** Represents layout of buttons on a modal dialog */
export var TripsDialogButtonLayout;
(function (TripsDialogButtonLayout) {
  /** Dialog with horizontally stacked buttons */
  TripsDialogButtonLayout["INLINE"] = "INLINE";
  /** Dialog with vertically stacked buttons */
  TripsDialogButtonLayout["STACKED"] = "STACKED";
})(TripsDialogButtonLayout || (TripsDialogButtonLayout = {}));
export var TripsDisplayMode;
(function (TripsDisplayMode) {
  TripsDisplayMode["DEFAULT"] = "DEFAULT";
  TripsDisplayMode["MODAL"] = "MODAL";
  TripsDisplayMode["NEW_TAB"] = "NEW_TAB";
})(TripsDisplayMode || (TripsDisplayMode = {}));
/** Controls the width of the divider */
export var TripsDivider;
(function (TripsDivider) {
  TripsDivider["NARROW"] = "NARROW";
  TripsDivider["WIDE"] = "WIDE";
})(TripsDivider || (TripsDivider = {}));
export var TripsFindItineraryNumberView;
(function (TripsFindItineraryNumberView) {
  TripsFindItineraryNumberView["FIND_ITINERARY_OTHER_EMAIL"] = "FIND_ITINERARY_OTHER_EMAIL";
  TripsFindItineraryNumberView["FIND_ITINERARY_USER_EMAIL"] = "FIND_ITINERARY_USER_EMAIL";
  TripsFindItineraryNumberView["RESULT"] = "RESULT";
})(TripsFindItineraryNumberView || (TripsFindItineraryNumberView = {}));
/** This enum is to indicate what type of image is being placed into TripsFittedImageCard. UitkLayoutGrid would apply onto BARCODE */
export var TripsFittedImageType;
(function (TripsFittedImageType) {
  TripsFittedImageType["BARCODE"] = "BARCODE";
  TripsFittedImageType["E_FRANKING_STAMP"] = "E_FRANKING_STAMP";
  TripsFittedImageType["QR_CODE"] = "QR_CODE";
})(TripsFittedImageType || (TripsFittedImageType = {}));
/** This enum is to indicate whether the form container should have padding or it should fit right inside the parent component */
export var TripsFormContainerTheme;
(function (TripsFormContainerTheme) {
  TripsFormContainerTheme["MATCH_PARENT"] = "MATCH_PARENT";
  TripsFormContainerTheme["WRAP_CONTENT"] = "WRAP_CONTENT";
})(TripsFormContainerTheme || (TripsFormContainerTheme = {}));
export var TripsFormType;
(function (TripsFormType) {
  TripsFormType["CREATE_NEW_TRIP_FROM_ITEM"] = "CREATE_NEW_TRIP_FROM_ITEM";
  TripsFormType["FIND_ITINERARY_NUMBER"] = "FIND_ITINERARY_NUMBER";
  TripsFormType["INVITE"] = "INVITE";
  TripsFormType["SAVE_NEW_TRIP"] = "SAVE_NEW_TRIP";
  TripsFormType["SEARCH_BOOKING"] = "SEARCH_BOOKING";
  TripsFormType["SEND_ITINERARY_EMAIL"] = "SEND_ITINERARY_EMAIL";
  TripsFormType["UPDATE_TRIP"] = "UPDATE_TRIP";
})(TripsFormType || (TripsFormType = {}));
/** Enum to represent the number of lines that the text field supports. Defaulted to one line (single) if no changes are made. */
export var TripsInputType;
(function (TripsInputType) {
  TripsInputType["MULTIPLE"] = "MULTIPLE";
  TripsInputType["SINGLE"] = "SINGLE";
})(TripsInputType || (TripsInputType = {}));
export var TripsLinkTarget;
(function (TripsLinkTarget) {
  TripsLinkTarget["EXTERNAL"] = "EXTERNAL";
  TripsLinkTarget["INTERNAL"] = "INTERNAL";
})(TripsLinkTarget || (TripsLinkTarget = {}));
/** The type of map marker */
export var TripsMarkerType;
(function (TripsMarkerType) {
  TripsMarkerType["ACTIVITYEVENTMARKER"] = "ActivityEventMarker";
  TripsMarkerType["ACTIVITYGUESTPICKUPMARKER"] = "ActivityGuestPickupMarker";
  TripsMarkerType["ACTIVITYLOCATIONMARKER"] = "ActivityLocationMarker";
  TripsMarkerType["ACTIVITYREDEMPTIONMARKER"] = "ActivityRedemptionMarker";
  TripsMarkerType["AIRPORTMARKER"] = "AirportMarker";
  TripsMarkerType["CARMARKER"] = "CarMarker";
  TripsMarkerType["CRUISEMARKER"] = "CruiseMarker";
  TripsMarkerType["HOTELMARKER"] = "HotelMarker";
  TripsMarkerType["PLACEMARKER"] = "PlaceMarker";
})(TripsMarkerType || (TripsMarkerType = {}));
/** The `TripsPlanSourceType` defines a list of supported pages or views from which an item can be saved to a trip. */
export var TripsPlanSourceType;
(function (TripsPlanSourceType) {
  TripsPlanSourceType["ACTIVITY_DETAILS"] = "ACTIVITY_DETAILS";
  TripsPlanSourceType["ACTIVITY_SEARCH"] = "ACTIVITY_SEARCH";
  TripsPlanSourceType["CAR_INFOSITE"] = "CAR_INFOSITE";
  TripsPlanSourceType["CAR_INFOSITE_V2"] = "CAR_INFOSITE_V2";
  TripsPlanSourceType["CAR_SEARCH"] = "CAR_SEARCH";
  TripsPlanSourceType["CAR_SEARCH_V2"] = "CAR_SEARCH_V2";
  /** @deprecated Use LOGING_SEARCH instead */
  TripsPlanSourceType["HOTEL_SEARCH"] = "HOTEL_SEARCH";
  TripsPlanSourceType["LODGING_DETAILS"] = "LODGING_DETAILS";
  TripsPlanSourceType["LODGING_SEARCH"] = "LODGING_SEARCH";
  TripsPlanSourceType["PACKAGE_DETAILS"] = "PACKAGE_DETAILS";
  TripsPlanSourceType["TRIP_OVERVIEW"] = "TRIP_OVERVIEW";
})(TripsPlanSourceType || (TripsPlanSourceType = {}));
export var TripsResponseStatus;
(function (TripsResponseStatus) {
  TripsResponseStatus["FAIL"] = "FAIL";
  TripsResponseStatus["SUCCESS"] = "SUCCESS";
})(TripsResponseStatus || (TripsResponseStatus = {}));
export var TripsSaveItemVariant;
(function (TripsSaveItemVariant) {
  TripsSaveItemVariant["CONTROL"] = "CONTROL";
  TripsSaveItemVariant["VARIANT_B"] = "VARIANT_B";
  TripsSaveItemVariant["VARIANT_C"] = "VARIANT_C";
})(TripsSaveItemVariant || (TripsSaveItemVariant = {}));
export var TripsScreen;
(function (TripsScreen) {
  TripsScreen["INVITE_LANDING_PAGE"] = "INVITE_LANDING_PAGE";
  TripsScreen["PUBLIC_TRIP_BOARD"] = "PUBLIC_TRIP_BOARD";
  TripsScreen["TRIP_ASSIST"] = "TRIP_ASSIST";
  TripsScreen["TRIP_BOOKED_LIST"] = "TRIP_BOOKED_LIST";
  TripsScreen["TRIP_CANCELLED_LIST"] = "TRIP_CANCELLED_LIST";
  TripsScreen["TRIP_ITEM_DETAILS"] = "TRIP_ITEM_DETAILS";
  TripsScreen["TRIP_ITEM_ITINERARY"] = "TRIP_ITEM_ITINERARY";
  TripsScreen["TRIP_ITEM_MANAGE_BOOKING"] = "TRIP_ITEM_MANAGE_BOOKING";
  TripsScreen["TRIP_ITEM_PRICING_REWARDS"] = "TRIP_ITEM_PRICING_REWARDS";
  TripsScreen["TRIP_ITEM_RECEIPT"] = "TRIP_ITEM_RECEIPT";
  TripsScreen["TRIP_LIST"] = "TRIP_LIST";
  TripsScreen["TRIP_MANAGE_GUESTS"] = "TRIP_MANAGE_GUESTS";
  TripsScreen["TRIP_OVERVIEW"] = "TRIP_OVERVIEW";
  TripsScreen["TRIP_OVERVIEW_ITINERARY"] = "TRIP_OVERVIEW_ITINERARY";
  TripsScreen["TRIP_PAST_LIST"] = "TRIP_PAST_LIST";
  TripsScreen["TRIP_SAVED_LIST"] = "TRIP_SAVED_LIST";
})(TripsScreen || (TripsScreen = {}));
export var TripsSearchBookingView;
(function (TripsSearchBookingView) {
  TripsSearchBookingView["SEARCH_BY_ITINERARY_NUMBER"] = "SEARCH_BY_ITINERARY_NUMBER";
  TripsSearchBookingView["SEARCH_BY_ITINERARY_NUMBER_AND_EMAIL"] = "SEARCH_BY_ITINERARY_NUMBER_AND_EMAIL";
  TripsSearchBookingView["SEARCH_RESULT"] = "SEARCH_RESULT";
})(TripsSearchBookingView || (TripsSearchBookingView = {}));
/** This enum represents the different fields that a TripsSignalPair relates to. */
export var TripsSignalPairKey;
(function (TripsSignalPairKey) {
  TripsSignalPairKey["PRIMARY"] = "PRIMARY";
  TripsSignalPairKey["SECONDARY"] = "SECONDARY";
  TripsSignalPairKey["STATUS"] = "STATUS";
})(TripsSignalPairKey || (TripsSignalPairKey = {}));
/** This enum represents the different category types of signals registered within the platform. */
export var TripsSignalType;
(function (TripsSignalType) {
  TripsSignalType["REMOVE"] = "REMOVE";
  TripsSignalType["UPDATE"] = "UPDATE";
})(TripsSignalType || (TripsSignalType = {}));
export var TripsTimelineStates;
(function (TripsTimelineStates) {
  TripsTimelineStates["CURRENT"] = "CURRENT";
  TripsTimelineStates["FUTURE"] = "FUTURE";
  TripsTimelineStates["PAST"] = "PAST";
})(TripsTimelineStates || (TripsTimelineStates = {}));
/** Represents a toggle's state. */
export var TripsToggleStatus;
(function (TripsToggleStatus) {
  TripsToggleStatus["DISABLED"] = "DISABLED";
  TripsToggleStatus["ENABLED"] = "ENABLED";
})(TripsToggleStatus || (TripsToggleStatus = {}));
export var TripsUiAttachQualificationType;
(function (TripsUiAttachQualificationType) {
  TripsUiAttachQualificationType["CARMIP"] = "CARMIP";
  TripsUiAttachQualificationType["HOTMIP"] = "HOTMIP";
})(TripsUiAttachQualificationType || (TripsUiAttachQualificationType = {}));
/** Input to be used for fetching based on variant type of savings */
export var TripsUiAttachSavingsVariant;
(function (TripsUiAttachSavingsVariant) {
  TripsUiAttachSavingsVariant["BANNER"] = "BANNER";
  TripsUiAttachSavingsVariant["SHEET"] = "SHEET";
})(TripsUiAttachSavingsVariant || (TripsUiAttachSavingsVariant = {}));
export var TripsUiCardBackgroundTheme;
(function (TripsUiCardBackgroundTheme) {
  TripsUiCardBackgroundTheme["GLOBAL_LOYALTY_EXTRA_HIGH"] = "GLOBAL_LOYALTY_EXTRA_HIGH";
  TripsUiCardBackgroundTheme["GLOBAL_LOYALTY_HIGH"] = "GLOBAL_LOYALTY_HIGH";
  TripsUiCardBackgroundTheme["GLOBAL_LOYALTY_LOW"] = "GLOBAL_LOYALTY_LOW";
  TripsUiCardBackgroundTheme["GLOBAL_LOYALTY_MID"] = "GLOBAL_LOYALTY_MID";
  TripsUiCardBackgroundTheme["HIGHLIGHT"] = "HIGHLIGHT";
  TripsUiCardBackgroundTheme["NONE"] = "NONE";
  TripsUiCardBackgroundTheme["PRIMARY"] = "PRIMARY";
  TripsUiCardBackgroundTheme["SECONDARY"] = "SECONDARY";
  TripsUiCardBackgroundTheme["STANDARD"] = "STANDARD";
})(TripsUiCardBackgroundTheme || (TripsUiCardBackgroundTheme = {}));
export var TripsUiCardBorder;
(function (TripsUiCardBorder) {
  TripsUiCardBorder["SELECTED"] = "SELECTED";
  TripsUiCardBorder["SOLID"] = "SOLID";
})(TripsUiCardBorder || (TripsUiCardBorder = {}));
export var TripsUiCustomerNotificationTripScheduleChangeStatus;
(function (TripsUiCustomerNotificationTripScheduleChangeStatus) {
  TripsUiCustomerNotificationTripScheduleChangeStatus["FLIGHT_SCHEDULE_CHANGE"] = "FLIGHT_SCHEDULE_CHANGE";
  TripsUiCustomerNotificationTripScheduleChangeStatus["NO_CHANGE"] = "NO_CHANGE";
})(TripsUiCustomerNotificationTripScheduleChangeStatus || (TripsUiCustomerNotificationTripScheduleChangeStatus = {}));
/** Alignment for the buttons in a dialog's footer */
export var TripsUiDialogFooterButtonLayout;
(function (TripsUiDialogFooterButtonLayout) {
  TripsUiDialogFooterButtonLayout["INLINE"] = "INLINE";
  TripsUiDialogFooterButtonLayout["STACKED"] = "STACKED";
})(TripsUiDialogFooterButtonLayout || (TripsUiDialogFooterButtonLayout = {}));
export var TripsUiFullScreenMapViewState;
(function (TripsUiFullScreenMapViewState) {
  TripsUiFullScreenMapViewState["COLLAPSED"] = "COLLAPSED";
  TripsUiFullScreenMapViewState["EXPANDED"] = "EXPANDED";
})(TripsUiFullScreenMapViewState || (TripsUiFullScreenMapViewState = {}));
export var TripsUiImageFit;
(function (TripsUiImageFit) {
  TripsUiImageFit["CONTAIN"] = "CONTAIN";
  TripsUiImageFit["COVER"] = "COVER";
})(TripsUiImageFit || (TripsUiImageFit = {}));
export var TripsUiImageGalleryLayout;
(function (TripsUiImageGalleryLayout) {
  TripsUiImageGalleryLayout["GRID"] = "GRID";
  TripsUiImageGalleryLayout["LIST"] = "LIST";
})(TripsUiImageGalleryLayout || (TripsUiImageGalleryLayout = {}));
export var TripsUiItemCardMediaPosition;
(function (TripsUiItemCardMediaPosition) {
  TripsUiItemCardMediaPosition["LEFT"] = "LEFT";
  TripsUiItemCardMediaPosition["TOP"] = "TOP";
})(TripsUiItemCardMediaPosition || (TripsUiItemCardMediaPosition = {}));
export var TripsUiManageExternalItemsCheckboxCardActionType;
(function (TripsUiManageExternalItemsCheckboxCardActionType) {
  TripsUiManageExternalItemsCheckboxCardActionType["TOGGLE_ADD_LIST"] = "TOGGLE_ADD_LIST";
  TripsUiManageExternalItemsCheckboxCardActionType["TOGGLE_REMOVE_LIST"] = "TOGGLE_REMOVE_LIST";
})(TripsUiManageExternalItemsCheckboxCardActionType || (TripsUiManageExternalItemsCheckboxCardActionType = {}));
export var TripsUiMessagingBannerCardTheme;
(function (TripsUiMessagingBannerCardTheme) {
  TripsUiMessagingBannerCardTheme["CRITICAL"] = "CRITICAL";
  TripsUiMessagingBannerCardTheme["DEFAULT"] = "DEFAULT";
  TripsUiMessagingBannerCardTheme["ERROR"] = "ERROR";
})(TripsUiMessagingBannerCardTheme || (TripsUiMessagingBannerCardTheme = {}));
export var TripsUiResponseStatus;
(function (TripsUiResponseStatus) {
  TripsUiResponseStatus["FAIL"] = "FAIL";
  TripsUiResponseStatus["SUCCESS"] = "SUCCESS";
})(TripsUiResponseStatus || (TripsUiResponseStatus = {}));
export var TripsUiSingleDateSelectorFieldType;
(function (TripsUiSingleDateSelectorFieldType) {
  TripsUiSingleDateSelectorFieldType["END_DATE"] = "END_DATE";
  TripsUiSingleDateSelectorFieldType["START_DATE"] = "START_DATE";
})(TripsUiSingleDateSelectorFieldType || (TripsUiSingleDateSelectorFieldType = {}));
export var TripsViewType;
(function (TripsViewType) {
  TripsViewType["ACTIVITIES_SEARCH_RESULTS"] = "ACTIVITIES_SEARCH_RESULTS";
  TripsViewType["ASC_ACCEPT"] = "ASC_ACCEPT";
  TripsViewType["ASC_CANCEL"] = "ASC_CANCEL";
  TripsViewType["BOOKING_FLIGHT_CANCEL"] = "BOOKING_FLIGHT_CANCEL";
  TripsViewType["BOOKING_FLIGHT_CHANGE"] = "BOOKING_FLIGHT_CHANGE";
  TripsViewType["BOOKING_LODGING_CHANGE"] = "BOOKING_LODGING_CHANGE";
  TripsViewType["BOOKING_SERVICING_HEADS_UP"] = "BOOKING_SERVICING_HEADS_UP";
  TripsViewType["CAMPAIGNS"] = "CAMPAIGNS";
  TripsViewType["CARS_SEARCH_RESULTS"] = "CARS_SEARCH_RESULTS";
  TripsViewType["CHECKOUT_VAS_CART"] = "CHECKOUT_VAS_CART";
  TripsViewType["FILTERED"] = "FILTERED";
  TripsViewType["FIND_ITINERARY_BY_OTHER_EMAIL"] = "FIND_ITINERARY_BY_OTHER_EMAIL";
  TripsViewType["FIND_ITINERARY_BY_USER_EMAIL"] = "FIND_ITINERARY_BY_USER_EMAIL";
  TripsViewType["FLIGHTS_SEARCH_RESULTS"] = "FLIGHTS_SEARCH_RESULTS";
  TripsViewType["ITEM_DETAILS"] = "ITEM_DETAILS";
  TripsViewType["ITEM_ESSENTIAL_INFO"] = "ITEM_ESSENTIAL_INFO";
  TripsViewType["ITEM_PRICING_AND_REWARDS"] = "ITEM_PRICING_AND_REWARDS";
  TripsViewType["ITEM_VOUCHER"] = "ITEM_VOUCHER";
  TripsViewType["ITINERARY"] = "ITINERARY";
  TripsViewType["LOB_SELECTION_VIEW"] = "LOB_SELECTION_VIEW";
  TripsViewType["LODGING_SEARCH_RESULTS"] = "LODGING_SEARCH_RESULTS";
  TripsViewType["LOGIN_PROMPT"] = "LOGIN_PROMPT";
  TripsViewType["MANAGE_BOOKING"] = "MANAGE_BOOKING";
  TripsViewType["MANAGE_GUESTS"] = "MANAGE_GUESTS";
  TripsViewType["OVERVIEW"] = "OVERVIEW";
  TripsViewType["PACKAGES_FC_SEARCH_RESULTS"] = "PACKAGES_FC_SEARCH_RESULTS";
  TripsViewType["PACKAGES_FHC_SEARCH_RESULTS"] = "PACKAGES_FHC_SEARCH_RESULTS";
  TripsViewType["PACKAGES_HC_SEARCH_RESULTS"] = "PACKAGES_HC_SEARCH_RESULTS";
  TripsViewType["PACKAGES_HF_SEARCH_RESULTS"] = "PACKAGES_HF_SEARCH_RESULTS";
  TripsViewType["PENDING_INVITE"] = "PENDING_INVITE";
  TripsViewType["SEARCH_BY_ITINERARY_NUMBER"] = "SEARCH_BY_ITINERARY_NUMBER";
  TripsViewType["SEARCH_BY_ITINERARY_NUMBER_AND_EMAIL"] = "SEARCH_BY_ITINERARY_NUMBER_AND_EMAIL";
  TripsViewType["TRIPS_LIST"] = "TRIPS_LIST";
  TripsViewType["TRIP_ASSIST"] = "TRIP_ASSIST";
})(TripsViewType || (TripsViewType = {}));
export var UiActionName;
(function (UiActionName) {
  UiActionName["MODULE_REFRESH"] = "MODULE_REFRESH";
  UiActionName["REDIRECT_TO_UNRECOVERABLE_ERROR_PAGE"] = "REDIRECT_TO_UNRECOVERABLE_ERROR_PAGE";
  UiActionName["TRIGGER_RENDER_QUERY"] = "TRIGGER_RENDER_QUERY";
})(UiActionName || (UiActionName = {}));
/** Specifies whether to open the link in the same user interface context or in a different context */
export var UiLinkTarget;
(function (UiLinkTarget) {
  UiLinkTarget["EXTERNAL"] = "EXTERNAL";
  UiLinkTarget["INTERNAL"] = "INTERNAL";
})(UiLinkTarget || (UiLinkTarget = {}));
export var UiSignal;
(function (UiSignal) {
  UiSignal["ABANDON_BOOKING"] = "ABANDON_BOOKING";
  UiSignal["ABANDON_BOOKING_SUCCESS"] = "ABANDON_BOOKING_SUCCESS";
  UiSignal["BOOKING_ALREADY_BOOKED"] = "BOOKING_ALREADY_BOOKED";
  UiSignal["BOOKING_ERROR"] = "BOOKING_ERROR";
  UiSignal["BOOKING_SUCCESS"] = "BOOKING_SUCCESS";
  UiSignal["BOOKING_SUSPENDED"] = "BOOKING_SUSPENDED";
  UiSignal["CONFIGURATION_ADDED"] = "CONFIGURATION_ADDED";
  UiSignal["CONTINUE_BOOKING"] = "CONTINUE_BOOKING";
  UiSignal["DUPLICATE_REQUEST"] = "DUPLICATE_REQUEST";
  UiSignal["GENERIC_DOWNSTREAM_ERROR"] = "GENERIC_DOWNSTREAM_ERROR";
  UiSignal["INSURANCE_UNAVAILABLE"] = "INSURANCE_UNAVAILABLE";
  UiSignal["INVALID_EMAIL"] = "INVALID_EMAIL";
  UiSignal["OFFER_ADDED"] = "OFFER_ADDED";
  UiSignal["OFFER_CHANGED"] = "OFFER_CHANGED";
  UiSignal["OFFER_REMOVED"] = "OFFER_REMOVED";
  UiSignal["OFFER_UNAVAILABLE"] = "OFFER_UNAVAILABLE";
  UiSignal["OPERATION_FAILED"] = "OPERATION_FAILED";
  UiSignal["PAYMENT_ERROR"] = "PAYMENT_ERROR";
  UiSignal["PAYMENT_METHODS_APPLIED"] = "PAYMENT_METHODS_APPLIED";
  UiSignal["PAYMENT_METHOD_UPDATED"] = "PAYMENT_METHOD_UPDATED";
  UiSignal["PENDING_CONFIRMATION"] = "PENDING_CONFIRMATION";
  UiSignal["PRICE_ADJUSTED"] = "PRICE_ADJUSTED";
  UiSignal["PRICE_CHANGED"] = "PRICE_CHANGED";
  UiSignal["PROMOTION_CHANGED"] = "PROMOTION_CHANGED";
  UiSignal["REQUEST_CONFLICT"] = "REQUEST_CONFLICT";
  UiSignal["SESSION_EXPIRED"] = "SESSION_EXPIRED";
  UiSignal["SESSION_TOKEN_UPDATED"] = "SESSION_TOKEN_UPDATED";
  UiSignal["UNKNOWN"] = "UNKNOWN";
  UiSignal["UNRECOVERABLE_FAILURE"] = "UNRECOVERABLE_FAILURE";
  UiSignal["USER_STATE_UPDATED"] = "USER_STATE_UPDATED";
})(UiSignal || (UiSignal = {}));
export var UniversalProfileAccountManagementOptionType;
(function (UniversalProfileAccountManagementOptionType) {
  UniversalProfileAccountManagementOptionType["TRAVELER_ARRANGER"] = "TRAVELER_ARRANGER";
})(UniversalProfileAccountManagementOptionType || (UniversalProfileAccountManagementOptionType = {}));
export var UniversalProfileAccountTakeOverWidgetTypeRequest;
(function (UniversalProfileAccountTakeOverWidgetTypeRequest) {
  UniversalProfileAccountTakeOverWidgetTypeRequest["CAPTCHA"] = "CAPTCHA";
  UniversalProfileAccountTakeOverWidgetTypeRequest["CSRF"] = "CSRF";
})(UniversalProfileAccountTakeOverWidgetTypeRequest || (UniversalProfileAccountTakeOverWidgetTypeRequest = {}));
export var UniversalProfileAnalyticsEventSubType;
(function (UniversalProfileAnalyticsEventSubType) {
  UniversalProfileAnalyticsEventSubType["BLURRED"] = "BLURRED";
  UniversalProfileAnalyticsEventSubType["FOCUSED"] = "FOCUSED";
  UniversalProfileAnalyticsEventSubType["INPUTTED"] = "INPUTTED";
  UniversalProfileAnalyticsEventSubType["SUCCEEDED"] = "SUCCEEDED";
})(UniversalProfileAnalyticsEventSubType || (UniversalProfileAnalyticsEventSubType = {}));
export var UniversalProfileAvatarUploadRequestType;
(function (UniversalProfileAvatarUploadRequestType) {
  UniversalProfileAvatarUploadRequestType["ADD_IMAGE"] = "ADD_IMAGE";
  UniversalProfileAvatarUploadRequestType["CHANGE_IMAGE"] = "CHANGE_IMAGE";
})(UniversalProfileAvatarUploadRequestType || (UniversalProfileAvatarUploadRequestType = {}));
export var UniversalProfileCategorySwitchOperator;
(function (UniversalProfileCategorySwitchOperator) {
  UniversalProfileCategorySwitchOperator["OFF"] = "OFF";
  UniversalProfileCategorySwitchOperator["ON"] = "ON";
})(UniversalProfileCategorySwitchOperator || (UniversalProfileCategorySwitchOperator = {}));
export var UniversalProfileCheckboxAnalyticsEventSubType;
(function (UniversalProfileCheckboxAnalyticsEventSubType) {
  UniversalProfileCheckboxAnalyticsEventSubType["DESELECTED"] = "DESELECTED";
  UniversalProfileCheckboxAnalyticsEventSubType["SELECTED"] = "SELECTED";
})(UniversalProfileCheckboxAnalyticsEventSubType || (UniversalProfileCheckboxAnalyticsEventSubType = {}));
export var UniversalProfileClientType;
(function (UniversalProfileClientType) {
  UniversalProfileClientType["ANDROID"] = "ANDROID";
  UniversalProfileClientType["IOS"] = "IOS";
  UniversalProfileClientType["WEB"] = "WEB";
})(UniversalProfileClientType || (UniversalProfileClientType = {}));
export var UniversalProfileCommunicationPreferencesCategoryType;
(function (UniversalProfileCommunicationPreferencesCategoryType) {
  UniversalProfileCommunicationPreferencesCategoryType["ACCOUNT_SUPPORT"] = "ACCOUNT_SUPPORT";
  UniversalProfileCommunicationPreferencesCategoryType["CONFIRMATION_AND_CRITICAL_UPDATES"] = "CONFIRMATION_AND_CRITICAL_UPDATES";
  UniversalProfileCommunicationPreferencesCategoryType["OFFERS_AND_INSPIRATION"] = "OFFERS_AND_INSPIRATION";
  UniversalProfileCommunicationPreferencesCategoryType["ONE_KEY"] = "ONE_KEY";
  UniversalProfileCommunicationPreferencesCategoryType["ONE_KEY_MONTHLY_STATEMENTS"] = "ONE_KEY_MONTHLY_STATEMENTS";
  UniversalProfileCommunicationPreferencesCategoryType["ONE_KEY_REWARD_ACCOUNT_UPDATES"] = "ONE_KEY_REWARD_ACCOUNT_UPDATES";
  UniversalProfileCommunicationPreferencesCategoryType["PARTNERS_OFFERS_WITH_US"] = "PARTNERS_OFFERS_WITH_US";
  UniversalProfileCommunicationPreferencesCategoryType["PERSONALIZED_TRIP_RECOMMENDATIONS"] = "PERSONALIZED_TRIP_RECOMMENDATIONS";
  UniversalProfileCommunicationPreferencesCategoryType["REVIEWS"] = "REVIEWS";
  UniversalProfileCommunicationPreferencesCategoryType["SURVEYS"] = "SURVEYS";
  UniversalProfileCommunicationPreferencesCategoryType["THE_TRAVEL_EDIT"] = "THE_TRAVEL_EDIT";
  UniversalProfileCommunicationPreferencesCategoryType["TRIP_BOARD_ACTIVITY"] = "TRIP_BOARD_ACTIVITY";
  UniversalProfileCommunicationPreferencesCategoryType["TRIP_PLANNING_ASSISTANCE"] = "TRIP_PLANNING_ASSISTANCE";
})(UniversalProfileCommunicationPreferencesCategoryType || (UniversalProfileCommunicationPreferencesCategoryType = {}));
export var UniversalProfileCommunicationPreferencesFormType;
(function (UniversalProfileCommunicationPreferencesFormType) {
  UniversalProfileCommunicationPreferencesFormType["COMMUNICATION_PREFERENCE_CATEGORY_FORM"] = "COMMUNICATION_PREFERENCE_CATEGORY_FORM";
  UniversalProfileCommunicationPreferencesFormType["COMMUNICATION_PREFERENCE_COMPLETENESS_MODULE"] = "COMMUNICATION_PREFERENCE_COMPLETENESS_MODULE";
  UniversalProfileCommunicationPreferencesFormType["COMMUNICATION_PREFERENCE_MANAGE_EMAIL_FORM"] = "COMMUNICATION_PREFERENCE_MANAGE_EMAIL_FORM";
  UniversalProfileCommunicationPreferencesFormType["COMMUNICATION_PREFERENCE_UNSUBSCRIBE_CATEGORY_FORM"] = "COMMUNICATION_PREFERENCE_UNSUBSCRIBE_CATEGORY_FORM";
  UniversalProfileCommunicationPreferencesFormType["COMMUNICATION_PREFERENCE_UNSUBSCRIBE_STRICT_FORM"] = "COMMUNICATION_PREFERENCE_UNSUBSCRIBE_STRICT_FORM";
})(UniversalProfileCommunicationPreferencesFormType || (UniversalProfileCommunicationPreferencesFormType = {}));
export var UniversalProfileCompletenessModulePromptType;
(function (UniversalProfileCompletenessModulePromptType) {
  UniversalProfileCompletenessModulePromptType["ADD_MOBILE_NUMBER"] = "ADD_MOBILE_NUMBER";
  UniversalProfileCompletenessModulePromptType["CONFIRM_MOBILE_NUMBER"] = "CONFIRM_MOBILE_NUMBER";
  UniversalProfileCompletenessModulePromptType["EMAIL_PREFERENCES"] = "EMAIL_PREFERENCES";
  UniversalProfileCompletenessModulePromptType["ONE_KEY_CREDIT_CARD"] = "ONE_KEY_CREDIT_CARD";
  UniversalProfileCompletenessModulePromptType["PUSH_NOTIFICATION_PREFERENCES"] = "PUSH_NOTIFICATION_PREFERENCES";
})(UniversalProfileCompletenessModulePromptType || (UniversalProfileCompletenessModulePromptType = {}));
export var UniversalProfileDashboardOptionType;
(function (UniversalProfileDashboardOptionType) {
  UniversalProfileDashboardOptionType["COMMUNICATIONS"] = "COMMUNICATIONS";
  UniversalProfileDashboardOptionType["CONNECTIONS"] = "CONNECTIONS";
  UniversalProfileDashboardOptionType["COUPONS"] = "COUPONS";
  UniversalProfileDashboardOptionType["CREDITS"] = "CREDITS";
  UniversalProfileDashboardOptionType["EG_LABS"] = "EG_LABS";
  UniversalProfileDashboardOptionType["HELP"] = "HELP";
  UniversalProfileDashboardOptionType["LEGAL"] = "LEGAL";
  UniversalProfileDashboardOptionType["PAYMENTS"] = "PAYMENTS";
  UniversalProfileDashboardOptionType["PROFILE"] = "PROFILE";
  UniversalProfileDashboardOptionType["PUBLIC_PROFILE"] = "PUBLIC_PROFILE";
  UniversalProfileDashboardOptionType["REVIEWS"] = "REVIEWS";
  UniversalProfileDashboardOptionType["SETTINGS"] = "SETTINGS";
})(UniversalProfileDashboardOptionType || (UniversalProfileDashboardOptionType = {}));
export var UniversalProfileDependsOnFieldIdentificationCriteriaOperator;
(function (UniversalProfileDependsOnFieldIdentificationCriteriaOperator) {
  UniversalProfileDependsOnFieldIdentificationCriteriaOperator["EXCLUDES"] = "EXCLUDES";
  UniversalProfileDependsOnFieldIdentificationCriteriaOperator["INCLUDES"] = "INCLUDES";
})(UniversalProfileDependsOnFieldIdentificationCriteriaOperator || (UniversalProfileDependsOnFieldIdentificationCriteriaOperator = {}));
export var UniversalProfileExperienceType;
(function (UniversalProfileExperienceType) {
  UniversalProfileExperienceType["ADDITIONAL_TRAVELER"] = "ADDITIONAL_TRAVELER";
  UniversalProfileExperienceType["COMMUNICATION_PREFERENCES"] = "COMMUNICATION_PREFERENCES";
  UniversalProfileExperienceType["HELP"] = "HELP";
  UniversalProfileExperienceType["LEGAL"] = "LEGAL";
  UniversalProfileExperienceType["PROFILE"] = "PROFILE";
  UniversalProfileExperienceType["SESSION_MANAGEMENT"] = "SESSION_MANAGEMENT";
  UniversalProfileExperienceType["SETTINGS"] = "SETTINGS";
  UniversalProfileExperienceType["TRAVELER_DOCUMENTS"] = "TRAVELER_DOCUMENTS";
})(UniversalProfileExperienceType || (UniversalProfileExperienceType = {}));
export var UniversalProfileImageUploadCategory;
(function (UniversalProfileImageUploadCategory) {
  UniversalProfileImageUploadCategory["PROFILE_AVATAR"] = "PROFILE_AVATAR";
})(UniversalProfileImageUploadCategory || (UniversalProfileImageUploadCategory = {}));
export var UniversalProfileInformationFormType;
(function (UniversalProfileInformationFormType) {
  UniversalProfileInformationFormType["COMMUNICATION_PREFERENCE_UNSUB"] = "COMMUNICATION_PREFERENCE_UNSUB";
  UniversalProfileInformationFormType["COMPLETENESS_MODULE"] = "COMPLETENESS_MODULE";
  UniversalProfileInformationFormType["CONFIRM_AVATAR_UPLOAD"] = "CONFIRM_AVATAR_UPLOAD";
  UniversalProfileInformationFormType["DELETE_SAVED_CARD"] = "DELETE_SAVED_CARD";
  UniversalProfileInformationFormType["DELETE_VERIFIED_PHONE_NUMBER"] = "DELETE_VERIFIED_PHONE_NUMBER";
  UniversalProfileInformationFormType["GENERATE_AVATAR_UPLOAD_URL"] = "GENERATE_AVATAR_UPLOAD_URL";
  UniversalProfileInformationFormType["UPDATE_ADDITIONAL_TRAVELER_INFO"] = "UPDATE_ADDITIONAL_TRAVELER_INFO";
  UniversalProfileInformationFormType["UPDATE_BASIC_INFORMATION"] = "UPDATE_BASIC_INFORMATION";
  UniversalProfileInformationFormType["UPDATE_COMMUNICATION_PREFERENCE"] = "UPDATE_COMMUNICATION_PREFERENCE";
  UniversalProfileInformationFormType["UPDATE_CONTACT_INFORMATION"] = "UPDATE_CONTACT_INFORMATION";
  UniversalProfileInformationFormType["UPDATE_CONTACT_INFORMATION_EMAIL"] = "UPDATE_CONTACT_INFORMATION_EMAIL";
  UniversalProfileInformationFormType["UPDATE_CONTACT_INFORMATION_PHONE_NUMBER"] = "UPDATE_CONTACT_INFORMATION_PHONE_NUMBER";
  UniversalProfileInformationFormType["UPDATE_PASSPORT_INFO"] = "UPDATE_PASSPORT_INFO";
  UniversalProfileInformationFormType["UPDATE_TRAVELER_DOCUMENT"] = "UPDATE_TRAVELER_DOCUMENT";
  UniversalProfileInformationFormType["UPDATE_TSA_INFORMATION"] = "UPDATE_TSA_INFORMATION";
})(UniversalProfileInformationFormType || (UniversalProfileInformationFormType = {}));
export var UniversalProfileLocationAndLanguageOptionType;
(function (UniversalProfileLocationAndLanguageOptionType) {
  UniversalProfileLocationAndLanguageOptionType["COUNTY"] = "COUNTY";
  UniversalProfileLocationAndLanguageOptionType["CURRENCY"] = "CURRENCY";
  UniversalProfileLocationAndLanguageOptionType["LANGUAGE"] = "LANGUAGE";
})(UniversalProfileLocationAndLanguageOptionType || (UniversalProfileLocationAndLanguageOptionType = {}));
export var UniversalProfileLoginInformationSettingsOptionType;
(function (UniversalProfileLoginInformationSettingsOptionType) {
  UniversalProfileLoginInformationSettingsOptionType["CHANGE_PASSWORD"] = "CHANGE_PASSWORD";
  UniversalProfileLoginInformationSettingsOptionType["CONNECTED_DEVICES"] = "CONNECTED_DEVICES";
  UniversalProfileLoginInformationSettingsOptionType["DELETE_PHONE_NUMBER"] = "DELETE_PHONE_NUMBER";
  UniversalProfileLoginInformationSettingsOptionType["EMAIL"] = "EMAIL";
  UniversalProfileLoginInformationSettingsOptionType["PHONE_NUMBER"] = "PHONE_NUMBER";
})(UniversalProfileLoginInformationSettingsOptionType || (UniversalProfileLoginInformationSettingsOptionType = {}));
export var UniversalProfileMoreDetailsOptionType;
(function (UniversalProfileMoreDetailsOptionType) {
  UniversalProfileMoreDetailsOptionType["AIRPORT_SECURITY"] = "AIRPORT_SECURITY";
  UniversalProfileMoreDetailsOptionType["FLIGHT_PREFERENCES"] = "FLIGHT_PREFERENCES";
  UniversalProfileMoreDetailsOptionType["REWARD_PROGRAM"] = "REWARD_PROGRAM";
  UniversalProfileMoreDetailsOptionType["TRAVELER_DOCUMENTS"] = "TRAVELER_DOCUMENTS";
})(UniversalProfileMoreDetailsOptionType || (UniversalProfileMoreDetailsOptionType = {}));
export var UniversalProfilePreferencesOptionType;
(function (UniversalProfilePreferencesOptionType) {
  UniversalProfilePreferencesOptionType["COUNTRY"] = "COUNTRY";
  UniversalProfilePreferencesOptionType["CURRENCY"] = "CURRENCY";
  UniversalProfilePreferencesOptionType["DISPLAY_APPEARANCE"] = "DISPLAY_APPEARANCE";
  UniversalProfilePreferencesOptionType["LANGUAGE"] = "LANGUAGE";
})(UniversalProfilePreferencesOptionType || (UniversalProfilePreferencesOptionType = {}));
export var UniversalProfileSettingsFormType;
(function (UniversalProfileSettingsFormType) {
  UniversalProfileSettingsFormType["DELETE_ACCOUNT"] = "DELETE_ACCOUNT";
  UniversalProfileSettingsFormType["UPDATE_COUNTRY"] = "UPDATE_COUNTRY";
  UniversalProfileSettingsFormType["UPDATE_EMAIL"] = "UPDATE_EMAIL";
  UniversalProfileSettingsFormType["UPDATE_LANGUAGE"] = "UPDATE_LANGUAGE";
  UniversalProfileSettingsFormType["UPDATE_PASSWORD"] = "UPDATE_PASSWORD";
})(UniversalProfileSettingsFormType || (UniversalProfileSettingsFormType = {}));
export var UniversalProfileSubExperienceType;
(function (UniversalProfileSubExperienceType) {
  UniversalProfileSubExperienceType["COMMUNICATION_PREFERENCES_EXPEDIA"] = "COMMUNICATION_PREFERENCES_EXPEDIA";
  UniversalProfileSubExperienceType["COMMUNICATION_PREFERENCES_HOTELS"] = "COMMUNICATION_PREFERENCES_HOTELS";
  UniversalProfileSubExperienceType["COMMUNICATION_PREFERENCES_VRBO"] = "COMMUNICATION_PREFERENCES_VRBO";
  UniversalProfileSubExperienceType["COMMUNICATION_PREFERENCES_WOTIF"] = "COMMUNICATION_PREFERENCES_WOTIF";
  UniversalProfileSubExperienceType["VISIT_HELP_CENTER"] = "VISIT_HELP_CENTER";
})(UniversalProfileSubExperienceType || (UniversalProfileSubExperienceType = {}));
export var UniversalProfileTravelerDocumentsOptionType;
(function (UniversalProfileTravelerDocumentsOptionType) {
  UniversalProfileTravelerDocumentsOptionType["PASSPORT"] = "PASSPORT";
})(UniversalProfileTravelerDocumentsOptionType || (UniversalProfileTravelerDocumentsOptionType = {}));
export var UniversalProfileVerifiedPhoneIntent;
(function (UniversalProfileVerifiedPhoneIntent) {
  UniversalProfileVerifiedPhoneIntent["DELETE"] = "DELETE";
})(UniversalProfileVerifiedPhoneIntent || (UniversalProfileVerifiedPhoneIntent = {}));
export var UpdateAction;
(function (UpdateAction) {
  UpdateAction["ACCEPT"] = "ACCEPT";
  UpdateAction["SHARE"] = "SHARE";
})(UpdateAction || (UpdateAction = {}));
/** Enum for holding values with reference to page stack history */
export var UpdateHistory;
(function (UpdateHistory) {
  UpdateHistory["REMOVE"] = "REMOVE";
})(UpdateHistory || (UpdateHistory = {}));
export var UpdatePaymentMutationBusinessFlow;
(function (UpdatePaymentMutationBusinessFlow) {
  UpdatePaymentMutationBusinessFlow["BOOKING"] = "BOOKING";
  UpdatePaymentMutationBusinessFlow["CHECKOUT_PAYMENT_MODULE"] = "CHECKOUT_PAYMENT_MODULE";
  UpdatePaymentMutationBusinessFlow["ITINERARY"] = "ITINERARY";
})(UpdatePaymentMutationBusinessFlow || (UpdatePaymentMutationBusinessFlow = {}));
export var UploadLogoStatusType;
(function (UploadLogoStatusType) {
  UploadLogoStatusType["FAILURE"] = "FAILURE";
  UploadLogoStatusType["PENDING"] = "PENDING";
  UploadLogoStatusType["SUCCESS"] = "SUCCESS";
})(UploadLogoStatusType || (UploadLogoStatusType = {}));
export var UriClassification;
(function (UriClassification) {
  UriClassification["CLASSIFICATION_DEALS"] = "CLASSIFICATION_DEALS";
  UriClassification["CLASSIFICATION_INVALID"] = "CLASSIFICATION_INVALID";
  UriClassification["CLASSIFICATION_LEGAL"] = "CLASSIFICATION_LEGAL";
})(UriClassification || (UriClassification = {}));
/** Signal on user activity */
export var UserActivitySignal;
(function (UserActivitySignal) {
  UserActivitySignal["COLD"] = "COLD";
  UserActivitySignal["WARM"] = "WARM";
})(UserActivitySignal || (UserActivitySignal = {}));
export var VrCancellationReason;
(function (VrCancellationReason) {
  VrCancellationReason["CONFLICT_WITH_HOUSE_RULES"] = "CONFLICT_WITH_HOUSE_RULES";
  VrCancellationReason["DATES_BOOKED_EXTERNALLY"] = "DATES_BOOKED_EXTERNALLY";
  VrCancellationReason["EXTENUATING_CIRCUMSTANCES"] = "EXTENUATING_CIRCUMSTANCES";
  VrCancellationReason["GUEST_NEEDS_TO_CANCEL"] = "GUEST_NEEDS_TO_CANCEL";
  VrCancellationReason["NEW_OWNERSHIP_OF_PROPERTY"] = "NEW_OWNERSHIP_OF_PROPERTY";
  VrCancellationReason["PAYMENT_NOT_RECEIVED"] = "PAYMENT_NOT_RECEIVED";
})(VrCancellationReason || (VrCancellationReason = {}));
/** Represents the video experience component type */
export var VideoExperienceComponentType;
(function (VideoExperienceComponentType) {
  VideoExperienceComponentType["CAROUSEL"] = "CAROUSEL";
  VideoExperienceComponentType["VIDEO_PLAYER"] = "VIDEO_PLAYER";
})(VideoExperienceComponentType || (VideoExperienceComponentType = {}));
/** Represents the video experience interaction type */
export var VideoExperienceInteractionType;
(function (VideoExperienceInteractionType) {
  VideoExperienceInteractionType["BUTTON_TAP"] = "BUTTON_TAP";
  VideoExperienceInteractionType["CLICK"] = "CLICK";
  VideoExperienceInteractionType["PAUSE"] = "PAUSE";
  VideoExperienceInteractionType["PLAY"] = "PLAY";
  VideoExperienceInteractionType["SWIPE"] = "SWIPE";
  VideoExperienceInteractionType["VIEW"] = "VIEW";
  VideoExperienceInteractionType["WATCH_TIME"] = "WATCH_TIME";
})(VideoExperienceInteractionType || (VideoExperienceInteractionType = {}));
/** Represents the entry point for the video experience queries */
export var VideoExperienceProductId;
(function (VideoExperienceProductId) {
  VideoExperienceProductId["EG_STORIES"] = "EG_STORIES";
  VideoExperienceProductId["MESO_ADS"] = "MESO_ADS";
  VideoExperienceProductId["TRAVEL_SHOP"] = "TRAVEL_SHOP";
})(VideoExperienceProductId || (VideoExperienceProductId = {}));
/** Represents the status of response */
export var VirtualAgentCheckoutStatus;
(function (VirtualAgentCheckoutStatus) {
  VirtualAgentCheckoutStatus["FAILED"] = "FAILED";
  VirtualAgentCheckoutStatus["SUCCESS"] = "SUCCESS";
})(VirtualAgentCheckoutStatus || (VirtualAgentCheckoutStatus = {}));
export var VirtualAgentControlAnalyticEventSubType;
(function (VirtualAgentControlAnalyticEventSubType) {
  VirtualAgentControlAnalyticEventSubType["BLURRED"] = "BLURRED";
  VirtualAgentControlAnalyticEventSubType["FOCUSED"] = "FOCUSED";
  VirtualAgentControlAnalyticEventSubType["INPUTTED"] = "INPUTTED";
  VirtualAgentControlAnalyticEventSubType["SUCCEEDED"] = "SUCCEEDED";
})(VirtualAgentControlAnalyticEventSubType || (VirtualAgentControlAnalyticEventSubType = {}));
/** Represents event type, used by the mutation to send event data */
export var VirtualAgentControlEventType;
(function (VirtualAgentControlEventType) {
  /** Represents a conversation read event type */
  VirtualAgentControlEventType["CONVERSATION_READ"] = "CONVERSATION_READ";
  /** Represents a heartbeat event type */
  VirtualAgentControlEventType["HEARTBEAT"] = "HEARTBEAT";
  /** Represents a typing indicator event type */
  VirtualAgentControlEventType["TYPING_INDICATOR"] = "TYPING_INDICATOR";
})(VirtualAgentControlEventType || (VirtualAgentControlEventType = {}));
/** Represents event type, used by the mutation to send event data for menuItem */
export var VirtualAgentControlMenuItemType;
(function (VirtualAgentControlMenuItemType) {
  /** Represents a conversation read event type */
  VirtualAgentControlMenuItemType["DOWNLOAD_TRANSCRIPT"] = "DOWNLOAD_TRANSCRIPT";
  /** Represents a report spam event type */
  VirtualAgentControlMenuItemType["REPORT_SPAM"] = "REPORT_SPAM";
  /** Represents a block conversations event type */
  VirtualAgentControlMenuItemType["TOGGLE_BLOCK_CONVERSATION"] = "TOGGLE_BLOCK_CONVERSATION";
  /** Represents a toggle sound event type */
  VirtualAgentControlMenuItemType["TOGGLE_SOUND"] = "TOGGLE_SOUND";
})(VirtualAgentControlMenuItemType || (VirtualAgentControlMenuItemType = {}));
export var VirtualAgentControlMessageTriggerLocation;
(function (VirtualAgentControlMessageTriggerLocation) {
  VirtualAgentControlMessageTriggerLocation["EXTERNAL"] = "EXTERNAL";
  VirtualAgentControlMessageTriggerLocation["INTERNAL"] = "INTERNAL";
})(VirtualAgentControlMessageTriggerLocation || (VirtualAgentControlMessageTriggerLocation = {}));
export var VirtualAgentControlMessageType;
(function (VirtualAgentControlMessageType) {
  VirtualAgentControlMessageType["FILE"] = "FILE";
  VirtualAgentControlMessageType["INTENT"] = "INTENT";
  VirtualAgentControlMessageType["POSTBACK"] = "POSTBACK";
  VirtualAgentControlMessageType["TEXT"] = "TEXT";
})(VirtualAgentControlMessageType || (VirtualAgentControlMessageType = {}));
/** Represents the mode of user presence */
export var VirtualAgentControlPresenceMode;
(function (VirtualAgentControlPresenceMode) {
  VirtualAgentControlPresenceMode["HEARTBEAT"] = "HEARTBEAT";
  VirtualAgentControlPresenceMode["NONE"] = "NONE";
})(VirtualAgentControlPresenceMode || (VirtualAgentControlPresenceMode = {}));
/** Represents the progress bar theme/variant */
export var VirtualAgentControlProgressBarTheme;
(function (VirtualAgentControlProgressBarTheme) {
  VirtualAgentControlProgressBarTheme["MUTED"] = "MUTED";
  VirtualAgentControlProgressBarTheme["POSITIVE"] = "POSITIVE";
  VirtualAgentControlProgressBarTheme["STANDARD"] = "STANDARD";
})(VirtualAgentControlProgressBarTheme || (VirtualAgentControlProgressBarTheme = {}));
export var WaiverType;
(function (WaiverType) {
  WaiverType["ELP"] = "ELP";
  WaiverType["INSURANCE"] = "INSURANCE";
  WaiverType["NO_WAIVER"] = "NO_WAIVER";
  WaiverType["SUPPLIER"] = "SUPPLIER";
})(WaiverType || (WaiverType = {}));
export var WaivingSource;
(function (WaivingSource) {
  WaivingSource["COMBINED"] = "COMBINED";
  WaivingSource["EXPEDIA"] = "EXPEDIA";
  WaivingSource["NO_WAIVER"] = "NO_WAIVER";
  WaivingSource["SUPPLIER"] = "SUPPLIER";
})(WaivingSource || (WaivingSource = {}));
export var WalletLedgerTabType;
(function (WalletLedgerTabType) {
  WalletLedgerTabType["ONE_KEY_CASH"] = "ONE_KEY_CASH";
  WalletLedgerTabType["REFUND_CREDITS"] = "REFUND_CREDITS";
})(WalletLedgerTabType || (WalletLedgerTabType = {}));
export var WidgetCardType;
(function (WidgetCardType) {
  WidgetCardType["GET_THERE"] = "GET_THERE";
  WidgetCardType["THINGS_TO_DO"] = "THINGS_TO_DO";
  WidgetCardType["VIBES"] = "VIBES";
  WidgetCardType["WEATHER"] = "WEATHER";
})(WidgetCardType || (WidgetCardType = {}));
export var WishlistPageType;
(function (WishlistPageType) {
  WishlistPageType["DISCOVER"] = "DISCOVER";
  WishlistPageType["EXPANDED_WISHLIST"] = "EXPANDED_WISHLIST";
  WishlistPageType["TRIPS"] = "TRIPS";
})(WishlistPageType || (WishlistPageType = {}));
export var WizardMode;
(function (WizardMode) {
  WizardMode["CREATE"] = "CREATE";
  WizardMode["EDIT"] = "EDIT";
})(WizardMode || (WizardMode = {}));
export var WizardStep;
(function (WizardStep) {
  WizardStep["AD"] = "AD";
  WizardStep["AD_GROUP"] = "AD_GROUP";
  WizardStep["CAMPAIGN"] = "CAMPAIGN";
  WizardStep["REVIEW"] = "REVIEW";
})(WizardStep || (WizardStep = {}));
export var EgdsIconFragmentFragmentDoc = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment EGDSIconFragment on Icon {\n    description\n    id\n    size\n    theme\n    title\n    withBackground\n    __typename\n  }\n"], ["\n  fragment EGDSIconFragment on Icon {\n    description\n    id\n    size\n    theme\n    title\n    withBackground\n    __typename\n  }\n"])));
export var EgdsGraphicFragmentFragmentDoc = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  fragment EGDSGraphicFragment on UIGraphic {\n    ... on Icon {\n      ...EGDSIconFragment\n      __typename\n    }\n    __typename\n  }\n  ", "\n"], ["\n  fragment EGDSGraphicFragment on UIGraphic {\n    ... on Icon {\n      ...EGDSIconFragment\n      __typename\n    }\n    __typename\n  }\n  ", "\n"])), EgdsIconFragmentFragmentDoc);
export var ClientSideAnalyticsFragmentFragmentDoc = gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    linkName\n    referrerId\n    __typename\n  }\n"], ["\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    linkName\n    referrerId\n    __typename\n  }\n"])));
export var EgdsStandardBadgeFragmentFragmentDoc = gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  fragment EGDSStandardBadgeFragment on EGDSStandardBadge {\n    __typename\n    text\n    theme\n    accessibility\n    size\n  }\n"], ["\n  fragment EGDSStandardBadgeFragment on EGDSStandardBadge {\n    __typename\n    text\n    theme\n    accessibility\n    size\n  }\n"])));
export var ActivityDestinationViewSearchDocument = gql(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  query ActivityDestinationViewSearch(\n    $context: ContextInput!\n    $destination: ActivityDestinationInput!\n    $dateRange: ActivityDateRangeInput\n    $sort: ActivitySort\n    $filters: ActivitySearchFiltersInput\n    $pagination: PaginationInput\n    $marketing: ActivityMarketingInfoInput\n    $searchViewOptions: [ActivitySearchViewOptions!]\n  ) {\n    activitySearch(\n      context: $context\n      destination: $destination\n      dateRange: $dateRange\n      sort: $sort\n      filters: $filters\n      pagination: $pagination\n      marketing: $marketing\n      searchViewOptions: $searchViewOptions\n    ) {\n      pageTitle\n      searchSummary {\n        pageInfo {\n          pageId\n          pageName\n          title\n        }\n        paginationInfo {\n          pageSize\n        }\n        messages {\n          index\n          type\n          title {\n            text\n            icon {\n              description\n              id\n              size\n              withBackground\n            }\n            mark {\n              description\n              id\n              url {\n                value\n              }\n            }\n          }\n          subtitle {\n            text\n            icon {\n              description\n              id\n              size\n              withBackground\n            }\n            mark {\n              description\n              id\n            }\n          }\n          action {\n            primary {\n              href\n              rfrr\n              text\n            }\n            secondary {\n              href\n              rfrr\n              text\n            }\n          }\n        }\n        dateValidationResult {\n          dateAdjusted\n          formattedStartDate\n          formattedEndDate\n        }\n        aboveTheFold {\n          banners {\n            title\n            subtitle\n            icon {\n              description\n              id\n              size\n              withBackground\n            }\n            mark {\n              description\n              id\n            }\n            action {\n              href\n              text\n              rfrr\n            }\n            type\n          }\n          breadcrumbs {\n            label\n            selectionsToRemove {\n              id\n              value\n            }\n            analytics {\n              linkName\n              referrerId\n            }\n          }\n        }\n        resolvedRegion {\n          regionId\n          regionName\n          fullRegionName\n        }\n      }\n      activityGroups {\n        heading {\n          ... on EGDSHeading {\n            text\n            headingType\n          }\n        }\n        type\n        viewType\n        action {\n          label\n          accessibilityText\n          url\n          analytics {\n            linkName\n            referrerId\n          }\n        }\n        analyticsList {\n          linkName\n          referrerId\n        }\n        activityTiles {\n          __typename\n          ... on Activity {\n            id\n            primary {\n              ... on EGDSHeading {\n                text\n                headingType\n              }\n            }\n            description\n            supplierName\n            clientSideAnalytics {\n              ...ClientSideAnalyticsFragment\n            }\n            image {\n              description\n              url\n            }\n            cardBadges {\n              ... on ActivityCardBadges {\n                secondary {\n                  ... on EGDSStandardBadge {\n                    text\n                    theme\n                    graphic {\n                      ... on Icon {\n                        description\n                        id\n                        size\n                      }\n                      ... on Mark {\n                        description\n                        id\n                      }\n                    }\n                  }\n                }\n                primary {\n                  ... on EGDSStandardBadge {\n                    text\n                    theme\n                    graphic {\n                      ... on Icon {\n                        description\n                        id\n                        size\n                      }\n                      ... on Mark {\n                        description\n                        id\n                        url {\n                          ... on HttpURI {\n                            __typename\n                            relativePath\n                            value\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n            activityDuration {\n              ... on EGDSIconText {\n                text\n                icon {\n                  id\n                }\n              }\n            }\n            features {\n              volumePricing {\n                description\n              }\n              freeCancellationFeature {\n                ... on EGDSStylizedText {\n                  text\n                  theme\n                  weight\n                }\n              }\n              loyaltyEarnAwards {\n                mark {\n                  id\n                  url {\n                    value\n                  }\n                }\n                label\n              }\n              pinnedTopBottom {\n                tileTop {\n                  description\n                }\n                tileBottom {\n                  id\n                  description\n                }\n              }\n              travelDistance {\n                label\n              }\n              hotelPickup {\n                icon_temp {\n                  id\n                }\n                label\n              }\n              enhancedCleaningFeature {\n                ... on EGDSIconText {\n                  text\n                  icon {\n                    id\n                    size\n                  }\n                }\n              }\n            }\n            leadTicketPrice {\n              __typename\n              priceLockup {\n                ... on EGDSPriceLockup {\n                  __typename\n                  priceSubtextFirst\n                  priceSubtextStandard\n                  lockupPrice\n                  strikeThroughPrice\n                  accessibilityStrikeThroughDialogTrigger\n                  accessibilityPrice\n                  lockupFormattedPoints\n                  leadingCaption\n                  isPointsFirst\n                  isStrikeThroughFirst\n                }\n              }\n              disclaimer {\n                ... on ActivityDisclaimerDialog {\n                  __typename\n                  dialog {\n                    ... on EGDSActionDialog {\n                      closeAnalytics {\n                        ...ClientSideAnalyticsFragment\n                      }\n                      footer {\n                        ... on EGDSInlineDialogFooter {\n                          buttons {\n                            ... on UITertiaryButton {\n                              accessibility\n                              primary\n                            }\n                          }\n                        }\n                      }\n                    }\n                  }\n                  trigger {\n                    ... on ActivityGraphicDialogTrigger {\n                      analytics {\n                        ...ClientSideAnalyticsFragment\n                      }\n                      accessibility\n                      graphic {\n                        ... on Icon {\n                          id\n                          description\n                        }\n                      }\n                    }\n                  }\n                  contents {\n                    ... on EGDSPlainText {\n                      text\n                    }\n                  }\n                  dialogActions {\n                    ... on ActivityLinkClickAction {\n                      accessibilityText\n                      analytics {\n                        ... on ActivityAnalytics {\n                          linkName\n                          referrerId\n                        }\n                      }\n                      opensInNewTab\n                      linkTagUrl\n                      anchorTagUrl\n                    }\n                  }\n                }\n              }\n            }\n            reviewSummary {\n              reviewRatingMessage\n              reviewCountMessage\n              reviewRatingBadge {\n                ...EGDSStandardBadgeFragment\n              }\n              reviewSuperlative {\n                ... on EGDSStylizedText {\n                  __typename\n                  text\n                  theme\n                  weight\n                  size\n                }\n              }\n              source\n              blockWebCrawlersEnabled\n              reviewRatingAccessibilityText\n              averageScore {\n                ... on EGDSStylizedText {\n                  __typename\n                  text\n                  weight\n                }\n              }\n              total\n              disclaimer {\n                ... on ActivityDisclaimerDialog {\n                  __typename\n                  dialog {\n                    ... on EGDSActionDialog {\n                      closeAnalytics {\n                        ...ClientSideAnalyticsFragment\n                      }\n                      footer {\n                        ... on EGDSInlineDialogFooter {\n                          buttons {\n                            ... on UITertiaryButton {\n                              accessibility\n                              primary\n                            }\n                          }\n                        }\n                      }\n                    }\n                  }\n                  trigger {\n                    ... on ActivityLinkDialogTrigger {\n                      analytics {\n                        ...ClientSideAnalyticsFragment\n                      }\n                      accessibility\n                      label\n                      graphic {\n                        ... on Icon {\n                          id\n                          description\n                        }\n                      }\n                    }\n                  }\n                  contents {\n                    ... on EGDSParagraph {\n                      style\n                      text\n                    }\n                  }\n                  dialogActions {\n                    ... on ActivityLinkClickAction {\n                      accessibilityText\n                      analytics {\n                        ... on ActivityAnalytics {\n                          linkName\n                          referrerId\n                        }\n                      }\n                      opensInNewTab\n                      linkTagUrl\n                      anchorTagUrl\n                    }\n                  }\n                }\n              }\n              sectionRef\n            }\n            saveItem {\n              initialChecked\n              itemId\n              source\n              attributes {\n                ... on TripsSaveActivityAttributes {\n                  regionId\n                  dateRange {\n                    start {\n                      day\n                      month\n                      year\n                      __typename\n                    }\n                    end {\n                      day\n                      month\n                      year\n                      __typename\n                    }\n                    __typename\n                  }\n                }\n                __typename\n              }\n              save {\n                accessibility\n                analytics {\n                  referrerId\n                  linkName\n                  uisPrimeMessages {\n                    messageContent\n                    schemaName\n                  }\n                  __typename\n                }\n                label\n                __typename\n              }\n              remove {\n                accessibility\n                analytics {\n                  referrerId\n                  linkName\n                  uisPrimeMessages {\n                    messageContent\n                    schemaName\n                  }\n                  __typename\n                }\n                label\n                __typename\n              }\n              __typename\n            }\n            thirdPartyPartnerName\n            clickAction {\n              openInNewTab\n              uri {\n                relativePath\n              }\n            }\n            imageCarousel {\n              __typename\n              items {\n                __typename\n                ... on EGDSMediaCarouselItem {\n                  media {\n                    __typename\n                    ... on ActivityMediaItem {\n                      media {\n                        __typename\n                        ... on Image {\n                          __typename\n                          description\n                          url\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n              nextButton {\n                accessibility\n                analytics {\n                  referrerId\n                  linkName\n                }\n              }\n              previousButton {\n                accessibility\n                analytics {\n                  referrerId\n                  linkName\n                }\n              }\n            }\n          }\n          ... on ActivityBasicTile {\n            primary {\n              ... on EGDSHeading {\n                text\n                headingType\n              }\n              ... on EGDSPlainText {\n                text\n              }\n            }\n            link\n            image {\n              description\n              url\n            }\n            clientSideAnalytics {\n              ...ClientSideAnalyticsFragment\n            }\n            secondaryMessage\n            enabled\n          }\n          ... on ActivityMessageTile {\n            type\n            title {\n              text\n            }\n            subtitle {\n              text\n            }\n            action {\n              first {\n                text\n                clickAction {\n                  __typename\n                  analytics {\n                    microMessagePayload\n                    linkName\n                    referrerId\n                  }\n                  ... on ActivityLinkClickAction {\n                    linkTagUrl\n                    anchorTagUrl\n                    opensInNewTab\n                    accessibilityText\n                  }\n                  ... on ActivityPopupClickAction {\n                    dismissAction {\n                      text\n                      href\n                      rfrr\n                    }\n                    title\n                    messages\n                  }\n                }\n              }\n              second {\n                text\n                clickAction {\n                  __typename\n                  analytics {\n                    microMessagePayload\n                    linkName\n                    referrerId\n                  }\n                  ... on ActivityLinkClickAction {\n                    linkTagUrl\n                    anchorTagUrl\n                    opensInNewTab\n                    accessibilityText\n                  }\n                  ... on ActivityPopupClickAction {\n                    dismissAction {\n                      text\n                      href\n                      rfrr\n                    }\n                    title\n                    messages\n                  }\n                }\n              }\n            }\n            icon {\n              description\n              id\n              withBackground\n              size\n            }\n            mark {\n              description\n              id\n              url {\n                value\n              }\n            }\n            graphic {\n              ... on Illustration {\n                __typename\n                description\n                id\n                url\n              }\n            }\n            analytics {\n              linkName\n              referrerId\n            }\n            signInButton {\n              ... on UIPrimaryButton {\n                primary\n                action {\n                  ... on UILinkAction {\n                    analytics {\n                      linkName\n                      referrerId\n                    }\n                    resource {\n                      ... on HttpURI {\n                        relativePath\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n          ... on ActivityTextTile {\n            anchoredText {\n              clickAction {\n                analytics {\n                  linkName\n                  referrerId\n                }\n                ... on ActivityLinkClickAction {\n                  anchorTagUrl\n                  opensInNewTab\n                  accessibilityText\n                }\n              }\n              icon {\n                id\n                description\n              }\n              text\n            }\n            activityText {\n              ... on ActivityText {\n                __typename\n                text\n                size\n              }\n            }\n            alignment\n          }\n          ... on ActivityAssortedComponentsTile {\n            sortSection {\n              ... on ShoppingSortAndFilterSection {\n                fields {\n                  ... on ShoppingDropdownField {\n                    __typename\n                    primary\n                    options {\n                      primary\n                      value\n                      selected\n                      disabled\n                      selectAnalytics {\n                        linkName\n                        referrerId\n                      }\n                    }\n                  }\n                }\n              }\n            }\n            shopWithPoints {\n              ... on ActivityToggle {\n                checked\n                checkedLabel\n                uncheckedLabel\n                checkedAnalytics {\n                  linkName\n                  referrerId\n                }\n                uncheckedAnalytics {\n                  linkName\n                  referrerId\n                }\n              }\n            }\n            sortDisclaimer {\n              text\n              icon {\n                id\n                description\n              }\n              clickAction {\n                ... on ActivityLinkClickAction {\n                  anchorTagUrl\n                  analytics {\n                    linkName\n                    referrerId\n                  }\n                  accessibilityText\n                  opensInNewTab\n                }\n              }\n            }\n            pills {\n              appliedFilters {\n                nextSearchCriteria {\n                  selections {\n                    id\n                    value\n                  }\n                }\n                pill {\n                  primary\n                  accessibility\n                  action {\n                    ... on ShoppingSortAndFilterAction {\n                      analytics {\n                        linkName\n                        referrerId\n                      }\n                    }\n                  }\n                }\n              }\n              clearAll {\n                ... on UITertiaryButton {\n                  primary\n                  action {\n                    ... on UILinkAction {\n                      analytics {\n                        linkName\n                        referrerId\n                      }\n                      resource {\n                        ... on HttpURI {\n                          relativePath\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n          ... on ActivityEmptyStateTile {\n            heading\n            body\n            icon {\n              id\n              description\n            }\n            analytics {\n              referrerId\n              linkName\n            }\n          }\n        }\n      }\n      universalSortAndFilter {\n        ... on ShoppingSortAndFilters {\n          applyAction {\n            ... on UIPrimaryFloatingActionButton {\n              primary\n              accessibility\n              action {\n                ... on ShoppingSortAndFilterAction {\n                  analytics {\n                    referrerId\n                    linkName\n                  }\n                }\n              }\n            }\n          }\n          revealAction {\n            ... on UISecondaryFloatingActionButton {\n              primary\n              accessibility\n              badge\n              action {\n                ... on ShoppingSortAndFilterAction {\n                  analytics {\n                    referrerId\n                    linkName\n                  }\n                }\n              }\n            }\n          }\n          toolbar {\n            primary\n            actions {\n              ... on UIToolbarActions {\n                primary {\n                  accessibility\n                }\n                secondaries {\n                  primary\n                  accessibility\n                  action {\n                    ... on ShoppingSortAndFilterAction {\n                      analytics {\n                        referrerId\n                        linkName\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n          clearAll {\n            ... on UITertiaryButton {\n              primary\n              action {\n                ... on UILinkAction {\n                  analytics {\n                    linkName\n                    referrerId\n                  }\n                  resource {\n                    ... on HttpURI {\n                      relativePath\n                    }\n                  }\n                }\n              }\n            }\n          }\n          appliedFilters {\n            ... on EGDSSortAndFilterAppliedFilter {\n              pill {\n                primary\n                accessibility\n                action {\n                  ... on ShoppingSortAndFilterAction {\n                    analytics {\n                      linkName\n                      referrerId\n                    }\n                  }\n                }\n              }\n              nextSearchCriteria {\n                selections {\n                  id\n                  value\n                }\n              }\n            }\n          }\n          sortSections {\n            ... on ShoppingSortAndFilterSection {\n              fields {\n                ... on ShoppingDropdownField {\n                  __typename\n                  primary\n                  options {\n                    ... on ShoppingSelectableFilterOption {\n                      id\n                      value\n                      primary\n                      selected\n                      secondary\n                      disabled\n                      icon {\n                        id\n                        description\n                      }\n                      selectAnalytics {\n                        linkName\n                        referrerId\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n          filterSections {\n            ... on ShoppingSortAndFilterSection {\n              title\n              fields {\n                ... on ShoppingTextInputField {\n                  __typename\n                  id\n                  label\n                  placeholder\n                  icon {\n                    id\n                  }\n                  analytics {\n                    linkName\n                    referrerId\n                  }\n                  selected\n                }\n                ... on ShoppingMultiSelectionField {\n                  __typename\n                  primary\n                  options {\n                    ... on ShoppingSelectableFilterOption {\n                      value\n                      id\n                      primary\n                      selected\n                      description\n                      disabled\n                      selectAnalytics {\n                        linkName\n                        referrerId\n                      }\n                      deselectAnalytics {\n                        linkName\n                        referrerId\n                      }\n                      nestedOptions {\n                        value\n                        id\n                        primary\n                        selected\n                        description\n                        disabled\n                        selectAnalytics {\n                          linkName\n                          referrerId\n                        }\n                        deselectAnalytics {\n                          linkName\n                          referrerId\n                        }\n                      }\n                      accessibility\n                    }\n                  }\n                }\n                ... on ShoppingSelectionField {\n                  __typename\n                  primary\n                  options {\n                    ... on ShoppingSelectableFilterOption {\n                      id\n                      value\n                      primary\n                      selected\n                      description\n                      disabled\n                      selectAnalytics {\n                        linkName\n                        referrerId\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      noMatchesFound {\n        title\n        message\n        graphic {\n          ...EGDSGraphicFragment\n          __typename\n        }\n        filterPills {\n          ... on ShoppingAppliedFilter {\n            ... on BasicShoppingAppliedFilter {\n              filter {\n                ... on EGDSPill {\n                  ... on EGDSBasicRemovablePill {\n                    accessibility\n                    disabled\n                    icon {\n                      ...EGDSGraphicFragment\n                      __typename\n                    }\n                    name\n                    primary\n                    remove {\n                      ...EGDSGraphicFragment\n                      __typename\n                    }\n                    removeAnalytics {\n                      ...ClientSideAnalyticsFragment\n                    }\n                    selected\n                    value\n                    __typename\n                  }\n                  __typename\n                }\n              }\n              nextSearchCriteria {\n                selections {\n                  id\n                  value\n                  __typename\n                }\n                __typename\n              }\n            }\n          }\n          __typename\n        }\n        removeAllFiltersButton {\n          primary\n          accessibility\n          __typename\n        }\n        removeAllFiltersAction {\n          ... on ActivityLinkClickAction {\n            linkTagUrl\n            clientSideAnalytics {\n              ...ClientSideAnalyticsFragment\n            }\n            __typename\n          }\n          __typename\n        }\n        analytics {\n          ...ClientSideAnalyticsFragment\n        }\n        __typename\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n"], ["\n  query ActivityDestinationViewSearch(\n    $context: ContextInput!\n    $destination: ActivityDestinationInput!\n    $dateRange: ActivityDateRangeInput\n    $sort: ActivitySort\n    $filters: ActivitySearchFiltersInput\n    $pagination: PaginationInput\n    $marketing: ActivityMarketingInfoInput\n    $searchViewOptions: [ActivitySearchViewOptions!]\n  ) {\n    activitySearch(\n      context: $context\n      destination: $destination\n      dateRange: $dateRange\n      sort: $sort\n      filters: $filters\n      pagination: $pagination\n      marketing: $marketing\n      searchViewOptions: $searchViewOptions\n    ) {\n      pageTitle\n      searchSummary {\n        pageInfo {\n          pageId\n          pageName\n          title\n        }\n        paginationInfo {\n          pageSize\n        }\n        messages {\n          index\n          type\n          title {\n            text\n            icon {\n              description\n              id\n              size\n              withBackground\n            }\n            mark {\n              description\n              id\n              url {\n                value\n              }\n            }\n          }\n          subtitle {\n            text\n            icon {\n              description\n              id\n              size\n              withBackground\n            }\n            mark {\n              description\n              id\n            }\n          }\n          action {\n            primary {\n              href\n              rfrr\n              text\n            }\n            secondary {\n              href\n              rfrr\n              text\n            }\n          }\n        }\n        dateValidationResult {\n          dateAdjusted\n          formattedStartDate\n          formattedEndDate\n        }\n        aboveTheFold {\n          banners {\n            title\n            subtitle\n            icon {\n              description\n              id\n              size\n              withBackground\n            }\n            mark {\n              description\n              id\n            }\n            action {\n              href\n              text\n              rfrr\n            }\n            type\n          }\n          breadcrumbs {\n            label\n            selectionsToRemove {\n              id\n              value\n            }\n            analytics {\n              linkName\n              referrerId\n            }\n          }\n        }\n        resolvedRegion {\n          regionId\n          regionName\n          fullRegionName\n        }\n      }\n      activityGroups {\n        heading {\n          ... on EGDSHeading {\n            text\n            headingType\n          }\n        }\n        type\n        viewType\n        action {\n          label\n          accessibilityText\n          url\n          analytics {\n            linkName\n            referrerId\n          }\n        }\n        analyticsList {\n          linkName\n          referrerId\n        }\n        activityTiles {\n          __typename\n          ... on Activity {\n            id\n            primary {\n              ... on EGDSHeading {\n                text\n                headingType\n              }\n            }\n            description\n            supplierName\n            clientSideAnalytics {\n              ...ClientSideAnalyticsFragment\n            }\n            image {\n              description\n              url\n            }\n            cardBadges {\n              ... on ActivityCardBadges {\n                secondary {\n                  ... on EGDSStandardBadge {\n                    text\n                    theme\n                    graphic {\n                      ... on Icon {\n                        description\n                        id\n                        size\n                      }\n                      ... on Mark {\n                        description\n                        id\n                      }\n                    }\n                  }\n                }\n                primary {\n                  ... on EGDSStandardBadge {\n                    text\n                    theme\n                    graphic {\n                      ... on Icon {\n                        description\n                        id\n                        size\n                      }\n                      ... on Mark {\n                        description\n                        id\n                        url {\n                          ... on HttpURI {\n                            __typename\n                            relativePath\n                            value\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n            activityDuration {\n              ... on EGDSIconText {\n                text\n                icon {\n                  id\n                }\n              }\n            }\n            features {\n              volumePricing {\n                description\n              }\n              freeCancellationFeature {\n                ... on EGDSStylizedText {\n                  text\n                  theme\n                  weight\n                }\n              }\n              loyaltyEarnAwards {\n                mark {\n                  id\n                  url {\n                    value\n                  }\n                }\n                label\n              }\n              pinnedTopBottom {\n                tileTop {\n                  description\n                }\n                tileBottom {\n                  id\n                  description\n                }\n              }\n              travelDistance {\n                label\n              }\n              hotelPickup {\n                icon_temp {\n                  id\n                }\n                label\n              }\n              enhancedCleaningFeature {\n                ... on EGDSIconText {\n                  text\n                  icon {\n                    id\n                    size\n                  }\n                }\n              }\n            }\n            leadTicketPrice {\n              __typename\n              priceLockup {\n                ... on EGDSPriceLockup {\n                  __typename\n                  priceSubtextFirst\n                  priceSubtextStandard\n                  lockupPrice\n                  strikeThroughPrice\n                  accessibilityStrikeThroughDialogTrigger\n                  accessibilityPrice\n                  lockupFormattedPoints\n                  leadingCaption\n                  isPointsFirst\n                  isStrikeThroughFirst\n                }\n              }\n              disclaimer {\n                ... on ActivityDisclaimerDialog {\n                  __typename\n                  dialog {\n                    ... on EGDSActionDialog {\n                      closeAnalytics {\n                        ...ClientSideAnalyticsFragment\n                      }\n                      footer {\n                        ... on EGDSInlineDialogFooter {\n                          buttons {\n                            ... on UITertiaryButton {\n                              accessibility\n                              primary\n                            }\n                          }\n                        }\n                      }\n                    }\n                  }\n                  trigger {\n                    ... on ActivityGraphicDialogTrigger {\n                      analytics {\n                        ...ClientSideAnalyticsFragment\n                      }\n                      accessibility\n                      graphic {\n                        ... on Icon {\n                          id\n                          description\n                        }\n                      }\n                    }\n                  }\n                  contents {\n                    ... on EGDSPlainText {\n                      text\n                    }\n                  }\n                  dialogActions {\n                    ... on ActivityLinkClickAction {\n                      accessibilityText\n                      analytics {\n                        ... on ActivityAnalytics {\n                          linkName\n                          referrerId\n                        }\n                      }\n                      opensInNewTab\n                      linkTagUrl\n                      anchorTagUrl\n                    }\n                  }\n                }\n              }\n            }\n            reviewSummary {\n              reviewRatingMessage\n              reviewCountMessage\n              reviewRatingBadge {\n                ...EGDSStandardBadgeFragment\n              }\n              reviewSuperlative {\n                ... on EGDSStylizedText {\n                  __typename\n                  text\n                  theme\n                  weight\n                  size\n                }\n              }\n              source\n              blockWebCrawlersEnabled\n              reviewRatingAccessibilityText\n              averageScore {\n                ... on EGDSStylizedText {\n                  __typename\n                  text\n                  weight\n                }\n              }\n              total\n              disclaimer {\n                ... on ActivityDisclaimerDialog {\n                  __typename\n                  dialog {\n                    ... on EGDSActionDialog {\n                      closeAnalytics {\n                        ...ClientSideAnalyticsFragment\n                      }\n                      footer {\n                        ... on EGDSInlineDialogFooter {\n                          buttons {\n                            ... on UITertiaryButton {\n                              accessibility\n                              primary\n                            }\n                          }\n                        }\n                      }\n                    }\n                  }\n                  trigger {\n                    ... on ActivityLinkDialogTrigger {\n                      analytics {\n                        ...ClientSideAnalyticsFragment\n                      }\n                      accessibility\n                      label\n                      graphic {\n                        ... on Icon {\n                          id\n                          description\n                        }\n                      }\n                    }\n                  }\n                  contents {\n                    ... on EGDSParagraph {\n                      style\n                      text\n                    }\n                  }\n                  dialogActions {\n                    ... on ActivityLinkClickAction {\n                      accessibilityText\n                      analytics {\n                        ... on ActivityAnalytics {\n                          linkName\n                          referrerId\n                        }\n                      }\n                      opensInNewTab\n                      linkTagUrl\n                      anchorTagUrl\n                    }\n                  }\n                }\n              }\n              sectionRef\n            }\n            saveItem {\n              initialChecked\n              itemId\n              source\n              attributes {\n                ... on TripsSaveActivityAttributes {\n                  regionId\n                  dateRange {\n                    start {\n                      day\n                      month\n                      year\n                      __typename\n                    }\n                    end {\n                      day\n                      month\n                      year\n                      __typename\n                    }\n                    __typename\n                  }\n                }\n                __typename\n              }\n              save {\n                accessibility\n                analytics {\n                  referrerId\n                  linkName\n                  uisPrimeMessages {\n                    messageContent\n                    schemaName\n                  }\n                  __typename\n                }\n                label\n                __typename\n              }\n              remove {\n                accessibility\n                analytics {\n                  referrerId\n                  linkName\n                  uisPrimeMessages {\n                    messageContent\n                    schemaName\n                  }\n                  __typename\n                }\n                label\n                __typename\n              }\n              __typename\n            }\n            thirdPartyPartnerName\n            clickAction {\n              openInNewTab\n              uri {\n                relativePath\n              }\n            }\n            imageCarousel {\n              __typename\n              items {\n                __typename\n                ... on EGDSMediaCarouselItem {\n                  media {\n                    __typename\n                    ... on ActivityMediaItem {\n                      media {\n                        __typename\n                        ... on Image {\n                          __typename\n                          description\n                          url\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n              nextButton {\n                accessibility\n                analytics {\n                  referrerId\n                  linkName\n                }\n              }\n              previousButton {\n                accessibility\n                analytics {\n                  referrerId\n                  linkName\n                }\n              }\n            }\n          }\n          ... on ActivityBasicTile {\n            primary {\n              ... on EGDSHeading {\n                text\n                headingType\n              }\n              ... on EGDSPlainText {\n                text\n              }\n            }\n            link\n            image {\n              description\n              url\n            }\n            clientSideAnalytics {\n              ...ClientSideAnalyticsFragment\n            }\n            secondaryMessage\n            enabled\n          }\n          ... on ActivityMessageTile {\n            type\n            title {\n              text\n            }\n            subtitle {\n              text\n            }\n            action {\n              first {\n                text\n                clickAction {\n                  __typename\n                  analytics {\n                    microMessagePayload\n                    linkName\n                    referrerId\n                  }\n                  ... on ActivityLinkClickAction {\n                    linkTagUrl\n                    anchorTagUrl\n                    opensInNewTab\n                    accessibilityText\n                  }\n                  ... on ActivityPopupClickAction {\n                    dismissAction {\n                      text\n                      href\n                      rfrr\n                    }\n                    title\n                    messages\n                  }\n                }\n              }\n              second {\n                text\n                clickAction {\n                  __typename\n                  analytics {\n                    microMessagePayload\n                    linkName\n                    referrerId\n                  }\n                  ... on ActivityLinkClickAction {\n                    linkTagUrl\n                    anchorTagUrl\n                    opensInNewTab\n                    accessibilityText\n                  }\n                  ... on ActivityPopupClickAction {\n                    dismissAction {\n                      text\n                      href\n                      rfrr\n                    }\n                    title\n                    messages\n                  }\n                }\n              }\n            }\n            icon {\n              description\n              id\n              withBackground\n              size\n            }\n            mark {\n              description\n              id\n              url {\n                value\n              }\n            }\n            graphic {\n              ... on Illustration {\n                __typename\n                description\n                id\n                url\n              }\n            }\n            analytics {\n              linkName\n              referrerId\n            }\n            signInButton {\n              ... on UIPrimaryButton {\n                primary\n                action {\n                  ... on UILinkAction {\n                    analytics {\n                      linkName\n                      referrerId\n                    }\n                    resource {\n                      ... on HttpURI {\n                        relativePath\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n          ... on ActivityTextTile {\n            anchoredText {\n              clickAction {\n                analytics {\n                  linkName\n                  referrerId\n                }\n                ... on ActivityLinkClickAction {\n                  anchorTagUrl\n                  opensInNewTab\n                  accessibilityText\n                }\n              }\n              icon {\n                id\n                description\n              }\n              text\n            }\n            activityText {\n              ... on ActivityText {\n                __typename\n                text\n                size\n              }\n            }\n            alignment\n          }\n          ... on ActivityAssortedComponentsTile {\n            sortSection {\n              ... on ShoppingSortAndFilterSection {\n                fields {\n                  ... on ShoppingDropdownField {\n                    __typename\n                    primary\n                    options {\n                      primary\n                      value\n                      selected\n                      disabled\n                      selectAnalytics {\n                        linkName\n                        referrerId\n                      }\n                    }\n                  }\n                }\n              }\n            }\n            shopWithPoints {\n              ... on ActivityToggle {\n                checked\n                checkedLabel\n                uncheckedLabel\n                checkedAnalytics {\n                  linkName\n                  referrerId\n                }\n                uncheckedAnalytics {\n                  linkName\n                  referrerId\n                }\n              }\n            }\n            sortDisclaimer {\n              text\n              icon {\n                id\n                description\n              }\n              clickAction {\n                ... on ActivityLinkClickAction {\n                  anchorTagUrl\n                  analytics {\n                    linkName\n                    referrerId\n                  }\n                  accessibilityText\n                  opensInNewTab\n                }\n              }\n            }\n            pills {\n              appliedFilters {\n                nextSearchCriteria {\n                  selections {\n                    id\n                    value\n                  }\n                }\n                pill {\n                  primary\n                  accessibility\n                  action {\n                    ... on ShoppingSortAndFilterAction {\n                      analytics {\n                        linkName\n                        referrerId\n                      }\n                    }\n                  }\n                }\n              }\n              clearAll {\n                ... on UITertiaryButton {\n                  primary\n                  action {\n                    ... on UILinkAction {\n                      analytics {\n                        linkName\n                        referrerId\n                      }\n                      resource {\n                        ... on HttpURI {\n                          relativePath\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n          ... on ActivityEmptyStateTile {\n            heading\n            body\n            icon {\n              id\n              description\n            }\n            analytics {\n              referrerId\n              linkName\n            }\n          }\n        }\n      }\n      universalSortAndFilter {\n        ... on ShoppingSortAndFilters {\n          applyAction {\n            ... on UIPrimaryFloatingActionButton {\n              primary\n              accessibility\n              action {\n                ... on ShoppingSortAndFilterAction {\n                  analytics {\n                    referrerId\n                    linkName\n                  }\n                }\n              }\n            }\n          }\n          revealAction {\n            ... on UISecondaryFloatingActionButton {\n              primary\n              accessibility\n              badge\n              action {\n                ... on ShoppingSortAndFilterAction {\n                  analytics {\n                    referrerId\n                    linkName\n                  }\n                }\n              }\n            }\n          }\n          toolbar {\n            primary\n            actions {\n              ... on UIToolbarActions {\n                primary {\n                  accessibility\n                }\n                secondaries {\n                  primary\n                  accessibility\n                  action {\n                    ... on ShoppingSortAndFilterAction {\n                      analytics {\n                        referrerId\n                        linkName\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n          clearAll {\n            ... on UITertiaryButton {\n              primary\n              action {\n                ... on UILinkAction {\n                  analytics {\n                    linkName\n                    referrerId\n                  }\n                  resource {\n                    ... on HttpURI {\n                      relativePath\n                    }\n                  }\n                }\n              }\n            }\n          }\n          appliedFilters {\n            ... on EGDSSortAndFilterAppliedFilter {\n              pill {\n                primary\n                accessibility\n                action {\n                  ... on ShoppingSortAndFilterAction {\n                    analytics {\n                      linkName\n                      referrerId\n                    }\n                  }\n                }\n              }\n              nextSearchCriteria {\n                selections {\n                  id\n                  value\n                }\n              }\n            }\n          }\n          sortSections {\n            ... on ShoppingSortAndFilterSection {\n              fields {\n                ... on ShoppingDropdownField {\n                  __typename\n                  primary\n                  options {\n                    ... on ShoppingSelectableFilterOption {\n                      id\n                      value\n                      primary\n                      selected\n                      secondary\n                      disabled\n                      icon {\n                        id\n                        description\n                      }\n                      selectAnalytics {\n                        linkName\n                        referrerId\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n          filterSections {\n            ... on ShoppingSortAndFilterSection {\n              title\n              fields {\n                ... on ShoppingTextInputField {\n                  __typename\n                  id\n                  label\n                  placeholder\n                  icon {\n                    id\n                  }\n                  analytics {\n                    linkName\n                    referrerId\n                  }\n                  selected\n                }\n                ... on ShoppingMultiSelectionField {\n                  __typename\n                  primary\n                  options {\n                    ... on ShoppingSelectableFilterOption {\n                      value\n                      id\n                      primary\n                      selected\n                      description\n                      disabled\n                      selectAnalytics {\n                        linkName\n                        referrerId\n                      }\n                      deselectAnalytics {\n                        linkName\n                        referrerId\n                      }\n                      nestedOptions {\n                        value\n                        id\n                        primary\n                        selected\n                        description\n                        disabled\n                        selectAnalytics {\n                          linkName\n                          referrerId\n                        }\n                        deselectAnalytics {\n                          linkName\n                          referrerId\n                        }\n                      }\n                      accessibility\n                    }\n                  }\n                }\n                ... on ShoppingSelectionField {\n                  __typename\n                  primary\n                  options {\n                    ... on ShoppingSelectableFilterOption {\n                      id\n                      value\n                      primary\n                      selected\n                      description\n                      disabled\n                      selectAnalytics {\n                        linkName\n                        referrerId\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      noMatchesFound {\n        title\n        message\n        graphic {\n          ...EGDSGraphicFragment\n          __typename\n        }\n        filterPills {\n          ... on ShoppingAppliedFilter {\n            ... on BasicShoppingAppliedFilter {\n              filter {\n                ... on EGDSPill {\n                  ... on EGDSBasicRemovablePill {\n                    accessibility\n                    disabled\n                    icon {\n                      ...EGDSGraphicFragment\n                      __typename\n                    }\n                    name\n                    primary\n                    remove {\n                      ...EGDSGraphicFragment\n                      __typename\n                    }\n                    removeAnalytics {\n                      ...ClientSideAnalyticsFragment\n                    }\n                    selected\n                    value\n                    __typename\n                  }\n                  __typename\n                }\n              }\n              nextSearchCriteria {\n                selections {\n                  id\n                  value\n                  __typename\n                }\n                __typename\n              }\n            }\n          }\n          __typename\n        }\n        removeAllFiltersButton {\n          primary\n          accessibility\n          __typename\n        }\n        removeAllFiltersAction {\n          ... on ActivityLinkClickAction {\n            linkTagUrl\n            clientSideAnalytics {\n              ...ClientSideAnalyticsFragment\n            }\n            __typename\n          }\n          __typename\n        }\n        analytics {\n          ...ClientSideAnalyticsFragment\n        }\n        __typename\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n"])), ClientSideAnalyticsFragmentFragmentDoc, EgdsStandardBadgeFragmentFragmentDoc, EgdsGraphicFragmentFragmentDoc);
export var ActivityDetailBasicDocument = gql(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  query ActivityDetailBasic(\n    $context: ContextInput!\n    $activityId: String!\n    $dateRange: ActivityDateRangeInput\n    $destination: ActivityDestinationInput\n    $marketing: ActivityMarketingInfoInput\n    $detailsViewOptions: [ActivityDetailViewOptions!]\n    $offerFilters: ActivityOfferFilterInput\n  ) {\n    activityInfo(\n      context: $context\n      activityId: $activityId\n      dateRange: $dateRange\n      destination: $destination\n      marketing: $marketing\n      detailsViewOptions: $detailsViewOptions\n      offerFilters: $offerFilters\n    ) {\n      telesales {\n        label\n        phoneNumberLink {\n          phoneNumber\n          value\n        }\n        analytics {\n          linkName\n          referrerId\n        }\n      }\n      tabbedNavigationBar {\n        tabs {\n          label\n          sectionRef\n          analytics {\n            linkName\n            referrerId\n          }\n        }\n        findTicketsButton {\n          primary\n          accessibility\n        }\n        findTicketsAction {\n          sectionRef\n          clientSideAnalytics {\n            linkName\n            referrerId\n          }\n        }\n      }\n      availabilities {\n        date {\n          isoFormat\n          day\n          month\n          year\n          fullDateFormat\n        }\n        isAvailable\n        price {\n          formatted\n        }\n        priceTextTheme\n      }\n      availabilityCalendar {\n        date {\n          isoFormat\n        }\n        price {\n          formatted\n        }\n      }\n      location {\n        event {\n          coordinates {\n            latitude\n            longitude\n          }\n          address {\n            firstLine\n            secondLine\n            thirdLine\n            city\n            province\n            zipCode\n            country\n          }\n          description\n          region {\n            regionId\n            regionName\n            fullRegionName\n          }\n        }\n        redemption {\n          address {\n            firstLine\n            secondLine\n            thirdLine\n            province\n            city\n            zipCode\n            country\n          }\n          description\n          coordinates {\n            latitude\n            longitude\n          }\n          distanceFromHotel {\n            text\n            size\n          }\n        }\n        sectionRef\n      }\n      uisPayload {\n        detailsPayload\n      }\n      presentation {\n        partnerProvidedDetails {\n          heading\n          body\n        }\n        title\n        staticMap\n        detailsSectionGroups {\n          footer\n          heading\n          sectionRef\n          sections {\n            heading\n            headingGraphic {\n              ... on Icon {\n                description\n                id\n                size\n                token\n              }\n            }\n            sectionRefLink {\n              analytics {\n                microMessagePayload\n                linkName\n                referrerId\n              }\n              label\n              sectionRef\n            }\n            structuredItems {\n              icon_temp {\n                description\n                id\n                size\n                token\n              }\n              label\n            }\n          }\n        }\n        pointsToRemember {\n          __typename\n          headingGraphic {\n            ... on Icon {\n              description\n              id\n            }\n          }\n          key\n          heading\n          items\n          structuredItems {\n            icon {\n              description\n              id\n            }\n            label\n          }\n          sectionRef\n          sectionRefLink {\n            analytics {\n              microMessagePayload\n              linkName\n              referrerId\n            }\n            ... on ActivityRefClickAction {\n              label\n              sectionRef\n            }\n          }\n          expando {\n            expandLabel\n            collapseLabel\n            expandAnalytics {\n              linkName\n              referrerId\n            }\n          }\n        }\n        banners {\n          title\n          subtitle\n          icon {\n            description\n            id\n            size\n            withBackground\n          }\n          mark {\n            description\n            id\n          }\n          type\n          action {\n            rfrr\n            href\n            text\n          }\n        }\n        features {\n          label\n          subtext\n          url\n          icon {\n            description\n            id\n          }\n          mark {\n            description\n            id\n            url {\n              value\n            }\n          }\n        }\n        loyaltyPointsValue {\n          formatted\n          currencyInfo {\n            code\n            name\n            symbol\n          }\n          amount\n        }\n        promotionMessage {\n          type\n          mark {\n            description\n            id\n          }\n          icon {\n            description\n            id\n            size\n            withBackground\n          }\n          subtitle\n          title\n          action {\n            primary {\n              __typename\n              text\n              url\n            }\n            secondary {\n              __typename\n              text\n              url\n            }\n          }\n          clickAction {\n            first {\n              text\n              clickAction {\n                __typename\n                analytics {\n                  microMessagePayload\n                  linkName\n                  referrerId\n                }\n                ... on ActivityLinkClickAction {\n                  accessibilityText\n                  linkTagUrl\n                  anchorTagUrl\n                  opensInNewTab\n                }\n                ... on ActivityPopupClickAction {\n                  dismissAction {\n                    text\n                    href\n                    rfrr\n                  }\n                  title\n                  messages\n                }\n              }\n            }\n            second {\n              text\n              clickAction {\n                __typename\n                analytics {\n                  microMessagePayload\n                  linkName\n                  referrerId\n                }\n                ... on ActivityLinkClickAction {\n                  accessibilityText\n                  linkTagUrl\n                  anchorTagUrl\n                  opensInNewTab\n                }\n                ... on ActivityPopupClickAction {\n                  dismissAction {\n                    text\n                    href\n                    rfrr\n                  }\n                  title\n                  messages\n                }\n              }\n            }\n          }\n          analytics {\n            linkName\n            referrerId\n          }\n          signInButton {\n            ... on UIPrimaryButton {\n              primary\n              action {\n                ... on UILinkAction {\n                  analytics {\n                    linkName\n                    referrerId\n                  }\n                  resource {\n                    ... on HttpURI {\n                      relativePath\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n        legalDisclaimer {\n          icon {\n            id\n            withBackground\n          }\n          title\n        }\n        localisationDisclaimer {\n          icon {\n            withBackground\n            id\n          }\n          title\n          action {\n            href\n            text\n            accessibilityText\n          }\n          secondaryAction {\n            href\n            text\n            accessibilityText\n          }\n        }\n      }\n      activity {\n        supplierName\n        reviewSummary {\n          reviewCountMessage\n          source\n          blockWebCrawlersEnabled\n          score {\n            formatted\n            raw\n          }\n          total\n          disclaimer {\n            ... on ActivityDisclaimerDialog {\n              __typename\n              dialog {\n                ... on EGDSActionDialog {\n                  closeAnalytics {\n                    ... on ClientSideAnalytics {\n                      linkName\n                      referrerId\n                    }\n                  }\n                  footer {\n                    ... on EGDSInlineDialogFooter {\n                      buttons {\n                        ... on UITertiaryButton {\n                          accessibility\n                          primary\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n              trigger {\n                ... on ActivityLinkDialogTrigger {\n                  analytics {\n                    ... on ClientSideAnalytics {\n                      linkName\n                      referrerId\n                    }\n                  }\n                  accessibility\n                  label\n                  graphic {\n                    ... on Icon {\n                      id\n                      description\n                    }\n                  }\n                }\n              }\n              contents {\n                ... on EGDSParagraph {\n                  style\n                  text\n                }\n              }\n              dialogActions {\n                ... on ActivityLinkClickAction {\n                  accessibilityText\n                  analytics {\n                    linkName\n                    referrerId\n                  }\n                  opensInNewTab\n                  linkTagUrl\n                }\n              }\n            }\n          }\n          sectionRef\n        }\n        description\n        name\n        image {\n          description\n          url\n        }\n        id\n        redemption {\n          type\n        }\n        saveItem {\n          initialChecked\n          itemId\n          source\n          attributes {\n            ... on TripsSaveActivityAttributes {\n              regionId\n              dateRange {\n                start {\n                  day\n                  month\n                  year\n                  __typename\n                }\n                end {\n                  day\n                  month\n                  year\n                  __typename\n                }\n                __typename\n              }\n            }\n            __typename\n          }\n          save {\n            accessibility\n            analytics {\n              referrerId\n              linkName\n              uisPrimeMessages {\n                messageContent\n                schemaName\n              }\n              __typename\n            }\n            label\n            __typename\n          }\n          remove {\n            accessibility\n            analytics {\n              referrerId\n              linkName\n              uisPrimeMessages {\n                messageContent\n                schemaName\n              }\n              __typename\n            }\n            label\n            __typename\n          }\n          __typename\n        }\n        sectionRef\n      }\n      offersSummary {\n        leadTicketView {\n          action {\n            text\n          }\n          message\n          ticket {\n            label\n            price {\n              leadFormatted\n              leadAmount\n              strikeOutFormatted\n            }\n            loyaltyPointsOption {\n              formattedPoints\n              leadingCaption\n              pointsFirst\n              strikeThroughFirst\n            }\n            priceAccessibilityText\n            legalDisclaimer {\n              clickAction {\n                ... on ActivityPopupClickAction {\n                  messages\n                  dismissAction {\n                    href\n                    rfrr\n                    text\n                  }\n                }\n                analytics {\n                  linkName\n                  referrerId\n                }\n              }\n              icon {\n                description\n                id\n              }\n              text\n              accessibilityText\n            }\n          }\n        }\n        filters {\n          id\n          title\n          fields {\n            label\n            theme\n            value\n          }\n        }\n      }\n      offers(filter: $offerFilters) {\n        activityOfferTicketsSummary {\n          title\n          icon\n        }\n        availableTimeEpoch\n        formattedAvailableTime\n        availableTime {\n          day\n          hour\n          minute\n          month\n          second\n          year\n          epochSeconds\n          formatted(format: \"yyyy-MM-dd HH:mm:ss\")\n          fullDateFormat\n          raw\n          shortDateFormat\n          shortTimeFormat\n        }\n        priceMetaData {\n          discountType\n          discountPercent\n        }\n        activityOfferMessages {\n          vbpMessage\n          nonRefundable {\n            title\n            subTitle\n          }\n          operatingHours {\n            text\n          }\n        }\n        badges {\n          secondary {\n            text\n            type\n            icon {\n              description\n              id\n              size\n              withBackground\n            }\n            mark {\n              description\n              id\n            }\n          }\n          primary {\n            text\n            type\n            mark {\n              description\n              id\n            }\n            icon {\n              description\n              id\n              size\n              withBackground\n            }\n          }\n        }\n        description\n        features {\n          icon {\n            description\n            id\n            size\n            withBackground\n          }\n          mark {\n            description\n            id\n            url {\n              value\n            }\n          }\n          label\n          subtext\n          url\n          anchoredSubtext {\n            clickAction {\n              ... on ActivityPopupClickAction {\n                messages\n                dismissAction {\n                  href\n                  rfrr\n                  text\n                }\n              }\n              analytics {\n                linkName\n                referrerId\n              }\n            }\n            icon {\n              description\n              id\n            }\n            text\n          }\n        }\n        id\n        promoId\n        name\n        maxTicketSelectionAllowed\n        hotelPickupAvailable\n        priceType\n        count\n        priceSummary {\n          totalPriceSummary {\n            title\n            priceAccessibilityText\n            loyaltyPointsMessage\n            pointsFirst\n            legalDisclaimer {\n              clickAction {\n                ... on ActivityPopupClickAction {\n                  messages\n                  dismissAction {\n                    href\n                    rfrr\n                    text\n                  }\n                }\n                analytics {\n                  linkName\n                  referrerId\n                }\n              }\n              icon {\n                description\n                id\n              }\n              text\n              accessibilityText\n            }\n            price {\n              strikeOutFormatted\n              leadFormatted\n            }\n          }\n          ticketBreakdownSummary {\n            title\n            ticketTypePrices {\n              accessibilityText\n              breakdownLeadPriceLabel\n              breakdownStrikeOutPriceLabel\n              totalLeadPriceLabel\n            }\n          }\n        }\n        ticketTypes {\n          maxSelectableCount\n          minSelectableCount\n          step\n          type\n          defaultSelectedCount\n          label\n          promoId\n          restrictionText\n          ticketKey\n          ticketSingular\n          ticketPlural\n          prices {\n            selectedCount\n            perTravelerPrice {\n              lead {\n                currencyInfo {\n                  code\n                  symbol\n                }\n              }\n              leadAmount\n              leadFormatted\n              strikeOutAmount\n              strikeOutFormatted\n            }\n            totalPrice {\n              leadAmount\n              leadFormatted\n              strikeOutAmount\n              strikeOutFormatted\n            }\n            totalLoyaltyPointsOption {\n              pointsAmount {\n                raw\n              }\n              pointsUnit\n              leadingCaption\n              pointsFirst\n              strikeThroughFirst\n            }\n          }\n        }\n        selections {\n          id\n          title\n          fields {\n            label\n            theme\n            value\n          }\n          graphic {\n            ... on Icon {\n              description\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n"], ["\n  query ActivityDetailBasic(\n    $context: ContextInput!\n    $activityId: String!\n    $dateRange: ActivityDateRangeInput\n    $destination: ActivityDestinationInput\n    $marketing: ActivityMarketingInfoInput\n    $detailsViewOptions: [ActivityDetailViewOptions!]\n    $offerFilters: ActivityOfferFilterInput\n  ) {\n    activityInfo(\n      context: $context\n      activityId: $activityId\n      dateRange: $dateRange\n      destination: $destination\n      marketing: $marketing\n      detailsViewOptions: $detailsViewOptions\n      offerFilters: $offerFilters\n    ) {\n      telesales {\n        label\n        phoneNumberLink {\n          phoneNumber\n          value\n        }\n        analytics {\n          linkName\n          referrerId\n        }\n      }\n      tabbedNavigationBar {\n        tabs {\n          label\n          sectionRef\n          analytics {\n            linkName\n            referrerId\n          }\n        }\n        findTicketsButton {\n          primary\n          accessibility\n        }\n        findTicketsAction {\n          sectionRef\n          clientSideAnalytics {\n            linkName\n            referrerId\n          }\n        }\n      }\n      availabilities {\n        date {\n          isoFormat\n          day\n          month\n          year\n          fullDateFormat\n        }\n        isAvailable\n        price {\n          formatted\n        }\n        priceTextTheme\n      }\n      availabilityCalendar {\n        date {\n          isoFormat\n        }\n        price {\n          formatted\n        }\n      }\n      location {\n        event {\n          coordinates {\n            latitude\n            longitude\n          }\n          address {\n            firstLine\n            secondLine\n            thirdLine\n            city\n            province\n            zipCode\n            country\n          }\n          description\n          region {\n            regionId\n            regionName\n            fullRegionName\n          }\n        }\n        redemption {\n          address {\n            firstLine\n            secondLine\n            thirdLine\n            province\n            city\n            zipCode\n            country\n          }\n          description\n          coordinates {\n            latitude\n            longitude\n          }\n          distanceFromHotel {\n            text\n            size\n          }\n        }\n        sectionRef\n      }\n      uisPayload {\n        detailsPayload\n      }\n      presentation {\n        partnerProvidedDetails {\n          heading\n          body\n        }\n        title\n        staticMap\n        detailsSectionGroups {\n          footer\n          heading\n          sectionRef\n          sections {\n            heading\n            headingGraphic {\n              ... on Icon {\n                description\n                id\n                size\n                token\n              }\n            }\n            sectionRefLink {\n              analytics {\n                microMessagePayload\n                linkName\n                referrerId\n              }\n              label\n              sectionRef\n            }\n            structuredItems {\n              icon_temp {\n                description\n                id\n                size\n                token\n              }\n              label\n            }\n          }\n        }\n        pointsToRemember {\n          __typename\n          headingGraphic {\n            ... on Icon {\n              description\n              id\n            }\n          }\n          key\n          heading\n          items\n          structuredItems {\n            icon {\n              description\n              id\n            }\n            label\n          }\n          sectionRef\n          sectionRefLink {\n            analytics {\n              microMessagePayload\n              linkName\n              referrerId\n            }\n            ... on ActivityRefClickAction {\n              label\n              sectionRef\n            }\n          }\n          expando {\n            expandLabel\n            collapseLabel\n            expandAnalytics {\n              linkName\n              referrerId\n            }\n          }\n        }\n        banners {\n          title\n          subtitle\n          icon {\n            description\n            id\n            size\n            withBackground\n          }\n          mark {\n            description\n            id\n          }\n          type\n          action {\n            rfrr\n            href\n            text\n          }\n        }\n        features {\n          label\n          subtext\n          url\n          icon {\n            description\n            id\n          }\n          mark {\n            description\n            id\n            url {\n              value\n            }\n          }\n        }\n        loyaltyPointsValue {\n          formatted\n          currencyInfo {\n            code\n            name\n            symbol\n          }\n          amount\n        }\n        promotionMessage {\n          type\n          mark {\n            description\n            id\n          }\n          icon {\n            description\n            id\n            size\n            withBackground\n          }\n          subtitle\n          title\n          action {\n            primary {\n              __typename\n              text\n              url\n            }\n            secondary {\n              __typename\n              text\n              url\n            }\n          }\n          clickAction {\n            first {\n              text\n              clickAction {\n                __typename\n                analytics {\n                  microMessagePayload\n                  linkName\n                  referrerId\n                }\n                ... on ActivityLinkClickAction {\n                  accessibilityText\n                  linkTagUrl\n                  anchorTagUrl\n                  opensInNewTab\n                }\n                ... on ActivityPopupClickAction {\n                  dismissAction {\n                    text\n                    href\n                    rfrr\n                  }\n                  title\n                  messages\n                }\n              }\n            }\n            second {\n              text\n              clickAction {\n                __typename\n                analytics {\n                  microMessagePayload\n                  linkName\n                  referrerId\n                }\n                ... on ActivityLinkClickAction {\n                  accessibilityText\n                  linkTagUrl\n                  anchorTagUrl\n                  opensInNewTab\n                }\n                ... on ActivityPopupClickAction {\n                  dismissAction {\n                    text\n                    href\n                    rfrr\n                  }\n                  title\n                  messages\n                }\n              }\n            }\n          }\n          analytics {\n            linkName\n            referrerId\n          }\n          signInButton {\n            ... on UIPrimaryButton {\n              primary\n              action {\n                ... on UILinkAction {\n                  analytics {\n                    linkName\n                    referrerId\n                  }\n                  resource {\n                    ... on HttpURI {\n                      relativePath\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n        legalDisclaimer {\n          icon {\n            id\n            withBackground\n          }\n          title\n        }\n        localisationDisclaimer {\n          icon {\n            withBackground\n            id\n          }\n          title\n          action {\n            href\n            text\n            accessibilityText\n          }\n          secondaryAction {\n            href\n            text\n            accessibilityText\n          }\n        }\n      }\n      activity {\n        supplierName\n        reviewSummary {\n          reviewCountMessage\n          source\n          blockWebCrawlersEnabled\n          score {\n            formatted\n            raw\n          }\n          total\n          disclaimer {\n            ... on ActivityDisclaimerDialog {\n              __typename\n              dialog {\n                ... on EGDSActionDialog {\n                  closeAnalytics {\n                    ... on ClientSideAnalytics {\n                      linkName\n                      referrerId\n                    }\n                  }\n                  footer {\n                    ... on EGDSInlineDialogFooter {\n                      buttons {\n                        ... on UITertiaryButton {\n                          accessibility\n                          primary\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n              trigger {\n                ... on ActivityLinkDialogTrigger {\n                  analytics {\n                    ... on ClientSideAnalytics {\n                      linkName\n                      referrerId\n                    }\n                  }\n                  accessibility\n                  label\n                  graphic {\n                    ... on Icon {\n                      id\n                      description\n                    }\n                  }\n                }\n              }\n              contents {\n                ... on EGDSParagraph {\n                  style\n                  text\n                }\n              }\n              dialogActions {\n                ... on ActivityLinkClickAction {\n                  accessibilityText\n                  analytics {\n                    linkName\n                    referrerId\n                  }\n                  opensInNewTab\n                  linkTagUrl\n                }\n              }\n            }\n          }\n          sectionRef\n        }\n        description\n        name\n        image {\n          description\n          url\n        }\n        id\n        redemption {\n          type\n        }\n        saveItem {\n          initialChecked\n          itemId\n          source\n          attributes {\n            ... on TripsSaveActivityAttributes {\n              regionId\n              dateRange {\n                start {\n                  day\n                  month\n                  year\n                  __typename\n                }\n                end {\n                  day\n                  month\n                  year\n                  __typename\n                }\n                __typename\n              }\n            }\n            __typename\n          }\n          save {\n            accessibility\n            analytics {\n              referrerId\n              linkName\n              uisPrimeMessages {\n                messageContent\n                schemaName\n              }\n              __typename\n            }\n            label\n            __typename\n          }\n          remove {\n            accessibility\n            analytics {\n              referrerId\n              linkName\n              uisPrimeMessages {\n                messageContent\n                schemaName\n              }\n              __typename\n            }\n            label\n            __typename\n          }\n          __typename\n        }\n        sectionRef\n      }\n      offersSummary {\n        leadTicketView {\n          action {\n            text\n          }\n          message\n          ticket {\n            label\n            price {\n              leadFormatted\n              leadAmount\n              strikeOutFormatted\n            }\n            loyaltyPointsOption {\n              formattedPoints\n              leadingCaption\n              pointsFirst\n              strikeThroughFirst\n            }\n            priceAccessibilityText\n            legalDisclaimer {\n              clickAction {\n                ... on ActivityPopupClickAction {\n                  messages\n                  dismissAction {\n                    href\n                    rfrr\n                    text\n                  }\n                }\n                analytics {\n                  linkName\n                  referrerId\n                }\n              }\n              icon {\n                description\n                id\n              }\n              text\n              accessibilityText\n            }\n          }\n        }\n        filters {\n          id\n          title\n          fields {\n            label\n            theme\n            value\n          }\n        }\n      }\n      offers(filter: $offerFilters) {\n        activityOfferTicketsSummary {\n          title\n          icon\n        }\n        availableTimeEpoch\n        formattedAvailableTime\n        availableTime {\n          day\n          hour\n          minute\n          month\n          second\n          year\n          epochSeconds\n          formatted(format: \"yyyy-MM-dd HH:mm:ss\")\n          fullDateFormat\n          raw\n          shortDateFormat\n          shortTimeFormat\n        }\n        priceMetaData {\n          discountType\n          discountPercent\n        }\n        activityOfferMessages {\n          vbpMessage\n          nonRefundable {\n            title\n            subTitle\n          }\n          operatingHours {\n            text\n          }\n        }\n        badges {\n          secondary {\n            text\n            type\n            icon {\n              description\n              id\n              size\n              withBackground\n            }\n            mark {\n              description\n              id\n            }\n          }\n          primary {\n            text\n            type\n            mark {\n              description\n              id\n            }\n            icon {\n              description\n              id\n              size\n              withBackground\n            }\n          }\n        }\n        description\n        features {\n          icon {\n            description\n            id\n            size\n            withBackground\n          }\n          mark {\n            description\n            id\n            url {\n              value\n            }\n          }\n          label\n          subtext\n          url\n          anchoredSubtext {\n            clickAction {\n              ... on ActivityPopupClickAction {\n                messages\n                dismissAction {\n                  href\n                  rfrr\n                  text\n                }\n              }\n              analytics {\n                linkName\n                referrerId\n              }\n            }\n            icon {\n              description\n              id\n            }\n            text\n          }\n        }\n        id\n        promoId\n        name\n        maxTicketSelectionAllowed\n        hotelPickupAvailable\n        priceType\n        count\n        priceSummary {\n          totalPriceSummary {\n            title\n            priceAccessibilityText\n            loyaltyPointsMessage\n            pointsFirst\n            legalDisclaimer {\n              clickAction {\n                ... on ActivityPopupClickAction {\n                  messages\n                  dismissAction {\n                    href\n                    rfrr\n                    text\n                  }\n                }\n                analytics {\n                  linkName\n                  referrerId\n                }\n              }\n              icon {\n                description\n                id\n              }\n              text\n              accessibilityText\n            }\n            price {\n              strikeOutFormatted\n              leadFormatted\n            }\n          }\n          ticketBreakdownSummary {\n            title\n            ticketTypePrices {\n              accessibilityText\n              breakdownLeadPriceLabel\n              breakdownStrikeOutPriceLabel\n              totalLeadPriceLabel\n            }\n          }\n        }\n        ticketTypes {\n          maxSelectableCount\n          minSelectableCount\n          step\n          type\n          defaultSelectedCount\n          label\n          promoId\n          restrictionText\n          ticketKey\n          ticketSingular\n          ticketPlural\n          prices {\n            selectedCount\n            perTravelerPrice {\n              lead {\n                currencyInfo {\n                  code\n                  symbol\n                }\n              }\n              leadAmount\n              leadFormatted\n              strikeOutAmount\n              strikeOutFormatted\n            }\n            totalPrice {\n              leadAmount\n              leadFormatted\n              strikeOutAmount\n              strikeOutFormatted\n            }\n            totalLoyaltyPointsOption {\n              pointsAmount {\n                raw\n              }\n              pointsUnit\n              leadingCaption\n              pointsFirst\n              strikeThroughFirst\n            }\n          }\n        }\n        selections {\n          id\n          title\n          fields {\n            label\n            theme\n            value\n          }\n          graphic {\n            ... on Icon {\n              description\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n"])));
export var ActivityDetailOffersWithAvailabilityDocument = gql(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  query ActivityDetailOffersWithAvailability(\n    $context: ContextInput!\n    $activityId: String!\n    $dateRange: ActivityDateRangeInput\n    $destination: ActivityDestinationInput\n    $marketing: ActivityMarketingInfoInput\n    $detailsViewOptions: [ActivityDetailViewOptions!]\n  ) {\n    activityInfo(\n      context: $context\n      activityId: $activityId\n      dateRange: $dateRange\n      destination: $destination\n      marketing: $marketing\n      detailsViewOptions: $detailsViewOptions\n    ) {\n      availabilities {\n        date {\n          isoFormat\n          day\n          month\n          year\n          fullDateFormat\n        }\n        isAvailable\n        price {\n          formatted\n        }\n        priceTextTheme\n      }\n      availabilityCalendar {\n        date {\n          isoFormat\n        }\n        price {\n          formatted\n        }\n      }\n      presentation {\n        banners {\n          title\n          subtitle\n          icon {\n            description\n            id\n            size\n            withBackground\n          }\n          mark {\n            description\n            id\n          }\n          type\n          action {\n            rfrr\n            href\n            text\n          }\n        }\n        promotionMessage {\n          type\n          mark {\n            description\n            id\n          }\n          icon {\n            description\n            id\n            size\n            withBackground\n          }\n          subtitle\n          title\n          action {\n            primary {\n              text\n              url\n            }\n            secondary {\n              text\n              url\n            }\n          }\n          analytics {\n            linkName\n            referrerId\n          }\n        }\n      }\n      uisPayload {\n        detailsPayload\n      }\n      offersSummary {\n        leadTicketView {\n          action {\n            text\n          }\n          message\n          ticket {\n            label\n            price {\n              leadFormatted\n              leadAmount\n            }\n          }\n        }\n        filters {\n          id\n          title\n          fields {\n            label\n            theme\n            value\n          }\n        }\n      }\n      offers {\n        activityOfferTicketsSummary {\n          title\n          icon\n        }\n        availableTimeEpoch\n        formattedAvailableTime\n        availableTime {\n          day\n          hour\n          minute\n          month\n          second\n          year\n          epochSeconds\n          formatted(format: \"yyyy-MM-dd HH:mm:ss\")\n          fullDateFormat\n          raw\n          shortDateFormat\n          shortTimeFormat\n        }\n        priceMetaData {\n          discountType\n          discountPercent\n        }\n        activityOfferMessages {\n          vbpMessage\n          operatingHours {\n            text\n          }\n        }\n        badges {\n          secondary {\n            text\n            type\n            mark {\n              description\n              id\n            }\n            icon {\n              description\n              id\n              size\n              withBackground\n            }\n          }\n          primary {\n            text\n            type\n            mark {\n              description\n              id\n            }\n            icon {\n              description\n              id\n              size\n              withBackground\n            }\n          }\n        }\n        description\n        features {\n          icon {\n            description\n            id\n          }\n          mark {\n            description\n            id\n            url {\n              value\n            }\n          }\n          label\n          subtext\n          url\n          anchoredSubtext {\n            clickAction {\n              ... on ActivityPopupClickAction {\n                messages\n                dismissAction {\n                  href\n                  rfrr\n                  text\n                }\n              }\n              analytics {\n                linkName\n                referrerId\n              }\n            }\n            icon {\n              description\n              id\n            }\n            text\n          }\n        }\n        id\n        promoId\n        name\n        maxTicketSelectionAllowed\n        hotelPickupAvailable\n        priceType\n        count\n        priceSummary {\n          totalPriceSummary {\n            title\n            priceAccessibilityText\n            loyaltyPointsMessage\n            pointsFirst\n            legalDisclaimer {\n              clickAction {\n                ... on ActivityPopupClickAction {\n                  messages\n                  dismissAction {\n                    href\n                    rfrr\n                    text\n                  }\n                }\n                analytics {\n                  linkName\n                  referrerId\n                }\n              }\n              icon {\n                description\n                id\n              }\n              text\n              accessibilityText\n            }\n            price {\n              strikeOutFormatted\n              leadFormatted\n            }\n          }\n          ticketBreakdownSummary {\n            title\n            ticketTypePrices {\n              accessibilityText\n              breakdownLeadPriceLabel\n              breakdownStrikeOutPriceLabel\n              totalLeadPriceLabel\n            }\n          }\n        }\n        ticketTypes {\n          maxSelectableCount\n          minSelectableCount\n          step\n          type\n          defaultSelectedCount\n          label\n          promoId\n          restrictionText\n          ticketKey\n          ticketSingular\n          ticketPlural\n          prices {\n            selectedCount\n            perTravelerPrice {\n              lead {\n                currencyInfo {\n                  code\n                  symbol\n                }\n              }\n              leadAmount\n              leadFormatted\n              strikeOutAmount\n              strikeOutFormatted\n            }\n            totalPrice {\n              leadAmount\n              leadFormatted\n              strikeOutAmount\n              strikeOutFormatted\n            }\n            totalLoyaltyPointsOption {\n              pointsAmount {\n                raw\n              }\n              pointsUnit\n              leadingCaption\n              pointsFirst\n              strikeThroughFirst\n            }\n          }\n        }\n        selections {\n          id\n          title\n          fields {\n            label\n            theme\n            value\n          }\n        }\n      }\n    }\n  }\n"], ["\n  query ActivityDetailOffersWithAvailability(\n    $context: ContextInput!\n    $activityId: String!\n    $dateRange: ActivityDateRangeInput\n    $destination: ActivityDestinationInput\n    $marketing: ActivityMarketingInfoInput\n    $detailsViewOptions: [ActivityDetailViewOptions!]\n  ) {\n    activityInfo(\n      context: $context\n      activityId: $activityId\n      dateRange: $dateRange\n      destination: $destination\n      marketing: $marketing\n      detailsViewOptions: $detailsViewOptions\n    ) {\n      availabilities {\n        date {\n          isoFormat\n          day\n          month\n          year\n          fullDateFormat\n        }\n        isAvailable\n        price {\n          formatted\n        }\n        priceTextTheme\n      }\n      availabilityCalendar {\n        date {\n          isoFormat\n        }\n        price {\n          formatted\n        }\n      }\n      presentation {\n        banners {\n          title\n          subtitle\n          icon {\n            description\n            id\n            size\n            withBackground\n          }\n          mark {\n            description\n            id\n          }\n          type\n          action {\n            rfrr\n            href\n            text\n          }\n        }\n        promotionMessage {\n          type\n          mark {\n            description\n            id\n          }\n          icon {\n            description\n            id\n            size\n            withBackground\n          }\n          subtitle\n          title\n          action {\n            primary {\n              text\n              url\n            }\n            secondary {\n              text\n              url\n            }\n          }\n          analytics {\n            linkName\n            referrerId\n          }\n        }\n      }\n      uisPayload {\n        detailsPayload\n      }\n      offersSummary {\n        leadTicketView {\n          action {\n            text\n          }\n          message\n          ticket {\n            label\n            price {\n              leadFormatted\n              leadAmount\n            }\n          }\n        }\n        filters {\n          id\n          title\n          fields {\n            label\n            theme\n            value\n          }\n        }\n      }\n      offers {\n        activityOfferTicketsSummary {\n          title\n          icon\n        }\n        availableTimeEpoch\n        formattedAvailableTime\n        availableTime {\n          day\n          hour\n          minute\n          month\n          second\n          year\n          epochSeconds\n          formatted(format: \"yyyy-MM-dd HH:mm:ss\")\n          fullDateFormat\n          raw\n          shortDateFormat\n          shortTimeFormat\n        }\n        priceMetaData {\n          discountType\n          discountPercent\n        }\n        activityOfferMessages {\n          vbpMessage\n          operatingHours {\n            text\n          }\n        }\n        badges {\n          secondary {\n            text\n            type\n            mark {\n              description\n              id\n            }\n            icon {\n              description\n              id\n              size\n              withBackground\n            }\n          }\n          primary {\n            text\n            type\n            mark {\n              description\n              id\n            }\n            icon {\n              description\n              id\n              size\n              withBackground\n            }\n          }\n        }\n        description\n        features {\n          icon {\n            description\n            id\n          }\n          mark {\n            description\n            id\n            url {\n              value\n            }\n          }\n          label\n          subtext\n          url\n          anchoredSubtext {\n            clickAction {\n              ... on ActivityPopupClickAction {\n                messages\n                dismissAction {\n                  href\n                  rfrr\n                  text\n                }\n              }\n              analytics {\n                linkName\n                referrerId\n              }\n            }\n            icon {\n              description\n              id\n            }\n            text\n          }\n        }\n        id\n        promoId\n        name\n        maxTicketSelectionAllowed\n        hotelPickupAvailable\n        priceType\n        count\n        priceSummary {\n          totalPriceSummary {\n            title\n            priceAccessibilityText\n            loyaltyPointsMessage\n            pointsFirst\n            legalDisclaimer {\n              clickAction {\n                ... on ActivityPopupClickAction {\n                  messages\n                  dismissAction {\n                    href\n                    rfrr\n                    text\n                  }\n                }\n                analytics {\n                  linkName\n                  referrerId\n                }\n              }\n              icon {\n                description\n                id\n              }\n              text\n              accessibilityText\n            }\n            price {\n              strikeOutFormatted\n              leadFormatted\n            }\n          }\n          ticketBreakdownSummary {\n            title\n            ticketTypePrices {\n              accessibilityText\n              breakdownLeadPriceLabel\n              breakdownStrikeOutPriceLabel\n              totalLeadPriceLabel\n            }\n          }\n        }\n        ticketTypes {\n          maxSelectableCount\n          minSelectableCount\n          step\n          type\n          defaultSelectedCount\n          label\n          promoId\n          restrictionText\n          ticketKey\n          ticketSingular\n          ticketPlural\n          prices {\n            selectedCount\n            perTravelerPrice {\n              lead {\n                currencyInfo {\n                  code\n                  symbol\n                }\n              }\n              leadAmount\n              leadFormatted\n              strikeOutAmount\n              strikeOutFormatted\n            }\n            totalPrice {\n              leadAmount\n              leadFormatted\n              strikeOutAmount\n              strikeOutFormatted\n            }\n            totalLoyaltyPointsOption {\n              pointsAmount {\n                raw\n              }\n              pointsUnit\n              leadingCaption\n              pointsFirst\n              strikeThroughFirst\n            }\n          }\n        }\n        selections {\n          id\n          title\n          fields {\n            label\n            theme\n            value\n          }\n        }\n      }\n    }\n  }\n"])));
export var ActivityPageSeoContentDocument = gql(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  query ActivityPageSeoContent($context: ContextInput!, $activityId: String, $pageType: ActivityPageType!) {\n    activitySeoContent(context: $context, activityId: $activityId, pageType: $pageType) {\n      canonicalUrl {\n        value\n      }\n      metaTags {\n        content\n        metaTagType\n        metaTagValue\n      }\n      hreflangLinks {\n        href\n        hrefLang\n      }\n      title\n    }\n  }\n"], ["\n  query ActivityPageSeoContent($context: ContextInput!, $activityId: String, $pageType: ActivityPageType!) {\n    activitySeoContent(context: $context, activityId: $activityId, pageType: $pageType) {\n      canonicalUrl {\n        value\n      }\n      metaTags {\n        content\n        metaTagType\n        metaTagValue\n      }\n      hreflangLinks {\n        href\n        hrefLang\n      }\n      title\n    }\n  }\n"])));
var defaultWrapper = function (action, _operationName, _operationType) {
  return action();
};
var ActivityDestinationViewSearchDocumentString = print(ActivityDestinationViewSearchDocument);
var ActivityDetailBasicDocumentString = print(ActivityDetailBasicDocument);
var ActivityDetailOffersWithAvailabilityDocumentString = print(ActivityDetailOffersWithAvailabilityDocument);
var ActivityPageSeoContentDocumentString = print(ActivityPageSeoContentDocument);
export function getSdk(client, withWrapper) {
  if (withWrapper === void 0) {
    withWrapper = defaultWrapper;
  }
  return {
    ActivityDestinationViewSearch: function (variables, requestHeaders) {
      return withWrapper(function (wrappedRequestHeaders) {
        return client.rawRequest(ActivityDestinationViewSearchDocumentString, variables, __assign(__assign({}, requestHeaders), wrappedRequestHeaders));
      }, 'ActivityDestinationViewSearch', 'query');
    },
    ActivityDetailBasic: function (variables, requestHeaders) {
      return withWrapper(function (wrappedRequestHeaders) {
        return client.rawRequest(ActivityDetailBasicDocumentString, variables, __assign(__assign({}, requestHeaders), wrappedRequestHeaders));
      }, 'ActivityDetailBasic', 'query');
    },
    ActivityDetailOffersWithAvailability: function (variables, requestHeaders) {
      return withWrapper(function (wrappedRequestHeaders) {
        return client.rawRequest(ActivityDetailOffersWithAvailabilityDocumentString, variables, __assign(__assign({}, requestHeaders), wrappedRequestHeaders));
      }, 'ActivityDetailOffersWithAvailability', 'query');
    },
    ActivityPageSeoContent: function (variables, requestHeaders) {
      return withWrapper(function (wrappedRequestHeaders) {
        return client.rawRequest(ActivityPageSeoContentDocumentString, variables, __assign(__assign({}, requestHeaders), wrappedRequestHeaders));
      }, 'ActivityPageSeoContent', 'query');
    }
  };
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;